// http://ejohn.org/blog/javascript-micro-templating/

// Simple JavaScript Templating
// John Resig - http://ejohn.org/ - MIT Licensed
(function() {
  var cache = {};

  this.tmpl = function tmpl(str, data) {
    // Figure out if we're getting a template, or if we need to
    // load the template - and be sure to cache the result.
    var fn = !/\W/.test(str) ?
      cache[str] = cache[str] ||
      tmpl(document.getElementById(str).innerHTML) :

      // Generate a reusable function that will serve as a template
      // generator (and which will be cached).
      new Function("obj",
        "var p=[],print=function(){p.push.apply(p,arguments);};" +

        // Introduce the data as local variables using with(){}
        "with(obj){p.push('" +

        // Convert the template into pure JavaScript

        /* // Original Code
        str
          .replace(/[\r\t\n]/g, " ")
          .split("<%").join("\t")
          .replace(/((^|%>)[^\t]*)'/g, "$1\r")
          .replace(/\t=(.*?)%>/g, "',$1,'")
          .split("\t").join("');")
          .split("%>").join("p.push('")
          .split("\r").join("\\'")
      + "');}return p.join('');");
        */

        // Supports (') single quote. Example: <div data-id='<%= obj.id %>'></div>
        str.replace(/[\r\t\n]/g, " ")
        .replace(/'(?=[^%]*%>)/g, "\t")
        .split("'").join("\\'")
        .split("\t").join("'")
        .replace(/<%=(.+?)%>/g, "',$1,'")
        .split("<%").join("');")
        .split("%>").join("p.push('") +
        "');}return p.join('');");

    // Provide some basic currying to the user
    return data ? fn(data) : fn;
  };
})();
/***********************************************************/
/***********************************************************/
/* Form Validation Module */
/***********************************************************/
/***********************************************************/

var formValidationModule = (function() {

  function getPopupParentFlagName(parent) {
    var className = parent.attr('class'),
      flagName = '';

    className = className.replace('hide', '').trim();

    var str = className.split('-');

    for (var i = 0; i < str.length; i++) {

      var s = i === 0 ? str[i] : str[i].charAt(0).toUpperCase() + str[i].slice(1);
      flagName += s;
    }

    return flagName;
  }

  function validateForm(formParent, inErrorTitle, successFunc, inShowErrorPopup, desktop) {
    var desktop = desktop || false;
    var showErrorPopup = inShowErrorPopup != null ? inShowErrorPopup : true;
    var errorList = []; // For desktop use only
    var firstError = null;
    var firstErrorFieldType = null;

    var data = {};

    formParent.find('input,textarea,select').each(function() {
      if ($(this).is(':visible')) {
        var inputType = $(this).data('input-type');
        if (fieldTypes[inputType] != null) {
          var fieldType = fieldTypes[inputType];
          if (!fieldType.validator($(this), fieldType.validationFunc, true) && desktop) {
            errorList.push(fieldType.errorMessage);
          }
          if (!fieldType.validator($(this), fieldType.validationFunc, true) && firstError == null) {
            firstError = $(this);
            firstErrorFieldType = fieldType;
          } else {
            // Valid
            var param = $(this).data('param');
            if (param != null) {
              var paramValue = fieldType.paramValuefunc($(this));
              if (paramValue != null) {
                data[param] = paramValue;
              }
            }
          }
        }
      }
    });

    if (firstError == null) {
      if (successFunc != null) {
        successFunc(data);
      }

      return true; // No errors.
    }


    if (showErrorPopup) {

      var errorTitle = firstErrorFieldType.errorTitle != null ? firstErrorFieldType.errorTitle : inErrorTitle;

      if (desktop) {
        // Desktop
        var newErrors = errorList.join('<br>');
        var data = {
          title: errorTitle,
          message: newErrors,
          okCallback: function() {
            firstError.trigger('focus');
          }
        };

        var popup = new Popup(data);
        popup.render();
      } else {
        // Mobile
        var popupFlag = false;
        if ($('.backdrop').is(':visible')) {
          popupModule.close(formParent, getPopupParentFlagName(formParent));
          popupFlag = true;
        }

        if ($('.whole-screen-popup').is(':visible')) {
          preventScrolling($('.whole-screen-popup'));
        }

        showMessageDialogOKCallback(errorTitle, firstErrorFieldType.errorMessage, function() {
          if (popupFlag) {
            popupModule.open(formParent, getPopupParentFlagName(formParent));
            popupFlag = false;
          }

          $('body').scrollTop(firstError.offset().top);

          firstError.trigger('focus');
        }, null);
      }
    }
  }

  function addData(data, parent, override) {
    parent.find('input').each(function() {
      var inputType = $(this).data('input-type');
      if (fieldTypes[inputType] != null) {
        var fieldType = fieldTypes[inputType];
        var param = $(this).data('param');
        if (param != null && (override || data[param] == null)) {
          var paramValue = fieldType.paramValuefunc($(this));
          if (paramValue != null) {
            data[param] = paramValue;
          }
        }
      }
    });
  }

  function addDataFromInputAndSelect(data, parent, visible, override) {
    var selectors = 'input, select, textarea';
    if (visible) {
      selectors = 'input:visible, select:visible, textarea:visible';
    }

    parent.find(selectors).each(function() {
      var inputType = $(this).data('input-type');
      if (fieldTypes[inputType] != null) {
        var fieldType = fieldTypes[inputType];
        var param = $(this).data('param');
        if (param != null && (override || !data[param])) {
          var paramValue = fieldType.paramValuefunc($(this));
          if (paramValue != null) {
            data[param] = paramValue;
          }
        }
      }
    });
  }

  var fieldTypes = {};

  function FieldType(validator, validationFunc, paramValuefunc, errorTitle, errorMessage) {
    this.validator = validator;
    this.validationFunc = validationFunc;
    this.paramValuefunc = paramValuefunc;
    this.errorTitle = errorTitle;
    this.errorMessage = errorMessage;
  }

  function registerFieldType(inputType, validationFunc, errorTitle, errorMessage, inValidator, inParamValueFunc) {
    var validator = inValidator != null ? inValidator : defaultValidator;
    var paramValueFunc = inParamValueFunc != null ? inParamValueFunc : defaultParamValue;

    fieldTypes[inputType] = new FieldType(validator, validationFunc, paramValueFunc, errorTitle, errorMessage);

    $(document).on('blur', 'input[data-input-type="' + inputType + '"]', function() {
      var inputType = $(this).data('input-type');
      if (fieldTypes[inputType] != null) {
        var fieldType = fieldTypes[inputType];
        fieldType.validator($(this), fieldType.validationFunc, false);
      }
    });

    $(document).on('focus', 'input[data-input-type="' + inputType + '"]', function() {
      showDefault(null, $(this));
    });
  }

  function defaultValidator(el, validationFunc, submit) {
    if (validationFunc(el)) {
      showIndicatorPass(null, el);
      return true;
    } else {
      showIndicatorFail(null, el);
      return false;
    }
  }

  function optionalValidator(el, validationFunc, submit) {
    if (clean(el.val()).length == 0) {
      showDefault(null, el);
      return true;
    }

    if (validationFunc(el)) {
      showIndicatorPass(null, el);
      return true;
    } else {
      showIndicatorFail(null, el);
      return false;
    }
  }

  function confirmValidator(el, validationFunc, newClass, newConfirmClass, submit) {
    if (submit) {
      if (el.data('input-type') == newClass) {
        if (validationFunc(el)) {
          showIndicatorPass(null, el);
          return true;
        } else {
          showIndicatorFail(null, el);
          return false;
        }
      } else if (el.data('input-type') == newConfirmClass) {
        var el1 = getFormParent(el).find('input[data-input-type="' + newClass + '"]');
        if (el.val().length > 0 && (el.val() === el1.val())) {
          showIndicatorPass(null, el);
          return true;
        } else {
          showIndicatorFail(null, el);
          return false;
        }
      }

      return true;
    } else {
      var el1 = el;
      var el2;

      var checkConfirmField = false;
      if (el1.data('input-type') == newConfirmClass) {
        el2 = el1;
        el1 = getFormParent(el2).find('input[data-input-type="' + newClass + '"]');
        checkConfirmField = true;
      } else {
        el2 = getFormParent(el1).find('input[data-input-type="' + newConfirmClass + '"]');
      }

      if (!validationFunc(el1)) {
        showIndicatorFail(null, el1);

        if (checkConfirmField) {
          showIndicatorFail(null, el2);
        }

        return false;
      }

      // Make sure that both text field have values
      if ($(el1).val() !== '' && $(el2).val() !== '') {
        if ($(el1).val() !== $(el2).val()) {
          if ($(el2).val().length > 0) {
            showIndicatorFail(null, el2);
          }
        } else {
          showIndicatorPass(null, el1);
          showIndicatorPass(null, el2);
          return true; // match.
        }
      } else {
        if ($(el1).val() !== '') {
          showIndicatorPass(null, el1);
          if (checkConfirmField) {
            showIndicatorFail(null, el2);
          } else {
            showDefault(null, el2);
          }
        }
      }

      return false;
    }
  }

  function defaultParamValue(e) {
    return e.val();
  }

  registerFieldType('new-email', function(e) {
    var value = clean(e.val());
    if (value.length == 0) {
      return false;
    }
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
  }, null, 'Please enter a valid e-mail address.');

  registerFieldType('email', function(e) {
    var value = clean(e.val());
    if (value.length == 0) {
      return false;
    }
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
  }, null, 'Please enter your email address.');
  registerFieldType('name', isEmpty, null, 'Please enter a name.');
  registerFieldType('business-name', isEmpty, null, 'Please enter a business name.');
  registerFieldType('account-name', isEmpty, null, 'Please enter an account name.');
  registerFieldType('phone', isValidPhone, null, 'Please enter a valid mobile phone number.');
  registerFieldType('address1', isEmpty, null, 'Please enter an address.');
  registerFieldType('address2', isAnything, null, null, optionalValidator);
  registerFieldType('postcode', isValidPostalCode, null, 'Please enter a post code.');
  registerFieldType('city', isEmpty, null, 'Please enter a city.');
  registerFieldType('state', isValidState, null, 'Please select a state.');
  registerFieldType('country', isAnything, null, null, optionalValidator);
  registerFieldType('business-number', isEmpty, null, 'Please enter a business number or tax ID.');

  registerFieldType('name-joint', isAnything, null, null, optionalValidator);
  registerFieldType('phone-joint', isValidPhone, null, 'Please enter a valid mobile phone number for the Joint Account Holder.');
  registerFieldType('address1-joint', isEmpty, null, 'Please enter an address for the Joint Account Holder.');
  registerFieldType('address2-joint', isAnything, null, null, optionalValidator);
  registerFieldType('postcode-joint', isEmpty, null, 'Please enter a post code for the Joint Account Holder.');
  registerFieldType('state-joint', isValidState, null, 'Please select a state for the Joint Account Holder.');
  registerFieldType('city-joint', isEmpty, null, 'Please enter a city for the Joint Account Holder.');

  registerFieldType('name-sign1', isEmpty, null, 'Please enter a name for Signatory #1.');
  registerFieldType('phone-sign1', isValidPhone, null, 'Please enter a valid mobile phone number for Signatory #1.');
  registerFieldType('address1-sign1', isEmpty, null, 'Please enter an address for Signatory #1.');
  registerFieldType('address2-sign1', isAnything, null, null, optionalValidator);
  registerFieldType('postcode-sign1', isEmpty, null, 'Please enter a post code for Signatory #1.');
  registerFieldType('state-sign1', isValidState, null, 'Please select a state for Signatory #1.');
  registerFieldType('city-sign1', isEmpty, null, 'Please enter a city for Signatory #1.');

  registerFieldType('name-sign2', isAnything, null, null, optionalValidator);
  registerFieldType('phone-sign2', isValidPhone, null, 'Please enter a valid mobile phone number for Signatory #2.');
  registerFieldType('address1-sign2', isEmpty, null, 'Please enter an address for Signatory #2.');
  registerFieldType('address2-sign2', isAnything, null, null, optionalValidator);
  registerFieldType('postcode-sign2', isEmpty, null, 'Please enter a post code for Signatory #2.');
  registerFieldType('state-sign2', isValidState, null, 'Please select a state for Signatory #2.');
  registerFieldType('city-sign2', isEmpty, null, 'Please enter a city for Signatory #1.');

  registerFieldType('name-sign3', isAnything, null, null, optionalValidator);
  registerFieldType('phone-sign3', isValidPhone, null, 'Please enter a valid mobile phone number for Signatory #3.');
  registerFieldType('address1-sign3', isEmpty, null, 'Please enter an address for Signatory #3.');
  registerFieldType('address2-sign3', isAnything, null, null, optionalValidator);
  registerFieldType('postcode-sign3', isEmpty, null, 'Please enter a post code for Signatory #3.');
  registerFieldType('state-sign3', isValidState, null, 'Please select a state for Signatory #3.');
  registerFieldType('city-sign3', isEmpty, null, 'Please enter a city for Signatory #1.');

  registerFieldType('name-sign4', isAnything, null, null, optionalValidator);
  registerFieldType('phone-sign4', isValidPhone, null, 'Please enter a valid mobile phone number for Signatory #4.');
  registerFieldType('address1-sign4', isEmpty, null, 'Please enter an address for Signatory #4.');
  registerFieldType('address2-sign4', isAnything, null, null, optionalValidator);
  registerFieldType('postcode-sign4', isEmpty, null, 'Please enter a post code for Signatory #4.');
  registerFieldType('state-sign4', isValidState, null, 'Please select a state for Signatory #4.');
  registerFieldType('city-sign4', isEmpty, null, 'Please enter a city for Signatory #4.');

  registerFieldType('password', function(e) {
    var pass = $(e).val();
    if (pass.length >= 6 && pass.length <= 100) {
      return true;
    }
    return false;
  }, null, 'Please enter your Password.', defaultValidator, function(e) {
    return MD5(e.val());
  });

  registerFieldType('old-password', isEmpty, null, 'Please enter your old Password.', defaultValidator, function(e) {
    return MD5(e.val());
  });

  registerFieldType('new-password', function(e) {
    var pass = $(e).val();
    if (pass.length >= 6 && pass.length <= 100) {
      if (/\d/.test(pass)) {
        if (pass.toLowerCase() != pass) {
          return true;
        }
      }
    }

    return false;
  }, null, 'Your password needs to be at least 6 characters long and must not exceed 100 characters containing at least one uppercase letter and one number.', function(e, validationFunc, submit) {
    return confirmValidator(e, validationFunc, 'new-password', 'new-password-confirm', submit);
  }, function(e) {
    return MD5(e.val());
  });

  // registerFieldType('new-password', function(e) {
  //   var pass = $(e).val();
  //   if(pass.length <= 100) {
  //     return true
  //   }

  //   return false;
  // }, null, 'Your password must not exceed 100 characters.', function(e, validationFunc, submit) {
  //   return confirmValidator(e, validationFunc, 'new-password', 'new-password-confirm', submit);
  // }, function(e) { return MD5(e.val());
  // });

  registerFieldType('new-password-confirm', function(e) {
    var pass = $(e).val();
    if (pass.length >= 6) {
      if (/\d/.test(pass)) {
        if (pass.toLowerCase() != pass) {
          return true;
        }
      }
    }

    return false;
  }, null, 'Your password and password confirmation do not match.', function(e, validationFunc, submit) {
    return confirmValidator(e, validationFunc, 'new-password', 'new-password-confirm', submit);
  });

  registerFieldType('pin', function(e) {
    var pin = clean($(e).val());
    if (pin.length >= 4) {
      return true;
    }

    return false;
  }, 'Account Verification', 'Please enter your PIN code.');

  registerFieldType('new-pin', function(e) {
    var pin = clean($(e).val());
    if (pin.length >= 4) {
      return true;
    }

    return false;
  }, 'PIN Code', 'The PIN Code must contain a minimum of four digits.', function(e, validationFunc, submit) {
    return confirmValidator(e, validationFunc, 'new-pin', 'new-pin-confirm', submit);
  });

  registerFieldType('new-pin-confirm', function(e) {
    var pin = clean($(e).val());
    if (pin.length >= 4) {
      return true;
    }

    return false;
  }, null, 'Your PIN code and PIN code confirmation do not match.', function(e, validationFunc, submit) {
    return confirmValidator(e, validationFunc, 'new-pin', 'new-pin-confirm', submit);
  });

  registerFieldType('2fa-code', isEmpty, null, 'Please enter your 2-factor authentication code.');
  registerFieldType('auth-code', isEmpty, null, 'Please enter your authentication code.');

  registerFieldType('contact-name', isEmpty, null, 'Please enter your name.');
  registerFieldType('message', isEmpty, null, 'Please enter a message.');
  registerFieldType('question', isEmpty, null, 'Please enter a question.');
  registerFieldType('amount', isEmpty, null, 'Please enter the spot price for which you like to set the alert.');
  registerFieldType('amount-deposit', isEmpty, 'Insufficient Amount', 'Please note that the minimum account funding amount is 1,000.');
  registerFieldType('amount-withdraw', isEmpty, 'Insufficient Amount', 'Please note that the amount to withdraw can not be zero.');

  registerFieldType('branchcode', function(e) {
    var s = clean($(e).val());
    if (s.length == 3) {
      return true;
    }

    return false;
  }, 'Payment', 'The Branch Code should consist of 3 digits.');


  registerFieldType('accountnumber', isEmpty, 'Payment', 'Please enter the Account Number.');

  registerFieldType('bank', isEmpty, 'Payment', 'Please enter the name of the Bank.');
  registerFieldType('bankaddress', isEmpty, 'Payment', 'Please enter the Bank Address.');
  registerFieldType('accountname', isEmpty, 'Payment', 'Please enter the Bank Account Holder Name.');
  registerFieldType('swift', isEmpty, 'Payment', 'Please enter SWIFT/BIC/National Bank ID.');
  registerFieldType('iban', isEmpty, 'Payment', 'Please enter Account Number/IBAN.');
  registerFieldType('chequebank', isEmpty, 'Payment', 'Please enter the name of the Bank.');
  registerFieldType('chequeaccountname', isEmpty, 'Payment', 'Please enter the Bank Account Holder Name.');
  registerFieldType('credit', isAnything, null, null, optionalValidator);

  // special sell payment method fields
  registerFieldType('abaroutingnumber', function(e) {
    var routingnumber = clean($(e).val());
    if (/^(\d{9})$/.test(routingnumber)) {
      return true;
    }

    return false;
  }, 'Payment', 'The ABA Routing Number for US bank accounts must consist of 9 digits. Please enter an ABA Routing Number consisting of 9 digits.');

  registerFieldType('gbpsortcode', function(e) {
    var gbpsortcode = clean($(e).val());
    if (/^(\d{2}-\d{2}-\d{2})$/.test(gbpsortcode)) {
      return true;
    }

    return false;
  }, 'Payment', 'The Sort Code for UK bank accounts must consist of 6 digits. Please enter a Sort Code consisting of 6 digits.');

  registerFieldType('nzdaccountnumber', function(e) {
    var accountnumber = clean($(e).val());
    if (/^(\d{2}-\d{4}-\d{7}-\d{2,3})$/.test(accountnumber)) {
      return true;
    }

    return false;
  }, 'Payment', 'New Zealand bank account numbers consist of 15 or 16 digits. Please enter a bank account number consisting of 15 or 16 digits. ');

  registerFieldType('audbsbcode', function(e) {
    var bsbcode = clean($(e).val());
    if (/^(\d{3}-\d{3})$/.test(bsbcode)) {
      return true;
    }

    return false;
  }, 'Payment', 'The BSB Code for Australian bank accounts must consist of 6 digits. Please enter a BSB Code consisting of 6 digits.');

  registerFieldType('address', function(e) {
    var address = clean($(e).val());
    if (/^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,59}$/.test(address)) {
      return true;
    }

    if (address.length > 10) {
      sendUserErrorReport('BTC Address Validation', address + ' is not valid.');
    }

    return false;
  }, 'Payment', 'Please enter a valid Bitcoin address.');

  registerFieldType('bchaddress', function(e) {
    var address = clean($(e).val());
    if (/^[13M][a-km-zA-HJ-NP-Z1-9]{25,34}$/.test(address)) {
      return true;
    }

    if (/^([pq])[a-zA-HJ-NP-Z0-9]{41}$/.test(address)) {
      return true;
    }

    if (address.length > 10) {
      sendUserErrorReport('BCH Address Validation', address + ' is not valid.');
    }
    return false;
  }, 'Payment', 'Please enter a valid Bitcoin Cash address.');

  registerFieldType('ethaddress', function(e) {
    var address = clean($(e).val());
    if (/^(0x){1}[0-9a-fA-F]{40}$/.test(address)) {
      // check if it has the basic requirements of an address
      return true;
    }

    if (address.length > 10) {
      sendUserErrorReport('ETH Address Validation', address + ' is not valid.');
    }
    return false;
  }, 'Payment', 'Please enter a valid Ethereum address.');

  registerFieldType('xautaddress', function(e) {
    var address = clean($(e).val());
    if (/^(0x){1}[0-9a-fA-F]{40}$/.test(address)) {
      // check if it has the basic requirements of an address
      return true;
    }

    if (address.length > 10) {
      sendUserErrorReport('XAUT Address Validation', address + ' is not valid.');
    }
    return false;
  }, 'Payment', 'Please enter a valid XAUT (Tether Gold) address.');

  registerFieldType('paxgaddress', function(e) {
    var address = clean($(e).val());
    if (/^(0x){1}[0-9a-fA-F]{40}$/.test(address)) {
      // check if it has the basic requirements of an address
      return true;
    }

    if (address.length > 10) {
      sendUserErrorReport('PAXG Address Validation', address + ' is not valid.');
    }
    return false;
  }, 'Payment', 'Please enter a valid PAXG (PAX Gold) address.');

  registerFieldType('ltcaddress', function(e) {
    var address = clean($(e).val());
    if (/^([LM3]{1}[a-km-zA-HJ-NP-Z1-9]{26,33}||ltc1[a-z0-9]{39})$/.test(address)) {
      return true;
    }

    if (address.length > 10) {
      sendUserErrorReport('LTC Address Validation', address + ' is not valid.');
    }
    return false;
  }, 'Payment', 'Please enter a valid Litecoin address.');

  registerFieldType('xdgaddress', function(e) {
    var address = clean($(e).val());
    if (/^[D][a-km-zA-HJ-NP-Z1-9]{33}$/.test(address)) {
      return true;
    }

    if (address.length > 10) {
      sendUserErrorReport('XDG Address Validation', address + ' is not valid.');
    }
    return false;
  }, 'Payment', 'Please enter a valid Dogecoin address.');

  registerFieldType('alert-value', isEmpty, null, 'Please enter the spot price for which you would like to set the alert.');

  registerFieldType('shipping-name', isEmpty, null, 'Please enter the name of the recipient.');
  registerFieldType('shipping-address1', isEmpty, null, 'Please enter the address of the recipient.');
  registerFieldType('shipping-address2', isAnything, null, null, optionalValidator);
  registerFieldType('shipping-postcode', isValidPostalCode, null, 'Please enter the post code of the recipient.');
  registerFieldType('shipping-city', isEmpty, null, 'Please enter the city of the recipient.');
  registerFieldType('shipping-state', isValidState, null, 'Please select a state of the recipient.');
  registerFieldType('creditcard-number', function(e) {
    var prefix = {
      mastercard: /^(5|2)[1-5][0-9]{14}$/,
      visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      unionpay: /^(62|63|69|8)\d+$/,
    }

    var isValidCard = false;
    for (var key in prefix) {
      if (prefix[key].test($(e).val().replace(/ /g, ''))) {
        isValidCard = true
        console.log('Card is ' + key)
      }
    }
    return isValidCard
  }, 'Invalid Card Details', 'Only Visa, Mastercard, JCP and UnionPay are accepted.');
  registerFieldType('creditcard-number', function(e) {
    return $(e).val().replace(/ /g, '').length === 16
  }, 'Invalid Card Details', 'The card number you have input appears to be invalid. Please try again.');

  registerFieldType('creditcard-exp-mm', function(e) {
    var val = $(e).val().padStart(2, '0');
    var accepted = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    return ($.inArray(val, accepted) !== -1)
  }, 'Invalid Card Details', 'The expiry month ("Exp MM") must consist of 2 digits, for example, "01" for January.');
  registerFieldType('creditcard-exp-yy', function(e) {
    var val = $(e).val().substring(-2);
    var date = new Date();
    var year = date.getFullYear();
    var formattedYear = parseInt(year.toString().substring(-2));
    return val <= formattedYear + 50 && val >= formattedYear
  }, 'Invalid Card Details', 'The expiry year ("Exp YY") must consist of 2 digits, e.g. "24" for 2024.');
  registerFieldType('creditcard-exp-cvv', isEmpty, 'Invalid Card Details', 'Please enter the 3-digit security CVV number on the back of your card.');
  registerFieldType('creditcard-holder-name', isEmpty, 'Invalid Card Details', 'Please enter the cardholder name.');
  registerFieldType('personal-letter', isEmpty, 'Careers', 'Please write a text for personal letter and/or comments.');

  registerFieldType('unlock-account-full-name', isEmpty, 'Unlock Account or Reset PIN Number', 'Please enter your full name.');
  registerFieldType('unlock-account-email', isEmpty, 'Unlock Account or Reset PIN Number', 'Please enter your email.');
  registerFieldType('unlock-account-phone-number', isEmpty, 'Unlock Account or Reset PIN Number', 'Please enter your mobile phone number.');
  registerFieldType('unlock-account-file1', isMaxFileSize, 'Unlock Account or Reset PIN Number', 'Document 1: The maximum allowed file size is 10 MB. Please re-upload a file with a size within the limit.');
  registerFieldType('unlock-account-file2', isMaxFileSize, 'Unlock Account or Reset PIN Number', 'Document 2: The maximum allowed file size is 10 MB. Please re-upload a file with a size within the limit.');
  registerFieldType('unlock-account-code', isEmpty, 'Unlock Account or Reset PIN Number', 'Please enter the security code sent to your email.');
  registerFieldType('cv-file', isMaxFileSize, 'Careers', 'The maximum allowed file size is 10 MB. Please re-upload a file with a size within the limit.');

  registerFieldType('affiliate-platforms', isEmpty, null, 'Please enter the promotion strategy & channels.');
  registerFieldType('affiliate-platform-links', isEmpty, null, 'Please enter the platform links.');
  registerFieldType('affiliate-audience-size', isEmpty, null, 'Please enter the audience size.');
  registerFieldType('affiliate-audience-profile', isEmpty, null, 'Please enter the audience profile.');
  registerFieldType('affiliate-strategy', isEmpty, null, 'Please enter the promotion strategy.');
  registerFieldType('affiliate-volume', isEmpty, null, 'Please enter the expected referral volume.');
  registerFieldType('affiliate-reason', isEmpty, null, 'Please enter the reason for partnering with BullionStar.');

  function isAnything(el) {
    return true;
  }

  function isEmpty(el) {
    if (clean(el.val()).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  function isValidPhone(el) {
    if (clean(el.val()).length >= 5) {
      return true;
    } else {
      return false;
    }
  }

  function isValidState(el) {
    console.log('TE' + $(el).closest('.form').children('.country-form-field').find('.country-select').val());
    if ($(el).closest('.form').children('.country-form-field').find('.country-select').val() === 'US') {
      console.log('US');
      console.log(el.val());
      // return clean(el.val()).length > 0;
      return clean(el.val()).length > 0 && $(el).closest('.state-form-select-field').find('option').filter(function(idx, opt) {
        return $(opt).val() === el.val();
      }).length > 0;
    } else {
      return true;
    }
  }

  function isValidPostalCode(el) {
    if ($(el).closest('.form').children('.country-form-field').find('.country-select').val() === 'US') {
      var input = clean(el.val());
      return /^\d{5}(-\d{4})?$/.test(input);

      // var postalCodePart1 = input;
      // if (input.indexOf('-') != -1) {
      //   var postalCodes = input.split('-');
      //   var suffix = postalCodes[1];
      //   if (!suffix || suffix.length != 4) {
      //     return false;
      //   }
      //   postalCodePart1 = postalCodes[0];
      // }

      // if (postalCodePart1.length != 5) {
      //   return false;
      // }

      // return true;
    }

    return isEmpty(el);
  }

  function clean(s) {
    return s.trim();
  }

  function isMaxFileSize(el) {
    var file = el.get(0).files;
    var fileSize = file[0] ? file[0].size : 0;

    if (fileSize >= 10485760) { // 10mb file/total form size.
      return false;
    } else {
      return true;
    }
  }

  // param: event
  // desc: allow only numbers to be type in
  //       used event in general (e.g keyup, keypress, keydown)
  function showNumberOnly(e) {
    return (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) ? false : true;
  }

  // param: event
  // desc: allow only numbers and decimal points and comma to be type in
  //       used event in general (e.g keyup, keypress, keydown)
  function showDecimalOnly(e) {
    return (e.which != 8 && e.which != 0 && e.which != 44 && e.which != 46 && (e.which < 48 || e.which > 57)) ? false : true;
  }

  // param: event
  // desc: check for same the value of text in two different element
  //       used in on blur event
  function getFormParent(el) {
    var p = el.closest('form');
    if (p.length == 0) {
      p = el.closest('.form-wrap');
    }

    return p;
  }

  // param: parent string
  // desc: focus on the first .error-field element
  //       used in form validation
  function focusOnFirstError(parent) {
    if ($(parent + ' .error-field').length) {
      $('body').scrollTop($(parent + ' .error-field').eq(0).find('input').offset().top);
      // Add a 300 miliseconds delay to see action happen
      setTimeout(function() {
        $(parent + ' .error-field').eq(0).find('input').trigger('focus');
      }, 300);
    }
  }

  // param: form parent
  // desc: clear all fileds, use default values
  //       used in form validation
  function resetForm(parent, className) {
    className = className || '.form-field';
    $(parent).find(className).each(function(i, field) {
      var $parent = $(field),
        $target = $parent.find('input').length ? $parent.find('input') :
        ($parent.find('select').length ? $parent.find('select') : $parent.find('textarea'));
      $parent.find('label').removeClass('active');
      showDefault(null, $target);

      // Check if target has both input and select field. Most Probably in mobile field
      if ($target.is('input') && $parent.find('select').length) {
        $target2 = $parent.find('select');
        $target2[0].selectedIndex = 0;
        $target2.change();
      }

      $target.is('input') || $target.is('textarea') ? $target.val('') : $target[0].selectedIndex = 0;
    });
  }

  function showError(formParent, param) {
    if (param != null && param.length > 0) {
      showIndicatorFail(null, $(formParent).find('input[data-param="' + param + '"]'));
      focusOnFirstError(formParent);
    }
  }

  return {
    validateForm: validateForm,
    addData: addData,
    addDataFromInputAndSelect: addDataFromInputAndSelect,

    showNumberOnly: showNumberOnly,
    showDecimalOnly: showDecimalOnly,

    focusOnFirstError: focusOnFirstError,
    resetForm: resetForm,
    showError: showError,

  }
}());

/* Add for mocha testing */
// Basically it make the accountModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = formValidationModule;
}
/***********************************************************/
/***********************************************************/
/* Inquiry Module */
/***********************************************************/
/***********************************************************/

var inquiryModule = (function() {
  var url = '/account/inquiry/';

  /*
    DESC: Send product inquiry. USED IN: /buy/product/*
    POST /api/v1/inquiry/send
    productId
    code
    name
    email 
    question
  */
  function send(data, cb) {
    data.code = 'fred';
    var req = new Request(servicesUrl + url + 'send', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res)
      }
    });

    req.call();
  }

  return {
    send: send
  }

}());

/* Add for mocha testing */
// Basically it make the inquiryModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = inquiryModule;
}
/***********************************************************/
/***********************************************************/
/* Product Inquiry Module */
/***********************************************************/
/***********************************************************/

var productInquiryModule = (function() {
  var url = '/api/v1/productInquiry/';

  /*
    DESC: Send product inquiry. USED IN: /buy/product/*
    POST /api/v1/productInquiry/send
    productId
    code
    name
    email
    message
  */
  function send(data, cb) {
    data.code = 'fred';
    var req = new Request(servicesSGUrl + url + 'send', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res)
      }
    });

    req.call();
  }

  return {
    send: send
  }

}());

/* Add for mocha testing */
// Basically it make the productInquiryModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = productInquiryModule;
}
function Popup(options) {
  var _this = this;
  if (typeof options.cancel == 'undefined') {
    options.cancel = false;
  }
  if (typeof options.context == 'undefined') {
    options.context = null;
  }
  if (typeof options.okCallback == 'undefined') {
    options.okCallback = null;
  }
  if (typeof options.cancelCallback == 'undefined') {
    options.cancelCallback = null;
  }
  if (typeof options.customButtons == 'undefined') {
    options.customButtons = false;
  }
  if (typeof options.wide == 'undefined') {
    options.wide = false;
  }
  if (typeof options.closeOnClickOutside == 'undefined') {
    options.closeOnClickOutside = true;
  }

  this.title = options.title;
  this.message = options.message;
  this.cancel = options.cancel;
  this.element = null;
  this.context = options.context;
  this.okCallback = options.okCallback;
  this.cancelCallback = options.cancelCallback;
  this.customButtons = options.customButtons;
  this.buttons = options.buttons;
  this.wide = options.wide;
  this.closeOnClickOutside = options.closeOnClickOutside;

  this.render = function() {
    var e = $('.backdrop2 .popup');
    if (e.length > 0) {
      console.log('popup exists, remove.');
      e.closest('.backdrop2').remove();
    }

    /*
    **** MARKUP *****
      <div class="loading-backdrop">
        <div class="popup">
          <div class="title">Sample Title</div>
          <div class="body">
            <div class="message">Sample Message</div>

            <div class="buttons">
              <button class="btn-common-radius ok">OK</button>
              <button class="btn-common-radius cancel">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    **** MARKUP *****
    */

    this.element = $('<div class="backdrop2"></div>');
    var $popup = $('<div class="popup"></div>');

    if (this.wide) {
      $popup.addClass('wide');
    }

    $popup.on('click', function(e) {
      e.stopPropagation();
    });

    $popup.data('popup', this);
    var $title = $('<div class="title">' + this.title + '</div>');

    $popup.append($title);

    var $body = $('<div class="body"></div>');
    $popup.append($body);

    var message = $('<div class="message">' + this.message + '</div>');
    $body.append(message);

    var $buttons = $('<div class="buttons text-center"></div>');

    if (this.customButtons) {
      $.each(this.buttons, function(i, btn) {
        if (btn.link) {
          var button = $('<a href="' + btn.action + '" class="btn-common-radius">' + btn.name + '</a>');
          $buttons.append(button);
        } else {
          var button = $('<button class="btn-common-radius">' + btn.name + '</button>');
          if (btn.action === 'close') {
            button.on('click', function(e) {
              _this.close();
            });
          } else if (btn.action === 'reload') {
            button.on('click', function(e) {
              window.location.href = window.location.href;
            });
          } else if (btn.action === 'callback') {
            button.on('click', function(e) {
              _this.close();
              btn.callback();
            });
          }
          $buttons.append(button);
        }
      });

    } else {
      var $ok = $('<button class="btn-common-radius ok">OK</button>');

      // Click on Ok
      $ok.on('click', function() {
        _this.okClicked();
      });

      $buttons.prepend($ok);
    }

    if (this.cancel) {
      var $cancel = $('<button class="btn-common-radius cancel">Cancel</button>');
      $buttons.prepend($cancel);
      // Click on Cancel
      $cancel.on('click', function() {
        _this.cancelClicked();
      });
    }

    $body.append($buttons);
    this.element.append($popup);

    $('body').append(this.element);

    this.element.on('click', function(e) {
      if (_this.closeOnClickOutside) {
        _this.close();
      }
      typeof options.clickOutsideCallback === 'function' && options.clickOutsideCallback();
    });

    if (!this.customButtons) {
      $ok.trigger('focus');
    }

  };

  this.okClicked = function() {
    this.close();
    if (this.okCallback != null) {
      this.okCallback(this.context);
    }
  };

  this.cancelClicked = function() {
    this.element.remove();
    console.log('CANCEL CLICKED')
    if (this.cancelCallback != null) {
      this.cancelCallback(this.context);
    }
  };

  this.close = function() {
    this.element.remove();
    // if(this.okCallback != null) {
    //   this.okCallback(this.context);
    // }
  }
}

function Loading() {

  this.render = function() {
    var e = $('.backdrop2 .bullion-loader');
    if (e.length > 0) { // loader is showing, inc stack
      console.log('Loading().render : found stack is:' + e.attr('stack') + 'html is: ' + e.html());
      var stack = parseInt(e.attr('stack'));
      stack++;
      e.attr('stack', stack);
      console.log('Loading().render : exists stack is now=' + stack);
    } else {
      $('body').append($('<div class="backdrop2"><div class="loading"><div class="bullion-loader" stack="1"></div></div></div>'));
      console.log('Loading().render : created new stack is now=1');
    }
  }

  this.close = function() {
    var e = $('.backdrop2 .bullion-loader');
    if (e.length > 0) { // loader is showing, dec stack
      var stack = parseInt(e.attr('stack'));
      stack--;
      if (stack <= 0) {
        e.closest('.backdrop2').remove();
        console.log('Loading().close : stack is 0. Removing element.');
      } else {
        e.attr('stack', stack);
        console.log('Loading().close : stack is now=' + stack);
      }
    } else {
      console.log('Loading().close : no element');
    }
  };

  this.isShowing = function() {
    return $('.bullion-loader').length > 0;
  };
}

function PopupLogin(options) {
  var _this = this;

  if (typeof options == 'undefined' || typeof options.withOutSignUp == 'undefined') {
    this.withOutSignUp = false;
  } else {
    this.withOutSignUp = true;
  }

  if (typeof options == 'undefined' || typeof options.redirectOnClose == 'undefined') {
    this.redirectOnClose = false;
  } else {
    this.redirectOnClose = true;
  }

  if (typeof options == 'undefined' || typeof options.shouldReloadPageOnLoginSuccess == 'undefined') {
    this.shouldReloadPageOnLoginSuccess = false;
  } else {
    this.shouldReloadPageOnLoginSuccess = true;
  }

  this.defaultHeading = 'Login - BullionStar Account';
  this.defaultMessage = '';
  if (!(typeof options == 'undefined' || typeof options.form == 'undefined')) {
    this.defaultHeading = options.form.heading;
    this.defaultMessage = '<p class="message">' + options.form.message + '</p>';
  }

  this.render = function() {
    var signUp = '<div class="register"><h3>New to BullionStar? <a href="/createaccount">Sign Up</a></h3></div>';
    if (this.withOutSignUp) {
      signUp = '';
    }
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-login"> <!-- start popup-login -->' +
      '<span class="btn-close-popup">' +
      ' <img src="' + cdnUrl + '/img/icon_close.svg" alt="Close" />' +
      '</span>' +
      '<div class="login">' +
      '<h3>' + this.defaultHeading + '</h3>' +
      this.defaultMessage +
      '<form>' +
      '<div class="form-wrap">' +
      '<div class="form-field">' +
      '<span class="icon icon-email"></span>' +
      '<label>Email</label>' +
      '<input type="email" name="email" maxlength="100" class="txt-required txt-login-email" autocomplete="false" data-input-type="email" data-param="email">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="form-field">' +
      '<span class="icon icon-lock"></span>' +
      '<label>Password</label>' +
      '<input type="password" data-input-type="password" data-param="hashedPassword" data-enter-action=".popup-login #btn-popup-login">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<p class="forgot-wrap"><a href="javascript:void(0);" class="forgot">Forgot your password?</a></p>' +
      '<div class="btn-common" id="btn-popup-login">Login</div>' +
      '</div>' +
      '</form>' +
      signUp +
      '</div>' +
      '</div> <!-- end popup-login -->';
    this.element.append(markup);

    $('body').append(this.element);

    if (window.stringContainerCreds.e.length && window.stringContainerCreds.p.length) {
      $('.popup-login input[type="email"]').val(window.stringContainerCreds.e).trigger('keyup');
      $('.popup-login input[type="email"]').prev().addClass('active');
      $('.popup-login input[type="password"]').val(window.stringContainerCreds.p).trigger('keyup');
      $('.popup-login input[type="password"]').prev().addClass('active');
    }

    this.element.on('click', function() {
      return false;
    });

    $('#btn-popup-login').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.form-wrap'), 'Login', function(data) {
        authenticationModule.login(data, function() {
          if (_this.shouldReloadPageOnLoginSuccess) {
            window.location.reload();
          }
          _this.close();
        });
      }, null, true);
    });

    this.element.find('.popup-login').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-login').on('click', '.btn-close-popup', function(e) {
      _this.close();

      if (_this.redirectOnClose) {
        window.location.href = '/';
      }
    });

    $('.popup-login').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    $('.popup-login').on('click', '.forgot', function(e) {
      var popup = new PopupResetPW();
      popup.render();
    });

    this.element.find('.popup-login input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }

  /*
  **** MARKUP *****
    <div class="popup-login"> <!-- start popup-login -->
      <a href="javascript:void(0);" class="btn-close-popup">
        <img src="/img/m/icon-close.svg" alt="Close" />
      </a>
      <div class="login">
        <h3><span class="image"></span>Login - BullionStar Account</h3>
        <div class="form-wrap">
          <div class="form-field">
            <span class="icon icon-email"></span>
            <label>Email</label>
            <input type="email" maxlength="100" class="txt-required txt-login-email" autocomplete="false" data-input-type="email" data-param="email">
            <span class="image hide"></span>
          </div>
          <div class="form-field with-forgot">
            <span class="icon icon-lock"></span>
            <label>Password</label>
            <input type="password" autocomplete="new-password" data-input-type="password" data-param="hashedPassword" data-enter-action=".popup-login .btn-sign-in">
            <span class="image hide"></span>
            <a href="javascript:void(0);" class="forgot">forgot?</a>
          </div>
          <div class="btn-common btn-sign-in">Login</div>
        </div>
        <h3>New to BullionStar?</h3>
        <div class="btn-common btn-register">Sign Up</div>
      </div>
    </div> <!-- end popup-login -->
  **** MARKUP *****
  */
}

function PopupTrustedMachine() {

  var _this = this;

  this.render = function(token) {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-trusted-machine"> <!-- start popup-trusted-machine -->' +
      '<h3 class="title">Login Verification: 2-Factor Authentication</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="content form-wrap">' +
      '<p class="description">It appears that you are trying to access your BullionStar account from a new computer or browser. We have sent you an access code to your e-mail. Please enter the code sent to your e-mail in the field below.</p>' +
      '<div class="form-field no-icon">' +
      '<label>Code</label>' +
      '<input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code" data-enter-action=".popup-trusted-machine #btn-trusted-machine-code">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="btn-common" id="btn-trusted-machine-code">OK</div>' +
      '</div>' +
      '</div> <!-- end popup-trusted-machine -->';
    this.element.append(markup);
    this.element.data('token', token);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('.popup-trusted-machine').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('#btn-trusted-machine-code').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.popup-trusted-machine'), 'Login', function(data) {
        data.twoFactorMachineToken = _this.element.data('token');
        authenticationModule.authenticateMachine(data);
      }, null, true);
    });

    this.element.find('.popup-trusted-machine').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-trusted-machine').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    this.element.find('.popup-trusted-machine input').eq(0).trigger('focus');
  };

  this.close = function() {
    this.element.remove();
  };

  /*
  **** MARKUP *****
    <div class="popup-trusted-machine"> <!-- start popup-trusted-machine -->
      <h3 class="title">Login Verification: 2-Factor Authentication</h3>
      <div class="content">
        <p class="description">It appears that you are trying to access your BullionStar account from a new computer or browser. We have sent you an access code to your e-mail. Please enter the code sent to your e-mail in the field below.</p>
        <div class="form-field no-icon">
          <label>Code</label>
          <input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code">
          <span class="image hide"></span>
        </div>
        <div class="btn-common" id="btn-trusted-machine-code">OK</div>
      </div>
    </div> <!-- end popup-trusted-machine -->
  **** MARKUP *****
  */
}

function PopupAuthenticateIP() {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-authenticate-ip"> <!-- start popup-authenticate-ip -->' +
      '<h3 class="title">Authenticate IP</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="content form-wrap">' +
      '<p class="description">Please enter our authentication code.</p>' +
      '<div class="form-field no-icon">' +
      '<label>Code</label>' +
      '<input type="password" autocomplete="false" data-input-type="auth-code" data-param="code" data-enter-action=".popup-authenticate-ip #btn-authenticate-ip">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="btn-common" id="btn-authenticate-ip">OK</div>' +
      '</div>' +
      '</div> <!-- end popup-authenticate-ip -->';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('.popup-authenticate-ip').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('#btn-authenticate-ip').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.popup-authenticate-ip'), 'Login', function(data) {
        authenticationModule.authenticateIP(data);
      }, null, true);
    });

    this.element.find('.popup-authenticate-ip').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-authenticate-ip').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    this.element.find('.popup-authenticate-ip input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }

  /*
  **** MARKUP *****
    <div class="popup-authenticate-ip"> <!-- start popup-authenticate-ip -->
      <h3 class="title">Authenticate IP</h3>
      <div class="content form-wrap">
        <p class="description">Please enter our authentication code.</p>
        <div class="form-field no-icon">
          <label>Code</label>
          <input type="password" autocomplete="false" data-input-type="auth-code" data-param="code" data-enter-action=".popup-authenticate-ip #btn-code">
          <span class="image hide"></span>
        </div>
        <div class="btn-common" id="btn-code">OK</div>
      </div>
    </div> <!-- end popup-authenticate-ip -->
  **** MARKUP *****
  */
}

function PopupTwoFactorAuth() {

  var _this = this;

  this.render = function(token) {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-2fa"> <!-- start popup-2fa -->' +
      '<h3 class="title">2-Factor Authentication</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="content form-wrap">' +
      '<p class="description">Please enter the code sent to your mobile phone in the field below.</p>' +
      '<div class="form-field-with-button clearfix">' +
      '<div class="form-field no-icon pull-left">' +
      '<label>2-Factor Code</label>' +
      '<input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code" data-enter-action=".popup-2fa #btn-send-2fa">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="btn-resend btn-common pull-right disabled">Re-Send <span></span></div>' +
      '</div>' +
      '<div class="btn-common" id="btn-send-2fa">OK</div>' +
      '</div>' +
      '</div> <!-- end popup-2fa -->';
    this.element.append(markup);
    this.element.data('token', token);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('#btn-send-2fa').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.popup-2fa'), 'Login', function(data) {
        data.twoFactorToken = _this.element.data('token');
        authenticationModule.sendTwoFactorAuth(data);
      }, null, true);
    });

    this.element.find('.popup-2fa').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-2fa').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    $('.popup-2fa').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('.popup-2fa').on('click', '.btn-resend', function(e) {
      authenticationModule.resendTwoFactorCode({
        twoFactorToken: _this.element.data('token')
      });
    });

    this.element.find('.popup-2fa input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }

  /*
  **** MARKUP *****
    <div class="popup-2fa"> <!-- start popup-2fa -->
      <h3 class="title">2-Factor Authentication</h3>
      <a href="javascript:void(0);" class="btn-close-popup">
        <img src="<?php echo $GLOBALS['cdnUrl']; ?>/img/m/icon-close.svg" alt="Close" />
      </a>
      <div class="content form-wrap">
        <p class="description">Please enter the code sent to your mobile phone in the field below.</p>

        <div class="form-field-with-button clearfix">
          <div class="form-field no-icon pull-left">
            <label>2-Factor Code</label>
            <input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code" data-enter-action=".popup-2fa .btn-common">
            <span class="image hide"></span>
          </div>
          <div class="btn-resend btn-common pull-right disabled">Re-Send <span></span></div>
        </div>

        <div class="btn-common" id="btn-send-2fa">OK</div>
      </div>
    </div> <!-- end popup-2fa -->
  **** MARKUP *****
  */
}

function PopupTwoFactorAuthNoAccount(options) {

  this.phoneNumber = options.phoneNumber;
  this.phoneCountry = options.phoneCountry;
  this.code = options.code || '';

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-2fa-no-account"> <!-- start popup-2fa-no-account -->' +
      '<h3 class="title">2-Factor Authentication</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="content form-wrap">' +
      '<p class="description">Please enter the code sent to your mobile phone in the field below.</p>' +
      '<div class="form-field-with-button clearfix">' +
      '<div class="form-field no-icon pull-left">' +
      '<label>2-Factor Code</label>' +
      '<input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code" data-enter-action=".popup-2fa-no-account #btn-send-2fa-no-account">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="btn-resend btn-common pull-right disabled">Re-Send <span></span></div>' +
      '</div>' +
      '<div class="btn-common" id="btn-send-2fa-no-account" data-code="' + this.code + '">OK</div>' +
      '</div>' +
      '</div> <!-- end popup-2fa-no-account -->';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('.popup-2fa-no-account').on('click', '#btn-send-2fa-no-account', function() {
      console.log($(this).data('code'));
      if ($(this).data('code') == $('.popup-2fa-no-account > .content input').val()) {
        _this.close();
        $('#two-factor-auth-sms')[0].checked = true;
        twoFACompletedSMS = true;
        $('#btn-create-account').trigger('click');
      } else {
        var options = {
          title: '2-Factor Authentication',
          message: 'The entered code was incorrect. Please try again.',
          okCallback: function() {
            $('.popup-2fa-no-account > .content input').trigger('focus');
          }
        };
        var popup = new Popup(options);
        popup.render();
      }
    });

    this.element.find('.popup-2fa-no-account').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-2fa-no-account').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    $('.popup-2fa-no-account').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('.popup-2fa-no-account').on('click', '.btn-resend', function(e) {
      var data = {};
      data.phoneNumber = _this.phoneNumber;
      data.phoneCountry = _this.phoneCountry;
      data.code = $('.btn-activate-no-account').data('code');
      accountModule.activate2FANoAccount(data, function() {
        _this.close();
      })
    });

    this.element.find('.popup-2fa-no-account input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }

  /*
  **** MARKUP *****
    <div class="popup-2fa-no-account"> <!-- start popup-2fa-no-account -->
      <h3 class="title">2-Factor Authentication</h3>
      <a href="javascript:void(0);" class="btn-close-popup">
        <img src="<?php echo $GLOBALS['cdnUrl']; ?>/img/m/icon-close.svg" alt="Close" />
      </a>
      <div class="content form-wrap">
        <p class="description">Please enter the code sent to your mobile phone in the field below.</p>

        <div class="form-field-with-button clearfix">
          <div class="form-field no-icon pull-left">
            <label>2-Factor Code</label>
            <input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code" data-enter-action=".popup-2fa-no-account .btn-common">
            <span class="image hide"></span>
          </div>
          <div class="btn-resend btn-common pull-right disabled">Re-Send <span></span></div>
        </div>

        <div class="btn-common" id="btn-send-2fa-no-account">OK</div>
      </div>
    </div> <!-- end popup-2fa-no-account -->
  **** MARKUP *****
  */
}

function PopupTwoFactorAuthDetails() {

  var _this = this;

  this.render = function(token) {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-details-2fa"> <!-- start popup-details-2fa -->' +
      '<h3 class="title">2-Factor Authentication</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="content form-wrap">' +
      '<p class="description">Please enter the code sent to your mobile phone in the field below.</p>' +
      '<div class="form-field-with-button clearfix">' +
      '<div class="form-field no-icon pull-left">' +
      '<label>2-Factor Code</label>' +
      '<input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code" data-enter-action=".popup-details-2fa #btn-activate-2fa">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="btn-resend btn-common pull-right disabled">Re-Send <span></span></div>' +
      '</div>' +
      '<div class="btn-common" id="btn-activate-2fa">OK</div>' +
      '</div>' +
      '</div> <!-- end popup-details-2fa -->';
    this.element.append(markup);
    this.element.data('token', token);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('#btn-activate-2fa').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.popup-details-2fa'), '2-Factor Authentication', function(data) {
        data.twoFactorToken = _this.element.data('token');
        accountModule.activate2FACode(data, function() {
          _this.close();
        });
      }, null, true);
    });

    this.element.find('.popup-details-2fa').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-details-2fa').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    $('.popup-details-2fa').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('.popup-details-2fa').on('click', '.btn-resend', function(e) {
      accountModule.resend2FACode();
    });

    this.element.find('.popup-details-2fa input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }

  /*
  **** MARKUP *****
    <div class="popup-details-2fa"> <!-- start popup-details-2fa -->
      <h3 class="title">2-Factor Authentication</h3>
      <a href="javascript:void(0);" class="btn-close-popup">
        <img src="<?php echo $GLOBALS['cdnUrl']; ?>/img/m/icon-close.svg" alt="Close" />
      </a>
      <div class="content form-wrap">
        <p class="description">Please enter the code sent to your mobile phone in the field below.</p>

        <div class="form-field-with-button clearfix">
          <div class="form-field no-icon pull-left">
            <label>2-Factor Code</label>
            <input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code" data-enter-action=".popup-details-2fa .btn-common">
            <span class="image hide"></span>
          </div>
          <div class="btn-resend btn-common pull-right disabled">Re-Send <span></span></div>
        </div>

        <div class="btn-common" id="btn-send-2fa">OK</div>
      </div>
    </div> <!-- end popup-details-2fa -->
  **** MARKUP *****

  */
}

function PopupResetPW() {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-reset-password"> <!-- start popup-reset-password -->' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<h3 class="title">Reset Password</h3>' +
      '<div class="content form-wrap">' +
      '<p class="description">Enter your account e-mail address below to generate an e-mail with a link to set a new password.</p>' +
      '<form>' +
      '<div class="form-field">' +
      '<span class="icon icon-email"></span>' +
      '<label>Email</label>' +
      '<input type="email" name="email" maxlength="100" autocomplete="false" data-input-type="new-email" data-param="email" data-enter-action=".popup-reset-password #btn-reset-password">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '</form>' +
      '<div class="btn-common" id="btn-reset-password">Reset Password</div>' +
      '</div>' +
      '</div> <!-- end popup-reset-password -->'
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('#btn-reset-password').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.popup-reset-password'), 'Login', function(data) {
        accountModule.forgotPassword(data, function() {
          _this.close();
        });
      }, null, true);
    });

    this.element.find('.popup-reset-password').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-reset-password').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    $('.popup-reset-password').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    this.element.find('.popup-reset-password input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }

  /*
  **** MARKUP *****
    <div class="popup-reset-password"> <!-- start popup-reset-password -->
      <a href="javascript:void(0);" class="btn-close-popup">
        <img src="/img/m/icon-close.svg" alt="Close" />
      </a>
      <h3 class="title">Reset Password</h3>
      <div class="create-account">
        <p class="description">Enter your account e-mail address below to generate an e-mail with a link to set a new password.</p>
        <div class="form-field">
          <span class="icon icon-email"></span>
          <label>Email</label>
          <input type="email" maxlength="100" autocomplete="false" data-input-type="new-email" data-param="email">
          <span class="image hide"></span>
        </div>
        <div class="btn-common" id="btn-reset-password">Reset Password</div>
      </div>
    </div> <!-- end popup-reset-password -->
  **** MARKUP *****
  */
}

function PopupAddAlert() {
  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-add-alerts"> <!-- start popup-add-alerts -->' +
      '<div class="body">' +
      '<header class="title">Market Alert Set</header>' +
      '<div class="content">' +
      '<p>Your market alert has been set and can be found under Active Alerts on this page. An e-mail and/or SMS notification will be sent to you when the price hits your set market price.</p>' +
      '<div class="checkbox-one-line">' +
      '<input type="checkbox" id="dont-show-again-alert-add" value="true">' +
      '<label for="dont-show-again-alert-add">' +
      '<span class="bullion-checkbox"></span>' +
      'Don\'t show this again.' +
      '</label>' +
      '</div>' +
      '</div>' +
      '<div class="buttons">' +
      '<div class="btn-common-radius btn-close-popup">OK</div>' +
      '</div>' +
      '</div>' +
      '</div> <!-- end popup-add-alerts -->';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-add-alerts').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-add-alerts').on('click', '#dont-show-again-alert-add', function() {
      if ($(this).is(':checked')) {
        createCookie('addAlertDontShow', true, 3650);
      } else {
        eraseCookie('addAlertDontShow');
      }
    });

    $('.popup-add-alerts').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupTNC(title, content) {
  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-tnc">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<h3 class="title">' + title + '</h3>' +
      '<div class="body">' + content + '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-tnc').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-tnc').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    this.element.on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupPhotos(options) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-photos">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="body">' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-photos').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-photos').on('click', '.open-original-photo', function(e) {
      e.preventDefault();
      var popup = new PopupPhotosOriginalSize($(this).data('url'), $(this).data('title'));
      popup.render();
    });

    $('.popup-photos').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupPhotosOriginalSize(src, title) {
  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop3"></div>');
    var markup = '<div class="popup-photos-original-size">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="body">' +
      '<div class="loading"><div class="bullion-loader"></div></div>' +
      '<img src="' + src + '" alt="' + title + '">' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-photos-original-size').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-photos-original-size').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupDocumentUpload() {
  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-document-upload"> <!-- start popup-document-upload -->' +
      '<header class="title">Document Uploader</header>' +
      '<div class="body">' +
      '<p>Uploading Document(s)</p>' +
      '<div class="content">' +
      '<div class="progress-upload">' +
      '<div class="bar"></div>' +
      '</div>' +
      '<div class="text-center">' +
      '<div class="btn-common" id="btn-cancel">Cancel</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div> <!-- end popup-document-upload -->';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-document-upload').on('click', function(e) {
      e.stopPropagation();
    });

  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupMyaccountBullionPhotos(options) {

  this.title = options.title;
  this.src = options.src;

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-myaccount-bullion-photo">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<p class="title">' + this.title + '<p>' +
      '<div class="body">' +
      '<img src="' + scaleImage(this.src, 260, 260) + '" srcset="' + scaleImage(this.src, 260, 260) + ' 1x, ' + scaleImage(this.src, 520, 520) + ' 2x" alt="' + this.title + '">' +
      '<div class="loading"><div class="bullion-loader"></div></div>' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-myaccount-bullion-photo').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-myaccount-bullion-photo').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupYoutube(src) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-youtube">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/d/close-thick.svg" alt="Close" width="30" />' +
      '</span>' +
      '<div class="embed-responsive embed-responsive-16by9">' +
      '<iframe allowfullscreen="" allow="autoplay" class="embed-responsive-item" frameborder="0" src="' + src + '"></iframe>' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      _this.close();
    });

    this.element.find('.popup-youtube').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-youtube').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupVirtualTour(src) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-virtual-tour">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/d/close-thick.svg" alt="Close" width="30" />' +
      '</span>' +
      '<div class="virtual-tour-box">' +
      '<div class="embed-responsive embed-responsive-4by3"><iframe class="embed-responsive-item" frameborder="0" height="450" src="https://www.google.com/maps/embed?pb=!1m0!3m2!1sen!2ssg!4v1421761175214!6m8!1m7!1s-p6O1HstDhEAAAQZN2nbag!2m2!1d1.288311!2d103.847016!3f81!4f0!5f1.4214797185029173"></iframe></div>' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      _this.close();
    });

    this.element.find('.popup-virtual-tour').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-virtual-tour').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupAddedItemCart(tier, cart, productId, changes) {

  var _this = this;
  this.tiers = tier;
  this.currentTier = 0;
  this.cart = cart;
  this.entry = [];
  this.quantityAdjustedStr = 'The quantity has been changed.';

  this.buildCartItem = function(entry) {

    var msg = '';
    // changes will always be 1
    if (changes.length) {
      msg = '<div class="warning"><p class="message">' + changes[0].message + '</p><span class="close-box">OK</span></div>';
    }

    return '<section id="shopping-cart-add-popup-item-wrap-' + productId + '" class="shopping-cart-add-popup-item-wrap" data-qty="' + entry[0].quantity + '" data-id="' + productId + '">' +
      '<p class="title">' + entry[0].title + '</p>' +
      '<div class="item">' +
      '<figure class="image">' +
      '<img width="80" src="' + scaleImage(entry[0].imageUrl, 80, 80) + '" srcset="' + scaleImage(entry[0].imageUrl, 80, 80) + ' 1x, ' + scaleImage(entry[0].imageUrl, 160, 160) + ' 2x" alt="' + entry[0].title + '">' +
      '</figure>' +
      '<div class="info">' +
      '<p class="count-controls">' +
      '<input type="number" class="change txt-number quantity" maxlength="8" value="' + entry[0].quantity + '" pattern="[0-9]*" autocomplete="false">' +
      '<a href="javascript:void(0);" class="add"><img src="' + cdnUrl + '/img/d/plusone.svg" alt="Add" /></a>' +
      '</p>' +
      '<p class="price">' +
      entry[0].unitPrices[getCurrency()] + ' each' +
      '</p>' +
      '<p class="total">' +
      'Total: ' + entry[0].totalPrices[getCurrency()] +
      '</p>' +
      '</div>' +
      '</div>' +
      '</section>' +
      msg;
  }

  this.buildInfo = function(quantity) {
    if (this.tiers && this.tiers.length) {
      var tier = {};

      // Get current Tier
      this.tiers.some(function(t) {
        tier = t;
        if (quantity < t.fromQuantity) return true; // Stops function on running after getting the first tier that    satisfy the condition
      });

      if (quantity >= tier.fromQuantity) {
        $('.lower-price-text').remove();
        return ''; // Stops function from executing when there is no Tier left
      }

      var diff = tier.fromQuantity - quantity;

      if ($('.lower-price-text').length) {
        $('.lower-price-text').find('.add-to-lower').data('to-add', diff);
        $('.lower-price-text').find('.diff').html(diff);
        $('.lower-price-text').find('.amount').data('id', productId).data('qty', tier.fromQuantity);
        return;
      }

      $('<p class="lower-price-text"><a href="javascript:void(0);" class="add-to-lower" data-to-add="' + diff + '">Click here</a> to add <span class="diff">' + diff + '</span> more of this item to get a cheaper price of <span class="amount" data-id="' + productId + '" data-qty="' + tier.fromQuantity + '">' + tier.price[getCurrency()] + '</span> per unit.</p>').insertAfter('.shopping-cart-add-popup-item-wrap');
    }
    return '';
  }

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');

    this.entry = $.grep(this.cart, function(cart) {
      return cart.productId == productId;
    });

    var markup = '<div class="popup-added-item-cart"> <!-- start popup-added-item-cart -->' +
      '<h3 class="title">You\'ve Added This Item to Your Cart</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="body">' +
      this.buildCartItem(this.entry) +
      '<div class="buttons">' +
      '<div class="btn-common" id="btn-continue">Continue Shopping</div>' +
      '<a href="/buy/checkout" class="btn-common" id="btn-proceed">Proceed to Checkout</a>' +
      '</div>' +
      '<div class="checkbox-one-line full-width">' +
      '<input type="checkbox" id="dont-show-again-item-add" value="yes" name="show-again">' +
      '<label for="dont-show-again-item-add"><span class="bullion-checkbox"></span>' +
      'Don\'t show this again.' +
      '</label>' +
      '</div>' +
      '</div>' +
      '</div> <!-- end popup-added-item-cart -->';
    this.element.append(markup);

    $('body').append(this.element);

    this.buildInfo(this.entry[0].quantity);
    productModule.getProductPrice(getAllProductIdsArr(), getCurrency());

    this.element.find('.popup-added-item-cart').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('#btn-continue').on('click', function(e) {
      _this.close();
    });

    this.element.find('.btn-close-popup').on('click', function(e) {
      _this.close();
    });

    this.element.find('#dont-show-again-item-add').on('click', function(e) {
      if ($(this).is(':checked')) {
        createCookie('addToCartDontShow', true, 3650);
      } else {
        eraseCookie('addToCartDontShow');
      }
    });

    if (changes.length) {
      $('.close-box').on('click', function() {
        $(this).closest('.warning').remove();
      });
    }

    // Change Item in Shopping Cart popup
    // this.element.find('input.quantity').on('change', debounce(function(e) {
    //   var $self = $(this);

    //   if($self.val() > 0) {
    //     _this.buildInfo($self.val());
    //     $('#shopping-cart-item-' + productId).find('input.change').val($self.val()).trigger('change');
    //   } else {
    //     _this.buildInfo(0);
    //   }
    // }, 300));

    // Keyup after typing number Item in Shopping Cart popup
    this.element.find('input.quantity').on('keyup', debounce(function(e) {
      var $self = $(this);
      if (e.keyCode < 37 || e.keyCode > 40) {
        if ($self.val()) {
          _this.buildInfo($self.val());
        } else {
          _this.buildInfo(0);
        }
        $('#shopping-cart-item-' + productId).find('input.change').val($self.val()).trigger('change');
        productModule.getProductPrice(getAllProductIdsArr(), getCurrency());
      }
    }, 300));

    this.element.find('a.add').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var $self = $(this),
        $quantity = $self.prev(),
        curVal = parseInt($quantity.val()) || 0,
        val;

      if ($quantity.val() <= 0) {
        val = 1;
      } else if (curVal < 99999999) {
        val = curVal + 1;
      }

      $quantity.val(val);
      _this.buildInfo(val);

      $('#shopping-cart-item-' + productId).find('.change').val(val).trigger('change');
      //$('#shopping-cart-item-' + productId).find('a.add').trigger('click');
      productModule.getProductPrice(getAllProductIdsArr(), getCurrency());
    });

    $('.popup-added-item-cart').on('click', '.add-to-lower', function() {
      var $self = $(this),
        addAmount = parseInt($self.data('to-add'), 10),
        curVal = parseInt(_this.element.find('input.quantity').val(), 10) || 0,
        newVal = curVal + addAmount;

      _this.element.find('input.quantity').val(newVal);
      _this.buildInfo(newVal);
      $('#shopping-cart-item-' + productId).find('input.change').val(newVal).trigger('change');
      productModule.getProductPrice(getAllProductIdsArr(), getCurrency());
    });

    this.element.on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.find('a.add').off('click');
    this.element.find('input.quantity').off('change');
    this.element.find('input.quantity').off('keyup');
    this.element.find('#dont-show-again-item-add').off('click');
    this.element.remove();
    if (this.element.find('input.quantity').val() == 0) {
      shoppingCartModule.remove({
        productId: productId
      }, function(res) {
        // remove
        $('#shopping-cart-item-' + productId).slideUp(500, function() {
          $(this).remove();
          // Display empty cart if necessary
          shoppingCartModule.build(res);
        });
      });
    }
  }
}

/*function PopupCart(init) {
  
  var _this = this;
  var init = init || false; // Init creates the cart popup but hides it
  
  this.element = $('<div class="backdrop-cart hide"></div>');
  
  this.render = function() {
    if(!init) {
      this.open();
    }
    var res = shoppingCartModule.cart();

    var markup =  '<div class="popup-cart-container"><div class="popup-cart"> <!-- start popup-cart -->' +
                    '<span class="arrow"></span>' +
                    '<div id="cart-list-wrap"></div>' + 
                  '</div></div> <!-- end popup-cart -->';
    this.element.append(markup);

    $('body').append(this.element);

    if($.isEmptyObject(res)) {
      this.element.find('#cart-list-wrap').html('<section class="empty"><p>Your shopping cart is empty.</p></section>');
    } else {
      this.element.find('#cart-list-wrap').html(tmpl($('#tmpl-shopping-cart-item').html(), { obj: res }));
    }
    
    this.element.on('click', function(e) {
      _this.close();
    });

    this.element.find('#cart-list-wrap').on('click', function(e) {
      e.stopPropagation();
    })

    // Change Item in Shopping Cart dropdown
    $('#cart-list-wrap').on('change', '.shopping-cart-item-wrap .quantity', debounce(function(e) {
      shoppingCartModule.handleChange($(this).closest('.shopping-cart-item-wrap').data('id'));
    }, 300));

    // Keyup after typing number Item in Shopping Cart dropdown
    $('#cart-list-wrap').on('keyup', '.shopping-cart-item-wrap .quantity', function(e) {
      if(e.keyCode < 37 || e.keyCode > 40) {
        shoppingCartModule.handleChange($(this).closest('.shopping-cart-item-wrap').data('id'));
      }
    });

    // +1 Item in Shopping Cart dropdown
    $('#cart-list-wrap').on('click', '.shopping-cart-item-wrap .add', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var _this = $(this),
          $parent = _this.parents('.shopping-cart-item-wrap'),
          id      = $parent.data('id'),
          curVal = parseInt(_this.prev().val()) || 0;

      if(id === '') {
        return;
      }

      if(_this.prev().val() <= 0) {
        _this.prev().val(1);
      } else if (curVal<99999999) {
        _this.prev().val(curVal + 1);
      }

      $parent.data('qty', _this.prev().val());
      console.log(id);
      genericAjaxTimer(function() {
        shoppingCartModule.update(null, true);
      })
      
    });

    // Remove Item in Shopping Cart dropdown
    $('#cart-list-wrap').on('click', '.shopping-cart-item-wrap .remove', function() {
      var _this   = $(this),
          $parent = _this.parents('.shopping-cart-item-wrap'),
          id      = $parent.data('id');

      shoppingCartModule.remove({ productId: id }, function(res) {
        // remove
        $parent.slideUp(500, function() {
          $(this).remove();
          // Display empty cart if necessary
          shoppingCartModule.build(res);
        });
      });
    });
  }

  this.open = function() {
    this.element.removeClass('hide')
  }

  this.close = function() {
    //$('body').removeClass('no-scroll');
    this.element.addClass('hide');
  }
}*/

function PopupEmailUs(id, productInquiry, subject) {
  var _this = this;
  var id = id || '';

  function showSubject() {
    var str = '',
      subjectValue = 'Enquiry to BullionStar';

    if (subject) {
      subjectValue = subject;
    }

    if (!productInquiry) {
      str = '<div class="form-field cf-subject">' +
        '<span class="icon icon-email"></span>' +
        '<label class="active">Subject</label>' +
        '<input type="text" autocomplete="false" data-input-type="subject" data-param="subject" maxlength="100" value="' + subjectValue + '">' +
        '<span class="image hide"></span>' +
        '</div>';
    }
    return str;
  }

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-email-us">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<h3>E-mail Us</h3>' +
      '<div class="contact-form form-wrap">' +
      '<div class="form-field from-parent">' +
      '<span class="icon icon-user"></span>' +
      '<label class="active">From</label>' +
      '<input type="text" autocomplete="false" maxlength="100" class="from-read-only" readonly>' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="form-field cf-name">' +
      '<span class="icon icon-user"></span>' +
      '<label>Full Name</label>' +
      '<input type="text" autocomplete="false" data-input-type="contact-name" data-param="name" maxlength="100">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="form-field cf-email">' +
      '<span class="icon icon-email"></span>' +
      '<label>Email</label>' +
      '<input type="email" autocomplete="false" data-input-type="new-email" data-param="email" maxlength="100">' +
      '<span class="image hide"></span>' +
      '</div>' +
      showSubject() +
      '<div class="form-field with-textarea no-border">' +
      '<label>Message</label>' +
      '<textarea class="bordered" rows="8" data-input-type="message" data-param="message" maxlength="1000"></textarea>' +
      '</div>' +
      '<div class="btn-common" id="btn-submit-email-contact-us" data-product-id="' + id + '">Submit</div>' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-email-us').on('click', function(e) {
      e.stopPropagation();
    });

    // Check if user is logged in
    if (hasLoggedInId()) {
      $('.popup-email-us .cf-name').addClass('hide');
      $('.popup-email-us .cf-email').addClass('hide');

      // Make sure it adds the email and name
      /*      if(window.location.pathname === '/contact' ||
               window.location.pathname === '/help/' ||
               window.location.pathname === '/help/contact' ||
               window.location.pathname === '/accountcreated' ||
               window.location.pathname === '/charts/' ||
               window.location.pathname === '/account/transactionconfirmed' ||
               window.location.pathname === '/' ||
               /\/o\/c\/?/.test(window.location.pathname) ||
               /\/o\/o\/?/.test(window.location.pathname) ||
               /\/buy\/product\/?/.test(window.location.pathname)) {*/
      var accountInfo = localStorage.getItem('info'),
        info = JSON.parse(accountInfo);
      $('.contact-form input[data-input-type="contact-name"]').val(info.name).prev().trigger('click');
      $('.contact-form input[data-input-type="new-email"]').val(info.email).prev().trigger('click');
      this.element.find('.from-read-only').val(info.email);
      //}

      $('.contact-form').addClass('logged-in');
    } else {
      $('.from-parent').remove();
    }

    $('.popup-email-us').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    // Click
    $('.popup-email-us').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    // Focus
    $('.popup-email-us').on('focus', '.form-field input, .form-field textarea', function(e) {
      var _this = $(this);
      _this.parents('.form-field').find('label').addClass('active');
      _this.parents('.form-field').addClass('focus');
    });

    // Blur
    $('.popup-email-us').on('blur', '.form-field input, .form-field textarea', function(e) {
      var _this = $(this);
      if (!_this.val()) {
        _this.prev().removeClass('active');
      }
      _this.parents('.form-field').removeClass('focus');
    });

    $('#btn-submit-email-contact-us').on('click', function() {
      var self = $(this);
      formValidationModule.validateForm($('.contact-form'), 'Email Us', function(data) {
        data.email = $('.contact-form input[data-input-type=new-email]').val();
        data.name = $('.contact-form input[data-input-type=contact-name]').val();
        data.subject = $('.contact-form input[data-input-type=subject]').val();

        if (productInquiry) {
          console.log('Product Inquiry');
          data.productId = self.data('product-id');
          productInquiryModule.send(data, function() {
            if ($('.contact-form').hasClass('logged-in')) {
              $('.contact-form textarea').val('');
            } else {
              formValidationModule.resetForm('.contact-form');
            }
            _this.close();
          });
        } else {
          console.log('Inquiry');
          inquiryModule.send(data, function() {
            if ($('.contact-form').hasClass('logged-in')) {
              $('.contact-form textarea').val('');
            } else {
              formValidationModule.resetForm('.contact-form');
            }
            _this.close();
          });
        }
      }, null, true);
    })

  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupNotifyMe(id) {
  var _this = this;
  var id = id || '';

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-notify-me">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<h3>Notify Me</h3>' +
      '<p>Enter your e-mail address and click "OK". BullionStar will send you an e-mail as soon as the product is available for ordering again.</p>' +
      '<div class="contact-form form-wrap">' +
      '<div class="form-field cf-email">' +
      '<span class="icon icon-email"></span>' +
      '<label>Email</label>' +
      '<input type="email" autocomplete="false" data-input-type="new-email" data-param="email" maxlength="100">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '</div>' +
      '<div class="buttons">' +
      '<div class="btn-common" id="btn-submit-notify-me">OK</div>' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-notify-me').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-notify-me').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    // Click
    $('.popup-notify-me').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    // Focus
    $('.popup-notify-me').on('focus', '.form-field input', function(e) {
      var _this = $(this);
      _this.parents('.form-field').find('label').addClass('active');
      _this.parents('.form-field').addClass('focus');
    });

    // Blur
    $('.popup-notify-me').on('blur', '.form-field input', function(e) {
      var _this = $(this);
      if (!_this.val()) {
        _this.prev().removeClass('active');
      }
      _this.parents('.form-field').removeClass('focus');
    });

    $('#btn-submit-notify-me').on('click', function() {
      formValidationModule.validateForm($('.contact-form'), 'Notify Me', function(data) {
        if (id) {
          data.productId = id;
        }

        data.locationId = getLocation();

        productModule.setProductNotify(data, function(res) {
          formValidationModule.resetForm('.contact-form');
          _this.close();
        });
      }, null, true);
    });

    this.element.find('.form-field input').focus();

  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupCurrency() {
  var _this = this;

  this.render = function() {
    var currencies = ['USD', 'EUR', 'SGD', 'JPY', 'GBP', 'AUD', 'SEK', 'NZD', 'BTC', 'BCH', 'ETH', 'LTC', 'XAUT', 'PAXG'];
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-change-currency">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<h3 class="title">Change Currency</h3>' +
      '<div class="body">';


    for (var i = 0; i < currencies.length; i++) {
      var c = currencies[i];
      markup += '<div class="radio-one-line">' +
        '<input type="radio" id="popup-currency-' + c.toLowerCase() + '" name="popup-currency" value="' + c + '"' + (getCurrency() === c ? ' checked' : '') + '>' +
        '<label for="popup-currency-' + c.toLowerCase() + '">' +
        '<span class="bullion-radio"></span>' +
        '<span class="bullion-radio-title-half">' + printCurrencyName(c) + '</span>' +
        '</label>' +
        '</div>';
    }
    markup += '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-change-currency').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-change-currency').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('.popup-change-currency').on('click', 'input[name="popup-currency"]', function() {
      var self = $(this),
        value = self.val();

      if (getCurrency() !== value) {
        $('#header-' + value.toLowerCase()).trigger('click');
      }
      _this.close();
    });

    this.element.on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupReviewUs(res, orderRef) {

  var _this = this;

  this.renderTypes = function() {
    if (res.types.length) {
      var typeStr = '';
      for (var i = 0; i < res.types.length; i++) {
        typeStr += '<div class="type pull-left" data-type="' + res.types[i].reviewTypeId + '">' +
          '<h4 class="clearfix"><img class="pull-left" src="' + cdnUrl + '/img/d/' + res.types[i].name.toLowerCase() + '.png" srcset="' + cdnUrl + '/img/d/' + res.types[i].name.toLowerCase() + '.png 1x, ' + cdnUrl + '/img/d/' + res.types[i].name.toLowerCase() + '-2x.png 2x" />' + res.types[i].title + '</h4>' +
          '<ul>' +
          '<li class="clearfix"><span class="pull-left num">1.</span><span class="pull-right">' + res.types[i].step1 + '<br><a href="' + res.types[i].linkUrl + '" target="_blank">' + res.types[i].linkText + '</a></span></li>' +
          (res.types[i].step2 ? '<li class="clearfix"><span class="pull-left num">2.</span><span class="pull-right">' + res.types[i].step2 + '<br><br><input type="text" data-type="' + res.types[i].reviewTypeId + '"><button class="btn-common-radius btn-submit-review" type="button">Submit</button></span></li>' : '') +
          (res.types[i].step3 ? '<li class="clearfix"><span class="pull-left num">3.</span><span class="pull-right">' + res.types[i].step3 + '</span></li>' : '') +
          '</ul>' +
          '</div>';
      }
      return typeStr;
    }
  }

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');

    var oneReview = res.types.length === 1 ? 'one' : '';
    var markup = '<div class="popup-review-us ' + oneReview + '">' +
      '<h3 class="title clearfix">' +
      '<img src="' + cdnUrl + res.imageUrl + '" srcset="' + cdnUrl + res.imageUrl + ' 1x, ' + cdnUrl + res.imageUrlRetina + ' 2x" alt="2 Silver coins" width="55" />' +
      '<span>' + res.header + '</span>' +
      '</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/d/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="body clearfix">' +
      this.renderTypes() +
      '</div>' +
      (res.types.length > 1 ? '<p class="note">You can review us on either one or both the review sites. Reviews must be publicly visible for us to approve the free products. Only one review per alias and review site.</p>' : '') +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.find('.popup-review-us').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-review-us').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('.popup-review-us').on('click', '.btn-submit-review', function(e) {
      var self = $(this),
        $input = self.prev(),
        alias = $input.val(),
        type = $input.data('type');

      console.log(alias, type);

      if (!alias.length) {
        var options = {
          title: 'Alias missing',
          message: 'Please enter your alias.'
        }
        var popup = new Popup(options);
        popup.render()

        return;
      }

      reviewsModule.submit({
        orderId: orderRef,
        reviewTypeId: type,
        username: alias
      });
    });

    this.element.on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupPictureUpload() {
  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');

    var markup = '<div class="popup-picture-upload">' +
      '<h3 class="title">' +
      '<span>Upload a photo</span>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/d/icon-close.svg" alt="Close" />' +
      '</span>' +
      '</h3>' +
      '<div class="body">' +
      '<p class="plus"><img src="' + cdnUrl + '/img/d/plus-big.svg" width="90" /></p>' +
      '<p class="large">Drop and Drag Files to Upload</p>' +
      '<p class="medium">or select an option below</p>' +
      '<div class="buttons">' +
      '<button id="btn-picture-browse"><img src="' + cdnUrl + '/img/d/browse.svg" width="35" />Browse Files</button>' +
      '<button id="btn-picture-photo"><img src="' + cdnUrl + '/img/d/take-photo.svg" width="35" />Take Photo</button>' +
      '<input type="file" class="hide" id="browse-picture">' +
      '</div>' +
      '<p class="small">Maximim File Size: 20MB</p>' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.find('.popup-picture-upload').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-picture-upload').on('click', '.btn-close-popup', function() {
      _this.close();
    });

    $('.popup-picture-upload').on('click', '#btn-picture-browse', function() {
      $('#browse-picture').trigger('click');
    });

    $('.popup-picture-upload').on('click', '#btn-picture-photo', function() {

      var popupTakePhoto = new PopupTakePhoto();
      popupTakePhoto.render();
      // Prefer camera resolution nearest to 1280x720.
      /*var constraints = { audio: false, video: { width: 1280, height: 720 } }; 

      navigator.mediaDevices.getUserMedia(constraints)
      .then(function(mediaStream) {
        console.log(mediaStream)
      })
      .catch(function(err) { 
        console.log(err.name + ": " + err.message); 
      });*/ // always check for errors at the end.
    });

    this.element.on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupTakePhoto() {
  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');

    var markup = '<div class="popup-take-photo">' +
      '<h3 class="title">' +
      '<span>Take a photo</span>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/d/icon-close.svg" alt="Close" />' +
      '</span>' +
      '</h3>' +
      '<div class="body">' +
      '<div class="preview"></div>' +
      '<div class="buttons">' +
      '<button type="button" id="btn-submit-photo" class="btn-common-radius">Submit Picture</button>' +
      '</div>' +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.find('.popup-take-photo').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-take-photo').on('click', '.btn-close-popup', function() {
      _this.close();
    });

    $('.popup-take-photo').on('click', '#btn-submit-photo', function() {});

    this.element.on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupStorageLocation(location) {
  var _this = this;

  this.drawLocations = function(loc) {
    var html = '';
    for (var i = 0; i < loc.length; i++) {
      html += '<div class="radio-one-line">' +
        '<input type="radio" id="popup-storage-location-' + loc[i].id + '" name="popup-storage-location" value="' + loc[i].id + '"' + (getLocation() == loc[i].id ? ' checked' : '') + '>' +
        '<label for="popup-storage-location-' + loc[i].id + '">' +
        '<span class="bullion-radio"></span>' +
        '<span class="bullion-radio-title-half">' + loc[i].title + '</span>' +
        '</label>' +
        '</div>';
    }
    return html;
  }

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-storage-location">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<h3 class="title">Change Stock Location</h3>' +
      '<div class="body">' +
      this.drawLocations(location) +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-storage-location').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-storage-location').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('.popup-storage-location').on('click', 'input[name="popup-storage-location"]', function() {
      var self = $(this),
        value = self.val();

      if (getLocation() !== value) {
        $('#header-location').val($(this).val()).trigger('change');
        $('.storage-location').text($('#header-location option[value=' + getLocation() + ']').text());
        _this.close();
      }
    });

    this.element.on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

// Not used anymore
// function PopupPortfolioLocation(location, locId, cb) {
//   var _this = this;

//   this.drawLocations = function(loc) {
//     var html = '';
//     for(var i = 0; i < loc.length; i++) {
//       html += '<div class="radio-one-line">' +
//                 '<input type="radio" id="popup-portfolio-location-' + loc[i].id + '" name="popup-portfolio-location" value="' + loc[i].id + '"' + (readCookie('dashboard-location') != null ? loc[i].id == readCookie('dashboard-location') ? ' checked' : '' : loc[i].id == locId ? ' checked' : '') + ' data-text="' + loc[i].title + '">' +
//                 '<label for="popup-portfolio-location-' + loc[i].id + '">' +
//                   '<span class="bullion-radio"></span>' +
//                   '<span class="bullion-radio-title-half">' + loc[i].title + '</span>' +
//                 '</label>' +
//               '</div>';
//     }
//     return html;
//   }

//   this.render = function() {
//     this.element = $('<div class="backdrop1"></div>');
//     var markup =  '<div class="popup-portfolio-location">' +
//                     '<span class="btn-close-popup">' +
//                       '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
//                     '</span>' +
//                     '<h3 class="title">Change Location</h3>' +
//                     '<div class="body">' +
//                       this.drawLocations(location) +
//                     '</div>' +
//                   '</div>';
//     this.element.append(markup);

//     $('body').append(this.element);

//     this.element.on('click', function() {
//       return false;
//     });

//     this.element.find('.popup-portfolio-location').on('click', function(e) {
//       e.stopPropagation();
//     });

//     $('.popup-portfolio-location').on('click', '.btn-close-popup', function(e) {
//       _this.close();
//     });

//     $('.popup-portfolio-location').on('click', 'input[name="popup-portfolio-location"]', function() {
//       var self = $(this),
//           value = self.val();

//       if(readCookie('dashboard-location') != null) {
//         locId = readCookie('dashboard-location');
//       }

//       if(locId != value) {
//         typeof cb === 'function' && cb(self);
//         _this.close();
//       }
//     });

//     this.element.on('click', function(e) {
//       _this.close();
//     });
//   }

//   this.close = function() {
//     this.element.remove();
//   }
// }

function PopupTwoFactorAuthGoogleDetails(qrCode, width, height, secretKey) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var qrCodeUrl = servicesUrl + '/order/qr/?qr=' + qrCode + '&w=' + width + '&h=' + height;
    var markup = '<div class="popup-details-2fa-google"> <!-- start popup-details-2fa-google -->' +
      '<h3 class="title">2-Factor Authentication</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="content form-wrap">' +
      '<p class="description">Scan the QR-code below or enter the secret key using your preferred app. The app will generate a 6-digit code that you need to enter in the field below.</p>' +
      '<div class="info clearfix">' +
      '<figure class="pull-left">' +
      '<img src="' + qrCodeUrl + '" width="' + width + '" height="' + height + '" />' +
      '</figure>' +
      '<div class="pull-right">' +
      '<span>Secret Key</span>' +
      '<div class="secret-key">' + secretKey + '</div>' +
      '</div>' +
      '</div>' +
      '<div class="form-field no-icon">' +
      '<label>Authenticator Code</label>' +
      '<input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code1" data-enter-action=".popup-details-2fa-google #btn-activate-2fa-google" maxlength="6">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="btn-common" id="btn-activate-2fa-google">OK</div>' +
      '</div>' +
      '</div> <!-- end popup-details-2fa-google -->';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('#btn-activate-2fa-google').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.popup-details-2fa-google'), '2-Factor Authentication Google', function(data) {
        accountModule.activate2FAGoogleCode(data, function() {
          _this.close();
        });
      }, null, true);
    });

    this.element.find('.popup-details-2fa-google').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-details-2fa-google').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    $('.popup-details-2fa-google').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    this.element.find('.popup-details-2fa-google input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupTwoFactorGoogleAuth(token) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-2fa-google"> <!-- start popup-2fa-google -->' +
      '<h3 class="title">2-Factor Authentication</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="content form-wrap">' +
      '<p class="description">Please enter the Authenticator 6-digit code in the field below.</p>' +

      '<div class="form-field no-icon">' +
      '<label>Authenticator Code</label>' +
      '<input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code" data-enter-action=".popup-2fa-google #btn-send-2fa-google" maxlength="6">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="btn-common" id="btn-send-2fa-google">OK</div>' +
      '</div>' +
      '</div> <!-- end popup-2fa-google -->';
    this.element.data('token', token);
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('#btn-send-2fa-google').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.popup-2fa-google'), 'Login', function(data) {
        data.twoFactorGoogleAuthenticatorToken = _this.element.data('token');
        console.log(data);
        authenticationModule.sendTwoFactorAuthGoogle(data);
      }, null, true);
    });

    this.element.find('.popup-2fa-google').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-2fa-google').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    $('.popup-2fa-google').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    this.element.find('.popup-2fa-google input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupTwoFactorGoogleAuthNoAccount(qrCode, width, height, secretKey, secretKeyId) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var qrCodeUrl = servicesUrl + '/order/qr/?qr=' + qrCode + '&w=' + width + '&h=' + height;
    var markup = '<div class="popup-no-account-2fa-google"> <!-- start popup-no-account-2fa-google -->' +
      '<h3 class="title">2-Factor Authentication</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="content form-wrap">' +
      '<p class="description">Scan the QR-code below or enter the secret key using your preferred app. The app will generate a 6-digit code that you need to enter in the field below.</p>' +
      '<div class="info clearfix">' +
      '<figure class="pull-left">' +
      '<img src="' + qrCodeUrl + '" width="' + width + '" height="' + height + '" />' +
      '</figure>' +
      '<div class="pull-right">' +
      '<span>Secret Key</span>' +
      '<div class="secret-key">' + secretKey + '</div>' +
      '</div>' +
      '</div>' +
      '<div class="form-field no-icon">' +
      '<label>Authenticator Code</label>' +
      '<input type="tel" autocomplete="false" data-input-type="2fa-code" data-param="code1" data-enter-action=".popup-details-2fa-google #btn-activate-2fa-google" maxlength="6">' +
      '<span class="image hide"></span>' +
      '</div>' +
      '<div class="btn-common" id="btn-activate-2fa-google">OK</div>' +
      '</div>' +
      '</div> <!-- end popup-no-account-2fa-google -->';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('#btn-activate-2fa-google').on('click', function() {
      formValidationModule.validateForm(_this.element.find('.popup-no-account-2fa-google'), '2-Factor Authentication Google', function(data) {
        data.secretKey = secretKey;
        accountModule.validateGoogle2FA(data, function() {
          _this.close();
          twoFACompletedGoogle = true;
          $('#btn-create-account').data('key', secretKey);
          $('#btn-create-account').data('id', secretKeyId);
          $('#btn-create-account').trigger('click');
        }, function() {
          _this.element.find('.single-input-wrap input').eq(0).trigger('focus');
        });
      }, null, true);
    });

    this.element.find('.popup-no-account-2fa-google').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-no-account-2fa-google').on('click', '.form-field label', function(e) {
      var _this = $(this);
      _this.addClass('active');
      _this.next().trigger('focus');
    });

    $('.popup-no-account-2fa-google').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    this.element.find('.popup-no-account-2fa-google input').eq(0).trigger('focus');
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupLocation(location) {
  var _this = this;


  this.drawLocations = function(loc) {
    var html = '';
    for (var i = 0; i < loc.length; i++) {
      html += '<div class="radio-one-line">' +
        '<input type="radio" id="popup-location-' + loc[i].id + '" name="popup-location" value="' + loc[i].id + '"' + (getLocation() == loc[i].id ? ' checked' : '') + '>' +
        '<label for="popup-location-' + loc[i].id + '">' +
        '<span class="bullion-radio"></span>' +
        '<span class="bullion-radio-title-half">' + loc[i].title + '</span>' +
        '</label>' +
        '</div>';
    }
    return html;
  }

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-location">' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<h3 class="title">Change Stock Location</h3>' +
      '<div class="body">' +
      this.drawLocations(location) +
      '</div>' +
      '</div>';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    this.element.find('.popup-location').on('click', function(e) {
      e.stopPropagation();
    });

    $('.popup-location').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    $('.popup-location').on('click', 'input[name="popup-location"]', function() {
      var self = $(this),
        value = self.val();

      $('#header-location').trigger('focus'); // Trigger focus to run the code to get value of beforeChangeLocationId
      if (getLocation() !== value) {
        $('#header-location').val($(this).val()).trigger('change');
        _this.close();
      }
    });

    this.element.on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupBidHistory(auction) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');

    var bidHistory = '';
    var items = auction.items;
    for (const i in items) {
      var bid = items[i];
      bidHistory += '<tr>' +
        '<td>' + bid.accountId + '</td>' +
        '<td>' + bid.amount + '</td>' +
        '<td>' + moment(new Date(bid.date)).format('DD MMM YYYY HH:mm:ss') + '</td>' +
        '<td>' + bid.remarks + '</td>' +
        '</tr>';
    }
    var endDateText = (auction.systemTime > auction.endDate ? 'Ended ' : 'Ends ') + moment(new Date(auction.endDate)).format('DD MMM YYYY HH:mm');
    var markup = '<div class="popup-bid-history"> <!-- start popup-bid-history -->' +
      '<h3 class="title">Bid History</h3>' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="body">' +
      '<figure>' +
      '<img src="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + '" srcset="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + ' 1x, ' + cdnUrl + scaleImage(auction.imageUrl, 300, 300) + ' 2x" alt="' + auction.title + ' Image" width="150" height="150">' +
      '</figure>' +
      '<div class="text">' +
      '<p class="name title">' + auction.title + '</p>' +
      '<p>' + endDateText + '</p>' +
      '<p>Number of bids: ' + auction.totalCount + '</p>' +
      '<p>Number of bidders: ' + auction.totalBidders + '</p>' +
      '</div>' +
      '</div>' +
      '<div class="table-wrap">' +
      '<table>' +
      '<thead>' +
      '<tr>' +
      '<th>Bidder ID</th>' +
      '<th>Bid</th>' +
      '<th>Date</th>' +
      '<th>Remarks</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>' +
      bidHistory +
      '</tbody>' +
      '</table>' +
      '</div>' +
      '<div class="bottom"><div class="btn-common close-popup btn-common-radius">Close</div></div>' +
      '</div> <!-- end popup-bid-history -->';
    this.element.append(markup);

    $('body').append(this.element);

    this.element.find('.popup-bid-history').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('.btn-close-popup, .close-popup').on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupConfirmBid(auction) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var isMyLeadingBid = isMyAccount(auction.latestBidderAccountId, auction.latestAutoBidderAccountId);
    var priceTextLabel = isMyLeadingBid ? 'My Leading Bid' : ((auction.bids > 0) ? 'Leading Bid' : 'Starting Price');
    var timeLeft = getAuctionTimeLeft(auction.systemTime, auction.endDate);
    var endDateText = (auction.systemTime > auction.endDate ? 'Ended ' : 'Ends ') + moment(new Date(auction.endDate)).format('DD MMM HH:mm');
    var markup = '<div class="popup-confirm-bid"> <!-- start popup-confirm-bid -->' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="product-info product-auction ' + (isMyLeadingBid ? 'my-leading' : '') + '" ' +
      'data-id="' + auction.id + '" ' +
      'data-title="' + auction.title + '" ' +
      'data-image-url="' + auction.imageUrl + '" ' +
      'data-latest-bid="' + auction.latestBid + '" ' +
      'data-latest-bidder-account-id="' + auction.latestBidderAccountId + '" ' +
      'data-minimum-bid="' + auction.minimumBid + '" ' +
      'data-minimum-bid-price="' + auction.minimumBidPrice + '" ' +
      'data-latest-autobidder-account-id="' + auction.latestAutoBidderAccountId + '" ' +
      'data-bids="' + auction.bids + '" ' +
      'data-bid="' + auction.bid + '" ' +
      'data-end-date="' + auction.endDate + '">' +
      '<p class="time-left">Time left <span class="time">' + timeLeft + '</span></p>' +
      '<p class="ends">' + endDateText + '</p>' +
      '<header>' +
      '<figure>' +
      '<img src="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + '" srcset="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + ' 1x, ' + cdnUrl + scaleImage(auction.imageUrl, 300, 300) + ' 2x" alt="' + auction.title + ' Image" width="150" height="150">' +
      '</figure>' +
      '<div class="name title">' + auction.title + '</div>' +
      '</header>' +
      '<p class="price-text">' + priceTextLabel + '</p>' +
      '<div class="price">' + auction.latestBid + '</div>' +
      '</div>' +
      '<div class="bid-info">' +
      '<p class="title">Confirm Bid</p>' +
      '<button class="btn-common-radius btn-confirm-place-bid" data-id="' + auction.id + '">Place Bid: ' + auction.bid + '</button>' +
      '<p class="tos">By placing this bid, you agree to BullionStar’s <a href="/help/tnc" target="_blank">terms and conditions</a> and agree that your bid is binding.</p>' +
      '<div class="or">' +
      '<span>or</span>' +
      '</div>' +
      '<p class="title">Activate Autobid</p>' +
      '<p class="tos instruction">Specify the maximum amount you are willing to pay. BullionStar will automatically raise your bid to the next bid level if you are outbid. <a href="/help/auctions-faq#autobidding" target="_blank">More info</a></p>' +
      '<div class="input">' +
      '<input type="text" class="autobid txt-number">' +
      '</div>' +
      '<button class="btn-common-radius btn-add-to-cart btn-auto-bid" data-id="' + auction.id + '">Activate Autobid</button>' +
      '<p class="tos">By activating this autobid, you agree to BullionStar’s <a href="/help/tnc" target="_blank">terms and conditions</a> and agree that your autobid is binding.</p>' +
      '</div>' +
      '</div> <!-- end popup-confirm-bid -->';
    this.element.append(markup);

    $('body').append(this.element);

    $('.btn-confirm-place-bid').on('click', debounce(function() {
      var popupLoading = new Loading();
      popupLoading.render();

      auctionModule.bidAuction(auction.id, _this.element.find('.product-info').data('bid'), false,
        function(res) {
          popupLoading.close();

          if (res.success) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };
            options.okCallback = function() {
              // check if there's extra message to show in another popup
              if (res?.extra?.title !== '' && res?.extra?.message !== '') {
                popup.element.find('.popup').remove();

                var options = {
                  closeOnClickOutside: false,
                  title: res.extra.title,
                  message: res.extra.message
                };

                options.okCallback = function() {
                  _this.close();
                }

                var extraPopup = new Popup(options);
                setTimeout(function() {
                  extraPopup.render();
                }, 500);
              } else {
                _this.close();
              }
            }
            var popup = new Popup(options);
            popup.render();
          } else if (!res.success && res.authenticationRequired) {
            $(document).trigger('validateAuctionLogin');
          } else if (res.title && res.title.length > 0 && res.message && res.message.length > 0) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };

            if (res.insufficientFunds) {
              options.customButtons = true;
              options.wide = true;
              options.buttons = [{
                  name: 'Close',
                  link: false,
                  action: 'close'
                },
                {
                  name: 'Add Funds to BullionStar Account',
                  link: true,
                  action: '/myaccount/addfunds'
                }
              ];

              var popup = new Popup(options);
              popup.render();
            } else if (!res.success && (res.title == 'Starting Bid' || res.title == 'Bid Increment')) {
              var outBidMessage = res.message;
              options.closeOnClickOutside = false;
              options.customButtons = true;
              options.buttons = [{
                  name: 'Yes',
                  action: 'callback',
                  callback: function() {
                    _this.element.find('.product-info').data('bid', res.minimumBid)
                    getAuctionElement(auction.id).find('.bid').val(res.minimumBid)
                    $('.btn-confirm-place-bid').text('Place Bid: ' + res.minimumBid);
                  }
                },
                {
                  name: 'Cancel',
                  action: 'close'
                }
              ]
              var popup = new Popup(options);
              popup.render();
            } else {
              if (this._afterSuccessDialogFunction != null) {
                options.okCallback = function() {
                  _this._afterSuccessDialogFunction();
                }
              }
              var popup = new Popup(options);
              popup.render();
            }
          }
        });
    }, 500));

    $('.btn-auto-bid').on('click', debounce(function() {
      var popupLoading = new Loading();
      popupLoading.render();

      var autobid = $('.popup-confirm-bid input.autobid').val();
      auctionModule.bidAuction(auction.id, autobid, true,
        function(res) {
          popupLoading.close();

          if (res.success) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };
            options.okCallback = function() {
              // check if there's extra message to show in another popup
              if (res?.extra?.title !== '' && res?.extra?.message !== '') {
                popup.element.find('.popup').remove();

                var options = {
                  closeOnClickOutside: false,
                  title: res.extra.title,
                  message: res.extra.message
                };

                options.okCallback = function() {
                  _this.close();
                }

                var extraPopup = new Popup(options);
                setTimeout(function() {
                  extraPopup.render();
                }, 500);
              } else {
                _this.close();
              }
            }
            var popup = new Popup(options);
            popup.render();
          } else if (!res.success && res.authenticationRequired) {
            $(document).trigger('validateAuctionLogin');
          } else if (res.title && res.title.length > 0 && res.message && res.message.length > 0) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };

            if (res.insufficientFunds) {
              options.customButtons = true;
              options.wide = true;
              options.buttons = [{
                  name: 'Close',
                  link: false,
                  action: 'close'
                },
                {
                  name: 'Add Funds to BullionStar Account',
                  link: true,
                  action: '/myaccount/addfunds'
                }
              ];

              var popup = new Popup(options);
              popup.render();
            } else if (!res.success && (res.title == 'Starting Bid' || res.title == 'Bid Increment')) { // TODO: Change `Starting Bid` and `Bid Increment` with the title that will be decided later
              options.closeOnClickOutside = false;
              options.customButtons = true;
              options.buttons = [{
                  name: 'Yes',
                  action: 'callback',
                  callback: function() {
                    $(_this.element).find('.autobid').val(res.minimumBid); // TODO: Change res.minimumBid with the property to the property name that will be used in the response data
                  }
                },
                {
                  name: 'Cancel',
                  action: 'close'
                }
              ]
              var popup = new Popup(options);
              popup.render();
            } else {
              if (this._afterSuccessDialogFunction != null) {
                options.okCallback = function() {
                  _this._afterSuccessDialogFunction();
                }
              }
              var popup = new Popup(options);
              popup.render();
            }
          }
        });
    }, 500));

    this.element.find('.popup-confirm-bid').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('.btn-close-popup, .close-popup').on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupEditAutoBid(auction) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');

    var isMyLeadingBid = isMyAccount(auction.latestBidderAccountId, auction.latestAutoBidderAccountId);
    var priceTextLabel = isMyLeadingBid ? 'My Leading Bid' : ((auction.bids > 0) ? 'Leading Bid' : 'Starting Price');
    var minimumAutoBid = Number(auction.maximumAutobid) + Number(auction.increment);
    var minimumFixedBid = Number(auction.maximumAutobid) + Number(auction.increment);
    var endDateText = (auction.systemTime > auction.endDate ? 'Ended ' : 'Ends ') + moment(new Date(auction.endDate)).format('DD MMM HH:mm');
    var timeLeft = getAuctionTimeLeft(auction.systemTime, auction.endDate);
    var markup = '<div class="popup-edit-auto-bid"> <!-- start popup-edit-auto-bid -->' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="product-info product-auction ' + (isMyLeadingBid ? 'my-leading' : '') + '"' +
      'data-id="' + auction.id + '" ' +
      'data-title="' + auction.title + '" ' +
      'data-image-url="' + auction.imageUrl + '" ' +
      'data-latest-bid="' + auction.latestBid + '" ' +
      'data-latest-bidder-account-id="' + auction.latestBidderAccountId + '" ' +
      'data-minimum-bid="' + auction.minimumBid + '" ' +
      'data-minimum-bid-price="' + auction.minimumBidPrice + '" ' +
      'data-latest-autobidder-account-id="' + auction.latestAutoBidderAccountId + '" ' +
      'data-bids="' + auction.bids + '" ' +
      'data-end-date="' + auction.endDate + '">' +
      '<p class="time-left">Time left <span class="time">' + timeLeft + '</span></p>' +
      '<p class="ends">' + endDateText + '</p>' +
      '<header class="" data-url="">' +
      '<figure>' +
      '<img src="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + '" srcset="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + ' 1x, ' + cdnUrl + scaleImage(auction.imageUrl, 300, 300) + ' 2x" alt="' + auction.title + ' Image" width="150" height="150">' +
      '</figure>' +
      '<div class="name title">' + auction.title + '</div>' +
      '</header>' +
      '<p class="price-text">' + priceTextLabel + '</p>' +
      '<div class="price">' + auction.latestBid + '</div>' +
      '</div>' +
      '<div class="bid-info">' +
      '<p class="title">Edit Autobid</p>' +
      '<p class="max-text">Your current maximum autobid is</p>' +
      '<p class="max"><span>' + auction.maximumAutobidPrice + '</span>.</p>' +
      '<div class="input">' +
      '<span class="bid-label">Edit Max. Autobid</span>' +
      '<div class="bid-price">' +
      '<span class="currency">' + getCurrencySign('SGD') + '</span>' +
      '<input type="text" value="' + minimumAutoBid + '" autocomplete="false" class="autobid txt-number" pattern="[0-9]*">' +
      '</div>' +
      '</div>' +
      '<button class="btn-common-radius btn-add-to-cart btn-auto-bid" data-id="' + auction.id + '">Update Autobid</button>' +
      '<p class="tos">By editing this autobid, you agree to BullionStar’s <a href="/help/tnc" target="_blank">terms and conditions</a> and agree that your autobid is binding.</p>' +
      '<div class="or">' +
      '<span>or</span>' +
      '</div>' +
      '<p class="title">Place a Fixed Bid</p>' +
      '<div class="input horizontal">' +
      '<div class="bid-price">' +
      '<span class="currency">' + getCurrencySign('SGD') + '</span>' +
      '<input type="text" value="' + minimumFixedBid + '" autocomplete="false" class="fixed-bid txt-number" pattern="[0-9]*">' +
      '</div>' +
      '<button class="btn-common-radius btn-confirm-edit-bid" data-id=' + auction.id + '>Place Bid</button>' +
      '</div>' +
      '<p class="tos">By placing this bid, you agree to BullionStar’s <a href="/help/tnc" target="_blank">terms and conditions</a> and agree that your bid is binding.</p>' +
      '</div>' +
      '</div> <!-- end popup-edit-auto-bid -->';
    this.element.append(markup);

    $('body').append(this.element);
    var inputField = $('.popup-edit-auto-bid .autobid');
    var inputLength = inputField.val().length;
    inputField.focus();
    inputField[0].setSelectionRange(inputLength, inputLength);

    this.element.find('.popup-edit-auto-bid').on('click', function(e) {
      e.stopPropagation();
    });

    $('.btn-auto-bid').on('click', debounce(function() {
      var popupLoading = new Loading();
      popupLoading.render();

      var autobid = $('.popup-edit-auto-bid input.autobid').val();
      auctionModule.bidAuction(auction.id, autobid, true,
        function(res) {
          popupLoading.close();

          if (res.success) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };
            options.okCallback = function() {
              _this.close();
            }
            var popup = new Popup(options);
            popup.render();
          } else if (!res.success && res.authenticationRequired) {
            $(document).trigger('validateAuctionLogin');
          } else if (res.title && res.title.length > 0 && res.message && res.message.length > 0) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };

            if (res.insufficientFunds) {
              options.customButtons = true;
              options.wide = true;
              options.buttons = [{
                  name: 'Close',
                  link: false,
                  action: 'close'
                },
                {
                  name: 'Add Funds to BullionStar Account',
                  link: true,
                  action: '/myaccount/addfunds'
                }
              ];

              var popup = new Popup(options);
              popup.render();
            } else if (!res.success && (res.title == 'Starting Bid' || res.title == 'Bid Increment')) { // TODO: Change `Starting Bid` and `Bid Increment` with the title that will be decided later
              options.closeOnClickOutside = false;
              options.customButtons = true;
              options.buttons = [{
                  name: 'Yes',
                  action: 'callback',
                  callback: function() {
                    $(_this.element).find('.autobid').val(res.minimumBid); // TODO: Change res.minimumBid with the property to the property name that will be used in the response data
                  }
                },
                {
                  name: 'Cancel',
                  action: 'close'
                }
              ]
              var popup = new Popup(options);
              popup.render();
            } else {
              if (this._afterSuccessDialogFunction != null) {
                options.okCallback = function() {
                  _this._afterSuccessDialogFunction();
                }
              }
              var popup = new Popup(options);
              popup.render();
            }
          }

        });
    }, 500));

    this.element.find('.btn-confirm-edit-bid').on('click', debounce(function(e) {
      e.stopPropagation();

      var popupLoading = new Loading();
      popupLoading.render();

      auction.bid = $(_this.element).find('.fixed-bid').val();
      auctionModule.bidAuction(auction.id, auction.bid, false,
        function(res) {
          popupLoading.close();

          if (res.success) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };
            options.okCallback = function() {
              _this.close();
            }
            var popup = new Popup(options);
            popup.render();
          } else if (!res.success && res.authenticationRequired) {
            $(document).trigger('validateAuctionLogin');
          } else if (res.title && res.title.length > 0 && res.message && res.message.length > 0) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };

            if (res.insufficientFunds) {
              options.customButtons = true;
              options.wide = true;
              options.buttons = [{
                  name: 'Close',
                  link: false,
                  action: 'close'
                },
                {
                  name: 'Add Funds to BullionStar Account',
                  link: true,
                  action: '/myaccount/addfunds'
                }
              ];

              var popup = new Popup(options);
              popup.render();
            } else if (!res.success && (res.title == 'Starting Bid' || res.title == 'Bid Increment')) {
              options.closeOnClickOutside = false;
              options.customButtons = true;
              options.buttons = [{
                  name: 'Yes',
                  action: 'callback',
                  callback: function() {
                    $(_this.element).find('.fixed-bid').val(res.minimumBid);
                  }
                },
                {
                  name: 'Cancel',
                  action: 'close'
                }
              ]
              var popup = new Popup(options);
              popup.render();
            } else {
              if (this._afterSuccessDialogFunction != null) {
                options.okCallback = function() {
                  _this._afterSuccessDialogFunction();
                }
              }
              var popup = new Popup(options);
              popup.render();
            }
          }
        });
    }, 500));

    this.element.find('.btn-close-popup, .close-popup').on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupEditBid(auction) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var isMyLeadingBid = isMyAccount(auction.latestBidderAccountId, auction.latestAutoBidderAccountId);
    var priceTextLabel = isMyLeadingBid ? 'My Leading Bid' : ((auction.bids > 0) ? 'Leading Bid' : 'Starting Price');
    var endDateText = (auction.systemTime > auction.endDate ? 'Ended ' : 'Ends ') + moment(new Date(auction.endDate)).format('DD MMM HH:mm');
    var timeLeft = getAuctionTimeLeft(auction.systemTime, auction.endDate);
    var markup = '<div class="popup-edit-bid"> <!-- start popup-edit-bid -->' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="product-info product-auction ' + (isMyLeadingBid ? 'my-leading' : '') + '" ' +
      'data-id="' + auction.id + '" ' +
      'data-title="' + auction.title + '" ' +
      'data-image-url="' + auction.imageUrl + '" ' +
      'data-latest-bid="' + auction.latestBid + '" ' +
      'data-latest-bidder-account-id="' + auction.latestBidderAccountId + '" ' +
      'data-minimum-bid="' + auction.minimumBid + '" ' +
      'data-minimum-bid-price="' + auction.minimumBidPrice + '" ' +
      'data-bids="' + auction.bids + '" ' +
      'data-end-date="' + auction.endDate + '" ' +
      'data-autobid="' + auction.autobid + '" ' +
      'data-maximum-autobid="' + auction.maximumAutobid + '" ' +
      'data-maximum-autobid-price="' + auction.maximumAutobidPrice + '" ' +
      'data-latest-autobidder-account-id="' + auction.latestAutobidderAccountId + '" ' +
      'data-increment="' + auction.increment + '">' +
      '<p class="time-left">Time left <span class="time">' + timeLeft + '</span></p>' +
      '<p class="ends">' + endDateText + '</p>' +
      '<header class="" data-url="">' +
      '<figure>' +
      '<img src="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + '" srcset="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + ' 1x, ' + cdnUrl + scaleImage(auction.imageUrl, 300, 300) + ' 2x" alt="' + auction.title + ' Image" width="150" height="150">' +
      '</figure>' +
      '<div class="name title">' + auction.title + '</div>' +
      '</header>' +
      '<p class="price-text">' + priceTextLabel + '</p>' +
      '<div class="price">' + auction.latestBid + '</div>' +
      '</div>' +
      '<div class="bid-info">' +
      '<p class="title">Edit Bid</p>' +
      '<p class="max-text">Your current bid is <span>' + auction.latestBid + '</span>.</p>' +
      '<div class="input">' +
      '<span class="bid-label">Edit Bid</span>' +
      '<div class="bid-price">' +
      '<span class="currency">' + getCurrencySign('SGD') + '</span>' +
      '<input type="text" value="' + auction.bid + '" autocomplete="false" class="bid txt-number" pattern="[0-9]*">' +
      '</div>' +
      '</div>' +
      '<button class="btn-common-radius btn-confirm-edit-bid" data-id="<?php echo $product->id ?>">Update Bid</button>' +
      '<p class="tos">By editing this bid, you agree to BullionStar’s <a href="/help/tnc" target="_blank">terms and conditions</a> and agree that your bid is binding.</p>' +
      '<div class="or">' +
      '<span>or</span>' +
      '</div>' +
      '<p class="title secondary">Activate Autobid</p>' +
      '<p class="tos instruction">Specify the maximum amount you are willing to pay. BullionStar will automatically raise your bid to the next bid level if you are outbid. <a href="/help/auctions-faq#autobidding" target="_blank">More info</a></p>' +
      '<div class="input">' +
      '<input type="text" class="autobid txt-number">' +
      '</div>' +
      '<button class="btn-common-radius btn-add-to-cart btn-auto-bid" data-id="' + auction.id + '">Activate Autobid</button>' +
      '<p class="tos">By activating this autobid, you agree to BullionStar’s <a href="/help/tnc" target="_blank">terms and conditions</a> and agree that your autobid is binding.</p>' +
      '</div>' +
      '</div> <!-- end popup-edit-bid -->';
    this.element.append(markup);

    $('body').append(this.element);
    var inputField = $('.popup-edit-bid .bid');
    var inputLength = inputField.val().length;
    inputField.focus();
    inputField[0].setSelectionRange(inputLength, inputLength);


    this.element.find('.btn-confirm-edit-bid').on('click', debounce(function(e) {
      e.stopPropagation();

      var popupLoading = new Loading();
      popupLoading.render();

      auction.bid = $(_this.element).find('.bid').val();
      auctionModule.bidAuction(auction.id, auction.bid, false,
        function(res) {
          popupLoading.close();

          if (res.success) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };
            options.okCallback = function() {
              _this.close();
            }
            var popup = new Popup(options);
            popup.render();
          } else if (!res.success && res.authenticationRequired) {
            $(document).trigger('validateAuctionLogin');
          } else if (res.title && res.title.length > 0 && res.message && res.message.length > 0) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };

            if (res.insufficientFunds) {
              options.customButtons = true;
              options.wide = true;
              options.buttons = [{
                  name: 'Close',
                  link: false,
                  action: 'close'
                },
                {
                  name: 'Add Funds to BullionStar Account',
                  link: true,
                  action: '/myaccount/addfunds'
                }
              ];

              var popup = new Popup(options);
              popup.render();
            } else if (!res.success && (res.title == 'Starting Bid' || res.title == 'Bid Increment')) {
              options.closeOnClickOutside = false;
              options.customButtons = true;
              options.buttons = [{
                  name: 'Yes',
                  action: 'callback',
                  callback: function() {
                    $(_this.element).find('.bid').val(res.minimumBid);
                  }
                },
                {
                  name: 'Cancel',
                  action: 'close'
                }
              ]
              var popup = new Popup(options);
              popup.render();
            } else {
              if (this._afterSuccessDialogFunction != null) {
                options.okCallback = function() {
                  _this._afterSuccessDialogFunction();
                }
              }
              var popup = new Popup(options);
              popup.render();
            }
          }
        });
    }, 500));

    $('.btn-auto-bid').on('click', debounce(function() {

      var popupLoading = new Loading();
      popupLoading.render();

      var autobid = $('.popup-edit-bid input.autobid').val();
      auctionModule.bidAuction(auction.id, autobid, true,
        function(res) {
          popupLoading.close();

          if (res.success) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };
            options.okCallback = function() {
              _this.close();
            }
            var popup = new Popup(options);
            popup.render();
          } else if (!res.success && res.authenticationRequired) {
            $(document).trigger('validateAuctionLogin');
          } else if (res.title && res.title.length > 0 && res.message && res.message.length > 0) {
            var options = {
              closeOnClickOutside: false,
              title: res.title,
              message: res.message
            };
            if (res.insufficientFunds) {
              options.customButtons = true;
              options.wide = true;
              options.buttons = [{
                  name: 'Close',
                  link: false,
                  action: 'close'
                },
                {
                  name: 'Add Funds to BullionStar Account',
                  link: true,
                  action: '/myaccount/addfunds'
                }
              ];

              var popup = new Popup(options);
              popup.render();
            } else if (!res.success && (res.title == 'Starting Bid' || res.title == 'Bid Increment')) {
              options.closeOnClickOutside = false;
              options.customButtons = true;
              options.buttons = [{
                  name: 'Yes',
                  action: 'callback',
                  callback: function() {
                    $(_this.element).find('.autobid').val(res.minimumBid);
                  }
                },
                {
                  name: 'Cancel',
                  action: 'close'
                }
              ]
              var popup = new Popup(options);
              popup.render();
            } else {
              if (this._afterSuccessDialogFunction != null) {
                options.okCallback = function() {
                  _this._afterSuccessDialogFunction();
                }
              }
              var popup = new Popup(options);
              popup.render();
            }
          }
        });
    }, 500));

    this.element.find('.btn-close-popup, .close-popup').on('click', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupSavedWatchlist(auction) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var isMyLeadingBid = isMyAccount(auction.latestBidderAccountId, auction.latestAutoBidderAccountId);
    var priceTextLabel = isMyLeadingBid ? 'My Leading Bid' : ((auction.bids > 0) ? 'Leading Bid' : 'Starting Price');
    var endDateText = (auction.systemTime > auction.endDate ? 'Ended ' : 'Ends ') + moment(new Date(auction.endDate)).format('DD MMM HH:mm');
    var timeLeft = getAuctionTimeLeft(auction.systemTime, auction.endDate);
    var markup = '<div class="popup-saved-watchlist"> <!-- start popup-saved-watchlist -->' +
      '<span class="btn-close-popup">' +
      '<img src="' + cdnUrl + '/img/m/icon-close.svg" alt="Close" />' +
      '</span>' +
      '<div class="product-info product-auction ' + (isMyLeadingBid ? 'my-leading' : '') + '" ' +
      'data-id="' + auction.id + '" ' +
      'data-title="' + auction.title + '" ' +
      'data-image-url="' + auction.imageUrl + '" ' +
      'data-latest-bid="' + auction.latestBid + '" ' +
      'data-latest-bidder-account-id="' + auction.latestBidderAccountId + '" ' +
      'data-minimum-bid="' + auction.minimumBid + '" ' +
      'data-minimum-bid-price="' + auction.minimumBidPrice + '" ' +
      'data-bids="' + auction.bids + '" ' +
      'data-end-date="' + auction.endDate + '">' +
      '<p class="time-left">Time left <span class="time">' + timeLeft + '</span></p>' +
      '<p class="ends">' + endDateText + '</p>' +
      '<header class="" data-url="">' +
      '<figure>' +
      '<img src="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + '" srcset="' + cdnUrl + scaleImage(auction.imageUrl, 150, 150) + ' 1x, ' + cdnUrl + scaleImage(auction.imageUrl, 300, 300) + ' 2x" alt="' + auction.title + ' Image" width="150" height="150">' +
      '</figure>' +
      '<div class="name">' + auction.title + '</div>' +
      '</header>' +
      '<p class="price-text">' + priceTextLabel + '</p>' +
      '<div class="price">' + auction.latestBid + '</div>' +
      '</div>' +
      '<div class="bid-info">' +
      '<div class="top">' +
      '<p class="title">Saved to Your Watchlist</p>' +
      '<p class="">The item has been saved to your watchlist. Your watchlist can be accessed under Your Account > My Auctions.<br><br> For saved watchlist items, you will receive a notification to your e-mail and via text message to your phone 15 minutes before the auction expires.</p>' +
      '<div class="buttons">' +
      '<a href="/myaccount/auctions" class="btn-common-radius">My Auctions</a>' +
      '<a href="/myaccount/details?s=auction" class="btn-common-radius">Auction Settings</a>' +
      // '<button class="btn-common-radius close-popup" data-id="<?php echo $product->id ?>">Close</button>' +
      '</div>' +
      '</div>' +
      '<div class="checkbox-one-line">' +
      '<input type="checkbox" id="dont-show-again-alert-add" value="true">' +
      '<label for="dont-show-again-alert-add">' +
      '<span class="bullion-checkbox"></span>' +
      'Don\'t show this again.' +
      '</label>' +
      '</div>' +
      '</div>' +
      '</div> <!-- end popup-saved-watchlist -->';
    this.element.append(markup);

    $('body').append(this.element);

    var $watchlistPopupDialog = this.element.find('.popup-saved-watchlist');
    this.element.find('.popup-saved-watchlist').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('.btn-close-popup').on('click', function(e) {
      alertWatchlistedAuctionDontShow($watchlistPopupDialog.find('#dont-show-again-alert-add').is(':checked'));
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupOneTimeChangeLocation(messageText, buttonText, locationId) {

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup-one-time-change-location"> <!-- start one-time-change-location -->' +
      '<div class="content form-wrap">' +
      '<p class="description">' + messageText + '</p>' +
      '<div class="buttons text-center"><button class="btn-common-radius  btn-grey" id="change-loc-close">Don\'t Change</button><button class="btn-common-radius" id="change-loc-confirm">' + buttonText + '</button></div>' +
      '</div>' +
      '</div> <!-- end one-time-change-location -->'
    this.element.append(markup);

    $('body').append(this.element);

    this.element.on('click', function() {
      return false;
    });

    $('#change-loc-confirm').on('click', function() {
      changeLocation(locationId, buttonText);
      _this.close();
    });

    $('#change-loc-close').on('click', function() {
      _this.close();
    });

    $('.popup-one-time-change-location').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupCaptcha(options) {
  var e = $('.backdrop1');
  if (e.length > 0) {
    e.closest('.backdrop1').remove();
  }

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup popup-captcha"> <!-- start popup-captcha -->' +
      '<div class="title">' + options.title + '</div>' +
      '<div class="body">' +
      '<div class="message">' + options.message + '</div>' +
      '<div class="captcha text-center"><img src="' + options.csvg + '" alt="Captcha Image" class="captcha-image"></div>' +
      '<div class="field text-center"><input type="text" data-ca="' + options.ca + '" class="captcha-answer"></div>' +
      '<div class="buttons text-center">' +
      '<button class="btn-common-radius btn-cancel" tabindex="0">Cancel</button>' +
      '<button class="btn-common-radius btn-ok" tabindex="0">Proceed</button>' +
      '</div>' +
      '</div>' +
      '</div> <!-- end popup-captcha -->';
    this.element.append(markup);

    $('body').append(this.element);

    // var $watchlistPopupDialog = this.element.find('.popup-captcha');
    this.element.find('.popup-captcha').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('.btn-ok').on('click', function(e) {
      var answer = $('.popup-captcha .captcha-answer').val();
      options.okCallback(answer);
      _this.element.remove();
    });

    this.element.find('.btn-cancel').on('click', function(e) {
      _this.element.remove();
    });
  }

  // this.close = function() {
  //   this.element.remove();
  // }
}

function PopupHCaptcha(options) {
  var e = $('.backdrop1');
  if (e.length > 0) {
    e.closest('.backdrop1').remove();
  }

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = '<div class="popup popup-hcaptcha"> <!-- start popup-hcaptcha -->' +
      '<div class="title">' + options.title + '</div>' +
      '<div class="body">' +
      '<div class="message">' + options.message + '</div>' +
      '<div class="captcha-widget"><h-captcha id="captchaContainer" site-key="' + hCaptchaSiteKey + '" size="normal" tabindex="0"></h-captcha></div>' +
      '<div class="buttons text-center">' +
      '<button class="btn-common-radius btn-cancel" tabindex="0">Cancel</button>' +
      '<button class="btn-common-radius btn-ok" tabindex="0" disabled>Proceed</button>' +
      '</div>' +
      '</div>' +
      '</div> <!-- end popup-hcaptcha -->';
    this.element.append(markup);

    $('body').append(this.element);

    const captchaContainer = document.getElementById('captchaContainer');

    captchaContainer.addEventListener('verified', (e) => {
      console.log('verified event', {
        token: e.token
      });
      _this.element.find('.btn-ok').prop('disabled', false);
    });

    captchaContainer.addEventListener('error', (e) => {
      console.log('error event', {
        error: e.error
      });
    });

    this.element.find('.popup-hcaptcha').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('.btn-ok').on('click', function(e) {
      var answer = $('textarea[name=h-captcha-response]').val();
      options.okCallback(answer);
      _this.element.remove();
    });

    this.element.find('.btn-cancel').on('click', function(e) {
      _this.element.remove();
    });
  }
}

function PopupApiKeys(options) {
  var e = $('.backdrop1');
  if (e.length > 0) {
    e.closest('.backdrop1').remove();
  }

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = `<div class="popup popup-api-keys"> <!-- popup-api-keys -->
            <div class="title">${options.title}</div>
            <div class="body">
              <p class="message">${options.message}</p>
                <div class="api-key-text text-center">
                  <input type="text" id="api-key" value="${options.apiKey}" readonly>
                  <button id="copy-api-key" class="btn-common-hollow">Copy</button>
                </div>
                <script>
                  document.getElementById('copy-api-key').addEventListener('click', function() {
                    var apiKeyInput = document.getElementById('api-key');
                    apiKeyInput.select();
                    apiKeyInput.setSelectionRange(0, 99999); // For mobile devices
                    document.execCommand('copy');
                    alert('API Key copied to clipboard');
                  });
                </script>
              <div class="text-center buttons">
                <button class="btn-common-radius btn-ok" tabindex="0">OK</button>
              </div>
            </div>
          </div> <!-- end popup-api-keys -->`;
    this.element.append(markup);

    $('body').append(this.element);

    this.element.find('.popup-api-keys').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('.btn-ok').on('click', function(e) {
      if (typeof options.okCallback === 'function') {
        options.okCallback();
      }

      _this.element.remove();
    });
  }
}

function PopupApiKeyForm(options) {
  var e = $('.backdrop1');
  if (e.length > 0) {
    e.closest('.backdrop1').remove();
  }

  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = `<div class="popup popup-generate-api-key"> <!-- popup-generate-api-key -->
            <h3 class="title">${options.title}</h3>
            <div class="form-wrap">
              <h4>Access Level</h4>
              <div class="radio-one-line">
                <input type="radio" id="read" name="access-level" value="1" ${ options?.edit ? options.accessLevel == 1  ? 'checked' : '' : 'checked' }>
                <label for="read">
                  <span class="bullion-radio"></span>
                  <p class="bullion-radio-title">Read</p>
                </label>
              </div>
              <div class="radio-one-line">
                <input type="radio" id="write" name="access-level" value="2" ${ options?.edit && options.accessLevel == 2  ? 'checked' : '' }>
                <label for="write">
                  <span class="bullion-radio"></span>
                  <p class="bullion-radio-title">Write</p>
                </label>
              </div>
              <div class="radio-one-line">
                <input type="radio" id="readwrite" name="access-level" value="3" ${ options?.edit && options.accessLevel == 3  ? 'checked' : '' }>
                <label for="readwrite">
                  <span class="bullion-radio"></span>
                  <p class="bullion-radio-title">Read/Write</p>
                </label>
              </div>

              <h4>IP Address</h4>
              <p class="field-description">Enter the IP addresses that are allowed to access the API. One IP address per line.</p>
              <textarea id="ip-addresses" placeholder="Enter IP address" rows="4">${ options?.ipAddresses || '' }</textarea>

              <h4 ${ options?.edit ? 'class="hide"' : '' }>Reason</h4>
              <textarea id="reason" placeholder="Optional" rows="2" ${ options?.edit ? 'class="hide"' : '' }></textarea>

              <div class="text-center buttons">
                <button class="btn-common-radius btn-submit" tabindex="0">${options.btnSubmitText}</button>
                <button class="btn-common-radius btn-cancel" tabindex="0">Cancel</button>
              </div>
            </div>
          </div> <!-- end popup-generate-api-key -->`;
    this.element.append(markup);

    $('body').append(this.element);

    this.element.find('.popup-generate-api-key').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('.btn-submit').on('click', function(e) {
      var accessLevel = $('input[name="access-level"]:checked').val();
      var ipAddresses = $('#ip-addresses').val().split('\n').filter(function(ip) {
        return ip.length > 0;
      }).join(',');
      var reason = $('#reason').val();

      if (typeof options.okCallback === 'function') {
        options.okCallback(accessLevel, ipAddresses, reason);
      }

      // _this.element.remove();
    });

    this.element.find('.btn-cancel').on('click', function(e) {
      _this.element.remove();
    });
  }
}

function PopupAutoInvestShippingAddress(shippingData) {
  var e = $('.backdrop1');
  if (e.length > 0) {
    e.closest('.backdrop1').remove();
  }

  var _this = this;

  this.render = function() {
    console.log(shippingData);
    this.element = $('<div class="backdrop1"></div>');
    var markup = tmpl($('#tmpl-shipping-address-popup').html(), {
      shippingData: shippingData
    });
    this.element.append(markup);

    $('body').append(this.element);

    this.element.find('.popup-auto-invest-shipping-address').on('click', function(e) {
      e.stopPropagation();
    });

    this.element.find('.btn-close-popup').on('click', function(e) {
      e.stopPropagation();
      // _this.close();
      if (shippingData?.handleCloseShippingPopup) {
        shippingData.handleCloseShippingPopup();
      }
    });
  };

  this.close = function() {
    this.element.remove();
    console.log('PopupAutoInvestShippingAddress closed');
  }
}

function PopupBuyLegalAcknowledgement(options) {
  var _this = this;

  this.render = function() {
    var paymentPeriod = 'next banking day';
    if (options.isCryptoCurrency) {
      paymentPeriod = 'next 20 minutes';
    } else if (options.isCardPayment) {
      paymentPeriod = 'next 24 hours';
    }

    this.element = $('<div class="backdrop1"></div>');
    var markup = `<div class="popup-buy-legal-acknowledgement">
                    <span class="btn-close-popup">
                     <img src="${cdnUrl}/img/m/icon-close.svg" alt="Close" />
                    </span>
                    <h3 class="title">Legal Acknowledgement</h3>
                    <div class="body">
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="binding-order">
                        <label for="binding-order">
                          <span class="bullion-checkbox"></span>
                          Binding Order - No Cancellation
                        </label>
                        <p class="info">I acknowledge and agree that this order is legally binding once placed and that <strong>no cancellation rights apply.</strong></p>
                      </div>

                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="payment-obligation">
                        <label for="payment-obligation">
                          <span class="bullion-checkbox"></span>
                          Payment Obligation
                        </label>
                        <p class="info">I agree that I <strong>must and will initiate payment no later than ${paymentPeriod}</strong> from placing this order.</p>
                      </div>

                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="liability-non-payment">
                        <label for="liability-non-payment">
                          <span class="bullion-checkbox"></span>
                          Liability for Non-Payment
                        </label>
                        <p class="info">I acknowledge and agree that if I fail to make payment within the required timeframe, I am <strong>legally liable for all applicable cancellation fees</strong> in accordance with BullionStar’s Terms and Conditions.</p>
                      </div>

                      ${options.isCashPayment && options.cashPaymentThresholdExceeded ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="cash-payments">
                        <label for="cash-payments">
                          <span class="bullion-checkbox"></span>
                          Cash Payments
                        </label>
                        <p class="info">I confirm that I am the owner of the cash funds used to pay for this order.</p>
                      </div>
                      ` : ''}

                      ${options.isBankTransfer ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="bank-transfer-payments">
                        <label for="bank-transfer-payments">
                          <span class="bullion-checkbox"></span>
                          Bank Transfer Payments
                        </label>
                        <p class="info">I agree that payment for this order <strong>must be made from a bank account held in the same name as my BullionStar account</strong>.</p>
                      </div>
                      ` : ''}
                      
                      ${options.isCryptoCurrency ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="cryptocurrency-payments">
                        <label for="cryptocurrency-payments">
                          <span class="bullion-checkbox"></span>
                          Cryptocurrency Payments
                        </label>
                        <p class="info">I confirm that I am the <strong>owner of the funds</strong> used to pay for the order.</p>
                      </div>
                      ` : ''}

                      ${options.isCardPayment && ((options.isShipping && locationId == '1' && options.shippingCountryCode === 'SG') || !options.isShipping) ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="card-payments">
                        <label for="card-payments">
                          <span class="bullion-checkbox"></span>
                          Card Payments
                        </label>
                        <p class="info">I agree that payment for this order is made from a card belonging to the BullionStar account holder.</p>
                      </div>
                      ` : ''}

                      ${options.isCardPayment && options.isShipping && (locationId != '1' || options.shippingCountryCode !== 'SG') ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="card-payments-non-sg-shipping">
                        <label for="card-payments-non-sg-shipping">
                          <span class="bullion-checkbox"></span>
                          Card Payments
                        </label>
                        <p class="info">I agree that payment for this order is made from a card belonging to the BullionStar account holder, and that <strong>proof of dispatch of the product(s) constitutes binding fulfilment</strong> of this order and is sufficient to bind the cardholder.</p>
                      </div>
                      ` : ''}
                      
                      ${locationId != '2' && options.isShipping && options.isInternationalShipping ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="international-shipping">
                        <label for="international-shipping">
                          <span class="bullion-checkbox"></span>
                          International Shipping
                        </label>
                        <p class="info">I understand and agree that when shipping to a destination outside the stock location, I am <strong>solely responsible for the importation process and liable for all applicable import taxes, duties, handling fees, and any other import-related charges</strong>.</p>
                      </div>
                      ` : ''}

                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="acceptance-tnc">
                        <label for="acceptance-tnc">
                          <span class="bullion-checkbox"></span>
                          Acceptance of Terms
                        </label>
                        <p class="info">I have read, understood, and agree to BullionStar’s <a href="/help/tnc/" class="open-tnc">Terms and Conditions</a>.</p>
                      </div>

                      <div class="text-center buttons">
                        <button class="btn-common-radius btn-submit" tabindex="0" disabled>Acknowledge</button>
                      </div>
                    </div>
                  </div>`;
    this.element.append(markup);

    $('body').append(this.element);

    $('.popup-buy-legal-acknowledgement').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    this.element.find('input[type="checkbox"]').on('change', function() {
      var allChecked = _this.element.find('input[type="checkbox"]').length === _this.element.find('input[type="checkbox"]:checked').length;
      _this.element.find('.btn-submit').prop('disabled', !allChecked);
    });

    this.element.find('.btn-submit').on('click', function(e) {
      e.preventDefault();
      options.callback();
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}

function PopupSellLegalAcknowledgement(options) {
  var _this = this;

  this.render = function() {
    this.element = $('<div class="backdrop1"></div>');
    var markup = `<div class="popup-sell-legal-acknowledgement">
                    <span class="btn-close-popup">
                     <img src="${cdnUrl}/img/m/icon-close.svg" alt="Close" />
                    </span>
                    <h3 class="title">Legal Acknowledgement</h3>
                    <div class="body">
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="binding-order">
                        <label for="binding-order">
                          <span class="bullion-checkbox"></span>
                          Binding Transaction - No Cancellation
                        </label>
                        <p class="info">I acknowledge and agree that this <strong>order is binding</strong> once submitted and that <strong>no cancellation or reversal rights apply</strong>.</p>
                      </div>
                      
                      ${options.isCryptoCurrency ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="cryptocurrency-payments">
                        <label for="cryptocurrency-payments">
                          <span class="bullion-checkbox"></span>
                          Cryptocurrency Payments
                        </label>
                        <p class="info">I acknowledge and agree that funds will be sent to the <strong>${options.cryptoCurrency} address: ${options.cryptoAddress}</strong>. I understand and agree that BullionStar is <strong>not responsible for incorrectly stated cryptocurrencies or incorrectly stated cryptocurrency addresses</strong>.</p>
                      </div>
                      ` : ''}

                      ${options.isBankTransfer ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="bank-transfer-payments">
                        <label for="bank-transfer-payments">
                          <span class="bullion-checkbox"></span>
                          Bank Transfer Payments
                        </label>
                        <p class="info">I acknowledge and agree that funds will be sent to the <strong>bank account number: ${options.bankAccountNumber}</strong>. I understand and agree that BullionStar is <strong>not responsible for incorrectly entered bank account details</strong>.</p>
                      </div>
                      ` : ''}

                      ${options.isBankTransfer ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="beneficiary-name-requirement">
                        <label for="beneficiary-name-requirement">
                          <span class="bullion-checkbox"></span>
                          Beneficiary Name Requirement
                        </label>
                        <p class="info">I acknowledge and agree that bank transfer payments can <strong>only be made to a beneficiary that matches the BullionStar account holder</strong>.</p>
                      </div>
                      ` : ''}

                      ${options?.isSellOrder && getLocation() == 1 ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="sell-orders-singapore">
                        <label for="sell-orders-singapore">
                          <span class="bullion-checkbox"></span>
                          Sell Orders
                        </label>
                        <p class="info">I acknowledge and agree that I must <strong>either hand over the items to BullionStar at BullionStar’s retail shop or initiate shipping of the items no later than the next business day</strong>.</p>
                      </div>
                      ` : ''}

                      ${options?.isSellOrder && getLocation() == 2 ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="sell-orders-united-states">
                        <label for="sell-orders-united-states">
                          <span class="bullion-checkbox"></span>
                          Sell Orders
                        </label>
                        <p class="info">I acknowledge and agree that I must <strong>initiate shipping of the items no later than the next business day</strong>.</p>
                      </div>
                      ` : ''}

                      ${options?.isSellOrder && getLocation() == 3 ? `
                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="sell-orders-new-zealand">
                        <label for="sell-orders-new-zealand">
                          <span class="bullion-checkbox"></span>
                          Sell Orders
                        </label>
                        <p class="info">I acknowledge and agree that I must <strong>either hand over the items to BullionStar’s vault in New Zealand or initiate shipping of the items no later than the next business day</strong>.</p>
                      </div>
                      ` : ''}

                      <div class="checkbox-one-line full-width">
                        <input type="checkbox" name="acknowledgment" id="acceptance-tnc">
                        <label for="acceptance-tnc">
                          <span class="bullion-checkbox"></span>
                          Acceptance of Terms
                        </label>
                        <p class="info">I have read, understood, and agree to BullionStar’s  <a href="/help/tnc/" class="open-tnc">Terms and Conditions</a>.</p>
                      </div>

                      <div class="text-center buttons">
                        <button class="btn-common-radius btn-submit" tabindex="0" disabled>Acknowledge</button>
                      </div>
                    </div>
                  </div>`;
    this.element.append(markup);

    $('body').append(this.element);

    $('.popup-sell-legal-acknowledgement').on('click', '.btn-close-popup', function(e) {
      _this.close();
    });

    this.element.find('input[type="checkbox"]').on('change', function() {
      var allChecked = _this.element.find('input[type="checkbox"]').length === _this.element.find('input[type="checkbox"]:checked').length;
      _this.element.find('.btn-submit').prop('disabled', !allChecked);
    });

    this.element.find('.btn-submit').on('click', function(e) {
      e.preventDefault();
      options.callback();
      _this.close();
    });
  }

  this.close = function() {
    this.element.remove();
  }
}
/***********************************************************/
/***********************************************************/
/* Authentication Module */
/***********************************************************/
/***********************************************************/

var authenticationModule = (function() {

  /*
   new Request('https://auth.bullionstar.com/auth/v1/initialize', { email: $('#email').val() }).success(function(json) {
   var hashedPassword = MD5($('#password').val());
   console.log('hashedPassword:' + hashedPassword);
   var encryptedPassword = MD5(json.salt + hashedPassword);
   console.log('salt:' + json.salt);
   console.log('encryptedPassword:' + encryptedPassword);
   new Request('https://auth.bullionstar.com/auth/v1/authenticate', { authToken : json.authToken, encryptedPassword : encryptedPassword }).success(function(json) {
   if (json.accessToken != null && json.accessToken.length>0) {
   $('#msg').html('Access token:' + json.accessToken);
   } else if (json.authenticateIp) {
   $('#msg').html('Authenticate IP');
   } else if (json.locked) {
   $('#msg').html('Account Locked');
   } else if (json.twoFactorToken != null && json.twoFactorToken.length>0) {
   twoFactorToken = json.twoFactorToken;
   $('#msg').html('Two Factor token:' + json.twoFactorToken);
   $('#codeBox').show();
   } else {
   $('#msg').html('Unknown result.');
   }

   */
  var url = '/auth/v1/',
    resendCtr = 0,
    resendTimer = 120;

  /*
   DESC: Login user. USED IN: Popup login button .btn-sign-in
   POST /auth/v1/initialize
   email=admin@bullionint.com
   hashedPassword=XXXXXXX (MD5 Hased)
   rememberMe=true
   token=kalle
   */
  function login(data, successCb) {

    var context = {
      data: data,
      successCb: successCb
    };

    var initReq = new Request(servicesUrl + url + 'initialize', {
      email: data.email,
      machineId: getMachineId()
    });
    initReq.context(context);
    initReq.success(function(res, context) {
      var hashedPassword = data.hashedPassword;
      var encryptedPassword = MD5(res.salt + hashedPassword);

      var req = new Request(servicesUrl + url + 'authenticate', {
        authToken: res.authToken,
        encryptedPassword: encryptedPassword,
        valuation: getValuation(),
        locationId: getLocation(),
        coupons: getCouponString()
      });
      req.context(context);
      req.success(function(res, context) {
        // For ADMIN login saving of creds
        window.stringContainerCreds.e = $('.popup-login input[type="email"]').val() || $('.login-page input[type="email"]').val();
        window.stringContainerCreds.p = $('.popup-login input[type="password"]').val() || $('.login-page input[type="password"]').val();

        // User with admin access
        if (res.authenticateIp) {
          // Show Auth Ip popup
          var popup = new PopupAuthenticateIP();
          popup.render();
        } else if (res.twoFactorToken != null) { // 2 Factor auth is on
          // Show 2 Factor sms auth popup
          var popup = new PopupTwoFactorAuth();
          popup.render(res.twoFactorToken);

          $('.btn-resend').addClass('disabled');
          codeTimer(resendTimer);

        } else if (res.twoFactorMachineToken != null) { // Check trusted machine
          // Show trusted machine popup
          var popup = new PopupTrustedMachine();
          popup.render(res.twoFactorMachineToken);
        } else if (res.twoFactorGoogleAuthenticatorToken != null) {
          // Show 2 Factor google auth popup
          var popup = new PopupTwoFactorGoogleAuth(res.twoFactorGoogleAuthenticatorToken);
          popup.render();
        } else {
          // accountInfo have some value Success
          afterSuccessfulLogin(res);
          runPromoCall();
          typeof context.successCb === 'function' && context.successCb();
        }
      });

      req.call();
    });
    initReq.call();
  }

  /*
   DESC: Authenticates user IP address. USED IN: Popup .popup-login-sign-up
   POST /auth/v1/authenticateIP
   code=testing123
   */
  function authenticateIP(data) {

    var req = new Request(servicesUrl + url + 'authenticateIP', data);

    req.afterErrorDialogFunction(function() {
      $('.popup-authenticate-ip input').val('').trigger('focus');
    });

    req.success(function(res) {
      if (res.success) {
        $('.backdrop1').remove();

        var popup = new PopupLogin({
          withOutSignUp: true
        });
        popup.render();
      }
    });

    req.call();
  }

  /*
   DESC: Authenticates Machine. USED IN: Popup .popup-login-sign-up
   POST /auth/v1/authenticateMachine
   code=testing123
   */
  function authenticateMachine(data) {
    data.valuation = getValuation();
    data.locationId = getLocation();
    var req = new Request(servicesUrl + url + 'authenticateMachine', data);

    req.afterErrorDialogFunction(function() {
      $('.popup-trusted-machine input').val('').trigger('focus');
    });

    req.success(function(res) {
      if (res.success) {
        $('.backdrop1').remove();

        // Login comes from either popup or wholeScreenPopup
        afterSuccessfulLogin(res);
      }
    });

    req.call();
  }

  /*
   DESC: Starts timer of resend code button.
   USED IN: after2Factor() and login()
   */
  function codeTimer(num) {
    clearInterval(resendCtr); //clear
    resendCtr = 0;

    var $button = $('.popup-2fa .btn-resend');

    resendCtr = setInterval(function() {
      $button.find('span').text('(' + num + ')');
      if (num == 0) {
        clearInterval(resendCtr); //clear
        resendCtr = 0;
        $button.find('span').empty();
        $button.removeClass('disabled');
      }
      num--;
    }, 1000);
  }

  /*
   DESC: Authenticates user via 2 factor authentication. USED IN: Popup .popup-2-factor-auth
   POST /auth/v1/authenticateTwoFactor
   code=12345
   */
  function sendTwoFactorAuth(data) {
    data.locationId = getLocation();
    data.valuation = getValuation();
    var req = new Request(servicesUrl + url + 'authenticateTwoFactor', data);

    req.afterErrorDialogFunction(function(res) {
      if (res.locked) return;
      // Show due diligence popup
      if (res.pendingDueDiligence) {
        //popupModule.open($('.popup-pending-due-diligence'), 'popupPendingDueDiligence');
        return;
      }
      if (resendCtr) {
        $('.popup-2fa .btn-resend').addClass('disabled');
      }

      after2Factor();
    });

    req.success(function(res) {
      $('.backdrop1').remove();

      afterSuccessfulLogin(res);
    });

    req.call();
  }

  /*
   DESC: Authenticates user via 2 factor google authentication. USED IN: Login
   POST /auth/v1/ga/authenticate
   */
  function sendTwoFactorAuthGoogle(data) {
    data.locationId = getLocation();
    var req = new Request(servicesUrl + url + 'ga/authenticate', data);

    data.valuation = getValuation();
    req.success(function(res) {
      $('.backdrop1').remove();

      afterSuccessfulLogin(res);
    });

    req.call();

  }

  /*
   DESC: Shows 2 factor authentication popup and start the resend button timer.
   USED IN: twoFactorAuth() and resendTwoFactorCode()
   */
  function after2Factor() {
    if (!resendCtr && $('.popup-2fa .btn-resend').hasClass('disabled')) {
      codeTimer(resendTimer);
    }
    $('.popup-2fa input').val('').trigger('focus');
  }

  /*
   DESC: Resend 2 factor authentication. USED IN: Popup .popup-2-factor-auth
   POST /auth/v1/authenticateTwoFactorResendCode
   */
  function resendTwoFactorCode(data) {

    var req = new Request(servicesUrl + url + 'authenticateTwoFactorResendCode', data);

    req.success(function(res) {
      if (res.success) {
        var options = {
          title: '2-Factor Authentication',
          message: 'The code has been re-sent.',
          okCallback: function() {
            $('.popup-2fa .btn-resend').addClass('disabled');
            after2Factor();
          }
        }
        var popup = new Popup(options);
        popup.render();
      } else { // res.error/warning = true Error or Warning
        console.log(res.message);
      }
    });

    req.call();
  }

  /*
   DESC: Logouts user. USED IN: Tooltip .user-logout
   POST /auth/v1/logout
   */
  function logout() {
    var req = new Request(servicesUrl + url + 'invalidate', {});

    req.success(function(res) {
      if (res.success) {
        getAnnouncement();
        localStorage.removeItem('hasOrders');

        updateHomeBanners();

        eraseCookie('apg'); // TODO: Mark, move this to local storage.
        removeApg();

        for (var i = 0; i < 10; ++i) {
          localStorage.removeItem('cart' + i);
        }
        localStorage.removeItem('logged-in-total-balance');
        localStorage.removeItem('logged-in-extra-link');
        localStorage.removeItem('logged-in-id');
        localStorage.removeItem('logged-in-name');
        localStorage.removeItem('logged-in-nationality');
        localStorage.removeItem('dashboard-location');
        localStorage.removeItem('watchlisted-auction-ids');

        //changeProductPricing();
        runPromoCall();

        window.stringContainerCreds = {
          e: '',
          p: ''
        };

        // Update Header to default.
        updateUserHeader(null);

        // Reset Login Forms
        formValidationModule.resetForm('.main-header .login', '.inputs');

        // Check URL and redirect to home if it comes from /myaccount/ and confirmation pages otherwise stay on the page
        if (/\/myaccount\/?/.test(window.location.pathname) ||
          /\/vault\/sell\/?/.test(window.location.pathname) ||
          /\/vault\/withdraw\/?/.test(window.location.pathname) ||
          /\/vault\/withdrawbsp\/?/.test(window.location.pathname) ||
          /\/account\/transaction\/?/.test(window.location.pathname) ||
          /\/o\/c\/?/.test(window.location.pathname) ||
          /\/o\/o\/?/.test(window.location.pathname) ||
          window.location.pathname === '/verification' ||
          window.location.pathname === '/verification1' ||
          window.location.pathname === '/buy/creditcardpayment' ||
          window.location.pathname === '/buy/checkout') {
          window.location.href = '/';
        } else {
          if (/setalerts/.test(window.location.pathname)) {
            alertModule.getSpotAlerts(function(res) {
              alertModule.loadAlertPage(res);
              // To update notification string
              $('.price-alert-value').trigger('keyup');
            });
          } else if (/verification/.test(window.location.pathname)) {
            //wholeScreenPopupModule.open('.login-signup');
          } else if (/accountcreated/.test(window.location.pathname)) {
            window.location.href = '/';
          } else if (window.location.pathname === '/sell/') {
            $('.change-sell-value').each(function(i, el) {
              $(el).val('');
            })
            sellCheckoutModule.loadSellPage(true);
            sellCheckoutModule.displaySellLogin(false);
          } else if (/\/buy\/checkout\/?/.test(window.location.pathname)) {
            window.location.reload();
          } else if (/\/buy\/creditcardpayment\/?/.test(window.location.pathname)) {

          } else if (/\/buy\/?/.test(window.location.pathname)) {
            productModule.getProductPrice(getAllProductIdsArr(), getCurrency())
          } else if (window.location.pathname === '/vault-storage-united-states/' ||
            window.location.pathname === '/vault-storage-singapore/' ||
            window.location.pathname === '/vault-storage-new-zealand/') {
            hideVaultPageOpenAccountLink(false);
          } else if (/auctions/.test(window.location.pathname)) {
            window.location.reload();
          }
        }

        shoppingCartModule.refresh();
        localStorage.setItem('hasOrders', 'no');
      }
    });

    req.call();
  }

  return {
    login: login,
    logout: logout,
    authenticateMachine: authenticateMachine,
    authenticateIP: authenticateIP,
    resendTwoFactorCode: resendTwoFactorCode,
    sendTwoFactorAuth: sendTwoFactorAuth,
    sendTwoFactorAuthGoogle: sendTwoFactorAuthGoogle,
  }
}());

/* Add for mocha testing */
// Basically it make the authenticationModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = authenticationModule;
}
/***********************************************************/
/***********************************************************/
/* Account Module */
/***********************************************************/
/***********************************************************/

var accountModule = (function() {
  var url = '/api/v1/account/',
    completionCheckCount = 0,
    completionCheckDelay = 0,
    resendCtr = 0,
    resendTimer = 120;

  /*
    DESC: Create a personal user account. USED IN: /createaccount
    POST: /v1/account/createIndividual
    email = '';
    hashedPassword = '';
    twoFactorAuthentication = false;

    // Main
    name = '';
    nationalityCode = '';
    phoneNumber = '';
    phoneCountry = '';
    address1 = '';
    address2 = '';
    postCode = '';
    state = '';
    city = '';
    countryCode = '';

    // Joint #1
    nameJoint1 = '';
    nationalityCodeJoint1 = '';
    phoneNumberJoint1 = '';
    phoneCountryJoint1 = '';
    address1Joint1 = '';
    address2Joint1 = '';
    postCodeJoint1 = '';
    stateJoint1 = '';
    cityJoint1 = '';
    countryCodeJoint1 = '';

    // Joint #2
    nameJoint2 = '';
    nationalityCodeJoint2 = '';
    phoneNumberJoint2 = '';
    phoneCountryJoint2 = '';
    address1Joint2 = '';
    address2Joint2 = '';
    postCodeJoint2 = '';
    stateJoint2 = '';
    cityJoint2 = '';
    countryCodeJoint2 = '';
  */

  function createIndividual(data) {
    data.machineId = getMachineId();
    data.sessionId = sessionModule.getSessionId();
    data.coupons = getCouponString();

    addAffiliateParameters(data);

    var req = new Request(servicesUrl + '/account/v1/createIndividual', data);

    req.success(function(res) {
      if (res.success) {
        updateUserHeader(res);
        window.location.href = '/accountcreated';
      }
    });

    req.call();
  }

  /*
    DESC: Create a business user account. USED IN: /createaccount
    POST: /v1/account/createBusiness
    email = '';
    hashedPassword = '';
    twoFactorAuthentication = false;

    // Main
    name = '';
    registrationCountryCode = '';

    businessType = '';
    businessTaxNumber = '';

    phoneNumber = '';
    phoneCountry = '';
    address1 = '';
    address2 = '';
    postCode = '';
    state = '';
    city = '';
    countryCode = '';

    // Signatory #1
    nameJoint1 = '';
    nationalityCodeJoint1 = '';
    phoneNumberJoint1 = '';
    phoneCountryJoint1 = '';
    address1Joint1 = '';
    address2Joint1 = '';
    postCodeJoint1 = '';
    stateJoint1 = '';
    cityJoint1 = '';
    countryCodeJoint1 = '';

    // Signatory #2
    nameJoint2 = '';
    nationalityJoint2 = '';
    phoneNumberJoint2 = '';
    phoneCountryJoint2 = '';
    address1Joint2 = '';
    address2Joint2 = '';
    postCodeJoint2 = '';
    stateJoint2 = '';
    cityJoint2 = '';
    countryCodeJoint2 = '';

    // Signatory #3
    nameJoint3 = '';
    nationalityJoint3 = '';
    phoneNumberJoint3 = '';
    phoneCountryJoint3 = '';
    address1Joint3 = '';
    address2Joint3 = '';
    postCodeJoint3 = '';
    stateJoint3 = '';
    cityJoint3 = '';
    countryCodeJoint3 = '';

    // Signatory #4
    nameJoint4 = '';
    nationalityJoint4 = '';
    phoneNumberJoint4 = '';
    phoneCountryJoint4 = '';
    address1Joint4 = '';
    address2Joint4 = '';
    postCodeJoint4 = '';
    stateJoint4 = '';
    cityJoint4 = '';
    countryCodeJoint4 = '';
  */

  function createBusiness(data) {
    data.machineId = getMachineId();
    data.sessionId = sessionModule.getSessionId();
    data.coupons = getCouponString();

    addAffiliateParameters(data);

    var req = new Request(servicesUrl + '/account/v1/createBusiness', data);

    req.success(function(res) {
      if (res.success) {
        updateUserHeader(res);
        window.location.href = '/accountcreated';
      }
    });

    req.call();
  }

  /*
    DESC: Create a legal arrangement user account. USED IN: /createaccount
    POST: /v1/account/createLegalArrangement
    email = '';
    hashedPassword = '';
    twoFactorAuthentication = false;

    // Main
    name = '';
    registrationCountryCode = '';
    entityType = '';
    phoneNumber = '';
    phoneCountry = '';
    address1 = '';
    address2 = '';
    postCode = '';
    state = '';
    city = '';
    countryCode = '';

    // Signatory #1
    nameJoint1 = '';
    nationalityJoint1 = '';
    phoneNumberJoint1 = '';
    phoneCountryJoint1 = '';
    address1Joint1 = '';
    address2Joint1 = '';
    postCodeJoint1 = '';
    stateJoint1 = '';
    cityJoint1 = '';
    countryCodeJoint1 = '';

    // Signatory #2
    nameJoint2 = '';
    nationalityJoint2 = '';
    phoneNumberJoint2 = '';
    phoneCountryJoint2 = '';
    address1Joint2 = '';
    address2Joint2 = '';
    postCodeJoint2 = '';
    stateJoint2 = '';
    cityJoint2 = '';
    countryCodeJoint2 = '';

    // Signatory #3
    nameJoint3 = '';
    nationalityJoint3 = '';
    phoneNumberJoint3 = '';
    phoneCountryJoint3 = '';
    address1Joint3 = '';
    address2Joint3 = '';
    postCodeJoint3 = '';
    stateJoint3 = '';
    cityJoint3 = '';
    countryCodeJoint3 = '';

    // Signatory #4
    nameJoint4 = '';
    nationalityJoint4 = '';
    phoneNumberJoint4 = '';
    phoneCountryJoint4 = '';
    address1Joint4 = '';
    address2Joint4 = '';
    postCodeJoint4 = '';
    stateJoint4 = '';
    cityJoint4 = '';
    countryCodeJoint4 = '';
  */

  function createLegalArrangement(data, cb) {
    data.machineId = getMachineId();
    data.sessionId = sessionModule.getSessionId();
    data.coupons = getCouponString();

    addAffiliateParameters(data);

    var req = new Request(servicesUrl + '/account/v1/createLegalArrangement', data);

    req.success(function(res) {
      if (res.success) {
        updateUserHeader(res);
        window.location.href = '/accountcreated';
      }
    });


    req.call();
  }

  /*
    DESC: Check if email exists. USED IN: /createaccount
    POST: /account/details/email-exists
    email = '';
  */

  function emailExists(data) {
    var req = new Request(servicesUrl + '/account/details/email-exists', data);

    req.afterErrorDialogFunction(function(res) {

    });

    req.success(function(res) {
      if (res.success) {
        return true;
      }
    });

    req.error(function(res) {
      return false;
    });

    req.call();
  }

  /*
    DESC: Update a user account: USED IN: After sign up
    POST /api/v1/account/update
    email=admin@bullionint.com
    hashedPassword=XXXXXXX (MD5 Hased)
    name=Joakim Andersson
    company=Bullion International Ltd
    phoneCountry=PH
    phoneNumber=9158908699
    address1=12 test street
    address2=test building
    postCode=12345
    state=NV
    city=Las Vegas
    countryCode=US
    twoFactorAuthentication=false
  */
  function updateAccount(data) {
    data.machineId = getMachineId();
    data.ct = getCT();
    data.locationId = getLocation();
    var req = new Request(servicesUrl + '/account/details/update', data);

    req.afterErrorDialogFunction(function() {
      formValidationModule.focusOnFirstError('#account-details');
    });

    req.success(function(res) {
      var msg = 'As you have changed your mobile phone number and have 2-factor authentication turned on, a code has been sent to your new mobile phone number for you to re-activate the 2-factor authentication. Please enter the code sent to your mobile phone in the field below.',
        options = {
          title: 'Two Factor Authentication',
          message: msg,
          okCallback: function() {
            accountModule.deactivate2FA(function() {
              $('.nav-details li').eq(1).trigger('click');
              $('#two-factor-auth')[0].checked = false;
              setTimeout(function() {
                accountModule.activate2FA();
              }, 100);
            });
          }
        };

      if (res.twoFactorAuthenticationDisabled) {
        var popup = new Popup(options);
        popup.render();
      }
      updateUserHeader(res);
    });

    req.afterSuccessDialogFunction(function(res) {
      if (res.redirectUrl.length) {
        window.location.href = res.redirectUrl;
      }
    });

    req.call();
  }

  /*
    DESC: Get user details. USED IN: adddetails page
    POST /account/details/get
  */
  function getDetails(cb) {
    var req = new Request(servicesUrl + '/account/details/get', {});

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  function checkJointVisibility() {
    for (var i = 1; i <= 4; i++) {
      if ($('#name-joint-' + i).length > 0 && $('#name-joint-' + i).val().trim().length > 0 && $('#name-joint-' + i).closest('.joint').hasClass('hide')) {
        $('#name-joint-' + i).closest('.joint').prev('.show-other-fields').trigger('click');
      }
    }
  }

  /*
    DESC: Populate user details fields. USED IN: adddetails and /myaccount/details, /sell, /buy/checkout page
  */
  function setAccountDetails(res) {
    // Trigger keyup to force show of label for each fields

    var count = 2;
    var numMandatory = 0;

    // Default
    $('.account-number').text(res.accountId ? res.accountId : '');

    if (res.email) {
      $('#email').val(res.email).prev().trigger('click');
    }
    if (res.phoneCountry) {
      $('#country-code-selection').val(res.phoneCountry ? res.phoneCountry : getGeoCountry());
      $('#country-code-selection').trigger('change');
    }
    if (res.phoneNumber) {
      $('#phone-number').val(res.phoneNumber);
    }
    if (res.name) {
      $('#name').val(res.name).prev().trigger('click');
    }
    if (res.company) {
      $('#company').val(res.company).prev().trigger('click');
    }
    if (res.address1) {
      $('#address1').val(res.address1).prev().trigger('click');
    }
    if (res.address1) {
      $('#address2').val(res.address2).prev().trigger('click');
    }
    if (res.city) {
      $('#city').val(res.city).prev().trigger('click');
    }
    if (res.countryCode) {
      $('#country').val(res.countryCode ? res.countryCode : getGeoCountry());
      $('#country').trigger('change');
    }
    if (res.postCode) {
      $('#post-code').val(res.postCode).prev().trigger('click');
    }
    if (res.state) {
      $('#state-textfield').val(res.state).prev().trigger('click');
      $('#state-dropdown').val(res.state).trigger('change');
    }

    if (res.type === 'PERSONAL') {
      count = 2;
      numMandatory = 0;
      $('#nationality').val(res.nationalityCode).trigger('change');
    } else if (res.type === 'LEGAL_PERSON') {
      count = 4;
      numMandatory = 1;
      $('#business-number').val(res.businessTaxNumber).prev().trigger('click');
      $('#business-type').val(res.businessType);
      $('#country-registration').val(res.registrationCountryCode ? res.registrationCountryCode : getGeoCountry());
      $('#country-registration').trigger('change');
    } else if (res.type === 'LEGAL_ARRANGEMENT') {
      count = 4;
      numMandatory = 1;
      $('#entity').val(res.entityType);
      $('#country-registration').val(res.registrationCountryCode ? res.registrationCountryCode : getGeoCountry());
      $('#country-registration').trigger('change');
    }

    // Joint
    // Note: For buy/checkout, auctions/checkout, /sell/, /vault/sell, /vault/withdraw, /vault/withdrawbsp, /vault/audit page this code block should be ignored because we don't show joint/user account there
    if (window.location.pathname !== '/buy/checkout' &&
      window.location.pathname.indexOf('/auctions/checkout') === -1 &&
      window.location.pathname !== '/sell/' &&
      window.location.pathname !== '/vault/sell' &&
      window.location.pathname !== '/vault/withdraw' &&
      window.location.pathname !== '/vault/withdrawbsp' &&
      window.location.pathname !== '/vault/audit') {
      for (var i = 1; i <= count; i++) {
        // Check if has full name
        if (res['nameJoint' + i].length) {
          if (res['phoneCountryJoint' + i] != '') {
            $('#country-code-selection-joint-' + i).val(res['phoneCountryJoint' + i] ? res['phoneCountryJoint' + i] : getGeoCountry());
            $('#country-code-selection-joint-' + i).trigger('change');
          }
          if (res['phoneNumberJoint' + i] != '') {
            $('#phone-number-joint-' + i).val(res['phoneNumberJoint' + i]);
          }
          if (res['nameJoint' + i] !== '') {
            $('#name-joint-' + i).val(res['nameJoint' + i]).prev().trigger('click');
          }
          if (res['nationalityCodeJoint' + i] !== '') {
            $('#nationality-joint-' + i).val(res['nationalityCodeJoint' + i]).prev().trigger('click');
            $('#nationality-joint-' + i).val(res['nationalityCodeJoint' + i]).trigger('change');
          }
          if (res['address1Joint' + i] !== '') {
            $('#address1-joint-' + i).val(res['address1Joint' + i]).prev().trigger('click');
          }
          if (res['address2Joint' + i] !== '') {
            $('#address2-joint-' + i).val(res['address2Joint' + i]).prev().trigger('click');
          }
          if (res['cityJoint' + i] !== '') {
            $('#city-joint-' + i).val(res['cityJoint' + i]).prev().trigger('click');
          }
          if (res['countryCodeJoint' + i] !== '') {
            $('#country-joint-' + i).val(res['countryCodeJoint' + i] ? res['countryCodeJoint' + i] : getGeoCountry());
            $('#country-joint-' + i).trigger('change');
          }
          if (res['postCodeJoint' + i] !== '') {
            $('#post-code-joint-' + i).val(res['postCodeJoint' + i]).prev().trigger('click');
          }
          if (res['stateJoint' + i] !== '') {
            $('#state-joint-' + i + '-textfield').val(res['stateJoint' + i]).prev().trigger('click');
            $('#state-joint-' + i + '-dropdown').val(res['stateJoint' + i]).trigger('change');
            if (res['countryCodeJoint' + i] === 'US') {
              $('#state-joint-' + i).closest('.state-form-field').addClass('hide');
              $('#state-joint-' + 1 + '-dropdown').closest('.state-form-select-field').removeClass('hide');
            }
          }
        } else {
          // Hide form-fields
          // Rule hide form fields optional
          if (res.type === 'PERSONAL' || res.type !== 'PERSONAL' && i > 1) {
            $('#country-code-selection-joint-' + i).parents('.form-field').addClass('hide');
            $('#phone-number-joint-' + i).parents('.form-field').addClass('hide');
            $('#nationality-joint-' + i).parents('.form-field').addClass('hide');
            $('#address1-joint-' + i).parents('.form-field').addClass('hide');
            $('#address2-joint-' + i).parents('.form-field').addClass('hide');
            $('#city-joint-' + i).parents('.form-field').addClass('hide');
            $('#state-joint-' + i).parents('.form-field').addClass('hide');
            $('#post-code-joint-' + i).parents('.form-field').addClass('hide');
            $('#country-joint-' + i).parents('.form-field').addClass('hide');
          }
        }
      }
    }

    // Show Optional User/Signatories if fullname is not empty
    checkJointVisibility();

    if (res.hasPin) {
      hidePinForm();
    }

    if (res.twoFactorSMSAvailable) {
      $('#two-fa-sms').show();
    } else {
      $('#two-fa-sms').hide();
    }

    if ($('#two-factor-auth').length) {
      if (res.twoFactorAuthenticationEnabled) {
        $('#two-factor-auth')[0].checked = true;
      } else {
        $('#two-factor-auth')[0].checked = false;
      }
    }

    if ($('#two-factor-auth-google').length) {
      if (res.twoFactorAuthenticationGoogleAuthenticatorEnabled) {
        $('#two-factor-auth-google')[0].checked = true;
      } else {
        $('#two-factor-auth-google')[0].checked = false;
      }
    }

    if ($('#sms').length) {
      if (res.acceptSMS) {
        $('#sms')[0].checked = true;
      } else {
        $('#sms')[0].checked = false;
      }
    }
  }

  function hidePinForm() {
    $('.form-body').eq(3).addClass('hide'); // Hide form
    $('.nav-details li').eq(3).addClass('hide'); // Hide nav
    $('.nav-details').addClass('no-pin'); // Adjust css
    $('.nav-details li').eq(0).trigger('click'); // Arigger account details
  }

  /*
    DESC: Load /myaccount/details page
  */
  function loadDetailsPage(res) {

    if (res.type === 'PERSONAL') {
      $('#account-details').html(tmpl($('#tmpl-details-personal').html()));
      $('.account-type span').text('Personal');
      initLandCode('#country-code-selection');
      initLandCode('#country-code-selection-joint-1');
    } else if (res.type === 'LEGAL_PERSON') {
      $('#account-details').html(tmpl($('#tmpl-details-business').html()));
      $('.account-type span').text('Business');
      initLandCode('#country-code-selection');
      initLandCode('#country-code-selection-joint-1');
      initLandCode('#country-code-selection-joint-2');
      initLandCode('#country-code-selection-joint-3');
      initLandCode('#country-code-selection-joint-4');
    } else if (res.type === 'LEGAL_ARRANGEMENT') {
      $('#account-details').html(tmpl($('#tmpl-details-tfi').html()));
      $('.account-type span').text('Trust / Foundation / IRA');
      initLandCode('#country-code-selection');
      initLandCode('#country-code-selection-joint-1');
      initLandCode('#country-code-selection-joint-2');
      initLandCode('#country-code-selection-joint-3');
      initLandCode('#country-code-selection-joint-4');
    }

    changeCountryFields();

    if (Object.size(res.additionalCountries)) {
      $.each(res.additionalCountries, function(i, country) {
        $('.country-select').prepend('<option value="' + country.countryCode + '">' + country.countryName + '</option>');
        $('.country-code-selection').prepend('<option value="' + country.countryCode + '" data-country="' + country.countryCodeLC + '" data-country-name="' + country.countryName + '" data-code="' + country.phoneCode + '">+' + country.phoneCode + ' ' + country.countryName + '</option>');
      });
    }

    setAccountDetails(res);

    if (res.type === 'PERSONAL') {
      countrySelect('#nationality');
      countrySelect('#country');
      countrySelect('#nationality-joint-1');
      countrySelect('#country-joint-1');
    } else if (res.type === 'LEGAL_PERSON') {
      countrySelect('#country-registration');
      countrySelect('#country');
      countrySelect('#nationality-joint-1');
      countrySelect('#nationality-joint-2');
      countrySelect('#nationality-joint-3');
      countrySelect('#nationality-joint-4');
      countrySelect('#country-joint-1');
      countrySelect('#country-joint-2');
      countrySelect('#country-joint-3');
      countrySelect('#country-joint-4');
    } else if (res.type === 'LEGAL_ARRANGEMENT') {
      countrySelect('#country-registration');
      countrySelect('#country');
      countrySelect('#nationality-joint-1');
      countrySelect('#nationality-joint-2');
      countrySelect('#nationality-joint-3');
      countrySelect('#nationality-joint-4');
      countrySelect('#country-joint-1');
      countrySelect('#country-joint-2');
      countrySelect('#country-joint-3');
      countrySelect('#country-joint-4');
    }

    if (detectIE()) {
      $('.txt-pin-code').attr('type', 'password');
    }

    $('#btn-save-changes').on('click', function(e) {

      checkJointVisibility();

      formValidationModule.validateForm($('#account-details'), 'Update Account Details', function(data) {
        data.phoneCountry = $('#country-code-selection').val();
        data.countryCode = $('#country').val();
        data.registrationCountryCode = $('#country-registration').val();

        if (res.type === 'PERSONAL') {
          data.nationalityCode = $('#nationality').val();
        }

        if (res.type === 'LEGAL_PERSON') {
          data.businessType = $('#business-type').val();
        }

        if (res.type === 'LEGAL_ARRANGEMENT') {
          data.entityType = $('#entity').val();
        }

        // Joint #1
        data.nationalityCodeJoint1 = $('.account-form .joint-account .joint-1 #nationality-joint-1').val();
        data.phoneCountryJoint1 = $('.account-form .joint-account .joint-1 #country-code-selection-joint-1').val();
        data.countryCodeJoint1 = $('.account-form .joint-account .joint-1 #country-joint-1').val();
        if (data.countryCodeJoint1 === 'US') {
          data.stateJoint1 = $('.state-form-select-field select[data-param=stateJoint1]').val();
        }

        // Joint #2
        data.nationalityCodeJoint2 = $('.account-form .joint-account .joint-2 #nationality-joint-2').val();
        data.phoneCountryJoint2 = $('.account-form .joint-account .joint-2 #country-code-selection-joint-2').val();
        data.countryCodeJoint2 = $('.account-form .joint-account .joint-2 #country-joint-2').val();

        if (res.type !== 'PERSONAL') {
          // Joint #3
          data.nationalityCodeJoint3 = $('.account-form .joint-account .joint-3 #nationality-joint-3').val();
          data.phoneCountryJoint3 = $('.account-form .joint-account .joint-3 #country-code-selection-joint-3').val();
          data.countryCodeJoint3 = $('.account-form .joint-account .joint-3 #country-joint-3').val();

          // Joint #4
          data.nationalityCodeJoint4 = $('.account-form .joint-account .joint-4 #nationality-joint-4').val();
          data.phoneCountryJoint4 = $('.account-form .joint-account .joint-4 #country-code-selection-joint-4').val();
          data.countryCodeJoint4 = $('.account-form .joint-account .joint-4 #country-joint-4').val();
        }

        accountModule.update(data);
      }, null, true);
    });

    var urlParams = getUrlVars();
    if ('tab' in urlParams) {
      console.log(urlParams.tab)
      if (urlParams.tab === '2fa') {
        $('.nav-details li').eq(1).trigger('click');
      } else if (urlParams.tab === 'password') {
        $('.nav-details li').eq(2).trigger('click');
      } else if (urlParams.tab === 'pin' && $('.nav-details li').eq(3).is(':visible')) {
        $('.nav-details li').eq(3).trigger('click');
      } else if (urlParams.tab === 'document') {
        $('.nav-details li').eq(4).trigger('click');
      }
    }

    // load auction settings
    if (isAuctionsEnabled()) {
      var accountAuctionSettings = (function() {
        function load() {
          getSettings();
        }

        function getSettings() {
          auctionModule.getSettings(function(res) {
            loadFields(res);
          });
        }

        function loadFields(res) {
          // initShippingField(res);
          // initSettlementCurrencyField(res);
          // initPaymentMethodField(res);
          initNotificationFields(res);
          initSaveField(res);
        }

        // function initShippingField(res) {
        //   if (res.shippingMethods && res.shippingMethods.length > 0) {
        //     $('#preferredShippingMethodId').html(res.shippingMethods.map(function(item) {
        //       return '<option value="' + item.id + '">' + item.title + '</option>'
        //     }).join(''));

        //     if (res.preferredShippingMethodId == -1) {
        //       $('#preferredShippingMethodId option:contains(Personal Collection (Pick-up) Singapore)').prop('selected', true);
        //     } else {
        //       $('#preferredShippingMethodId').val(res.preferredShippingMethodId);
        //     }
        //   }
        // }

        // function initSettlementCurrencyField(res) {
        //   var currencyOptions = [];
        //   $('input[name=header-currency]').parent().each(function(i, el) {
        //       currencyOptions.push('<option value="' + $(el).find('input[name=header-currency]').val() + '">' + $(el).find('.bullion-radio-title-half').html() + '</option>')
        //   });
        //   $('#preferredCurrency').html(currencyOptions.join(''));
        //   if (res.preferredCurrency && res.preferredCurrency.length > 0) {
        //     $('#preferredCurrency').val(res.preferredCurrency);
        //   } else {
        //     $('#preferredCurrency').val('SGD');
        //   }
        // }

        // function initPaymentMethodField(res) {
        //   if (res.paymentMethods && res.paymentMethods.length > 0) {
        //     $('#preferredPaymentMethodId').html(res.paymentMethods.map(function(item) {
        //       return '<option value="' + item.id + '">' + item.title + '</option>'
        //     }).join(''));

        //     if (res.preferredPaymentMethodId == -1) {
        //       $('#preferredPaymentMethodId option:contains(SGD Bank Transfer - OCBC)').prop('selected', true);
        //     } else {
        //       $('#preferredPaymentMethodId').val(res.preferredPaymentMethodId);
        //     }
        //   }
        // }

        function initNotificationFields(res) {
          $('#email-overbid').prop('checked', res.notifyWhenOutbidEmail);
          $('#email-expiry').prop('checked', res.notifyWhenAuctionExpiryEmail);
          $('#sms-overbid').prop('checked', res.notifyWhenOutbidSms);
          $('#sms-expiry').prop('checked', res.notifyWhenAuctionExpirySms);
        }

        function initSaveField(res) {
          $('#auction .toggle-checkbox').on('change', function() {
            new Loading().render();
            var accountAuctionSettings = {
              accountId: res.accountId,
              // preferredShippingMethodId: $('#preferredShippingMethodId').val(),
              // preferredCurrency: $('#preferredCurrency').val(),
              // preferredPaymentMethodId: $('#preferredPaymentMethodId').val(),
              notifyWhenOutbidEmail: $('#email-overbid').prop('checked'),
              notifyWhenAuctionExpiryEmail: $('#email-expiry').prop('checked'),
              notifyWhenOutbidSms: $('#sms-overbid').prop('checked'),
              notifyWhenAuctionExpirySms: $('#sms-expiry').prop('checked')
            }

            auctionModule.updateSettings(accountAuctionSettings, function() {
              new Loading().close();
            });
          });
        }


        return {
          load: load
        };
      }());

      accountAuctionSettings.load();
    }

  }

  /*
    DESC: Activates 2 Factor Authentication SMS. USED IN: /myaccount/details page
    POST /api/v2/account/testTwoFactor
  */
  function activateTwoFactorNoAccount(data, cb) {
    var req = new Request(servicesUrl + '/account/v1/testTwoFactor', data);

    req.success(function(res) {
      var options = {
        phoneNumber: data.phoneNumber,
        phoneCountry: data.phoneCountry,
        code: res.code
      }
      var popup2fa = new PopupTwoFactorAuthNoAccount(options);
      popup2fa.render();

      if (!resendCtr) {
        $('.popup-2fa-no-account .btn-resend').addClass('disabled');
        codeTimer(resendTimer, $('.popup-2fa-no-account .btn-resend'));
      } else {
        $('.popup-2fa-no-account .btn-resend').removeClass('disabled');
      }

      typeof cb === 'function' && cb(res);
    });

    req.call();
  }

  /*
    DESC: Activates 2 Factor Authentication. USED IN: /myaccount/details page
    POST /api/v1/account/activateTwoFactor
  */
  function activateTwoFactor() {
    var req = new Request(servicesUrl + '/account/v1/activateTwoFactor', {
      ct: getCT()
    });

    req.success(function(res) {
      if (res.success) {
        var popup = new PopupTwoFactorAuthDetails();
        popup.render();
        codeTimer(resendTimer, $('.popup-details-2fa .btn-resend'));
      }
    });

    req.call();
  }

  /*
    DESC: Deactivate 2 Factor Authentication. USED IN: /myaccount/details page
    POST /api/v1/account/deactivateTwoFactor
  */
  function deactivateTwoFactor(cb) {
    var req = new Request(servicesUrl + '/account/v1/deactivateTwoFactor', {});

    req.success(function(res) {
      typeof cb === 'function' && cb();
    });

    req.call();
  }

  /*
    DESC: Activate 2 factor authentication. USED IN: Popup /myaccount/details page
    POST /api/v1/account/activateTwoFactorCode
    code=12345
  */
  function activateTwoFactorCode(data, successCb) {
    data.ct = getCT();
    var req = new Request(servicesUrl + '/account/v1/activateTwoFactorCode', data);

    req.success(function(res) {
      if (res.success) {
        $('#two-factor-auth')[0].checked = true;
        typeof successCb === 'function' && successCb();
      } else { // res.error/warning = true Error or Warning
        console.log(res.message);
        $('#two-factor-auth')[0].checked = false;
      }
    });

    req.call();
  }

  /*
    DESC: Resend 2 factor authentication. USED IN: Popup /myaccount/details page
    POST /api/v1/account/resendTwoFactorCode
  */
  function resendTwoFactorCode() {

    var req = new Request(servicesUrl + '/account/v1/resendTwoFactorCode', {});

    req.success(function(res) {
      if (res.success) {
        var options = {
          title: '2-Factor Authentication',
          message: 'The code has been re-sent.',
          okCallback: function() {
            $('.popup-details-2fa .btn-resend').addClass('disabled');
            codeTimer(resendTimer, $('.popup-details-2fa .btn-resend'));
          }
        };
        var popup = new Popup(options);
        popup.render();
      } else { // res.error/warning = true Error or Warning
        console.log(res.message);
      }
    });

    req.call();
  }

  /*
    DESC: Shows 2 factor authentication popup and start the resend button timer. 
    USED IN: activateTwoFactorCode() and resendTwoFactorCode()
  */
  function after2Factor() {
    // Show 2 Factor auth popup
    popupModule.open($('.popup-2-factor-auth-activate'), 'popup2FactorAuthActivate');

    if (!resendCtr && $('.popup-2-factor-auth-activate .btn-activate-resend').hasClass('disabled')) {
      codeTimer(resendTimer);
    }
    $('.popup-2-factor-auth-activate input').val('').trigger('focus');
  }

  function activate2FAGoogle() {
    var req = new Request(servicesUrl + '/account/v1/activateTwoFactorGoogleAuthenticator', {
      ct: getCT()
    });

    req.success(function(res) {
      if (res.success) {
        var encodedQRCode = encodeURIComponent(res.qrCode)
        var popup = new PopupTwoFactorAuthGoogleDetails(encodedQRCode, 140, 140, res.secretKey);
        popup.render();
      }
    });

    req.call();
  }

  function deactivate2FAGoogle(cb) {
    var req = new Request(servicesUrl + '/account/v1/deactivateTwoFactorGoogleAuthenticator', {
      ct: getCT()
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb();
      }
    });

    req.call();
  }

  /*
    DESC: Shows 2 factor google authentication popup. 
    USED IN: /myaccount/details page
  */
  function activate2FAGoogleCode(data, cb) {
    data.ct = getCT();
    var req = new Request(servicesUrl + '/account/v1/activateTwoFactorGoogleAuthenticatorCodes', data);

    req.afterErrorDialogFunction(function(res) {
      $('.single-input-wrap input').eq(0).trigger('focus');
    });

    req.success(function(res) {
      if (res.success) {
        $('#two-factor-auth-google')[0].checked = true;
        typeof cb === 'function' && cb();
      }
    });

    req.call();
  }

  /*
    DESC: Generate a secret key. USED IN: /createaccount page
    POST /api/v2/account/ga/generate
  */
  function generateGoogle2FASecretKey(email) {
    var req = new Request(servicesUrl + '/account/v1/ga/generate', {
      email: email
    });

    req.success(function(res) {
      if (res.success) {
        var encodedQRCode = encodeURIComponent(res.qrCode)
        var popup = new PopupTwoFactorGoogleAuthNoAccount(encodedQRCode, 140, 140, res.secretKey, res.secretKeyId);
        popup.render();
      }
    });

    req.call();
  }

  /*
    DESC: Validate google auth code. USED IN: /myaccount/details page
    POST /api/v2/account/ga/validate
  */
  function validateGoogle2FA(data, successCb, errorCb) {
    var req = new Request(servicesUrl + '/account/v1/ga/validate', data);

    req.afterErrorDialogFunction(function() {
      typeof errorCb === 'function' && errorCb();
    });

    req.success(function(res) {
      if (res.success) {
        typeof successCb === 'function' && successCb();
      }
    });

    req.call();
  }

  /*
    DESC: Starts timer of resend code button. 
    USED IN: after2Factor()
  */
  function codeTimer(num, button) {
    clearInterval(resendCtr); // clear
    resendCtr = 0;
    createCookie('2FAtimer', 0, 1);

    var $button = button || $('.popup-2fa .btn-resend');

    resendCtr = setInterval(function() {
      $button.find('span').text('(' + num + ')');
      if (num == 0) {
        clearInterval(resendCtr); // clear
        resendCtr = 0;
        $button.find('span').empty();
        $button.removeClass('disabled');
        createCookie('2FAtimer', 1, 1);
      }
      num--;
    }, 1000);
  }

  /*
    DESC: Receive order and payment updates to your phone. USED IN: /myaccount/details page
    POST /account/v1/setAcceptSMS
  */
  function acceptSMS(data, cb) {
    data.ct = getCT();
    var req = new Request(servicesUrl + '/account/v1/setAcceptSMS', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb();
      }
    });

    req.call();
  }

  /*
    DESC: Set debit storage fee. USED IN: /myaccount/storagecharges
    POST /account/v1/setDebitStorageFeeToAccount
  */
  function setDebitStorageFee(data, cb) {
    var req = new Request(servicesUrl + '/account/v1/setDebitStorageFeeToAccount', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  /*
    DESC: Set invoice currency. USED IN: /myaccount/storagecharges
    POST /account/v1/setInvoiceCurrency
  */
  function setInvoiceCurrency(data, cb) {
    var req = new Request(servicesUrl + '/account/v1/setInvoiceCurrency', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  /*
    DESC: Get the info and shopping cart of the user. USED IN: After every page loads
    POST /api/v1/account/info
  */
  function info(successCb, alwaysCb) {
    console.log('calling /info');
    var req = new Request(servicesUrl + '/account/v1/info', {
      valuation: getValuation(),
      locationId: getLocation()
    });

    req.noApiErrorPopup = true;

    req.success(function(res) {
      infoResponseHandler(res, successCb);
      typeof alwaysCb === 'function' && alwaysCb();
    });

    req.send();
  }

  function infoResponseHandler(res, successCb) {
    removeHash();

    $('.currency-wrap .radio-one-line input[value="' + getCurrency() + '"]').prop('checked', true);
    $('.currency-wrap').find('.type').text(getCurrency());
    $('.currency-label').html(getCurrency()); // Used to display Currency in various pages such as /myaccount/dashboard

    if (res.loggedIn) {
      // Show Account information on the header
      updateUserHeader(res);

      localStorage.setItem('hasOrders', res.accountInfo.hasOrders ? 'yes' : 'no');

      updateHomeBanners();

      // Update pricing
      setApg(res.accountInfo.accountPricingGroupId);
      //changeProductPricing(res.accountInfo.accountPricingGroupId);

      // Save page state for /buy/checkout page
      if (window.location.pathname !== '/buy/checkout') {
        eraseCookie('buyCheckoutOverview');
      }

      if (window.location.pathname === '/login') {
        var urlParams = getUrlVars(),
          redirectUrl = '/';

        if (urlParams.redirectUrl !== undefined) {
          redirectUrl = decodeURIComponent(urlParams.redirectUrl);
        }

        window.location.href = redirectUrl;
      }

      typeof successCb === 'function' && successCb();

    } else {
      // Update Header to default.
      updateUserHeader(null);

      // Update pricing
      eraseCookie('apg');
      removeApg();
      //changeProductPricing();

      eraseCookie('buyCheckoutOverview');
    }
  }

  /*
    DESC: Change user password. USED IN: /myaccount/details page
    POST /account/v1/changePassword
  */
  function changePassword(data, cb) {
    data.machineId = getMachineId();
    data.ct = getCT();
    var req = new Request(servicesUrl + '/account/v1/changePassword', data);

    req.afterSuccessDialogFunction(function() {
      formValidationModule.resetForm('#account-password');
    });

    req.afterErrorDialogFunction(function() {
      formValidationModule.showError('#account-password', 'oldHashedPassword');
    });

    req.call();
  }

  /*
    DESC: Forgot user password. USED IN: Forgot password page
    POST /api/v1/account/forgotPassword
  */
  function forgotPassword(data, cb) {
    data.machineId = getMachineId();
    var req = new Request(servicesUrl + '/account/v1/forgot-password', data);

    req.afterSuccessDialogFunction(function() {
      typeof cb === 'function' && cb();
    });

    req.call();
  }

  /*
    DESC: Reset user password. USED IN: After forgot password email link clicked
    POST /api/v1/account/resetPassword
  */
  function resetPassword(data) {
    data.machineId = getMachineId();
    var req = new Request(servicesUrl + '/account/v1/resetPassword', data);

    req.afterSuccessDialogFunction(function() {
      window.location.href = '/login'
    });

    req.call();

  }

  /*
    DESC: Set user PIN. USED IN: /myaccount/details page
    POST /api/v1/account/setPin
  */
  function setPin(data, cb) {
    data.ct = getCT();
    var req = new Request(servicesUrl + '/account/v1/setPin', data);

    req.success(function(res) {
      typeof cb === 'function' && cb(res);
    });

    req.call();
  }

  /*
    DESC: Get transactions. USED IN: /myaccount/transactions NOT USED ANYMORE
    POST /api/v1/account/transactions
  */
  function getTransactions(cb) {
    var req = new Request(servicesSGUrl + url + 'transactions', {});

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  /*
    DESC: Get Deposit Payment method. USED IN: /myaccount/addfunds
    POST /account/v1/svf/getDepositPaymentMethods
  */
  function getDepositPaymentMethods(cb) {
    var req = new Request(servicesUrl + '/account/v1/svf/getDepositPaymentMethods', {
      locationId: getLocation()
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  /*
    DESC: Load Addfunds page. USED IN: /myaccount/addfunds
  */
  function loadAddfundsPage(res) {

    function checkPaymentMaxAmount() {
      $('.funding-option .radio-one-line, .funding-option .radio-description').each(function(i, item) {
        if ($(item).data('max-amount') !== '') {
          if ($('#amount').val() > $(item).data('max-amount')) {
            $(item).addClass('hide');
            if ($(item).find('input').attr('id') === $('[name=funds-' + $('.add-funds-wrap input[name=currency]:checked').val().toLowerCase() + ']:checked').attr('id')) {
              $('.funding-option-' + getCurrency().toLowerCase()).find('.radio-one-line:visible').eq(0).find('input').trigger('click');
              $('.funding-option-' + getCurrency().toLowerCase()).find('.radio-one-line:visible').eq(0).next().removeClass('hide');
            }
          } else {
            if ($(item).hasClass('radio-one-line')) {
              $(item).removeClass('hide');
            }
          }
        }
      })
    }

    $('.funding-option').html(tmpl($('#tmpl-myaccount-add-funds-payment-method').html(), {
      obj: res.paymentMethods,
      amount: $('#amount').val()
    }));
    $('.verification-header').after(tmpl($('#tmpl-pin-verification').html(), {
      pin: res.hasPin
    }));
    $('#amount').val('');

    if (locationShortName === 'SG') {
      $('.not-sg').addClass('hide');
    } else {
      $('.not-sg').removeClass('hide');
    }

    // if(detectIE() || isFirefox()) {
    //   $('.txt-pin-code').attr('type', 'password');
    // }

    $('#btn-submit-funding').on('click', function() {
      formValidationModule.validateForm($('.add-funds-wrap'), 'Add Funds', function(data) {
        data.deposit = true;
        $currency = $('.add-funds-wrap input[name=currency]:checked');
        data.currency = $currency.val();
        $paymentMethodId = $('[name=funds-' + $('.add-funds-wrap input[name=currency]:checked').val().toLowerCase() + ']:checked');
        data.paymentMethodId = $paymentMethodId.val();
        if (validateAgreeCheckboxes('Add Funds')) {
          initTransaction(data, '.add-funds-wrap', function() {
            checkPaymentMaxAmount();
          });
        }
      }, null, true);
    });

    $('#amount').on('keyup', checkPaymentMaxAmount);

    $('#sgd').on('click', function() {
      $('.funding-option').children().addClass('hide');
      $('.funding-option-sgd').removeClass('hide');
      $('.minimum-amount').addClass('hide');
      $('.minimum-amount.overall').removeClass('hide');
    });

    $('#usd').on('click', function() {
      $('.funding-option').children().addClass('hide');
      $('.funding-option-usd').removeClass('hide');
      $('.minimum-amount').addClass('hide');
      $('.minimum-amount.overall').removeClass('hide');
    });

    $('#eur').on('click', function() {
      $('.funding-option').children().addClass('hide');
      $('.funding-option-eur').removeClass('hide');
      $('.minimum-amount').addClass('hide');
      $('.minimum-amount.overall').removeClass('hide');
    });

    $('#gbp').on('click', function() {
      $('.funding-option').children().addClass('hide');
      $('.funding-option-gbp').removeClass('hide');
      $('.minimum-amount').addClass('hide');
      $('.minimum-amount.overall').removeClass('hide');
    });

    $('#nzd').on('click', function() {
      $('.funding-option').children().addClass('hide');
      $('.funding-option-nzd').removeClass('hide');
      $('.minimum-amount').addClass('hide');
      $('.minimum-amount.overall').removeClass('hide');
    });

    $('#aud').on('click', function() {
      $('.funding-option').children().addClass('hide');
      $('.funding-option-aud').removeClass('hide');
      $('.minimum-amount').addClass('hide');
      $('.minimum-amount.overall').removeClass('hide');
    });

    $('#jpy').on('click', function() {
      $('.funding-option').children().addClass('hide');
      $('.funding-option-jpy').removeClass('hide');
      $('.minimum-amount').addClass('hide');
      $('.minimum-amount.jpy').removeClass('hide');
    });

    $('#sek').on('click', function() {
      $('.funding-option').children().addClass('hide');
      $('.funding-option-sek').removeClass('hide');
      $('.minimum-amount').addClass('hide');
      $('.minimum-amount.sek').removeClass('hide');
    });

    // if(getCurrency() == 'EUR') {
    //   $('#eur').trigger('click');
    // } else if(getCurrency() == 'USD') {
    //   $('#usd').trigger('click');
    // } else {
    //   $('#sgd').trigger('click');
    // }

    if ($('#amount').val()) {
      checkPaymentMaxAmount();
    }

    $('input[name=currency]:checked').trigger('click');

    // Hide currency option if there is no method for the currency
    for (var prop in res.paymentMethods) {
      if (res.paymentMethods.hasOwnProperty(prop)) {
        if (!res.paymentMethods[prop].length) {
          console.log('No payment method for ' + prop);
          $parent.find('input[name=currency][value=' + prop.toUpperCase() + ']').closest('.radio-one-line').addClass('hide');
        }
      }
    }

    // If there is no payment method for the selected currency, select USD as default
    if (!res.paymentMethods?.[getCurrency().toUpperCase()]?.length) {
      $('#usd').trigger('click');
    }
  }

  /*
    DESC: Get Withdrawal Payment method. USED IN: /myaccount/withdrawfunds
    POST /account/v1/svf/getWithdrawalPaymentMethods
  */
  function getWithdrawalPaymentMethods(cb) {
    var req = new Request(servicesUrl + '/account/v1/svf/getWithdrawalPaymentMethods', {
      locationId: getLocation()
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  /*
    DESC: Load Withdrawal page. USED IN: /myaccount/withdrawfunds
  */
  function loadWithdrawalPage(res) {

    $('.cash-balance').html(tmpl($('#tmpl-myaccount-withdraw-funds-cash-balance').html(), res));
    $('.payment').html(tmpl($('#tmpl-myaccount-payment-payment-method').html(), res.paymentMethods));
    $('.payment-fields').html(tmpl($('#tmpl-myaccount-withdraw-payment-fields').html(), res.paymentMethods));
    $('.verification-header').after(tmpl($('#tmpl-pin-verification').html(), {
      pin: res.hasPin
    }));
    $('#amount-withdraw').val('');

    for (var c in res.paymentMethods) {
      if (res.paymentMethods.hasOwnProperty(c)) {
        var pms = res.paymentMethods[c];
        for (var id in pms) {
          if (pms.hasOwnProperty(id)) {
            var pm = pms[id];
            for (var fid in pm.fields) {
              if (pm.fields.hasOwnProperty(fid)) {
                var f = pm.fields[fid];

                if (f.visibleByOption.length > 0) {
                  $('#' + f.visibleByOption).change(f, function(e) {
                    var v = $(this).val();
                    var found = false;
                    for (var p = 0; p < e.data.visibleByOptionValues.length; p++) {
                      if (e.data.visibleByOptionValues[p] == v) {
                        found = true;
                      }
                    }

                    var f = $('input[data-name="' + e.data.name + '"]');
                    if (found) {
                      f.closest('.form-field').show();
                    } else {
                      f.closest('.form-field').hide();
                    }
                  }).trigger('change');
                }
              }
            }
          }
        }
      }
    }

    // if(detectIE() || isFirefox()) {
    //   $('.txt-pin-code').attr('type', 'password');
    // }

    // No Pin
    $('#btn-send-withdraw').on('click', function() {
      formValidationModule.validateForm($('.withdraw-funds-wrap'), 'Insufficient Amount', function(data) {
        data.deposit = false;
        $currency = $('.withdraw-funds-wrap input[name=currency]:checked');
        data.currency = $currency.val();
        $sellPaymentMethodId = $('[name=payment-' + $('.withdraw-funds-wrap input[name=currency]:checked').val().toLowerCase() + ']:checked');
        data.sellPaymentMethodId = $sellPaymentMethodId.val();
        data.sellPaymentMethodFieldString = processSellPaymentFieldString(data);
        if (validateAgreeCheckboxes('Withdraw Funds')) {
          initTransaction(data, '.withdraw-funds-wrap');
        }
      }, null, true);
    });

    // Show payment and payment fields based on selected of currency
    $('input[name=currency]').on('click', function() {
      $(this).prop('checked', true);
      var cur = $('input[name=currency]:checked').val().toLowerCase(),
        paymentId = $('input[name=payment-' + cur + ']:checked').val();
      $('.payment').children().addClass('hide');
      // Remove error-field class so it wont mess up formValidationModule.focusOnFirstError
      $('.payment-fields').find('.form-field')
        .removeClass('error-field')
        .find('span.fail')
        .addClass('hide');
      $('.payment-' + cur).removeClass('hide');
      $('.payment-fields').children().addClass('hide');
      $('.payment-field-' + cur).removeClass('hide');

      $('.minimum-amount').addClass('hide');
      if (cur === 'jpy') {
        $('.minimum-amount.jpy').removeClass('hide');
      } else if (cur === 'sek') {
        $('.minimum-amount.sek').removeClass('hide');
      } else {
        $('.minimum-amount.overall').removeClass('hide');
      }
    });

    // Show payment fields based on the currency and payment selected
    $('.payment input[type=radio]').on('click', function() {
      var cur = $('input[name=currency]:checked').val().toLowerCase(),
        paymentId = $('input[name=payment-' + cur + ']:checked').val();
      $('.payment-field-' + cur).children().addClass('hide');
      // Remove error-field class so it wont mess up formValidationModule.focusOnFirstError
      $('.payment-fields').find('.form-field')
        .removeClass('error-field')
        .find('span.fail')
        .addClass('hide');
      $('.payment-field-' + cur).find('.form-field-' + paymentId).removeClass('hide');
    });


    // if(getCurrency() == 'EUR') {
    //   $('input[name=currency]:checked').trigger('click');
    // } else if(getCurrency() == 'USD') {
    //   $('#usd').trigger('click');
    // } else {
    //   $('#sgd').trigger('click');
    // }

    $('input[name=currency]:checked').trigger('click');

  }

  /*
    DESC: Initialize Transaction. USED IN: /myaccount/addfunds and /myaccount/withdrawfunds
    POST /checkout/svf/withdraw-funds
    deposit=false
    pin=1111
    amount=2000
    currency=SGD
    paymentMethodId=null 
    sellPaymentMethodId=2
    sellPaymentMethodFieldString=bankcode
    1234
    branchcode
    987
    accountnumber
    12345678
  */
  function initTransaction(data, parent, errorCb) {
    data.machineId = getMachineId();
    data.ct = getCT();
    data.locationId = getLocation();

    var url;
    if (data.deposit) {
      url = '/checkout/svf/add-funds';
    } else {
      url = '/checkout/svf/withdraw-funds';
    }

    var req = new Request(servicesUrl + url, data);

    req.afterErrorDialogFunction(function(res) {
      if (res.accountLocked) {
        authenticationModule.logout();
      }

      // Show due diligence popup
      if (res.pendingDueDiligence) {
        popupModule.open($('.popup-pending-due-diligence'), 'popupPendingDueDiligence');
        return;
      }

      formValidationModule.showError(parent, res.errorField);

      typeof errorCb === 'function' && errorCb(res);
    });

    req.success(function(res) {
      if (res.url) {
        window.location.href = res.url;
        return;
      } else if (res.transactionId && res.transactionId != '') {
        waitForCompletion(req, res.transactionId);
        return;
      } else {
        req.hideLoader();
        return;
      }
    });

    req.dontHideLoaderOnSuccess(true);
    req.call();
  }

  function waitForCompletion(confirmReq, transactionId) {
    completionCheckCount = 0;
    completionCheckDelay = 500;

    setTimeout(checkForCompletion, completionCheckDelay, confirmReq, transactionId);
  }

  /*
    DESC: Check for completion status of a submitted svf transaction.
    GET /checkout/svf/status
    transactionId:1234-1234-1234-1234
  */
  function checkForCompletion(confirmReq, transactionId) {
    completionCheckCount++;
    if (completionCheckCount > 200) {
      completionCheckDelay = 3000;
    } else if (completionCheckCount > 50) {
      completionCheckDelay = 1000;
    } else {
      completionCheckDelay = 500;
    }


    new Request(servicesUrl + '/checkout/svf/status', {
        transactionId: transactionId
      })
      .error(function(json) {
        confirmReq.hideLoader();
        var popup = new Popup({
          title: json.title,
          message: json.message
        });
        popup.render();
      }).success(function(json) {
        console.log(json);
        if (json.url && json.url != '') {
          window.location.href = json.url;
        } else if (json.stockChanges) {
          console.log('json.stockChanges');
          confirmReq.hideLoader();
          sendUpdate();
        } else {
          setTimeout(checkForCompletion, completionCheckDelay, confirmReq, transactionId);
        }
      }).send();
  }
  /*
    DESC: Used to know if the page requires login. USED IN: /verification
    POST /account/v1/required
  */
  function accountRequired(cb) {
    var req = new Request(servicesUrl + '/account/v1/required', {});

    req.success(function(res) {
      typeof cb === 'function' && cb(res);
    });

    req.call();

  }

  return {
    createIndividual: createIndividual,
    createBusiness: createBusiness,
    createLegalArrangement: createLegalArrangement,
    update: updateAccount,
    details: getDetails,
    loadDetailsPage: loadDetailsPage,
    setDetails: setAccountDetails,
    getInfo: info,
    infoResponseHandler: infoResponseHandler,
    activate2FANoAccount: activateTwoFactorNoAccount,
    activate2FA: activateTwoFactor,
    deactivate2FA: deactivateTwoFactor,
    activate2FACode: activateTwoFactorCode,
    resend2FACode: resendTwoFactorCode,
    acceptSMS: acceptSMS,
    setDebitStorageFee: setDebitStorageFee,
    setInvoiceCurrency: setInvoiceCurrency,
    changePassword: changePassword,
    forgotPassword: forgotPassword,
    resetPassword: resetPassword,
    setPin: setPin,
    getDepositPaymentMethods: getDepositPaymentMethods,
    loadAddfundsPage: loadAddfundsPage,
    getWithdrawalPaymentMethods: getWithdrawalPaymentMethods,
    loadWithdrawalPage: loadWithdrawalPage,
    initTransaction: initTransaction,
    emailExists: emailExists,
    accountRequired: accountRequired,
    codeTimer: codeTimer,
    hidePinForm: hidePinForm,
    activate2FAGoogle: activate2FAGoogle,
    deactivate2FAGoogle: deactivate2FAGoogle,
    activate2FAGoogleCode: activate2FAGoogleCode,
    generateGoogle2FASecretKey: generateGoogle2FASecretKey,
    validateGoogle2FA: validateGoogle2FA,
  }
}());

/* Add for mocha testing */
// Basically it make the accountModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = accountModule;
}
/***********************************************************/
/***********************************************************/
/* Vault Module */
/***********************************************************/
/***********************************************************/

var vaultModule = (function() {

  var valuationMethods = ['Buy', 'Sell', 'Spot'],
    valuationMethodCtr = 0,
    metalAllocationChart = {},
    metalChart,
    productAllocationChart = {},
    productChart,
    portfolioLocation = -1,
    metalColors = {
      'XAU': '#de9701',
      'XAG': '#b6790f',
      'XPT': '#aeaeae',
      'XPD': '#c0c1c3'
    },
    productColors = ['#de9701', '#b6790f', '#aeaeae', '#c0c1c3', '#d9dadc', '#da7c00'],
    options = {
      'size': {
        'canvasWidth': '300',
        'canvasHeight': 300,
        'pieOuterRadius': '60%'
      },
      'data': {
        //  'sortOrder': 'value-desc'
      },
      'labels': {
        'outer': {
          //'format': 'label-percentage2',
          'format': 'label-percentage2',
          'pieDistance': 20
        },
        'inner': {
          'format': 'none',
          'hideWhenLessThanPercentage': 14
        },
        'mainLabel': {
          'fontSize': 11
        },
        'percentage': {
          'color': '#000',
          'decimalPlaces': 2
        },
        'value': {
          'color': '#adadad',
          'fontSize': 11
        },
        'lines': {
          'enabled': true,
          'style': 'straight'
        },
        'truncation': {
          'enabled': true
        }
      }
    },
    photoNotified = [];

  /*
    DESC: Get Vault summary.  USED IN: /myaccount
    POST /api/v1/vault/vaultSummary
  */
  function summary(data, cb) {
    data.requestLocationId = getLocation();
    var req = new Request(servicesUrl + '/account/portfolio/get', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  /*
    DESC: Get Storage Fee summary.  USED IN: /myaccount/storagecharges
    POST /api/v1/vault/storageFeeSummary
  */
  function storageFeeSummary(cb) {
    var req = new Request(servicesUrl + '/account/v1/storagefee/summary', {
      requestLocationId: getLocation()
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  /*
    DESC: Get Storage Fee in days.  USED IN: /myaccount/storagecharges
    POST /account/v1/storagefee/days
  */
  function storageFeeDays(data, cb) {
    var req = new Request(servicesUrl + '/account/v1/storagefee/days', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  function photosNotify(data, cb) {
    var flagName = data.orderId + '-' + data.name;
    if (photoNotified.includes(flagName)) {
      console.log('Photo ' + flagName + ' already notified');
      return;
    }
    var req = new Request(servicesUrl + '/account/photo/viewed', data)

    req.success(function(res) {
      if (res.success) {
        photoNotified.push(flagName)
        typeof cb === 'function' && cb(res);
      }
    });

    req.send();
  }

  /* 
    DESC: Create Enlarged Image object to be passed in the template 
  */
  function createEnlargedImg(obj) {
    var image = {};
    image.orderId = obj.data('id');
    image.createdDate = obj.data('date');
    image.photoHeaderText = obj.data('text');
    image.link = obj.data('image');
    image.name = obj.data('name');
    return image;
  }

  /*
    DESC: Populate /myaccount/photos page.  USED IN: /myaccount page
  */
  function loadPhotos(res) {
    $('.locations-wrap').append(tmpl($('#tmpl-myaccount-photos').html(), res));

    // Open Gallery popup
    $('.open-gallery').on('click', function(e) {
      e.preventDefault();

      var _this = $(this),
        carousel = [];

      if ($('.slick-initialized').length) {
        $('.carousel').slick('unslick');
      }

      var popup = new PopupPhotos();
      popup.render();

      var $target = $('.popup-photos > .body');

      // Create a carousel array
      _this.parents('ul').children().each(function(i, li) {
        carousel.push(createEnlargedImg($(li).find('.open-gallery')))
      });

      // Remove elements before _this and push removed elements to the end of array
      // Example:
      // -------> [a, b, c, d, e, f]
      // -------> clicked c
      // -------> array becomes
      // -------> [c, d, e, f, a, b]

      var removedList = carousel.splice(0, _this.data('ctr'));
      $.each(removedList, function(i, obj) {
        carousel.push(obj);
      });

      $target.html(tmpl($('#tmpl-myaccount-photo-enlarge').html(), {
        obj: carousel
      }));

      $('.carousel').slick({
        slidesToShow: 1,
        infinite: true
      });

      $('.carousel').on('afterChange', function() {
        photosNotify({
          orderId: $('.slick-current').data('id'),
          name: $('.slick-current').data('name'),
          url: $('.slick-current').data('image'),
          accountId: getAccountId(),
        })
      })

      $('.popup-photos .prev').on('click', function() {
        $('.carousel').slick('slickNext');
      });

      $('.popup-photos .next').on('click', function() {
        $('.carousel').slick('slickPrev');
      });

      photosNotify({
        orderId: _this.data('id'),
        name: _this.data('name'),
        url: _this.data('image'),
        accountId: getAccountId(),
      })
    });
  }

  /*
    DESC: Populate /myaccount/storagecharges page.  USED IN: /myaccount page
  */
  function loadStorageCharges(res) {
    //$('.total-remaining').text(res.totalRemaining);
    $('#invoice-currency option[value=' + res.invoiceCurrency + ']').prop('selected', true);
    $('.locations').html(tmpl($('#tmpl-myaccount-storage-charge-years').html(), res));
    $('.history-wrap').html(tmpl($('#tmpl-myaccount-storage-charge-transaction-history').html(), res));

    var chargeAccount = $('#charge-account');
    if (chargeAccount.length > 0) {
      if (res.debitStorageFeeToAccount) {
        chargeAccount[0].checked = true;
      } else {
        chargeAccount[0].checked = false;
      }
    }

    $('.storage-charges-wrap .locations .open-years').on('click', function() {
      var _this = $(this);

      var $parent = _this.parents('table');

      $parent.find('thead .image').toggleClass('active');
      $parent.find('tbody').toggleClass('hide');
    });

    $('.open-days').on('click', function() {
      var _this = $(this),
        data = {
          year: _this.data('year'),
          month: _this.data('month'),
          locationId: $(this).closest('.location').attr('locationId')
        };

      if (_this.hasClass('with-data')) {
        $('.sub-' + _this.data('month') + '-' + _this.data('year')).toggleClass('hide');
      } else {
        storageFeeDays(data, function(res) {
          _this.after(tmpl($('#tmpl-myaccount-storage-charge-days').html(), res.days));
          _this.addClass('with-data');
          $('.sub-' + _this.data('month') + '-' + _this.data('year')).toggleClass('hide');
        });
      }

      _this.find('.image').toggleClass('active');
    });

    $('.link-to-transaction').on('click', function() {
      window.location.href = $(this).data('url');
    });
  }

  /*
    DESC: Get Vault summary.  USED IN: /myaccount
    POST /api/v1/vault/photos
  */
  function photos(cb) {
    var req = new Request(servicesUrl + '/account/photos', {
      locationId: getLocation(),
      timeZoneId: moment.tz.guess()
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  function changeValuationViewAndText() {
    // 0 = Buy, 1 = Sell, 2 = Spot
    $('.valuation-value').text(valuationMethods[valuationMethodCtr]);
    $('.valuation').addClass('hide');
    $('.' + valuationMethods[valuationMethodCtr].toLowerCase()).removeClass('hide');
  }

  function showProfitLossColumn(flag) {
    if (flag) {
      $('.profit-loss-col').removeClass('hide');
    } else {
      $('.profit-loss-col').addClass('hide');
    }
  }

  function displayAllocationCharts(categories) {
    if (categories) {
      $('.charts-allocation-wrap').removeClass('hide');
    } else {
      $('.charts-allocation-wrap').addClass('hide');
    }
  }

  /*
    DESC: Populate /myaccount page.  USED IN: /myaccount page
  */
  function loadMyAccount(res) {
    var _this = this;

    if (res.metalAllocations.length >= 3 && res.metalAllocations[2].percent < 10) { // Switch places between gold and silver to avoid labels overlapping if all 3 metals are shown.
      var tmp = res.metalAllocations[1];
      res.metalAllocations[1] = res.metalAllocations[0];
      res.metalAllocations[0] = tmp;
    }

    metalAllocationChart = res.metalAllocations;
    productAllocationChart = res.productAllocations;

    $('.profit-loss').find('.body').html(tmpl($('#tmpl-myaccount-profit').html(), res));
    $('.cash-balance').html(tmpl($('#tmpl-myaccount-cash-balance').html(), res));
    $('.bullion-balance').html(tmpl($('#tmpl-myaccount-bullion-balance').html(), res.bullionBalances));
    $('.bullion-portfolio').find('tbody').html(tmpl($('#tmpl-myaccount-bullion-portfolio').html(), res));
    $('#portfolio-location').html(tmpl($('#tmpl-myaccount-location').html(), res));

    $('.total-assets .account-number').text(res.account.id);
    $('.total-assets .account-name').text(res.account.name);
    $('.total-assets .total-assets-amount').html(tmpl($('#tmpl-myaccount-total-assets').html(), {
      obj: res.totalAssets
    }));

    showProfitLossColumn(res.showProfit);

    displayAllocationCharts(res.categories.length);

    var dashBoardLocation = localStorage.getItem('dashboard-location');
    if (!dashBoardLocation) {
      localStorage.setItem('dashboard-location', -1);
    } else {
      $.each(res.locations, function(i, loc) {
        if (loc.id == dashBoardLocation) {
          $('.portfolio-location').text(loc.title);
          $('.portfolio-location').attr('data-id', loc.id);
        }
      });
    }

    $('#portfolio-location').on('change', function() {
      var _this = $(this);
      summary({
        locationId: _this.val(),
        currency: getCurrency()
      }, function(res) {
        localStorage.setItem('dashboard-location', _this.val());
        $('.profit-loss').find('.body').html(tmpl($('#tmpl-myaccount-profit').html(), res));
        $('.cash-balance').html(tmpl($('#tmpl-myaccount-cash-balance').html(), res));
        $('.bullion-balance').html(tmpl($('#tmpl-myaccount-bullion-balance').html(), res.bullionBalances));
        $('.bullion-portfolio').find('tbody').html(tmpl($('#tmpl-myaccount-bullion-portfolio').html(), res));
        $('.total-assets .total-assets-amount').html(tmpl($('#tmpl-myaccount-total-assets').html(), {
          obj: res.totalAssets
        }));
        showProfitLossColumn(res.showProfit);
        changeValuationViewAndText();
        displayAllocationCharts(res.categories.length);

        var m = res.metalAllocations['buy'];
        if (m.length) {
          createMetalChart(m);
          $('#metal').prev().removeClass('hide')
          $('#metal').removeClass('hide');
        } else {
          $('#metal').prev().addClass('hide')
          $('#metal').addClass('hide');
        }

        var p = res.productAllocations['buy'];
        if (p.length) {
          createProductChart(p);
          $('.chart-legend').find('tbody').html(tmpl($('#tmpl-myaccount-legends').html(), p));
          $('.chart-legend').removeClass('hide');
          $('#product').prev().removeClass('hide')
          $('#product').removeClass('hide');
        } else {
          $('.chart-legend').addClass('hide');
          $('#product').prev().addClass('hide');
          $('#product').addClass('hide');
        }

      });
    });

    // $('.change-portfolio-location').on('click', function() {
    //   var popup = new PopupPortfolioLocation(res.locations, portfolioLocation, function(self) {
    //     eraseCookie('dashboard-location');
    //     createCookie('dashboard-location', self.val(), 1);
    //     summary({ locationId: self.val(), currency : getCurrency() }, function(res) {
    //       $('.portfolio-location').text(self.data('text'));
    //       $('.portfolio-location').attr('data-id', self.val());
    //       portfolioLocation = self.val();
    //       $('.profit-loss').find('.body').html(tmpl($('#tmpl-myaccount-profit').html(), res));
    //       $('.bullion-balance').html(tmpl($('#tmpl-myaccount-bullion-balance').html(), res.bullionBalances));
    //       $('.bullion-portfolio').find('tbody').html(tmpl($('#tmpl-myaccount-bullion-portfolio').html(), res));
    //       $('.total-assets .total-assets-amount').html(tmpl($('#tmpl-myaccount-total-assets').html(), { obj: res.totalAssets }));
    //       showProfitLossColumn(res.showProfit);

    //       var m = res.metalAllocations['buy'];
    //       if(m.length) {
    //         createMetalChart(m);
    //         $('#metal').prev().removeClass('hide')
    //         $('#metal').removeClass('hide');
    //       } else {
    //         $('#metal').prev().addClass('hide')
    //         $('#metal').addClass('hide');
    //       }

    //       var p = res.productAllocations['buy'];
    //       if(p.length) {
    //         createProductChart(p);
    //         $('.chart-legend').find('tbody').html(tmpl($('#tmpl-myaccount-legends').html(), p));
    //         $('.chart-legend').removeClass('hide');
    //         $('#product').prev().removeClass('hide')
    //         $('#product').removeClass('hide');
    //       } else {
    //         $('.chart-legend').addClass('hide');
    //         $('#product').prev().addClass('hide');
    //         $('#product').addClass('hide');
    //       }

    //     });
    //   });
    //   popup.render();
    // });

    $(document).on('click', '.toggle-balance-list', function() {
      var _this = $(this);
      _this.closest('table').addClass('hide');
      _this.closest('table').siblings('table').removeClass('hide');
    });


    $(document).on('click', '.change-weight-unit', function(e) {
      var _this = $(this);
      $('.change-weight-unit').removeClass('active');
      $('.metal-weight').addClass('hide');
      _this.addClass('active');
      if (_this.data('unit') === 'g') {
        $('.gr').removeClass('hide');
      } else {
        $('.oz').removeClass('hide');
      }
    });

    $(document).on('click', '.open-image', function() {
      var _this = $(this),
        src = _this.data('image'),
        title = _this.data('title');

      var options = {
        title: title,
        src: src
      };

      var popup = new PopupMyaccountBullionPhotos(options);
      popup.render();
      /*var _this = $(this),
          valuationValue = $('.valuation-value').eq(0).text().toLowerCase(),
          $parent = $('.popup-bullion-portfolio'),
          values = _this.data('values');

      $parent.find('.title').text(_this.data('title'));
      if (_this.data('image')) {
        $parent.find('figure').html(tmpl($('#tmpl-retinafy').html(), {
          obj: {
            url: _this.data('image'),
            width: 98,
            uniqueId: _this.data('product-id')
          }
        }));
        $parent.find('figure').append('<span id="product-img-' + _this.data('product-id') + '"></span>');
      }
      $parent.find('.bp-quantity').text(_this.data('quantity'));
      $parent.find('.bp-average-buy-price').html(tmpl($('#tmpl-object-loop-currency').html(), {obj: _this.data('average-buy-price')}));
      $parent.find('.bp-todays-price').html(tmpl($('#tmpl-myaccount-bullion-portfolio-values-todays-price').html(), {obj: values}));
      $parent.find('.bp-change-today').html(tmpl($('#tmpl-myaccount-bullion-portfolio-values-change-today').html(), {obj: values}));
      $parent.find('.bp-market-value').html(tmpl($('#tmpl-myaccount-bullion-portfolio-values-market-value').html(), {obj: values}));
      $parent.find('.bp-profit-loss').html(tmpl($('#tmpl-myaccount-bullion-portfolio-values-profit').html(), {obj: values}));
      if (values.buy.marketValue[currency].percent === null || values.buy.marketValue[currency].percent === '') {
        $parent.find('.bp-profit-loss-percent').parent('li').addClass('hide');
      } else {
        $parent.find('.bp-profit-loss-percent').parent('li').removeClass('hide');
        $parent.find('.bp-profit-loss-percent').html(tmpl($('#tmpl-myaccount-bullion-portfolio-values-profit-percent').html(), {obj: values}));
      }

      // Select valuation
      $parent.find('.valuation').addClass('hide');
      $parent.find(' .' + valuationValue).removeClass('hide')
      popupModule.open($('.popup-bullion-portfolio'), 'popupBullionPortfolio');*/
    });

    $(document).on('click', '.change-valuation', function(e) {
      e.preventDefault();

      if (valuationMethodCtr >= 2) {
        valuationMethodCtr = 0;
      } else {
        valuationMethodCtr++;
      }

      changeValuationViewAndText();

      if ($('#metal').find('svg').length) {
        //metalChart.destroy();
      }
      var m = metalAllocationChart[valuationMethods[valuationMethodCtr].toLowerCase()];
      if (m.length) {
        createMetalChart(m);
        $('#metal').prev().removeClass('hide')
        $('#metal').removeClass('hide');
      } else {
        $('#metal').prev().addClass('hide')
        $('#metal').addClass('hide');
      }

      if ($('#product').find('svg').length) {
        //productChart.destroy();
      }
      var p = productAllocationChart[valuationMethods[valuationMethodCtr].toLowerCase()];
      if (p.length) {
        createProductChart(p);
        $('#product').prev().removeClass('hide')
        $('#product').removeClass('hide');
      } else {
        $('#product').prev().addClass('hide')
        $('#product').addClass('hide');
      }

      $('.chart-legend').find('tbody').html(tmpl($('#tmpl-myaccount-legends').html(), p));
      createCookie('valuation-method', valuationMethodCtr, 1);

      console.log('get info from localStorage');
      var info = localStorage.getItem('info');
      if (info) {
        console.log('change valuation info=' + info);
        var accountInfo = JSON.parse(info);
        console.log(accountInfo);
        var valuation = getValuation();
        var totalAssets;
        var vaultAmounts;
        if (valuation === 'spot') {
          totalAssets = accountInfo.totalAssetsSpot;
          vaultAmounts = accountInfo.vaultAmountsSpot;
        } else if (valuation === 'sell') {
          totalAssets = accountInfo.totalAssetsSell;
          vaultAmounts = accountInfo.vaultAmountsSell;
        } else {
          totalAssets = accountInfo.totalAssetsBuy;
          vaultAmounts = accountInfo.vaultAmountsBuy;
        }

        var $header = $('.main-header');
        $header.find('.account-info .cash-amount').html(tmpl($('#tmpl-object-loop-currency').html(), totalAssets));
        $header.find('.account-info .bullion-amount').html(tmpl($('#tmpl-object-loop-currency').html(), vaultAmounts));
      }
    });

    if (!readCookie('valuation-method')) {
      changeValuationViewAndText();

      var m = metalAllocationChart['buy']
      if (m.length) {
        createMetalChart(m);
        $('#metal').prev().removeClass('hide')
        $('#metal').removeClass('hide');
      } else {
        $('#metal').prev().addClass('hide')
        $('#metal').addClass('hide');
      }

      var p = productAllocationChart['buy'];
      if (p.length) {
        createProductChart(p);
        $('#product').prev().removeClass('hide')
        $('#product').removeClass('hide');
      } else {
        $('#product').prev().addClass('hide')
        $('#product').addClass('hide');
      }

      createCookie('valuation-method', valuationMethodCtr, 1);

      $('.chart-legend').find('tbody').html(tmpl($('#tmpl-myaccount-legends').html(), p));

    } else {
      valuationMethodCtr = readCookie('valuation-method');
      if (valuationMethodCtr == null || valuationMethodCtr > 2 || valuationMethodCtr < 0) {
        valuationMethodCtr = 0;
      }

      changeValuationViewAndText();

      var valuation = valuationMethods[valuationMethodCtr].toLowerCase();

      var m = metalAllocationChart[valuation];
      if (m.length) {
        createMetalChart(m);
        $('#metal').prev().removeClass('hide')
        $('#metal').removeClass('hide');
      } else {
        $('#metal').prev().addClass('hide')
        $('#metal').addClass('hide');
      }

      var p = productAllocationChart[valuation];
      if (p.length) {
        createProductChart(p);
        $('#product').prev().removeClass('hide')
        $('#product').removeClass('hide');
      } else {
        $('#product').prev().addClass('hide')
        $('#product').addClass('hide');
      }

      $('.chart-legend').find('tbody').html(tmpl($('#tmpl-myaccount-legends').html(), p));
    }

    // Select Currency
    $('.currency-wrap .radio-one-line input').on('click', function() {
      var loc = localStorage.getItem('dashboard-location');
      if (!loc) {
        loc = -1;
      }
      summary({
        locationId: loc,
        currency: getCurrency()
      }, function(res) {
        $('.profit-loss').find('.body').html(tmpl($('#tmpl-myaccount-profit').html(), res));
        $('.cash-balance').html(tmpl($('#tmpl-myaccount-cash-balance').html(), res));
        $('.bullion-balance').html(tmpl($('#tmpl-myaccount-bullion-balance').html(), res.bullionBalances));
        $('.bullion-portfolio').find('tbody').html(tmpl($('#tmpl-myaccount-bullion-portfolio').html(), res));
        $('.total-assets .total-assets-amount').html(tmpl($('#tmpl-myaccount-total-assets').html(), {
          obj: res.totalAssets
        }));
        showProfitLossColumn(res.showProfit);
        changeValuationViewAndText();

        var m = res.metalAllocations.buy;
        if (m.length) {
          createMetalChart(m);
          $('#metal').prev().removeClass('hide')
          $('#metal').removeClass('hide');
        } else {
          $('#metal').prev().addClass('hide')
          $('#metal').addClass('hide');
        }

        var p = res.productAllocations.buy;
        if (p.length) {
          createProductChart(p);
          $('.chart-legend').find('tbody').html(tmpl($('#tmpl-myaccount-legends').html(), p));
          $('.chart-legend').removeClass('hide');
          $('#product').prev().removeClass('hide')
          $('#product').removeClass('hide');
        } else {
          $('.chart-legend').addClass('hide');
          $('#product').prev().addClass('hide');
          $('#product').addClass('hide');
        }

      });

      // if($('#metal').find('svg').length) {
      //   //metalChart.destroy();
      // }
      // var m = metalAllocationChart[valuationMethods[parseInt(readCookie('valuation-method'))].toLowerCase()];
      // if(m.length) {
      //   createMetalChart(m);
      //   $('#metal').prev().removeClass('hide')
      //   $('#metal').removeClass('hide');
      // } else {
      //   $('#metal').prev().addClass('hide')
      //   $('#metal').addClass('hide');
      // }

      // if($('#product').find('svg').length) {
      //   //productChart.destroy();
      // }
      // var p = productAllocationChart[valuationMethods[parseInt(readCookie('valuation-method'))].toLowerCase()];
      // if(p.length) {
      //   createProductChart(p);
      //   $('#product').prev().removeClass('hide')
      //   $('#product').removeClass('hide');
      // } else {
      //   $('#product').prev().addClass('hide')
      //   $('#product').addClass('hide');
      // }

      // $('.chart-legend').find('tbody').html(tmpl($('#tmpl-myaccount-legends').html(), p));
    });
    /*$('.currency-selection').on('click', function() {

      if($('#metal').find('svg').length) {
        //metalChart.destroy();
      }
      var m = metalAllocationChart[valuationMethods[parseInt(readCookie('valuation-method')) + 1].toLowerCase()][getCurrency()];
      if(m.length) {
        createMetalChart(m);
        $('#metal').prev().removeClass('hide')
        $('#metal').removeClass('hide');
      } else {
        $('#metal').prev().addClass('hide')
        $('#metal').addClass('hide');
      }

      if($('#product').find('svg').length) {
        //productChart.destroy();
      }
      var p = productAllocationChart[valuationMethods[parseInt(readCookie('valuation-method')) + 1].toLowerCase()][getCurrency()];
      if(p.length) {
        createProductChart(p);
        $('#product').prev().removeClass('hide')
        $('#product').removeClass('hide');
      } else {
        $('#product').prev().addClass('hide')
        $('#product').addClass('hide');
      }

      $('.chart-legend').find('tbody').html(tmpl($('#tmpl-myaccount-legends').html(), p));

      $('.btn-close-main-menu, .wrap').one('click', function() {
        metalChart.redraw();
        productChart.redraw();
      });
    });*/

    $(document).on('mouseover', '.product-info', function() {
      $(this).closest('tr').prev().addClass('hover')
    })

    $(document).on('mouseout', '.product-info', function() {
      $(this).closest('tr').prev().removeClass('hover')
    })


  }

  /*
    DESC: Build Metal Allocation Chart
  */
  function createMetalChart(d) {
    var data = [];
    $.each(d, function(i, item) {
      data.push({
        label: item.shortTitle + ' ' + item.percent + '%',
        value: parseFloat(item.percent),
        color: metalColors[item.metal]
      });
    });

    //console.log(data);

    if (metalChart == null) {
      metalChart = new PieChart({
        id: 'metal',
        width: 300,
        height: 150,
        innerRadius: 0,
        outerRadius: 55,
        labelRadius: 55
      });
    }

    metalChart.render(data);
  }

  /*
    DESC: Build Product Allocation Chart
  */
  function createProductChart(d) {
    var data = [];
    $.each(d, function(i, item) {
      data.push({
        label: item.shortTitle + ' ' + item.percent + '%',
        value: parseFloat(item.percent),
        color: productColors[i]
      });
    });

    //console.log(data);

    if (productChart == null) {
      productChart = new PieChart({
        id: 'product',
        width: 300,
        height: 150,
        innerRadius: 0,
        outerRadius: 55,
        labelRadius: 55
      });
    }

    productChart.render(data);
  }

  /*
    DESC: Get PDF of Vault Certificate.  USED IN: popupm menu
    POST /api/v1/vault/certificate
  */
  function certificate(currency) {
    var req = new Request(servicesUrl + '/account/vault-certificate/certificate?currency=' + currency.toLowerCase(), {
      locationId: getLocation()
    });

    req.success(function(res) {
      if (res.success) {
        //window.location.href = res.url;
      }
    });

    req.send();
  }

  /*
    DESC: Get live audit.  USED IN: /myaccount/liveaudit
    POST /account/live-audit-report/items
  */
  function liveAudit(data, cb) {
    var req = new Request(servicesUrl + '/account/live-audit-report/items', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  /*
    DESC: Load live audit page. USED IN: /myaccount/addfunds
  */
  function loadLiveAuditPage(res) {
    $('.live-audit-wrap .result').html(tmpl($('#tmpl-audit').html(), {
      res: res
    }));
    console.log('typeof', res);
    if (res.userAccountId && res.userAccountId > -1) {
      $('.live-audit-wrap .account-no-wrap').removeClass('hide')
      $('.live-audit-wrap .account-no').text(res.userAccountId);
    } else {
      $('.live-audit-wrap .account-no-wrap').addClass('hide');
      $('.live-audit-wrap .account-no').text('');
    }

    if (res.accountId && res.userAccountId > -1) {
      $('.live-audit-wrap .result').removeClass('hide');
      $('.live-audit-wrap .search input').val(res.accountId);
    } else {
      $('.live-audit-wrap .result').addClass('hide');
      $('.live-audit-wrap .search input').val('');
    }

    var str = $.map(res.accountIds, function(id) {
      return '<a href="javascript:void(0);" class="show-holding" data-id="' + id + '">' + id + '</a>';
    });
    $('.account-ids').html(str.join(', '));
  }

  /*
    DESC: Get BSP.  USED IN: /vault/bsp
    POST /product/backing/get
  */
  function backingV2(data, cb) {
    var req = new Request(servicesUrl + '/product/backing/get', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.call();
  }

  function getProductChart() {
    return productAllocationChart;
  }

  function getPortfolio(loader) {
    if (!$('.price-chart').length) return;

    if (loader) {
      $('.price-chart > .loader').removeClass('hide');
      $('#main-chart').empty();
    }

    var data = {
      currency: getCurrency(),
      width: 600,
      height: 500,
      period: $('.product-chart-options div.active').data('period'),
      timeZoneId: moment.tz.guess()
    }

    var accountIdParam = getAccountIdParam();
    if (accountIdParam) {
      this.data['accountId'] = accountIdParam;
    }

    $xhr = $.ajax({
      type: 'GET',
      cache: true,
      crossDomain: true,
      data: data,
      url: servicesUrl + '/account/v1/portfolio',
      xhrFields: {
        withCredentials: true
      },
      dataType: 'json',
      headers: {
        'requestId': uuidv4()
      }
    }).done(function(res) {
      lastChartOptions = {
        type: 'line',
        width: 600,
        height: 500,
        preserveAspectRatio: 'xMinYMin meet',
        margin: {
          top: 27,
          bottom: 10,
          left: 10,
          right: 0
        },
        withStatistics: true,
        withTimeZone: false,
        withDateCovered: false,
        withLogo: false,
        withLineCursor: true,
        withLineCursorMouseMove: true,
        withHorizontalLinesEnds: true,
        withHorizontalLines: true,
        withVerticalLines: false,
        withVerticalLinesEnds: false,
        withBorder: false,
        gridColor: '#eee',
        cursorPointSize: 5,
        cursorPointColor: '#fcb134',
        cursorPointStrokeColor: '#ba741e',
        lineCursorColor: '#c9934b',
        lineCursorWeight: 0,
        lineCursorDashArray: '6,6',
        fontSize: 10,
        lineCursorBoxHeight: 20,
        lineCursorTextYOffset: 4,
        hasTime: res.hasTime,
        offsetChart: false,
        enableDrag: true,
        timeBoxBackgroundColor: '#555557',
        timeBoxMarginTop: 0,
        //timeBoxRight: 25,
        //timeBoxWidth: 130,
        //valueBoxWidth: 80,
        //timeBoxWidthOffset: 28,
        timeBoxFontColor: '#fff',
        logoColor: '#888a89',
        timeBoxBorderColor: 'none',
        // chartStatsCallback: function (open, low, high, close) {
        //   $('.price-info-wrap .stats > ._open').html(open);
        //   $('.price-info-wrap .stats > ._low').html(low);
        //   $('.price-info-wrap .stats > ._high').html(high);
        //   $('.price-info-wrap .stats > ._close').html(close);
        // },
        dataSeries: [{
          name: 'series1',
          area: true,
          color: 'transparent',
          lineColor: '#e5a158',
          lineWidth: '2',
          startDate: res.portfolio.startAt,
          data: res.portfolio.buy,
          numDecimals: res.numDecimals
        }]
      };

      $('#main-chart').html('');
      $('#main-chart').bstarchart(lastChartOptions);

    }).fail(function(res) {
      console.log(res);
    }).always(function() {
      $('.price-chart > .loader').addClass('hide');
    });
    return $xhr;
  }

  return {
    summary: summary,
    loadMyAccountPage: loadMyAccount,
    photos: photos,
    storageFeeSummary: storageFeeSummary,
    storageFeeDays: storageFeeDays,
    loadStorageCharges: loadStorageCharges,
    loadPhotos: loadPhotos,
    certificate: certificate,
    liveAudit: liveAudit,
    loadLiveAuditPage: loadLiveAuditPage,
    backingV2: backingV2,
    getProductChart: getProductChart,
    getPortfolio: getPortfolio,
  }
}());

/* Add for mocha testing */
// Basically it make the vaultModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = vaultModule;
}
/***********************************************************/
/***********************************************************/
/* Alert Module */
/***********************************************************/
/***********************************************************/

var alertModule = (function() {
  var url = '/account/v1/spot-alert/';
  var currentSpotPrices = null;


  /*
    DESC: Get spot alerts. USED IN: /setalerts
    GET /account/v1/spot-alert
  */
  function getSpotAlerts(cb) {
    var req = new Request(servicesSGUrl + url, {
      locationId: getLocation()
    });
    req.type('get');

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res)
      }
    });

    req.call();
  }

  /*
    DESC: Returns string after comparing amount entered and spot price. USED IN: /setalerts
  */
  function compareSpotPriceWithAmount() {
    var cur = getCurrency(),
      $unit = $('input[name=weight]:checked'),
      $selectedMetal = $('input[name=precious-metal]:checked'),
      spotPrice = alertModule.currentSpotPrices[cur.toUpperCase()][$unit.val()][$selectedMetal.val().toUpperCase()],
      $amount = $('.price-alert-value');

    var spotPriceStr = (parseFloat($amount.val()) > parseFloat(spotPrice)) ? ' below,' : ' above,';

    return spotPriceStr;
  }

  function saveOptions() {
    var data = {
      metal: $('input[name=precious-metal]:checked').attr('id'),
      weightUnit: $('input[name=weight]:checked').val(),
      notifEmail: $('.set-alerts-wrap #chk-email')[0].checked,
      notifSms: $('.set-alerts-wrap #chk-sms')[0].checked,
    };
    localStorage.setItem('alertsOptions', JSON.stringify(data));
  }

  /*
    DESC: Load Alert page. USED IN: /setalerts
  */
  function loadAlertPage(res) {
    update(res);
    $('.notif-string').text('').addClass('hide');
    $('.notif-checkbox').html(tmpl($('#tmpl-alert-notification-checkbox').html(), res));

    var notifStrEmail = 'your email address',
      notifStrPhone = 'your mobile number';

    if (res.email.length) {
      $('.set-alerts-wrap .terms').addClass('hide');
      notifStrEmail = res.email;
      notifStrPhone = res.phone && res.phone.length ? res.phone : 'your mobile number';
      // $('.user-fields').addClass('hide').empty();
    }

    $('.currency-wrap .radio-one-line input, .currency-selection').off('click'); // Remove previously click handler to avoid bubling handler
    $('#btn-set-alert').off('click'); // Remove previously click handler to avoid bubling handler
    $('#dont-show-again-alert-add').off('click'); // Remove previously click handler to avoid bubling handler
    $('.set-alerts-wrap #chk-email').off('click'); // Remove previously click handler to avoid bubling handler
    $('.set-alerts-wrap #chk-sms').off('click'); // Remove previously click handler to avoid bubling handler
    $('.price-alert-value').off('keyup'); // Remove previously click handler to avoid bubling handler
    $('.set-alerts-wrap #email').off('keyup'); // Remove previously click handler to avoid bubling handler
    $('.set-alerts-wrap #phone-number').off('keyup'); // Remove previously click handler to avoid bubling handler
    $('input[name=precious-metal]').off('click'); // Remove previously click handler to avoid bubling handler
    $('input[name=weight]').off('click'); // Remove previously click handler to avoid bubling handler
    $('.alert-wrap').off('click', '.alert .remove'); // Remove previously click handler to avoid bubling handler

    $('.price-alert-value').on('keyup', function() {
      console.log('currentlocation', getLocation());
      var _this = $(this),
        str = '',
        cur = getCurrency(),
        curStr = '<span class="usd' + ((cur.toLowerCase() == 'usd') ? '' : ' hide') + '">' + ((getLocation()) == 2 ? '$' : 'US$') + '</span>' +
        '<span class="sgd' + ((cur.toLowerCase() == 'sgd') ? '' : ' hide') + '">S$</span>' +
        '<span class="eur' + ((cur.toLowerCase() == 'eur') ? '' : ' hide') + '">€</span>' +
        '<span class="jpy' + ((cur.toLowerCase() == 'jpy') ? '' : ' hide') + '">¥</span>' +
        '<span class="aud' + ((cur.toLowerCase() == 'aud') ? '' : ' hide') + '">AU$</span>' +
        //  '<span class="sek' + ((cur.toLowerCase() == 'sek') ? '' : ' hide') + '">SEK</span>' +
        '<span class="nzd' + ((cur.toLowerCase() == 'nzd') ? '' : ' hide') + '">NZ$</span>' +
        '<span class="gbp' + ((cur.toLowerCase() == 'gbp') ? '' : ' hide') + '">£ </span>' +
        '<span class="btc' + ((cur.toLowerCase() == 'btc') ? '' : ' hide') + '">BTC </span>' +
        '<span class="bch' + ((cur.toLowerCase() == 'bch') ? '' : ' hide') + '">BCH </span>' +
        '<span class="eth' + ((cur.toLowerCase() == 'eth') ? '' : ' hide') + '">ETH </span>' +
        '<span class="ltc' + ((cur.toLowerCase() == 'ltc') ? '' : ' hide') + '">LTC </span>' +
        '<span class="xaut' + ((cur.toLowerCase() == 'xaut') ? '' : ' hide') + '">XAUT </span>' +
        '<span class="paxg' + ((cur.toLowerCase() == 'paxg') ? '' : ' hide') + '">PAXG </span>',
        $unit = $('input[name=weight]:checked'),
        $selectedMetal = $('input[name=precious-metal]:checked'),
        valCleanStr = isCryptoCurrency() ?
        cryptoDecimalPointRules(parseFloat(_this.val())) :
        commaSeparateNumber(parseFloat(_this.val()).toFixed(2));

      if (!parseFloat(_this.val())) {
        $('.notif-string').addClass('hide');
        return;
      }

      $('.notif-string').removeClass('hide');

      if ($('.set-alerts-wrap #chk-email')[0].checked && !$('.set-alerts-wrap #chk-sms')[0].checked) {
        str = 'When the spot price for <span class="str-metal">' + $selectedMetal.attr('id').toLowerCase() +
          '</span> hits ' + curStr + valCleanStr + '<span class="sek' + ((cur.toLowerCase() == 'sek') ? '' : ' hide') + '"> kr</span> per <span class="str-unit">' +
          $unit.data('text').toLowerCase() + '</span> from ' +
          '<span class="str-compare">' + compareSpotPriceWithAmount() + '</span>' +
          '<span class="str-email"> an e-mail notification will be sent to ' + notifStrEmail + '</span>' +
          '<span class="str-and hide"> and</span>' +
          '<span class="str-phone"></span>.';
        $('.notif-string').html(str);
      } else if (!$('.set-alerts-wrap #chk-email')[0].checked && $('.set-alerts-wrap #chk-sms')[0].checked) {
        // SMS notification is only checked
        str = 'When the spot price for <span class="str-metal">' + $selectedMetal.attr('id').toLowerCase() +
          '</span> hits ' + curStr + valCleanStr + '<span class="sek' + ((cur.toLowerCase() == 'sek') ? '' : ' hide') + '"> kr</span> per <span class="str-unit">' +
          $unit.data('text').toLowerCase() + '</span> from ' +
          '<span class="str-compare">' + compareSpotPriceWithAmount() + '</span>' +
          '<span class="str-email"></span>' +
          '<span class="str-and hide"> and</span>' +
          '<span class="str-phone"> an SMS will be sent to ' + notifStrPhone + '</span>.';
        $('.notif-string').html(str);
      } else if ($('.set-alerts-wrap #chk-email')[0].checked && $('.set-alerts-wrap #chk-sms')[0].checked) {
        str = 'When the spot price for <span class="str-metal">' + $selectedMetal.attr('id').toLowerCase() +
          '</span> hits ' + curStr + valCleanStr + '<span class="sek' + ((cur.toLowerCase() == 'sek') ? '' : ' hide') + '"> kr</span> per <span class="str-unit">' +
          $unit.data('text').toLowerCase() + '</span> from ' +
          '<span class="str-compare">' + compareSpotPriceWithAmount() + '</span>' +
          '<span class="str-email"> an e-mail notification will be sent to ' + notifStrEmail + '</span>' +
          '<span class="str-and"> and</span>' +
          '<span class="str-phone"> an SMS will be sent to ' + notifStrPhone + '</span>' + '.';
        $('.notif-string').html(str);
      }

      // Both unchecked
      if (!$('.set-alerts-wrap #chk-email')[0].checked && !$('.set-alerts-wrap #chk-sms')[0].checked) {
        $('.notif-string').addClass('hide');
      }

    });

    $('.price-alert-value').trigger('keyup');

    // Should Update Notification String metal and compare
    $('input[name=precious-metal]').on('click', function() {
      var _this = $(this),
        id = _this.attr('id');

      // Update spot price string
      $('.spot-price .selected-metal').text(id.charAt(0).toUpperCase() + id.slice(1));
      $('.spot-price .price .metals').addClass('hide');
      $('.spot-price .price .metals.' + _this.val()).removeClass('hide');

      // Update metal string to notification paragraph below
      $('.notif-string .str-metal').text(_this.attr('id').toLowerCase());
      // Update compare string to notification paragraph below
      $('.notif-string .str-compare').text(compareSpotPriceWithAmount());
      saveOptions();
    });

    $('input[name=weight]').on('click', function() {
      var _this = $(this);

      // Update spot price string
      $('.spot-price .price .units').addClass('hide');
      $('.spot-price .price .units.' + _this.val()).removeClass('hide');

      // Update unit string to notification paragraph below
      $('.notif-string').find('.str-unit').text(_this.data('text').toLowerCase());
      // Update compare string to notification paragraph below
      $('.notif-string .str-compare').text(compareSpotPriceWithAmount());
      saveOptions();
    });

    $('.set-alerts-wrap #chk-email').on('click', function() {
      var _this = $(this);

      if (_this[0].checked) {

        // Add email string to notification paragraph below
        $('.notif-string').find('.str-email').text(' an e-mail notification will be sent to ' + notifStrEmail);

        if ($('.set-alerts-wrap #chk-sms')[0].checked) {
          $('.notif-string').find('.str-and').removeClass('hide'); // show the word (and)
        } else {
          $('.notif-string').find('.str-and').addClass('hide'); // hide the word (and)
        }
      } else {
        $('.notif-string').find('.str-email').text('');
        $('.notif-string').find('.str-and').addClass('hide');
      }

      // Remove .hide if one notification checkbox is checked and alert has a value
      if (_this[0].checked && parseInt($('.price-alert-value').val())) {
        $('.notif-string').removeClass('hide');
      }

      // Add .hide if none of the notification checkbox is checked
      if (!_this[0].checked && !$('.set-alerts-wrap #chk-sms')[0].checked) {
        $('.notif-string').addClass('hide');
      }
      saveOptions();
    });

    $('.set-alerts-wrap #chk-sms').on('click', function() {
      var _this = $(this);

      if (_this[0].checked) {

        // Add SMS string to notification paragraph below
        $('.notif-string').find('.str-phone').text(' an SMS will be sent to ' + notifStrPhone);

        if ($('.set-alerts-wrap #chk-email')[0].checked) {
          $('.notif-string').find('.str-and').removeClass('hide'); // show the word (and)
        } else {
          $('.notif-string').find('.str-and').addClass('hide'); // hide the word (and)
        }
      } else {
        $('.notif-string').find('.str-phone').text('');
        $('.notif-string').find('.str-and').addClass('hide');
      }

      // Remove .hide if one notification checkbox is checked and alert has a value
      if (_this[0].checked && parseInt($('.price-alert-value').val())) {
        $('.notif-string').removeClass('hide');
      }

      // Add .hide if none of the notification checkbox is checked
      if (!_this[0].checked && !$('.set-alerts-wrap #chk-email')[0].checked) {
        $('.notif-string').addClass('hide');
      }
      saveOptions();
    });

    $('.currency-wrap .radio-one-line input').on('click', function() {
      var _this = $(this),
        value = _this.val();

      if (getCurrency() !== value) {
        changeCurrency(value);

        headerCurrencyChange();
      }
    });

    $('#payment-change-currency').on('click', function() {
      var popupCurrency = new PopupCurrency();
      popupCurrency.render();
    });

    // Select Currency
    $('.currency-selection').on('click', function() {
      // Update compare string to notification paragraph below
      $('.notif-string .str-compare').text(compareSpotPriceWithAmount(res));
    });

    if (localStorage.getItem('alertsOptions') !== null) {
      console.log('Options')
      var options = JSON.parse(localStorage.getItem('alertsOptions'));
      $('#chk-email').prop('checked', options.notifEmail);
      $('#chk-sms').prop('checked', options.notifSms);
      $('.weight #' + options.weightUnit).prop('checked', true).trigger('click');
      $('.metal-wrap #' + options.metal).prop('checked', true).trigger('click');
    }

    $('#btn-set-alert').on('click', function() {
      formValidationModule.validateForm($('.set-alerts-wrap'), 'Set Alert Level', function(data) {
        if ($('.set-alerts-wrap #chk-email')[0].checked || $('.set-alerts-wrap #chk-sms')[0].checked) {
          var cur = getCurrency(),
            $unit = $('input[name=weight]:checked'),
            $selectedMetal = $('input[name=precious-metal]:checked').val();

          data.emailAlert = $('.set-alerts-wrap #chk-email')[0].checked ? true : false;
          data.smsAlert = $('.set-alerts-wrap #chk-sms')[0].checked ? true : false;
          data.currentSpotPrice = alertModule.currentSpotPrices[cur][$unit.val()][$selectedMetal.toUpperCase()];
          data.currency = getCurrency();
          data.weightUnit = $unit.val();
          data.metal = $selectedMetal.toUpperCase();
          data.timeZone = moment.tz.guess();

          createSpotAlert(data, function(res) {
            $('.price-alert-value').val('');
            if (!readCookie('addAlertDontShow')) {
              var popup = new PopupAddAlert();
              popup.render();
            }
            update(res);
            $('.price-alert-value').keyup();
          }, function(res) {
            update(res);
            $('.price-alert-value').keyup();
          });
        } else {
          var options = {
            title: 'Set Alert',
            message: 'Please select how you would like to be notified when your desired market alert price is hit. Select either E-mail and/or SMS text message.',
            okCallback: function() {
              $('.wrap').scrollTop(390);
            }
          };
          var popup = new Popup(options);
          popup.render();
        }
      }, null, true);
    });

    $('.alert-wrap').on('click', '.alert .remove', function() {
      var _this = $(this);
      alertModule.deleteSpotAlert({
        id: _this.data('id')
      }, function(res) {
        _this.parents('tr').remove();
        if (!$('.active-alert .alert tr').length) {
          $('.active-alert').empty();
        }
        if (!$('.alert-history .alert tr').length) {
          $('.alert-history').empty();
        }
      });
    });
  }

  /*
   DESC: Updates the prices etc on the Set Alerts page. USED IN: /setalerts
   */
  function update(res) {
    if (res.currentSpotPrices != null) {
      alertModule.currentSpotPrices = res.currentSpotPrices;
    }

    if (res.currentSpotPriceStrings != null) {
      $('.spot-price .price').html(tmpl($('#tmpl-alert-spot-price').html(), {
        obj: res.currentSpotPriceStrings
      }));
    }

    if (res.activeItems != null) {
      $('.alert-wrap').html(tmpl($('#tmpl-alert-item').html(), res));
    }
  }

  /*
    DESC: Create spot alerts. USED IN: /setalerts
    POST /account/v1/spot-alert/
    emailAlert=true
    smsAlert=true
    amount=1000
    currentSpotPrice=1100
    currency=SGD
    metal=XAU
  */
  function createSpotAlert(data, cb, errorCb) {
    data.locationId = getLocation();
    var req = new Request(servicesSGUrl + url, data);

    req.afterErrorDialogFunction(function(res) {
      typeof errorCb === 'function' && errorCb(res)
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res)
      }
    });

    req.call();
  }

  /*
    DESC: Delete spot alerts. USED IN: /setalerts
    DELETE /account/v1/spot-alert/?id=10
  */
  function deleteSpotAlert(data, cb) {
    var req = new Request(servicesSGUrl + url, data);
    req.type('delete')

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res)
      }
    });

    req.call();
  }

  return {
    getSpotAlerts: getSpotAlerts,
    loadAlertPage: loadAlertPage,
    createSpotAlert: createSpotAlert,
    deleteSpotAlert: deleteSpotAlert,
    update: update,
    currentSpotPrices: currentSpotPrices
  }
}());

/* Add for mocha testing */
// Basically it make the alertModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = alertModule;
}
/***********************************************************/
/***********************************************************/
/* Transaction Confirmation Module */
/***********************************************************/
/***********************************************************/

var transactionConfirmationModule = (function() {

  var url = '/account/v1/svf/',
    btnPrint = '<div class="printer-friendly"><a href="javascript:void(0);" class="print"><img src="' + cdnUrl + '/img/d/printer.svg" width="18" height="16" />Print</a></div>';

  /*
   DESC: Get transaction confirmation. USED IN: /account/transactionconfirmed page
   POST /api/v1/transaction/confirmation
   */
  function confirmation(data, successCb, errorCb) {
    var req = new Request(servicesUrl + url + 'confirmation', data);

    req.success(function(res) {
      if (res.success) {
        typeof successCb === 'function' && successCb(res);
      }
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.call();
  }

  /*
   DESC: Get transaction invoice. USED IN: /account/transactionconfirmed page
   POST /api/v1/transaction/invoice
   */
  function invoice(data, successCb, errorCb) {
    var req = new Request(servicesUrl + url + 'invoice', data);

    req.success(function(res) {
      if (res.success) {
        typeof successCb === 'function' && successCb(res);
      }
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.call();
  }

  /*
   DESC: Get transaction green. USED IN: /account/transactiongreen page
   POST /api/v1/transaction/green
   */
  function green(data, successCb, errorCb) {
    var req = new Request(servicesUrl + url + 'green', data);

    req.success(function(res) {
      if (res.success) {
        typeof successCb === 'function' && successCb(res);
      }
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.call();
  }

  /* DESC: Load page. USED IN: /account/transactionconfirmed page */
  function loadPageConfirmation() {
    var path = window.location.search.split('?id='),
      id = path[path.length - 1];

    confirmation({
      id: id
    }, function(res) {
      $('.order-confirmation-wrap').html(res.html);
      $('.order-confirmation-wrap').append(btnPrint);

      $('.open-email-us').on('click', function() {
        var popupEmailUs = new PopupEmailUs();
        popupEmailUs.render();
      });

      $(document).on('click', '#btn-email-us, #btn-email-us-text', function() {
        var popupEmailUs = new PopupEmailUs(null, null, 'Transaction # ' + id);
        popupEmailUs.render();
        $('.contact-form .cf-subject').find('input').val('Transaction # ' + id);
      });
    }, function(res) {
      $('.order-confirmation-wrap').html('<h1>' + res.title + '</h1><p>' + res.message + '</p>');
    });
  }

  /* DESC: Load page. USED IN: /account/transaction page */
  function loadPageInvoice() {
    var path = window.location.search.split('?id='),
      id = path[path.length - 1];

    invoice({
      id: id
    }, function(res) {
      $('.order-confirmation-wrap').html(res.html);
      $('.order-confirmation-wrap').append(btnPrint);
      $('.order-confirmation-wrap').append(tmpl($('#tmpl-transaction-confirmation-status').html(), {
        obj: res.statusChanges
      }));
    }, function(res) {
      $('.order-confirmation-wrap').html('<h1>' + res.title + '</h1><p>' + res.message + '</p>');
    });
  }

  /* DESC: Load page. USED IN: /account/transactiongreen page */
  function loadPageGreen() {
    var path = window.location.search.split('?id='),
      id = path[path.length - 1];

    green({
      id: id
    }, function(res) {
      $('.order-confirmation-wrap').html(res.html);
      $('.order-confirmation-wrap').append(btnPrint);
    }, function(res) {
      $('.order-confirmation-wrap').html('<h1>' + res.title + '</h1><p>' + res.message + '</p>');
    });
  }

  /*
    DESC: Get transactions. USED IN: /myaccount/transactions
    POST /account/transaction/get
  */
  function getTransactionFilter(data, successCb, failCb) {
    var req = new Request(servicesUrl + '/account/transaction/get', data);

    req.afterErrorDialogFunction(function(res) {
      typeof failCb === 'function' && failCb(res);
    });

    req.success(function(res) {
      if (res.success) {
        typeof successCb === 'function' && successCb(res);

        if ($('input[name=transaction-type]:checked').val() === 'ORDER') {
          $('.history table th.th-balance, .history-item td.th-balance').addClass('hide');
        } else {
          $('.history table th.th-balance, .history-item td.th-balance').removeClass('hide');
        }
      }
    });

    req.call();
  }

  function getFilters(fieldChanged) {
    var transactionType = '',
      orderType = '',
      location = '';

    $('input[name=transaction-type]:checked').each(function(i, checkbox) {
      if (transactionType.length > 0) {
        transactionType += ',';
      }
      transactionType += checkbox.value;
    });

    if (fieldChanged == null) {
      fieldChanged = '';
    }

    orderType = $('input[name=order-type]:checked').val() || '';
    location = $('input[name=transaction-location]:checked').val() || '';

    return {
      requestLocationId: getLocation(),
      transactionType: transactionType,
      orderType: orderType,
      locationId: location,
      fromDate: $('#from-date-input').val(),
      toDate: $('#to-date-input').val(),
      fieldChanged: fieldChanged,
      tz: 'Asia/Singapore'
    };
  }

  function loadTranscationPage() {

    var data = {},
      nextPage = '',
      ajaxFlag = true;

    if (sessionStorage.getItem('tpage-transaction-type') === 'orders') {
      $('.transaction-wrap .filter .mid, .transaction-wrap .filter .bottom').removeClass('hide');
    }

    $('#orders').prop('checked', sessionStorage.getItem('tpage-transaction-type') && (sessionStorage.getItem('tpage-transaction-type') === 'orders'));
    $('#top-ups').prop('checked', sessionStorage.getItem('tpage-transaction-type') && (sessionStorage.getItem('tpage-transaction-type') === 'top-ups'));
    $('#withdrawals').prop('checked', sessionStorage.getItem('tpage-transaction-type') && (sessionStorage.getItem('tpage-transaction-type') === 'withdrawals'));
    $('#buy').prop('checked', sessionStorage.getItem('tpage-order-type') && sessionStorage.getItem('tpage-order-type') === 'buy');
    $('#auction').prop('checked', sessionStorage.getItem('tpage-order-type') && sessionStorage.getItem('tpage-order-type') === 'auction');
    $('#sell').prop('checked', sessionStorage.getItem('tpage-order-type') && sessionStorage.getItem('tpage-order-type') === 'sell');
    $('#withdrawal').prop('checked', sessionStorage.getItem('tpage-order-type') && sessionStorage.getItem('tpage-order-type') === 'withdrawal');
    $('#auto-invest').prop('checked', sessionStorage.getItem('tpage-order-type') && sessionStorage.getItem('tpage-order-type') === 'auto-invest');

    $('#sg').prop('checked', sessionStorage.getItem('tpage-transaction-location') && sessionStorage.getItem('tpage-transaction-location') === '1');
    $('#nz').prop('checked', sessionStorage.getItem('tpage-transaction-location') && sessionStorage.getItem('tpage-transaction-location') === '3');

    var now = new Date();
    var dd = now.getDate();
    var mm = now.getMonth() + 1;

    var yyyy = now.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    var today = dd + '-' + mm + '-' + yyyy;

    var from = $('#from-date-input').datepicker({
      showOn: 'button',
      buttonImage: '/img/d/calendar.svg',
      buttonImageOnly: true,
      buttonText: 'Open Calendar',
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd-mm-yy',
      onSelect: function(dateString, datePicker) {
        getTransactionFilter(getFilters('fromDate'), function(res) {
          $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
          nextPage = res.pagination.nextPage;
        });
        saveOptions();
        $('#to-date-input').datepicker('option', 'minDate', $('#from-date-input').datepicker('getDate'));
        $('#from-date-input').datepicker('option', 'maxDate', $('#to-date-input').datepicker('getDate'));
      },
      maxDate: sessionStorage.getItem('tpage-to') ? sessionStorage.getItem('tpage-to') : today,
    });

    $('#from-date-input').datepicker('setDate', sessionStorage.getItem('tpage-from') ? sessionStorage.getItem('tpage-from') : '');

    var to = $('#to-date-input').datepicker({
      showOn: 'button',
      buttonImage: '/img/d/calendar.svg',
      buttonImageOnly: true,
      buttonText: 'Open Calendar',
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd-mm-yy',
      onSelect: function(dateString, datePicker) {
        getTransactionFilter(getFilters('toDate'), function(res) {
          $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
          nextPage = res.pagination.nextPage;
        });
        saveOptions();
        $('#from-date-input').datepicker('option', 'maxDate', $('#to-date-input').datepicker('getDate'));
        $('#to-date-input').datepicker('option', 'minDate', $('#from-date-input').datepicker('getDate'));
      },
      maxDate: 0,
    });

    $('#to-date-input').datepicker('setDate', sessionStorage.getItem('tpage-to') ? sessionStorage.getItem('tpage-to') : '');
    $('#to-date-input').datepicker('option', 'minDate', $('#from-date-input').datepicker('getDate'));

    to.on('change', function() {
      getTransactionFilter(getFilters('toDate'), function(res) {
        saveOptions();
        if (res.toDate) {
          $('#to-date-input').val(res.toDate);
        }
        $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
        nextPage = res.pagination.nextPage;
        $('#from-date-input').datepicker('option', 'maxDate', $('#to-date-input').datepicker('getDate'));
        $('#to-date-input').datepicker('option', 'minDate', $('#from-date-input').datepicker('getDate'));
      }, function(res) {
        if (res.toDate) {
          $('#to-date-input').val(res.toDate);
        }
        $('#to-date-input').focus();
      });
      eraseCookie('tpage-to');
      sessionStorage.removeItem('tpage-to');
    });

    from.on('change', function() {
      getTransactionFilter(getFilters('fromDate'), function(res) {
        saveOptions();
        if (res.fromDate) {
          $('#from-date-input').val(res.fromDate);
        }
        $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
        nextPage = res.pagination.nextPage;
        $('#to-date-input').datepicker('option', 'minDate', $('#from-date-input').datepicker('getDate'));
        $('#from-date-input').datepicker('option', 'maxDate', $('#to-date-input').datepicker('getDate'));
      }, function(res) {
        if (res.fromDate) {
          $('#from-date-input').val(res.fromDate);
        }
        $('#from-date-input').focus();
      });
      sessionStorage.removeItem('tpage-from');
    });

    function saveOptions() {
      var transType = [],
        transTypeStr = '',
        orderType = '',
        location = '',
        from = '',
        to = '';

      $('input[name="transaction-type"]').each(function(i, input) {
        if ($(input)[0].checked) {
          transType.push($(input).attr('id'));
        }
      });

      orderType = $('input[name="order-type"]:checked').attr('id') || '';

      location = $('input[name="transaction-location"]:checked').val() || '';

      from = $('#from-date-input').val();
      to = $('#to-date-input').val();

      transTypeStr = transType.join(',');

      sessionStorage.setItem('tpage-transaction-type', transTypeStr);
      sessionStorage.setItem('tpage-order-type', orderType);
      sessionStorage.setItem('tpage-transaction-location', location);
      sessionStorage.setItem('tpage-from', from);
      sessionStorage.setItem('tpage-to', to);
    }

    var tTypeSelected = sessionStorage.getItem('tpage-transaction-type') || '';

    $('input[name=transaction-type]').on('click', function() {
      //console.time('Filter Transaction Type');
      var _this = $(this);

      console.log($(this).prop('checked'))
      console.log($(this).attr('id'));
      console.log(tTypeSelected);
      if ($(this).attr('id') === tTypeSelected) {
        $('input[name=transaction-type]').prop('checked', false);
        $('input[name=order-type]').prop('checked', false);
        $('input[name=transaction-location]').prop('checked', false);
        sessionStorage.removeItem('tpage-transaction-type');
        sessionStorage.removeItem('tpage-order-type');
        sessionStorage.removeItem('tpage-from');
        sessionStorage.removeItem('tpage-to');
        $('.transaction-wrap .filter .mid, .transaction-wrap .filter .bottom').addClass('hide');
        getTransactionFilter(getFilters(''), function(res) {
          $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
          nextPage = res.pagination.nextPage;
        });
        tTypeSelected = '';
        $(this).prop('checked', false);
        return;
      } else {
        $(this).prop('checked', true);
      }

      tTypeSelected = $(this).attr('id');

      if (_this.val() !== 'ORDER') {
        $('input[name=order-type]').prop('checked', false);
        $('input[name=transaction-location]').prop('checked', false);
        sessionStorage.removeItem('tpage-transaction-type');
        sessionStorage.removeItem('tpage-order-type');
      }

      getTransactionFilter(getFilters('transactionType'), function(res) {
        $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
        nextPage = res.pagination.nextPage;
      });

      $('.transaction-wrap .filter .mid, .transaction-wrap .filter .bottom').addClass('hide');
      if (_this.val() === 'ORDER') {
        $('.transaction-wrap .filter .mid, .transaction-wrap .filter .bottom').removeClass('hide');
      }
      saveOptions();
      //console.timeEnd('Filter Transaction Type');
    });

    $('input[name=order-type]').on('click', function() {
      //console.time('Filter Order Type');
      var _this = $(this);

      if ($(this).attr('id') === sessionStorage.getItem('tpage-order-type')) {
        $('input[name=order-type]').prop('checked', false);
        sessionStorage.removeItem('tpage-order-type');
      }

      $('input[name=order-type]').filter(function(i, el) {
        return _this.val() != el.value;
      });

      getTransactionFilter(getFilters('orderType'), function(res) {
        $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
        nextPage = res.pagination.nextPage;
      });
      saveOptions();
      //console.timeEnd('Filter Order Type');
    });

    $('input[name=transaction-location]').on('click', function() {
      //console.time('Filter Location Type');
      var _this = $(this);

      if ($(this).val() === sessionStorage.getItem('tpage-transaction-location')) {
        $('input[name=transaction-location]').prop('checked', false);
        sessionStorage.removeItem('tpage-transaction-location');
      }


      $('input[name=transaction-location]').filter(function(i, el) {
        return _this.val() != el.value;
      })

      getTransactionFilter(getFilters('locationId'), function(res) {
        $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
        nextPage = res.pagination.nextPage;
      });

      saveOptions();
      //console.timeEnd('Filter Location Type');
    });

    $('#clear-filter').on('click', function() {
      from.val('');
      to.val('');
      $('input[name=transaction-type]').prop('checked', false);
      $('input[name=order-type]').prop('checked', false);
      $('input[name=transaction-location]').prop('checked', false);
      sessionStorage.removeItem('tpage-transaction-type');
      sessionStorage.removeItem('tpage-order-type');
      sessionStorage.removeItem('tpage-transaction-location');
      sessionStorage.removeItem('tpage-from');
      sessionStorage.removeItem('tpage-to');

      tTypeSelected = '';
      $('.transaction-wrap .filter .mid, .transaction-wrap .filter .bottom').addClass('hide');
      getTransactionFilter(getFilters(''), function(res) {
        $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
        nextPage = res.pagination.nextPage;
      });
    });

    if ($('input[name="transaction-type"]:checked').length ||
      $('input[name="ordery-type"]:checked').length ||
      $('input[name="transaction-location"]:checked') ||
      $('#from-date-input').val() || $('#to-date-input').val()) {
      data = getFilters();
    }

    getTransactionFilter(data, function(res) {
      $('.history tbody').html(tmpl($('#tmpl-transactions').html(), res));
      nextPage = res.pagination.nextPage;
      $parent.removeClass('hide');

      $(document).on('scroll', function() {
        if (!$('.history .history-item').length) return;
        if (isElementInViewport($('.history .history-item:last-child'), 3) && nextPage) {
          if (ajaxFlag) {
            ajaxFlag = false;

            console.log('servicesSGUrl(1): ' + nextPage);
            var req = new Request(servicesSGUrl + nextPage, {});

            req.success(function(res) {
              nextPage = res.pagination.nextPage;
              if (res.transactions.length) {
                $('.history tbody').append(tmpl($('#tmpl-transactions').html(), res));

                if ($('input[name=transaction-type]:checked').val() === 'ORDER') {
                  $('.history table th.th-balance, .history-item td.th-balance').addClass('hide');
                } else {
                  $('.history table th.th-balance, .history-item td.th-balance').removeClass('hide');
                }
              }

            });

            req.complete(function() {
              ajaxFlag = true;
            });

            req.send();

            // $.ajax({
            //   url: nextPage,
            // }).done(function(res) {
            //   nextPage = res.pagination.nextPage;
            //   if(res.transactions.length) {
            //     $('.history tbody').append(tmpl($('#tmpl-transactions').html(), res));

            //     if($('input[name=transaction-type]:checked').val() === 'ORDER') {
            //       $('.history table th.th-balance, .history-item td.th-balance').addClass('hide');
            //     } else {
            //       $('.history table th.th-balance, .history-item td.th-balance').removeClass('hide');
            //     }
            //   }
            // }).always(function() {
            //   ajaxFlag = true;
            // });
          }
        }
      });
    });
  }

  return {
    confirmation: confirmation,
    invoice: invoice,
    loadPageConfirmation: loadPageConfirmation,
    loadPageInvoice: loadPageInvoice,
    loadPageGreen: loadPageGreen,
    loadTranscationPage: loadTranscationPage
  }
}());

/* Add for mocha testing */
// Basically it make the transactionConfirmationModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = transactionConfirmationModule;
}
/***********************************************************/
/***********************************************************/
/* Product Module */
/***********************************************************/
/***********************************************************/

var productModule = (function() {
  var url = '/api/v1/product/',
    urlHome = servicesUrl + '/product/v1/home',
    autoInvestUrl = servicesUrl + '/product/autoinvest/featured-products',
    currencyFlag, locationFlag;

  /*
    DESC: Set Product Notification. USED IN: /buy/*
    POST /product/v1/notify
  */
  function setProductNotify(data, cb) {
    var req = new Request(servicesUrl + '/product/v1/notify', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res)
      }
    });

    req.call();
  }

  function startPromoTimers() {
    $('.promoTime').each(function(i) {
      var prodId = $(this).data('product-id');
      var timeLeft = parseInt($(this).attr('data-time-left'));
      var expireDate = checkExpireDate(timeLeft);
      $(this).attr('data-expire-date', expireDate);

      stopPromoCounter(prodId);
      if (expireDate <= 1) {
        return;
      }

      $(this).attr('id', 'promoTime' + prodId);
      window.promoCounters['promo-' + prodId] = setInterval(updatePromoTimer, 1000, prodId);

      // if(!reRun) {
      //   // Make sure run promo timer on promo that timer hasn't start yet
      //   if((id == null || id == '') && timeLeft) {
      //     $(this).attr('id', 'promoTime' + promoCounterIndex);
      //     promoCounters[promoCounterIndex] = setInterval(updatePromoTimer, 1000, promoCounterIndex);
      //     promoCounterIndex++;
      //   }
      // } else {
      //   if(id) {
      //     // Rerun  
      //     promoCounters[promoCounterIndex] = setInterval(updatePromoTimer, 1000, id.slice(-1));
      //   }
      // }
    });
  }

  function stopPromoCounter(idx) {
    clearInterval(window.promoCounters['promo-' + idx]);
  }

  function changeProductBasedOnLocation(id) {
    return searchModule.getProduct({
      id: id
    }, function(res) {
      var stockStatusTxt = '', // Change Status Text
        orderField = ''; // Order Field
      if (res.product.status === 'IN_STOCK') {
        stockStatusTxt = '<span class="font-green">IN STOCK</span>';
        orderField = '<div class="controls"><input type="number" value="1" autocomplete="false" class="quantity txt-number" maxlength="8" pattern="[0-9]*"><div class="btn-common-radius btn-add-to-cart" id="btn-add-to-cart" data-id="' + res.product.id + '">Add to Cart</div></div>';
      } else if (res.product.status === 'IN_TRANSIT' || res.product.status === 'ON_DEMAND') {
        stockStatusTxt = '<span class="font-green">PRE-SALE ' + ((res.product.preSaleDate) ? '<span class="date">(' + res.product.preSaleDate + ')</span>' : '') + '</span>';
        orderField = '<div class="controls"><input type="number" value="1" autocomplete="false" class="quantity txt-number" maxlength="8" pattern="[0-9]*"><div class="btn-common-radius btn-add-to-cart" id="btn-add-to-cart" data-id="' + res.product.id + '">Add to Cart</div></div>';
      } else if (res.product.status === 'UNAVAILABLE') {
        stockStatusTxt = '<span class="font-red">OUT OF STOCK</span>';
        orderField = '<div class="notification-wrap"><div class="btn-common btn-email-notif" data-id="' + res.product.id + '">E-mail me when available</div></div>';
      }

      $('.product-default-wrap .order-field').html(orderField);
      $('.product-default-wrap .status').html(stockStatusTxt);
      // Change prev and next page
      // Next
      if (res.product.nextProduct) {
        $('.paging next-link').attr('href', '/buy/product/' + res.product.nextProduct.name);
        $('.paging next-link').attr('title', res.product.nextProduct.title);
        $('.paging next-text').text(res.product.nextProduct.title);
      }

      // Prev
      if (res.product.prevProduct) {
        $('.paging prev-link').attr('href', '/buy/product/' + res.product.prevProduct.name);
        $('.paging prev-link').attr('title', res.product.prevProduct.title);
        $('.paging prev-text').text(res.product.prevProduct.title);
      }
    }, null, null, true);
  }

  function getProductIdPeriodCookieName() {
    return 'product-details-period-' + $('.product-default-wrap').data('product-id');
  }

  function loadDetailsPage() {
    var chartData = {
      product: true,
      productId: $('#btn-add-to-cart').length ? $('#btn-add-to-cart').data('id') : $('.btn-email-notif').data('id'),
      productTo: false,
      toIndex: getCurrency(),
      fromIndex: '',
      period: 'MONTH_1',
      width: 320,
      height: 280,
      timeZoneId: moment.tz.guess(),
      weightUnit: 'tr_oz'
    };

    var elavateZoomOption = {
      responsive: true,
      easing: true,
      preloading: 1,
      zoomWindowPosition: 1,
      zoomWindowOffetx: 1,
      zoomWindowOffety: 0,
      zoomWindowWidth: $(window).innerWidth() <= 1200 ? $('.wrapper').innerWidth() - $('.product-default-wrap .photo').outerWidth(true) : $('.wrapper').innerWidth() - ($('.product-default-wrap .photo').outerWidth(true) - 35),
      zoomWindowHeight: 500,
      borderSize: 1,
      lensOpacity: 0.4,
      onZoomedImageLoaded: function(e) {
        console.log('loaded');
        $('#zoom-loader').addClass('hide');
        if (mouseInsideImage) {
          $('.zoomLens').css({
            'display': 'block',
          });
          $('.zoomWindow').css({
            'display': 'block',
            'top': '-1px',
            'left': '301px'
          });
        }
      }
    };

    var idQuantity = JSON.parse(localStorage.getItem('id-quantity')) || [];

    // Update quantity value
    if (idQuantity.length) {
      $.each(idQuantity, function(i, o) {
        if (o.id == chartData.productId) {
          $('.product-default-wrap input.quantity').val(o.value);
          return;
        }
      });
    }

    var $xhr;

    window.chartPeriod = readCookie(getProductIdPeriodCookieName()) || 'MONTH_1';
    $('.product-chart-options > .product-chart-option[data-period="' + window.chartPeriod + '"]').addClass('active');

    $('.product-chart-option').on('click', function() {
      var _this = $(this);

      $('.product-chart-options > .product-chart-option').removeClass('active');
      _this.addClass('active');

      chartData.toIndex = getCurrency();
      chartData.period = _this.data('period');
      window.chartPeriod = _this.data('period');

      createCookie(getProductIdPeriodCookieName(), _this.data('period'), 1);

      if (typeof $xhr === 'object') $xhr.abort();
      $xhr = getChartData(chartData, true);
    });

    var $zoomImg = $('#photo-target'),
      zoomLoader = '<div id="zoom-loader"><div class="loader"><div class="bullion-loader"></div></div></div>',
      mouseX = 0,
      mouseY = 0,
      mouseInsideImage = false;

    $zoomImg.on('mouseenter', function(e) {
      if (!$(this).hasClass('zoom')) return;
      $('.product-detail-wrap').css('overflow', 'visible');
      mouseInsideImage = true;
      if (!$('#zoom-loader').length) {
        $('.product-default-wrap .top').append(zoomLoader);
      } else {
        $('#zoom-loader').removeClass('hide');
      }
      var width = $(window).innerWidth() <= 1200 ? $('.wrapper').innerWidth() - $('.product-default-wrap .photo').outerWidth(true) : $('.wrapper').innerWidth() - ($('.product-default-wrap .photo').outerWidth(true) - 35);
      $('#zoom-loader').css({
        'width': width + 'px'
      });
      mouseX = e.pageX;
      mouseY = e.pageY;
    }).on('mouseleave', function() {
      $('.product-detail-wrap').css('overflow', 'hidden');
      $('#zoom-loader').addClass('hide');
      mouseInsideImage = false;
    });

    $zoomImg.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
    });

    if ($zoomImg.hasClass('zoom')) {
      $zoomImg.elevateZoom(elavateZoomOption);
    }

    $(window).on('resize', debounce(function() {
      var width = $(window).innerWidth() <= 1200 ? $('.wrapper').innerWidth() - $('.product-default-wrap .photo').outerWidth(true) : $('.wrapper').innerWidth() - ($('.product-default-wrap .photo').outerWidth(true) - 35);
      elavateZoomOption.zoomWindowWidth = width;

      $zoomImg.trigger('mouseleave');
    }, 200));

    $('.photo-thumb').on('click', function() {
      var _this = $(this),
        x2 = _this.data('src-x2');

      $zoomImg.addClass('hide');
      $('.photo-thumb').removeClass('active');
      _this.addClass('active');
      $('.photo .loader').removeClass('hide');

      $('#photo-target, .zoomContainer').remove(); // .zoomContainer prevents from poluting the DOM
      $('#zoom').prepend($('<img id="photo-target" class="zoom" src="' + x2 + '" data-zoom-image="' + _this.data('zoom-image') + '" width="300" height="300" />'));

      if (_this.hasClass('zoom')) {
        $('#photo-target').elevateZoom(elavateZoomOption);

        $('#photo-target').on('mouseenter', function() {
          if (!$(this).hasClass('zoom')) return;
          $('.product-detail-wrap').css('overflow', 'visible');
          mouseInsideImage = true;
          if (!$('#zoom-loader').length) {
            $('.product-default-wrap .top').append(zoomLoader);
          } else {
            $('#zoom-loader').removeClass('hide');
          }
          var width = $(window).innerWidth() <= 1200 ? $('.wrapper').innerWidth() - $('.product-default-wrap .photo').outerWidth(true) : $('.wrapper').innerWidth() - ($('.product-default-wrap .photo').outerWidth(true) - 35);
          $('#zoom-loader').css({
            'width': width + 'px'
          });
        }).on('mouseleave', function() {
          $('.product-detail-wrap').css('overflow', 'hidden');
          $('#zoom-loader').addClass('hide');
          mouseInsideImage = false;
        });
      }

      $('#photo-target').on('load', function() {
        $('.photo .loader').addClass('hide');
        $(this).removeClass('hide');
      });
    });

    $('input[name="header-currency"]').off('click');

    $('input[name="header-currency"]').on('click', function() {
      var id = $('#btn-add-to-cart').length ? $('#btn-add-to-cart').data('id') : $('.btn-email-notif').data('id');

      var data = {
        product: true,
        productId: id,
        productTo: false,
        toIndex: getCurrency(),
        fromIndex: '',
        period: $('.product-chart-options div.active').data('period'),
        width: 320,
        height: 280,
        timeZoneId: moment.tz.guess(),
        weightUnit: 'tr_oz'
      };

      changeCurrency($(this).val());

      if (typeof $xhr === 'object') $xhr.abort();
      $xhr = getChartData(data, true);

      if (typeof currencyFlag === 'object') {
        currencyFlag.abort();
      }

      currencyFlag = getProductPrice(getAllProductIdsArr(), getCurrency());

      headerCurrencyChange();
    });

    // $('#header-location').on('change', function() {
    //   var id = $('#btn-add-to-cart').length ? $('#btn-add-to-cart').data('id') : $('.btn-email-notif').data('id');
    //   if(typeof locationFlag === 'object') {
    //     locationFlag.abort();
    //   }

    //   locationFlag = $.ajax({
    //     url: '/api/v1/search/product/get' + '?id=' + id + addProductRequiredParams()
    //   }).done(function(res) {
    //     // Change Status Text
    //     var html = '';
    //     if(res.product.status === 'IN_STOCK') {
    //       html = '<span class="font-green">IN STOCK</span>';
    //     } else if(res.product.status === 'IN_TRANSIT' || res.product.status === 'ON_DEMAND') {
    //       html = '<span class="font-green">PRE-SALE ' + ((res.product.preSaleDate) ? '<span class="date">(' + res.product.preSaleDate + ')</span>' : '') + '</span>';
    //     } else if(res.product.status === 'UNAVAILABLE') {
    //       html = '<span class="font-red">OUT OF STOCK</span>';
    //     }

    //     $('.product-default-wrap .status').html(html);
    //     // Change prev and next page
    //     // Next
    //     if(res.product.nextProduct) {
    //       $('.paging next-link').attr('href', '/buy/product/' + res.product.nextProduct.name);
    //       $('.paging next-link').attr('title', res.product.nextProduct.title);
    //       $('.paging next-text').text(res.product.nextProduct.title);
    //     }

    //     // Prev
    //     if(res.product.prevProduct) {
    //       $('.paging prev-link').attr('href', '/buy/product/' + res.product.prevProduct.name);
    //       $('.paging prev-link').attr('title', res.product.prevProduct.title);
    //       $('.paging prev-text').text(res.product.prevProduct.title);
    //     }
    //   });
    // });
    getProductPrice(getAllProductIdsArr(), getCurrency());
    setInterval(function() {
      //var id = $('#btn-add-to-cart').length ? $('#btn-add-to-cart').data('id') : $('.btn-email-notif').data('id');
      if (!document.hidden) {
        getProductPrice(getAllProductIdsArr(), getCurrency());
      }
    }, 60000);

    // if($('.sidebar .product-promo-wrap').length >= 1) {
    //   for(var x = 0, len = $('.sidebar .product-promo-wrap').length; x < len; x++) {
    //     $promoSidebar = $('.sidebar .product-promo-wrap').eq(x);
    //     var id = $('#btn-add-to-cart').length ? $('#btn-add-to-cart').data('id') : $('.btn-email-notif').data('id');
    //     console.log($promoSidebar.data('product-id'));
    //     if($promoSidebar.data('product-id') === id) {
    //       $promoSidebar.remove();
    //       rotateLtoProducts();
    //     }
    //   }

    // }
  }

  var lastChartOptions = null;

  function getChartCurrency() {
    if (!$('#main-chart').length) return '';
    var last = $('#main-chart').attr('last');
    if (last && last.length > 4) {
      var c = last.substr(0, 3);
      return c;
    } else {
      return getCurrency();
    }
  }

  function renderChart(currency) {
    if (lastChartOptions) {
      var last = $('#main-chart').attr('last');
      if (last && last.length > 4) {
        var c = last.substr(0, 3);
        if (c == currency) {
          last = last.substr(4);
          last = last.replace(',', '');
          last = last.replace(',', '');
          last = last.replace(',', '');
          console.log('last:' + $('#main-chart').attr('last') + ' parsed:' + last);
          if (lastChartOptions.dataSeries[0].data.length > 0) {
            lastChartOptions.dataSeries[0].data[lastChartOptions.dataSeries[0].data.length - 1].v = parseFloat(last);
          }
        }
      }
      $('#main-chart').html('');
      $('#main-chart').bstarchart(lastChartOptions);
    }
  }

  function recordVisit(productId) {
    if (!productId || isNaN(productId)) return;

    var productVisits = getProductVisits();

    var productVisitsArray = productVisits.split(',');
    var id = null;
    var productVisitStr = '';
    var found = false;

    if (productVisitsArray.length > 20) {
      productVisitsArray.length = 20
    }

    for (var i = 0; i < productVisitsArray.length; i++) {
      var productVisitsItem = productVisitsArray[i];

      if (id == null) { // 0 and Even loop, Product ID
        id = productVisitsItem; // Save Product ID
      } else { // Odd loop, Product visit count
        productVisitsItemCtr = productVisitsItem; // Get current visit count
        if (id == productId) {
          productVisitsItemCtr++; // Add 1 to the current visit count
          found = true;
        }

        // Remove last comma in the string
        if (productVisitStr.length > 0) {
          productVisitStr += ',';
        }

        productVisitStr += id + ',' + productVisitsItemCtr; // Rebuild string
        id = null; // Reset ID flag
      }
    }

    // If not found prepend new Product ID and visit count
    if (!found) {
      productVisitStr = productId + ',1,' + productVisitStr;
    }

    localStorage.setItem('productVisits', productVisitStr);
  }

  function getProductVisits() {
    var s = localStorage.getItem('productVisits');
    if (s == null) {
      s = '';
    }

    return s;
  }

  function getHomeProducts(locationVal) {
    var req = new JsonRequest(urlHome, {
      currency: getCurrency(),
      locationId: locationVal || getLocation(),
      apg: getApgId(),
      productsVisited: getProductVisits()
    }, false, 'POST');

    req.success(function(res) {
      $('.popular-products div').html(tmpl($('#tmpl-home-product').html(), {
        obj: res.mostOrdered,
        rank: true
      }));
      $('.new-products div').html(tmpl($('#tmpl-home-product').html(), {
        obj: res.recommended,
        rank: false
      }));
    });

    req.send();
  }

  function getHomeProductsPriceOnly(cur) {
    var req = new JsonRequest(urlHome, {
      currency: cur || getCurrency(),
      locationId: getLocation(),
      apg: getApgId(),
      productsVisited: localStorage.getItem('productVisits')
    }, false, 'GET');

    req.success(function(res) {
      // Most Ordered Last 7 Days
      $.each(res.mostOrdered, function(i, el) {
        $('.popular-products div[data-product-id="' + el.id + '"]').find('.price > span').text(el.price);
      });
      // Recommended For You
      $.each(res.recommended, function(i, el) {
        $('.new-products div[data-product-id="' + el.id + '"]').find('.price > span').text(el.price);
      });
    });

    req.send();
  }

  function getAlsoBoughtProducts(id) {
    if (!id) {
      console.log('No ids provided.');
      return;
    }

    var req = new Request(servicesUrl + '/product/v1/also-bought', {
      currency: getCurrency(),
      locationId: getLocation(),
      apg: getApgId(),
      id: id
    });

    req.noApiErrorPopup = true;
    req.getXHR = true;

    req.success(function(res) {

      if (res.products.length === 0) {
        $('.also-bought-header').addClass('hide');
        $('.suggestion-product').addClass('hide');
        return;
      }

      $('.also-bought-header').removeClass('hide');
      $('.suggestion-product').removeClass('hide');
      $('.suggestion-product').html(tmpl($('#tmpl-search-product').html(), {
        obj: res.products,
        time: res.time,
        rank: false
      }));

      // Product details also bought section
      for (var i = 0; i < res.products.length; i++) {
        // Promo
        if (res.products[i].promoExpireDate) {
          startPromoTimers();
        }
      }
    });

    req.error(function() {
      $('.also-bought-header').remove();
      $('.suggestion-product').remove();
    })

    req.failure(function() {
      $('.also-bought-header').remove();
      $('.suggestion-product').remove();
    })

    req.send();

    return req.xhr;
  }

  function getTopGoldSilverPicks(onSuccess) {
    var req = new JsonRequest(autoInvestUrl, {
      currency: getCurrency(),
      locationId: getLocation(),
      apg: getApgId(),
    }, false, 'POST');

    req.success(function(res) {
      $('.top-picks-section .product-list').html(tmpl($('#tmpl-autoinvest-top-picks').html(), {
        obj: res.items
      }));
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
    });

    req.send();
  }

  function getProductPrice(ids, currency, successCb, errorCb) {
    if (!ids || ids.length === 0) {
      console.log('No ids provided.');
      return;
    }

    ids = convertArrToString(ids);

    if (!ids) return;

    var data = {
      currency: currency,
      locationId: getLocation(),
      productIds: ids
    };

    var req = new Request(servicesUrl + '/product/v2/prices', data);
    if (ids.length <= 20) {
      req.type('get');
    }
    req.getXHR = true;
    req.noApiErrorPopup = true;

    req.success(function(res) {

      var t0 = performance.now();
      var $sideBarParent = $('.sidebar');

      if (res.products.length) {

        var productIds = [];
        var productMap = [];

        for (var x = 0, prodLen = res.products.length; x < prodLen; x++) {
          var product = res.products[x];
          productIds.push(product.id);
          productMap[product.id] = product;
        }

        // Update lower price amount in the Add to Cart popup
        if ($('.popup-added-item-cart').length) {
          shoppingCartModule.updateCartPopupLowerPrice(productMap);
        }

        // Product details page 
        if (window.location.pathname.indexOf('/buy/product/') === 0) {
          $('.product-default-wrap').each(function() {
            var pid = $(this).data('product-id');
            if (typeof productMap[pid] !== 'undefined') {
              var product = productMap[pid];

              var $wrap = $(this);
              $wrap.find('.top > .prices').removeClass('hide');

              // Update promo timer for promo or default product since both will always be in the HTML
              var newSecLeft = parseInt((product.promoExpireDate - res.time) / 1000);
              var oldSecLeft = parseInt($wrap.find('.promoTime').attr('data-time-left')) || 0;
              var expireDate = checkExpireDate(newSecLeft);

              if (expireDate <= 1) {
                $wrap.find('.promo .time').html('&nbsp;');
              }

              $wrap.find('.promo .time').attr('data-time-left', newSecLeft);

              if (newSecLeft > oldSecLeft + window.promoTimerRunningAllowancePeriod || newSecLeft < oldSecLeft - window.promoTimerRunningAllowancePeriod) {
                startPromoTimers();
              }

              if (product.promoPrice && product.status !== 'UNAVAILABLE') {
                // Promo

                // Render promo HTML
                // Hide default HTML
                log('Render Promo');
                $wrap.find('.top > .prices').addClass('promo');
                $wrap.find('.top > h1').addClass('lto');
                // $wrap.find('.top > .photo').addClass('lto');
                // $wrap.find('.top > .prices').addClass('lto');
                $wrap.find('.top > .prices h1').addClass('lto');
                $wrap.find('.top > .prices > .promo').removeClass('hide');
                $wrap.find('.top > .prices > .default').addClass('hide');
                $wrap.find('.top > .prices > .order-field').addClass('lto');
                $wrap.find('.top > .prices > .status').addClass('lto');
                $wrap.find('.top > .prices > .great-price-premium').removeClass('lto');
                $wrap.find('.top > .prices .save').text(product.promoSaveText);

                $wrap.find('.prices.promo .price-old span').html(product.originalPrice);
                $wrap.find('.prices.promo .price-new span').html(product.promoPrice);

                $wrap.find('.top > .prices > .extra').addClass('hide');

                if (product.numSold != '') {
                  $wrap.find('.top > .prices > .extra-lto').removeClass('hide');
                } else {
                  $wrap.find('.top > .prices > .extra-lto').addClass('hide');
                }


                //console.log('getChartCurrency() is:' + getChartCurrency());
                if (getChartCurrency() == res.currency) {
                  console.log('product.js:640 value=' + product.promoPrice);
                  $('#main-chart').attr('last', product.promoPrice);
                  //renderChart(res.currency);
                }
              } else {
                // Regular Product

                // Render default HTML
                // Hide Promo HTML
                log('Render Default');
                $wrap.find('.top > .prices').removeClass('promo');
                $wrap.find('.top > h1').removeClass('lto');
                // $wrap.find('.top > .photo').removeClass('lto');
                // $wrap.find('.top > .prices').removeClass('lto');
                $wrap.find('.top > .prices h1').removeClass('lto');
                $wrap.find('.top > .prices > .promo').addClass('hide');
                $wrap.find('.top > .prices > .default').removeClass('hide');
                $wrap.find('.top > .prices > .order-field').removeClass('lto');
                $wrap.find('.top > .prices > .status').removeClass('lto');
                $wrap.find('.top > .prices > .great-price-premium').removeClass('lto');

                if (product.numSold != '') {
                  $wrap.find('.top > .prices > .extra').removeClass('hide');
                } else {
                  $wrap.find('.top > .prices > .extra').addClass('hide');
                }

                $wrap.find('.top > .prices > .extra-lto').addClass('hide');

                console.log('product.js:670 before if. chart cur=' + getChartCurrency() + ' res.currency=' + res.currency);
                if (getChartCurrency() == res.currency) {
                  console.log('product.js:669 value=' + (product.prices.length > 0 ? product.prices[0].price : ''));
                  $('#main-chart').attr('last', product.prices.length > 0 ? product.prices[0].price : '');
                  //renderChart(res.currency);
                }
              }

              // Updates prices regardless of promo or not
              var prices = product.prices,
                html = '',
                lastClass = '',
                hasPriceInfo = false;

              for (var i = 0, len = prices.length; i < len; i++) {
                if (i == (len - 1)) lastClass = ' -bold font-red-amazon';
                html += '<tr><td class="volume -bold">' + prices[i].name + '</td><td class="price' + lastClass + '">' + prices[i].price + '</td><tr>';
              }

              $wrap.find('.default .info tbody').html(html);

              if (product.totalAvailable <= 0) {
                $wrap.find('.default').addClass('hide');
              }

              var $priceWrap = $wrap.find('.price-info-wrap');
              // Price per gram
              if (product.pricePerGram) {
                $priceWrap.find('.price-gram').parent().removeClass('hide');
                hasPriceInfo = true;
              } else {
                $priceWrap.find('.price-gram').parent().addClass('hide');
              }
              $priceWrap.find('.price-gram.amount').text(product.pricePerGram);

              // Price per troy oz
              if (product.pricePerTroyOunce) {
                $priceWrap.find('.price-tr-oz.amount').parent().removeClass('hide');
                hasPriceInfo = true;
              } else {
                $priceWrap.find('.price-tr-oz.amount').parent().addClass('hide');
              }
              $priceWrap.find('.price-tr-oz.amount').text(product.pricePerTroyOunce);

              // Price premium
              if (product.pricePremium) {
                $priceWrap.find('.price-premium').parent().removeClass('hide');
                hasPriceInfo = true;
              } else {
                $priceWrap.find('.price-premium').parent().addClass('hide');
              }
              if (!product.vatFree && !product.useMarginTax) {
                $priceWrap.find('.price-premium.amount').text(product.pricePremium + ' + GST*');
              } else {
                $priceWrap.find('.price-premium.amount').text(product.pricePremium);
              }

              // Price spread
              if (product.priceSpread) {
                $priceWrap.find('.price-spread').parent().removeClass('hide');
                hasPriceInfo = true;
              } else {
                $priceWrap.find('.price-spread').parent().addClass('hide');
              }

              if (!product.vatFree && !product.useMarginTax) {
                $priceWrap.find('.price-spread.amount').text(product.priceSpread + ' + GST*');
              } else {
                $priceWrap.find('.price-spread.amount').text(product.priceSpread);
              }

              // Sell price
              var $sellPrice = $priceWrap.find('.price-sell');
              if (product.sellPrice) {
                $sellPrice.parent().removeClass('hide');
                hasPriceInfo = true;
                var $sellPriceAmount = $priceWrap.find('.price-sell.amount');
                if ($sellPriceAmount.find('a').length) {
                  $sellPriceAmount.find('a').text(product.sellPrice);
                } else {
                  $sellPriceAmount.text(product.sellPrice);
                }
              } else {
                $sellPrice.parent().addClass('hide');
              }

              if (!product.vatFree && !product.useMarginTax && product.pricePremium) {
                $priceWrap.find('.gst-footnote').removeClass('hide');
              } else {
                $priceWrap.find('.gst-footnote').addClass('hide');
              }

              if (product.numSold != '') {
                $time = ' times';
                if (product.numSold === '1') {
                  $time = ' time';
                }
                $wrap.find('.sales-table-text').text('Ordered ' + product.numSold + $time + ' last 7 days!');
              }

              // Great premium price
              var $greatPremium = $wrap.find('.great-price-premium');
              if (product.greatPricePremium) {
                $greatPremium.removeClass('hide');
                hasPriceInfo = true;
              } else {
                $greatPremium.addClass('hide');
              }
              $greatPremium.find('span').text(product.greatPricePremium);

              // Hide Prices
              if (product.totalAvailable <= 0) {
                // if(!$wrap.find('.default').hasClass('hide')) $wrap.find('.default').addClass('hide');
                // if(!$priceWrap.find('.price-gram').parent().hasClass('hide')) $priceWrap.find('.price-gram').parent().addClass('hide');
                // if(!$priceWrap.find('.price-info-wrap .price-tr-oz.amount').parent().hasClass('hide')) $priceWrap.find('.price-info-wrap .price-tr-oz.amount').parent().addClass('hide');
                // if(!$priceWrap.find('.price-premium').parent().hasClass('hide')) $priceWrap.find('.price-premium').parent().addClass('hide');
                // if(!$priceWrap.find('.price-spread').parent().hasClass('hide')) $priceWrap.find('.price-spread').parent().addClass('hide');
                // if(!$sellPrice.hasClass('hide')) $sellPrice.parent().addClass('hide');
                if (!$greatPremium.hasClass('hide')) $greatPremium.addClass('hide');
                $('.price-information').addClass('hide');
              } else {
                if (!$greatPremium.hasClass('hide')) $greatPremium.removeClass('hide');
                $('.price-information').removeClass('hide');
              }

              changeStockStatusDetails($wrap, product);
              // hasQuantityStock($wrap, product);

              if (hasPriceInfo) {
                $('.price-info-wrap > h2').removeClass('hide');
              } else {
                $('.price-info-wrap > h2').addClass('hide');
              }

              if ($('.price-premium-wrap').length) {

                if (product.pricePremium) {
                  $('.price-premium-wrap').removeClass('hide').find('.price-premium').text(product.pricePremium);
                } else {
                  $('.price-premium-wrap').addClass('hide').find('.price-premium');
                }

              }

              // not used?
              //$('.footnote .price-premium span').text(product.greatPricePremium);
            }

            if (product.auctionId > 0) {
              $wrap.find('.btn-auction-link').attr('href', '/auctions/' + product.auctionId);
              $wrap.find('.btn-auction-link').removeClass('hide');
            } else {
              $wrap.find('.btn-auction-link').addClass('hide');
            }
          });
        }

        // Auction details page
        if (pageInfo.requestUri.indexOf('/auctions/') !== -1 && $('.product-auction').length) {
          auctionModule.getShippingFee();
        }

        // Product overview
        if (window.location.pathname.indexOf('/buy/') !== -1 && window.location.pathname.indexOf('/buy/product/') === -1 || window.location.pathname === '/bsp') {
          // Promo res.Products
          $('.pricing-row').each(function() {
            var pid = $(this).data('product-id');
            if (typeof productMap[pid] !== 'undefined') {
              var product = productMap[pid];
              var $this = $(this);

              if (product.promoPrice && product.status !== 'UNAVAILABLE') {
                var $promoPricing = $this.find('table.info tbody tr.promo-pricing');
                $promoPricing.removeClass('hide');
                $promoPricing.find('.promo').text(product.promoPrice);
                $promoPricing.find('.promo-original').text(product.originalPrice);
                $this.find('table.info tbody tr.regular-pricing').addClass('hide');
                $this.find('td.name a span.promo').removeClass('hide');
              } else {
                var prod = product;
                var prices = prod.prices;

                $this.find('table.info tbody tr.promo-pricing').addClass('hide');
                $this.find('table.info tbody tr.regular-pricing').removeClass('hide');
                $this.find('td.name a span.promo').addClass('hide');

                var $pricing = $this.find('table.info tbody tr.regular-pricing');

                // Price tiers is the same as old
                if ($pricing.length === prices.length) {
                  // Update volume and price only
                  for (var y = 0, priceLen = prices.length; y < priceLen; y++) {
                    $pricing.eq(y).find('.volume').text(prices[y].name);
                    $pricing.eq(y).find('.price').text(prices[y].price);
                  }
                } else {
                  // Remove old pricing HTML
                  $pricing.each(function(i, el) {
                    $(el).remove();
                  });

                  // Create new pricing HTML
                  var newPriceHtml = '',
                    volumeClass = '',
                    priceClass = '';

                  for (var i = 0, len = prices.length; i < len; i++) {
                    if (i == (len - 1)) {
                      volumeClass = ' -bold';
                      priceClass = ' -bold font-red-amazon';
                    }
                    newPriceHtml += '<tr class="regular-pricing"><td class="volume' + volumeClass + '">' + prices[i].name + '</td><td class="price' + priceClass + '">' + prices[i].price + '</td></tr>';
                  }

                  $this.find('table.info tbody').append(newPriceHtml);
                }

                if (prices.length > 0) {
                  $this.find('table.info').show();
                } else {
                  $this.find('table.info').hide();
                }

                if (product.totalAvailable > 0) {
                  $this.find('table.info').removeClass('hide');
                } else {
                  $this.find('table.info').addClass('hide');
                }
              }

              changeStockStatusOverview($this, product);
              // hasQuantityStock($this, product);
            }
          });
        }

        // Product jewellery
        if (window.location.pathname === '/buy/refurbished-jewellery' || window.location.pathname === '/buy/jewellery') {
          $('.product-jewellery').each(function() {
            var pid = $(this).data('product-id');
            var product = productMap[pid];
            if (!product) return;
            if (product.status === 'UNAVAILABLE') {
              $(this).remove();
            }
            $(this).find('.price').text(product.price);
          });
        }

        // Sidebar promo product
        // [web-core] Skip the React-owned Limited Time Offer widget; it manages
        // its own prices/timers (see LimitedTimeOffer.jsx).
        $sideBarParent.find('.product-promo-wrap').not('[data-react-lto] .product-promo-wrap').each(function(i, el) {
          var pid = $(this).data('product-id');
          if (typeof productMap[pid] !== 'undefined') {
            var prod = productMap[pid];
            var $sideBarPromo = $(this);

            var promoPriceObj = prod.promoPrice.split(' ');
            var promoPriceCurrency = promoPriceObj[0];
            var promoPriceValue = promoPriceObj[1];
            $(el).find('.price-old > span').text(prod.originalPrice);
            // $(el).find('.price-new > .price-label span.currency').text(promoPriceCurrency);
            $(el).find('.price-new > .value span').text(prod.promoPrice);

            var newSecLeft = parseInt((prod.promoExpireDate - res.time) / 1000);
            var oldSecLeft = parseInt($(el).find('.promoTime').attr('data-time-left')) || 0;
            var expireDate = checkExpireDate(newSecLeft);

            // Check if expire date is not the same as current expire date
            if (newSecLeft > oldSecLeft + window.promoTimerRunningAllowancePeriod || newSecLeft < oldSecLeft - window.promoTimerRunningAllowancePeriod) {
              $(el).find('.promo-heading .time').attr('data-time-left', newSecLeft);
              stopPromoCounter(pid);
              if (expireDate <= 1) {
                $(el).find('.promo-heading .time').html('&nbsp;');
                $(el).remove();
                $('.promo-nav li:last-child').remove();
                rotateLtoProducts();
              }
              startPromoTimers();
            }

            hasQuantityStock($(el), prod);

            let footnote = $(el).find('.footnote');
            if (product.numSold != '') {
              footnote.removeClass('hide');

              $time = ' times';
              if (product.numSold === '1') {
                $time = ' time';
              }
              $(el).find('.sales-table-text').text('Ordered ' + product.numSold + $time + ' last 7 days!');
            } else {
              footnote.addClass('hide');
            }

          }
        });

        if ($sideBarParent.find('.product-promo-wrap').length <= 1) {
          $('.promo-nav').empty();
          $sideBarParent.find('.product-promo-wrap');
        }

        // Home most Ordered Last 7 Days
        $('.popular-products div').each(function() {
          var pid = $(this).data('product-id');
          if (typeof productMap[pid] !== 'undefined') {
            var product = productMap[pid];
            $(this).find('.price > span').text(product.price);
            changeStockStatusSearch($(this), product);
            // hasQuantityStock($(this), product);
          }
        });

        // Home recommended For You
        $('.new-products div').each(function() {
          var pid = $(this).data('product-id');
          if (typeof productMap[pid] !== 'undefined') {
            var product = productMap[pid];
            $(this).find('.price > span').text(product.price);
            changeStockStatusSearch($(this), product);
            // hasQuantityStock($(this), product);
          }
        });

        // Product details also bought section
        $('.suggestion-product > div').each(function() {
          var pid = $(this).data('product-id');
          if (typeof productMap[pid] !== 'undefined') {
            var product = productMap[pid];

            // Promo
            if ($(this).hasClass('promo-search')) {
              $(this).find('.price-old > span').text(product.originalPrice);
              $(this).find('.price-new > span').text(product.promoPrice);

              var newSecLeft = parseInt((product.promoExpireDate - res.time) / 1000);
              var oldSecLeft = parseInt($(this).find('.promoTime').attr('data-time-left')) || 0;
              var expireDate = checkExpireDate(newSecLeft);

              // Check if expire date is not the same as current expire date
              if (newSecLeft > oldSecLeft + window.promoTimerRunningAllowancePeriod || newSecLeft < oldSecLeft - window.promoTimerRunningAllowancePeriod) {
                $(this).find('.lto-timer .time').attr('data-time-left', newSecLeft);
                stopPromoCounter('-s-' + pid);
                if (expireDate <= 1) {
                  $(this).removeClass('promo-search');
                  $(this).find('.lto-timer').before('<div class="empty-placeholder"></div>');
                  $(this).find('.lto-timer').remove();
                  $(this).find('.status').after('<p class="as-low-as' + (product.status === 'UNAVAILABLE' ? ' invisible' : '') + '">As Low As</p><div class="price' + (product.status === 'UNAVAILABLE' ? ' invisible' : '') + '">' + product.price + '<span></span></div>');
                  $(this).find('.price-old').remove();
                  $(this).find('.price-new').remove();
                }
                startPromoTimers();
              }

              hasQuantityStock($(this), product);
              return;
            }
            // Default
            $(this).find('.price > span').text(product.price);
            hasQuantityStock($(this), product);
          }
        });

        // Search products
        $('.search-result-product .product').each(function() {
          var pid = $(this).data('product-id');
          if (typeof productMap[pid] !== 'undefined') {
            var product = productMap[pid];
            // Promo
            if ($(this).hasClass('promo-search')) {
              $(this).find('.price-old > span').text(product.originalPrice);
              $(this).find('.price-new > span').text(product.promoPrice);

              var newSecLeft = parseInt((product.promoExpireDate - res.time) / 1000);
              var oldSecLeft = parseInt($(this).find('.promoTime').attr('data-time-left')) || 0;
              var expireDate = checkExpireDate(newSecLeft);

              // Check if expire date is not the same as current expire date
              if (newSecLeft > oldSecLeft + window.promoTimerRunningAllowancePeriod || newSecLeft < oldSecLeft - window.promoTimerRunningAllowancePeriod) {
                $(this).find('.lto-timer .time').attr('data-time-left', newSecLeft);
                stopPromoCounter('-s-' + pid);
                if (expireDate <= 1) {
                  $(this).removeClass('promo-search');
                  $(this).find('.lto-timer').before('<div class="empty-placeholder"></div>');
                  $(this).find('.lto-timer').remove();
                  $(this).find('.status').after('<p class="as-low-as' + (product.status === 'UNAVAILABLE' ? ' invisible' : '') + '">As Low As</p><div class="price' + (product.status === 'UNAVAILABLE' ? ' invisible' : '') + '">' + product.price + '<span></span></div>');
                  $(this).find('.price-old').remove();
                  $(this).find('.price-new').remove();
                }
                startPromoTimers();
              }

              hasQuantityStock($(this), product);
              return;
            }
            // Default
            $(this).find('.price').html(product.price || '&nbsp;');

            if (product.totalAvailable > 0) {
              $(this).find('.as-low-as').removeClass('invisible');
              $(this).find('.price').removeClass('invisible');
            } else {
              $(this).find('.as-low-as').addClass('invisible');
              $(this).find('.price').addClass('invisible');
            }
            changeStockStatusSearch($(this), product)
            hasQuantityStock($(this), product);
          }
        });

        // Auction
        if (window.location.pathname.indexOf('/auctions/product/') === 0) {
          $('.product-default-wrap').each(function() {
            var pid = $(this).data('product-id');
            if (typeof productMap[pid] !== 'undefined') {
              var product = productMap[pid];

              var $wrap = $(this);
              $wrap.find('.top > .prices').removeClass('hide');

              // Update promo timer for promo or default product since both will always be in the HTML
              var newSecLeft = parseInt((product.promoExpireDate - res.time) / 1000);
              var oldSecLeft = parseInt($wrap.find('.promoTime').attr('data-time-left')) || 0;
              var expireDate = checkExpireDate(newSecLeft);

              if (expireDate <= 1) {
                $wrap.find('.promo .time').html('&nbsp;');
              }

              $wrap.find('.promo .time').attr('data-time-left', newSecLeft);

              if (newSecLeft > oldSecLeft + window.promoTimerRunningAllowancePeriod || newSecLeft < oldSecLeft - window.promoTimerRunningAllowancePeriod) {
                startPromoTimers();
              }

              if (product.promoPrice) {
                // Promo

                // Render promo HTML
                // Hide default HTML
                log('Render Promo');
                $wrap.find('.top > .prices').addClass('promo');
                $wrap.find('.top > h1').addClass('lto');
                // $wrap.find('.top > .photo').addClass('lto');
                // $wrap.find('.top > .prices').addClass('lto');
                $wrap.find('.top > .prices h1').addClass('lto');
                $wrap.find('.top > .prices > .promo').removeClass('hide');
                $wrap.find('.top > .prices > .default').addClass('hide');
                $wrap.find('.top > .prices > .order-field').addClass('lto');
                $wrap.find('.top > .prices > .status').addClass('lto');
                $wrap.find('.top > .prices > .great-price-premium').removeClass('lto');
                $wrap.find('.top > .prices .save').text(product.promoSaveText);

                $wrap.find('.prices.promo .price-old span').html(product.originalPrice);
                $wrap.find('.prices.promo .price-new span').html(product.promoPrice);

                $wrap.find('.top > .prices > .extra').addClass('hide');
                $wrap.find('.top > .prices > .extra-lto').removeClass('hide');

                //console.log('getChartCurrency() is:' + getChartCurrency());
                if (getChartCurrency() == res.currency) {
                  console.log('product.js:1094 value=' + product.promoPrice);
                  $('#main-chart').attr('last', product.promoPrice);
                  //renderChart(res.currency);
                }
              } else {
                // Regular Product

                // Render default HTML
                // Hide Promo HTML
                log('Render Default');
                $wrap.find('.top > .prices').removeClass('promo');
                $wrap.find('.top > h1').removeClass('lto');
                // $wrap.find('.top > .photo').removeClass('lto');
                // $wrap.find('.top > .prices').removeClass('lto');
                $wrap.find('.top > .prices h1').removeClass('lto');
                $wrap.find('.top > .prices > .promo').addClass('hide');
                $wrap.find('.top > .prices > .default').removeClass('hide');
                $wrap.find('.top > .prices > .order-field').removeClass('lto');
                $wrap.find('.top > .prices > .status').removeClass('lto');
                $wrap.find('.top > .prices > .great-price-premium').removeClass('lto');

                $wrap.find('.top > .prices > .extra').removeClass('hide');
                $wrap.find('.top > .prices > .extra-lto').addClass('hide');

                if (getChartCurrency() == res.currency) {
                  console.log('product.js:1118 value=' + (product.prices.length > 0 ? product.prices[0].price : ''));
                  $('#main-chart').attr('last', product.prices.length > 0 ? product.prices[0].price : '');
                  //renderChart(res.currency);
                }
              }

              // Updates prices regardless of promo or not
              var prices = product.prices,
                html = '',
                lastClass = '',
                hasPriceInfo = false;

              for (var i = 0, len = prices.length; i < len; i++) {
                if (i == (len - 1)) lastClass = ' -bold font-red-amazon';
                html += '<tr><td class="volume -bold">' + prices[i].name + '</td><td class="price' + lastClass + '">' + prices[i].price + '</td><tr>';
              }

              $wrap.find('.default .info tbody').html(html);

              if (product.totalAvailable <= 0) {
                $wrap.find('.default').addClass('hide');
              }

              var $priceWrap = $wrap.find('.price-info-wrap');
              // Price per gram
              if (product.pricePerGram) {
                $priceWrap.find('.price-gram').parent().removeClass('hide');
                hasPriceInfo = true;
              } else {
                $priceWrap.find('.price-gram').parent().addClass('hide');
              }
              $priceWrap.find('.price-gram.amount').text(product.pricePerGram);

              // Price per troy oz
              if (product.pricePerTroyOunce) {
                $priceWrap.find('.price-tr-oz.amount').parent().removeClass('hide');
                hasPriceInfo = true;
              } else {
                $priceWrap.find('.price-tr-oz.amount').parent().addClass('hide');
              }
              $priceWrap.find('.price-tr-oz.amount').text(product.pricePerTroyOunce);

              // Price premium
              if (product.pricePremium) {
                $priceWrap.find('.price-premium').parent().removeClass('hide');
                hasPriceInfo = true;
              } else {
                $priceWrap.find('.price-premium').parent().addClass('hide');
              }
              $priceWrap.find('.price-premium.amount').text(product.pricePremium);

              // Price spread
              if (product.priceSpread) {
                $priceWrap.find('.price-spread').parent().removeClass('hide');
                hasPriceInfo = true;
              } else {
                $priceWrap.find('.price-spread').parent().addClass('hide');
              }
              $priceWrap.find('.price-spread.amount').text(product.priceSpread);

              // Sell price
              var $sellPrice = $priceWrap.find('.price-sell');
              if (product.sellPrice) {
                $sellPrice.parent().removeClass('hide');
                hasPriceInfo = true;
                var $sellPriceAmount = $priceWrap.find('.price-sell.amount');
                if ($sellPriceAmount.find('a').length) {
                  $sellPriceAmount.find('a').text(product.sellPrice);
                } else {
                  $sellPriceAmount.text(product.sellPrice);
                }
              } else {
                $sellPrice.parent().addClass('hide');
              }

              // Great premium price
              var $greatPremium = $wrap.find('.great-price-premium');
              if (product.greatPricePremium) {
                $greatPremium.removeClass('hide');
                hasPriceInfo = true;
              } else {
                $greatPremium.addClass('hide');
              }
              $greatPremium.find('span').text(product.greatPricePremium);

              // Hide Prices
              if (product.totalAvailable <= 0) {
                // if(!$wrap.find('.default').hasClass('hide')) $wrap.find('.default').addClass('hide');
                // if(!$priceWrap.find('.price-gram').parent().hasClass('hide')) $priceWrap.find('.price-gram').parent().addClass('hide');
                // if(!$priceWrap.find('.price-info-wrap .price-tr-oz.amount').parent().hasClass('hide')) $priceWrap.find('.price-info-wrap .price-tr-oz.amount').parent().addClass('hide');
                // if(!$priceWrap.find('.price-premium').parent().hasClass('hide')) $priceWrap.find('.price-premium').parent().addClass('hide');
                // if(!$priceWrap.find('.price-spread').parent().hasClass('hide')) $priceWrap.find('.price-spread').parent().addClass('hide');
                // if(!$sellPrice.hasClass('hide')) $sellPrice.parent().addClass('hide');
                if (!$greatPremium.hasClass('hide')) $greatPremium.addClass('hide');
                $('.price-information').addClass('hide');
              } else {
                if (!$greatPremium.hasClass('hide')) $greatPremium.removeClass('hide');
                $('.price-information').removeClass('hide');
              }

              changeStockStatusDetails($wrap, product);
              // hasQuantityStock($wrap, product);

              if (hasPriceInfo) {
                $('.price-info-wrap > h2').removeClass('hide');
              } else {
                $('.price-info-wrap > h2').addClass('hide');
              }

              if ($('.price-premium-wrap').length) {

                if (product.pricePremium) {
                  $('.price-premium-wrap').removeClass('hide').find('.price-premium').text(product.pricePremium);
                } else {
                  $('.price-premium-wrap').addClass('hide').find('.price-premium');
                }

              }
            }
          });
        }

        // AutoInvest Top Gold & Silver Picks
        $('.top-picks-section .product').each(function() {
          var pid = $(this).data('product-id');
          if (typeof productMap[pid] !== 'undefined') {
            var product = productMap[pid];
            $(this).find('.price > span').text(product.price);
            changeStockStatusSearch($(this), product);
          }
        });
      }

      var t1 = performance.now();
      console.log("Render product prices took " + (t1 - t0) + " milliseconds.");

      typeof successCb === 'function' && successCb(res);
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
      setTimeout(getProductPrice, 3000, ids, currency, successCb, errorCb);
    });

    req.send();

    return req.xhr;
  }

  function getChartData(data, loader) {
    if (!$('.price-chart').length) return;

    if (loader) {
      $('.price-chart > .loader').removeClass('hide');
      $('#main-chart').empty();
    }

    data.toIndex = getCurrency();

    $xhr = $.ajax({
      type: 'GET',
      cache: true,
      crossDomain: true,
      data: data,
      url: servicesUrl + '/spot-chart/getChart',
      dataType: 'json',
      headers: {
        'requestId': uuidv4()
      }
    }).done(function(res) {
      lastChartOptions = {
        type: 'line',
        width: 320,
        height: 280,
        preserveAspectRatio: 'xMinYMin meet',
        margin: {
          top: 27,
          bottom: 10,
          left: 10,
          right: 0
        },
        withStatistics: true,
        withTimeZone: false,
        withDateCovered: false,
        withLogo: false,
        withLineCursor: true,
        withLineCursorMouseMove: true,
        withHorizontalLinesEnds: true,
        withHorizontalLines: true,
        withVerticalLines: false,
        withVerticalLinesEnds: false,
        withBorder: false,
        gridColor: '#eee',
        cursorPointSize: 5,
        cursorPointColor: '#fcb134',
        cursorPointStrokeColor: '#ba741e',
        lineCursorColor: '#c9934b',
        lineCursorWeight: 0,
        lineCursorDashArray: '6,6',
        fontSize: 10,
        lineCursorBoxHeight: 20,
        lineCursorTextYOffset: 4,
        hasTime: res.hasTime,
        offsetChart: false,
        enableDrag: true,
        timeBoxBackgroundColor: '#555557',
        timeBoxMarginTop: 0,
        //timeBoxRight: 25,
        //timeBoxWidth: 130,
        //valueBoxWidth: 80,
        //timeBoxWidthOffset: 28,
        timeBoxFontColor: '#fff',
        logoColor: '#888a89',
        timeBoxBorderColor: 'none',
        chartStatsCallback: function(open, low, high, close) {
          $('.price-info-wrap .stats > ._open').html(open);
          $('.price-info-wrap .stats > ._low').html(low);
          $('.price-info-wrap .stats > ._high').html(high);
          $('.price-info-wrap .stats > ._close').html(close);
        },
        dataSeries: [{
          name: 'series1',
          area: true,
          color: 'transparent',
          lineColor: '#e5a158',
          lineWidth: '2',
          startDate: res.startDate,
          data: res.dataSeries,
          numDecimals: res.numDecimals
        }]
      };


      if (res.toIndex == getCurrency()) {
        renderChart(res.toIndex);
        // if ($('.chart-footnote').length == 0) {
        //   $('#main-chart').append('<p class="chart-footnote">The chart illustrates the historical purchasing price for one item of this product</p>');
        // }
      }
    }).fail(function(res) {
      console.log(res);
    }).always(function() {
      $('.price-chart > .loader').addClass('hide');
    });
    return $xhr;
  }

  function updateChart() {
    if ($('.product-detail-wrap').length == 0) {
      return;
    }

    var chartData = {
      product: true,
      productId: $('#btn-add-to-cart').length ? $('#btn-add-to-cart').data('id') : $('.btn-email-notif').data('id'),
      productTo: false,
      toIndex: getCurrency(),
      fromIndex: '',
      period: $('.product-chart-option.active').data('period'),
      width: 320,
      height: 280,
      timeZoneId: moment.tz.guess(),
      weightUnit: 'tr_oz'
    };

    if (!chartData.period) {
      chartData.period = readCookie(getProductIdPeriodCookieName()) || 'MONTH_1';

    }

    getChartData(chartData, loader);
    loader = false;
  }

  var loader = true;

  return {
    setProductNotify: setProductNotify,
    startPromoTimers: startPromoTimers,
    stopPromoCounter: stopPromoCounter,
    recordVisit: recordVisit,
    getProductVisits: getProductVisits,
    loadDetailsPage: loadDetailsPage,
    getHomeProducts: getHomeProducts,
    getAlsoBoughtProducts: getAlsoBoughtProducts,
    changeProductBasedOnLocation: changeProductBasedOnLocation,
    getHomeProductsPriceOnly: getHomeProductsPriceOnly,
    getProductPrice: getProductPrice,
    getChartData: getChartData,
    updateChart: updateChart,
    renderChart: renderChart,
    getTopGoldSilverPicks: getTopGoldSilverPicks
  }

}());

/* Add for mocha testing */
// Basically it make the productModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = productModule;
}
/***********************************************************/
/***********************************************************/
/* Shopping Cart Module */
/***********************************************************/
/***********************************************************/

var shoppingCartModule = (function() {

  var url = servicesUrl + '/product/v1/shoppingcart/',
    cartItems = [],
    cart = {},
    changeXHR,
    refreshXHR;

  /*
    DESC: True when a React island owns the #cart-list-wrap markup (web-core's
          hydrated header marks .cart with data-react-cart). Then this module
          only publishes cart data and React renders it; the per-item DOM writes
          below are skipped because React would clobber them on its next render.
          No effect on the PHP site, which never sets that attribute.
  */
  function reactOwnsCart() {
    return !!document.querySelector('[data-react-cart]');
  }

  /*
    DESC: Single place that puts a cart response on screen. Publishes to the
          React island when one owns the cart (stashing the response first, so a
          response that lands before the island mounts is not lost), otherwise
          renders the legacy client template. The template lookup is guarded so a
          host that has dropped #tmpl-shopping-cart-item no-ops instead of
          throwing.
  */
  function renderCartList(res) {
    if (reactOwnsCart()) {
      window.bsCartData = res;
      if (typeof window.bsCartRender === 'function') {
        window.bsCartRender(res);
      }
      return;
    }
    var template = $('#tmpl-shopping-cart-item').html();
    if (template) {
      $('#cart-list-wrap').html(tmpl(template, {
        obj: res
      }));
    }
  }

  /*
    DESC: Use in /add /update /remove
    TODO: 1. Remove UI elements that doesnt exists in the cartEntries array. [✔]
          2. Update current UI elements from cartEntries. [✔]
          3. Add missing UI elements from cartEntries. [✔]
  */
  function genericResponseHandler(res, fromAdd) {
    fromAdd = fromAdd || false; // call from add()
    if (res.cartEntries.length === 0) {
      emptyCart();
      if (res.message && res.message.length > 0) {
        var popup = new Popup({
          title: 'Shopping Cart',
          message: res.message
        });
        popup.render();
      }
      return;
    }

    // Get cart ids currently in shopping cart
    var currentCartIds = [];
    $.each($('.shopping-cart-item-wrap'), function(i, el) {
      currentCartIds.push($(el).data('id'));
    });

    // Compare currentCartIds to API res.cartEntries
    // Remove ids that are in shopping cart and API response from currentCartIds
    $.each(res.cartEntries, function(i, item) {
      var position = $.inArray(item.productId, currentCartIds);
      currentCartIds.splice(position, 1);
    });

    // Remove all shopping cart items with ids in currentCartIds
    if (currentCartIds.length) {
      for (var x = 0; x <= currentCartIds.length; x++) {
        // Remove shopping cart item
        $('#shopping-cart-item-' + currentCartIds[x]).remove();
      }
    }

    // Check if there is/are shopping item(s) that will be removed
    // Then display message using popup
    if (currentCartIds.length && res.message && res.message.length) {
      var popup = new Popup({
        title: 'Shopping Cart',
        message: res.message
      });
      popup.render();
    }

    // React owns the markup: one render from the full response replaces the
    // incremental update/insert bookkeeping below (which reads and writes the
    // per-item DOM). res.changes drives the per-item .warning there too.
    if (reactOwnsCart()) {
      renderCartList(res);
      return;
    }

    $.each(res.cartEntries, function(i, item) {
      if ($('#shopping-cart-item-' + item.productId).length) {
        // 2. Update
        $targetItem = $('#shopping-cart-item-' + item.productId);

        if (item.quantityChanged) {
          $targetItem.data('qty', item.quantity);
          $targetItem.find('input.change').val(item.quantity).val(item.quantity || '');
        }

        // Update when Add to cart is clicked multiple times
        if (item.quantity != $targetItem.find('input.change').val()) {
          $targetItem.data('qty', item.quantity);
          if (fromAdd) {
            $targetItem.find('input.change').val(item.quantity).val(item.quantity || '');
          }
        }

        $targetItem.find('.original-price').html(item.originalUnitPrices[getCurrency()] + ' each');
        $targetItem.find('.price').html(item.unitPrices[getCurrency()] + ' each');
        $targetItem.find('.original-total').html(item.originalTotalPrices[getCurrency()]);
        $targetItem.find('.total').html(item.totalPrices[getCurrency()]);

        //$('#shopping-cart-item-' + item.productId).data('qty', item.quantity);
        //$('#shopping-cart-item-' + item.productId).find('.change').val(item.quantity || '');
      } else {
        // 3. Add
        if (res.cartEntries.length === 1) { // Only 1 cart item
          renderCartList(res);
          return;
        }
        var itemTemplate = $('#tmpl-shopping-cart-1-item').html();
        if (!itemTemplate) return; // host without the client templates (see renderCartList)
        var newItem = tmpl(itemTemplate, {
          obj: item
        });
        // Insert at the first cart item
        if (i == 0) {
          renderCartList(res);
          //$('.shopping-cart-item-container').html(newItem);
        } else {
          $(newItem).insertAfter($('.shopping-cart-item-wrap:eq(' + (i - 1) + ')'));
        }
      }
    });
  }

  /*
    DESC: Add shopping cart item. USED IN: Add to cart and +1 button
    POST /api/v2/shoppingcart/add
    productId=480
    quantity=20
  */
  function add(data, cb, noLoader, alwaysShowAddtoCartPopup) {
    data.cartString = getCartString();
    data.locationId = getLocation();
    data.apg = getApgId();
    data.sessionId = sessionModule.getSessionId();
    data.machineId = getMachineId();

    updateCartString(data.cartString);
    updateCartQueryId(data.productId, data.queryId);

    var override = readCookie('addToCartDontShow') ? false : true;

    var req = new JsonRequest(url + 'item', data, override);

    req.useRequestId(true);

    req.success(function(res) {
      updateCartString(res.cartString);
      genericResponseHandler(res, true);

      updateTotalsAndCount(res);

      if (alwaysShowAddtoCartPopup || !readCookie('addToCartDontShow')) {
        var changes = res.changes;
        var popupItemAdded = new PopupAddedItemCart(res.tiers, res.cartEntries, data.productId, changes);
        popupItemAdded.render();
      } else {
        if (res.changes.length) {
          var popup = new Popup({
            title: 'Product Information',
            message: res.changes[0].message
          });
          popup.render();
        }
      }

      // Run callback if callback is passed
      typeof cb === 'function' && cb(res);
    });

    req.error(function(res) {
      log('Error');

      if (res.title && res.title.length > 0 && res.message && res.message.length > 0) {
        var popup = new Popup({
          title: res.title,
          message: res.message
        });
        popup.render();
      }

      if (!res.cartEntries || res.cartEntries.length == 0) return;

      // Update : Quantity Field
      $.each(res.cartEntries, function(i, item) {
        // Shoping cart
        $('.item-wrap[data-id=' + item.productId + ']').find('.change').val(item.quantity);
      });
    })

    if (noLoader) {
      req.send();
    } else {
      req.call();
    }
  }

  /*
    DESC: Refresh shopping cart items. USED IN: Called before handler going to /buy/checkout from shopping cart header
    POST /api/v2/shoppingcart/refresh
  */
  function refresh(cb, getXHR) {
    var req = new JsonRequest(url, {
      cartString: getCartString(),
      locationId: getLocation(),
      apg: getApgId()
    }, true);

    req.useRequestId(true);

    req.getXHR = getXHR || false
    req.noApiErrorPopup = true;

    req.success(function(res) {

      updateCartString(res.cartString);

      //buildCart(res);
      genericResponseHandler(res);

      updateTotalsAndCount(res);

      // Run callback if callback is passed
      typeof cb === 'function' && cb(res);
    });

    req.send();

    if (getXHR) {
      return req.xhr;
    }
  }

  /*
    DESC: Change value of shopping cart item. USED IN: Shopping cart text field .change
    POST /api/v2/shoppingcart/change
    productId=481
    quantity=5
  */

  function generateCartString() {
    var str = '';

    $('.shopping-cart-item-container .shopping-cart-item-wrap').each(function() {
      var _this = $(this);
      var productId = _this.data('id');
      var quantity = _this.find('input').val() || 0;
      if (isNaN(quantity)) {
        quantity = _this.data('qty');
      }

      if (typeof productId != 'undefined' && typeof quantity != 'undefined') {
        if (str.length > 0) {
          str += ',';
        }
        str += productId + ',' + quantity;
      }
    });

    return str;
  }

  function update(cb, noLoader, getXHR, productId, queryId, popupErrorOverride) {

    var data = {
      cartString: generateCartString(),
      locationId: getLocation(),
      sessionId: sessionModule.getSessionId(),
      machineId: getMachineId(),
      apg: getApgId()
    };

    if (productId) {
      data.productId = productId;
    }
    if (queryId) {
      data.queryId = queryId;
    }

    updateCartString(data.cartString);

    if ($('.popup-added-item-cart').is(':visible')) {
      popupErrorOverride = true;
    }
    var req = new JsonRequest(url + 'item/' + productId, data, popupErrorOverride, 'PUT');

    req.useRequestId(true);
    req.getXHR = getXHR || false;

    req.success(function(res) {
      updateCartString(res.cartString);
      updateTotalsAndCount(res);
      // Per-item .warning is rendered by the React cart island from res.changes;
      // it only belongs in the dropdown in the same case the legacy code below
      // writes it (popupErrorOverride — i.e. no add-to-cart popup on screen).
      res.bsShowItemWarnings = !!popupErrorOverride;
      genericResponseHandler(res);

      // Appears on popup-added-item-cart
      // changes will always be 1
      if ($('.popup-added-item-cart').is(':visible') && res.changes.length) {
        if ($('.popup-added-item-cart .body').find('.warning').length) {
          $('.popup-added-item-cart .body .warning .message').text(res.changes[0].message);
        } else {
          $('.popup-added-item-cart .body').find('.shopping-cart-add-popup-item-wrap').after('<div class="warning"><p class="message">' + res.changes[0].message + '</p><span class="close-box">OK</span></div>');

          if (res.changes.length) {
            $('.close-box').on('click', function() {
              $(this).closest('.warning').remove();
            });
          }
        }
      } else if ($('.popup-added-item-cart').is(':visible') && !res.changes.length) {
        $('.popup-added-item-cart .body .warning').remove();
      }

      // Appears on cart mouseover — skipped when React owns the cart markup
      // (rendered from res.changes; these writes would be clobbered anyway).
      if (reactOwnsCart()) {
        typeof cb === 'function' && cb(res);
        return;
      }

      if (res.changes.length) {
        for (var i = 0; i < res.changes.length; i++) {
          if (popupErrorOverride) {
            $('#shopping-cart-item-' + res.changes[i].productId).find('.warning').removeClass('hide');
            $('#shopping-cart-item-' + res.changes[i].productId).find('.message').text(res.changes[i].message);
            return;
          }
        }
        if (!popupErrorOverride || res.changes.length) {
          $('#shopping-cart-item-' + res.changes[i].productId).find('.warning').addClass('hide');
        }
      } else {
        $('#shopping-cart-item-' + productId).find('.warning').addClass('hide');
        $('#shopping-cart-item-' + productId).find('.message').text('');
      }

      // Run callback if callback is passed
      typeof cb === 'function' && cb(res);
    });

    if (noLoader) {
      req.send();
    } else {
      req.call();
    }

    if (req.getXHR) {
      return req.xhr;
    }
  }

  /*
    DESC: Remove shopping cart item. USED IN: Remove button .remove
    POST /api/v2/shoppingcart/remove
    productId=480
  */
  function remove(data, cb) {
    data.cartString = getCartString();
    data.locationId = getLocation();
    data.apg = getApgId();

    updateCartString(data.cartString);
    removeCartQueryId(data.productId);

    var req = new JsonRequest(url + 'item/' + data.productId, data, false, 'DELETE');

    req.useRequestId(true);

    req.success(function(res) {

      updateCartString(res.cartString);

      updateTotalsAndCount(res);

      genericResponseHandler(res);

      typeof cb === 'function' && cb(res);
    });

    req.send();
  }

  function updateHeaderShoppingCartCount(count) {
    // Update header shopping cart count in main header and whole screen popup header
    console.log("updateHeaderShoppingCartCount: " + count);
    $('#shopping-cart-count').text(count);
    $('.shopping-cart-heading p span').text(count);

    localStorage.setItem('shopping-cart-count', count);
  }

  /*
    DESC: Update the totals in the shopping cart and the shopping cart item count in the header. 
    USED IN: add(), change() and remove()
  */
  function updateTotalsAndCount(res) {
    updateHeaderShoppingCartCount(res.cartEntries.length);

    // Check if cart is open then update the totals
    // Update : Total Price per item text
    //        : Total Price of all item
    $.each(res.cartEntries, function(i, item) {
      if ($('#shopping-cart-add-popup-item-wrap-' + item.productId).length) {
        if (item.quantityChanged) {
          $('#shopping-cart-add-popup-item-wrap-' + item.productId).data('qty', item.quantity);
          $('#shopping-cart-add-popup-item-wrap-' + item.productId).find('.change').val(item.quantity);
        }
        $('#shopping-cart-add-popup-item-wrap-' + item.productId).find('.original-price').html(item.originalUnitPrices[getCurrency()] + ' each');
        $('#shopping-cart-add-popup-item-wrap-' + item.productId).find('.price').html(item.unitPrices[getCurrency()] + ' each');
        $('#shopping-cart-add-popup-item-wrap-' + item.productId).find('.original-total').html(item.originalTotalPrices[getCurrency()]);
        $('#shopping-cart-add-popup-item-wrap-' + item.productId).find('.total').html(item.totalPrices[getCurrency()]);
      }

      // if(item.quantityChanged) {
      //   $('#shopping-cart-item-' + item.productId).data('qty', item.quantity);
      //   $('#shopping-cart-item-' + item.productId).find('.change').val(item.quantity);
      // }
      // $('#shopping-cart-item-' + item.productId).find('.price').html(tmpl($('#tmpl-object-loop-currency').html(), { obj: item.unitPrices }) + ' each');
      // $('#shopping-cart-item-' + item.productId).find('.total').html('Total: ' + tmpl($('#tmpl-object-loop-currency').html(), { obj: item.totalPrices }));
    });

    $('.cart-items-total > .shopping-cart-total-products').html(res.totals[getCurrency()]);
  }

  var quantityTimer = null;

  /*
    DESC: Handles changes in the quantity box. 
    USED IN: change and keyup in quantity boxes.
  */
  function handleChange(productId, cartPopupOpen) {
    // if (delay) {
    //   if (quantityTimer != null) {
    //       clearTimeout(quantityTimer);
    //       quantityTimer = null;
    //   }
    //   quantityTimer = setTimeout("shoppingCartHandleChange(" + productId + ");", 200);
    // } else {

    // }
    var isCartAddPopupOpen = cartPopupOpen || false;

    var $parent = isCartAddPopupOpen ? $('#shopping-cart-add-popup-item-wrap-' + productId) : $('#shopping-cart-item-' + productId);

    // Stops code from execution to avoid error
    // $parent might be removed already once product is sold out
    if ($parent.length === 0) return;
    var _this = $parent.find('.change');
    quantityString = _this.val().trim();
    if (quantityString.length == 0) {
      quantityString = '0';
      //_this.val(0);
    }

    var quantity = parseInt(quantityString, 10);

    if (!isNaN(quantity)) {
      if (parseInt($parent.data('qty')) != quantity) {
        $parent.data('qty', quantity);
        var $popup = $('.popup-added-item-cart');
        if (typeof changeXHR === 'object') changeXHR.abort();
        if ($popup.length) {
          changeXHR = update(null, true, true, productId);
        } else {
          console.log('isCartAddPopupOpen', isCartAddPopupOpen);
          if (!isCartAddPopupOpen) {
            changeXHR = update(null, true, true, productId, '', true);
          } else {
            changeXHR = update(null, true, true);
          }
        }
      }
    }
  }

  /*
    DESC: Build shopping cart html
    USED IN: afterSuccessfulLogin() and info()
  */
  function buildCart(res) {
    cart = res;
    renderCartList(res);
  }

  function loadAccount(cb) {

    var req = new JsonRequest(url + 'all', {
      cartString: getCartString(),
      locationId: getLocation(),
      apg: getApgId()
    });

    req.success(function(res) {

      updateCartStringLocation(res.response.cartString, res.response.locationId);

      buildCart(res.response);

      updateTotalsAndCount(res.response);

      // Run callback if callback is passed
      typeof cb === 'function' && cb(res.response);
    });

    req.send();
  }

  function load() {
    var req = new JsonRequest(url, {
      cartString: getCartString(),
      locationId: getLocation(),
      apg: getApgId()
    });

    req.success(function(res) {

      updateCartString(res.cartString);
      // Build Cart
      buildCart(res);

      updateTotalsAndCount(res);

      // Run callback if callback is passed
      typeof cb === 'function' && cb(res);
    });

    req.send();
  }

  function getCartString() {
    var cartString = localStorage.getItem('cart' + getLocation());
    if (cartString == null) {
      cartString = '';
    }

    return cartString;
  }

  function emptyCart() {
    updateCartString('');
    localStorage.removeItem('cart-queries');
    renderCartList({
      cartEntries: []
    });
  }

  function updateCartString(s) {
    updateCartStringLocation(s, getLocation());
  }

  function updateCartStringLocation(s, location) {
    if (s != null) {
      localStorage.setItem('cart' + location, s);
    }
  }

  function getCart() {
    return cart;
  }

  function getCartQueries() {
    var cartQueries = localStorage.getItem('cart-queries');
    if (cartQueries == null) {
      cartQueries = {};
    } else {
      cartQueries = JSON.parse(cartQueries);
    }

    return cartQueries;
  }

  function updateCartQueryId(productId, queryId) {
    // if (queryId) {
    //   queryId = 'none';
    // }
    // TODO: dont add queryId if product is already in cart
    if (!queryId) {
      return;
    }
    var cartQueries = getCartQueries();
    cartQueries[productId] = queryId;
    localStorage.setItem('cart-queries', JSON.stringify(cartQueries));
  }

  function removeCartQueryId(productId) {
    var cartQueries = getCartQueries();
    delete cartQueries[productId];
    localStorage.setItem('cart-queries', JSON.stringify(cartQueries));
  }

  /**
   * Updates the lower price text in the cart popup based on the provided product map.
   *
   * @param {Object} productMap - A map of product IDs to product details.
   * @param {Object} productMap[pid] - The product details for a specific product ID.
   * @param {Array} productMap[pid].prices - An array of price tiers for the product.
   * @param {number} productMap[pid].prices[].fromQuantity - The quantity from which the price tier applies.
   * @param {number} productMap[pid].prices[].price - The price for the corresponding quantity tier.
   */
  function updateCartPopupLowerPrice(productMap) {
    var lowerPriceElem = $('.popup-added-item-cart').find('.lower-price-text .amount');
    var pid = $(lowerPriceElem).data('id');
    if (typeof productMap[pid] !== 'undefined') {
      var product = productMap[pid];
      var prices = product.prices;
      var dataFromQuantity = $(lowerPriceElem).data('qty');
      var priceTier = prices.find(price => price.fromQuantity == dataFromQuantity);
      $(lowerPriceElem).text(priceTier.price);
    }
  }

  return {
    add: add,
    refresh: refresh,
    refreshXHR: refreshXHR,
    update: update,
    remove: remove,
    updateTotalsAndCount: updateTotalsAndCount,
    updateHeaderShoppingCartCount: updateHeaderShoppingCartCount,
    handleChange: handleChange,
    totalItem: cartItems,
    build: buildCart,
    cart: getCart,
    loadAccount: loadAccount,
    load: load,
    updateCartPopupLowerPrice: updateCartPopupLowerPrice,
    getCartString: getCartString,
    emptyCart: emptyCart,
    updateCartString: updateCartString,
    getCartQueries: getCartQueries,
  }
}());

function shoppingCartHandleChange(productId) {
  shoppingCartModule.handleChange(productId, false);
}

/* Add for mocha testing */
// Basically it make the shoppingCartModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = shoppingCartModule;
}
/***********************************************************/
/***********************************************************/
/* Slider Module */
/***********************************************************/
/***********************************************************/

var sliderModule = (function() {

  var PRECISION = 10000000;

  function updateSliderMinMax(slider, minFloat, maxFloat, priceRange, currencyChanged, intervals) {
    var cur = getCurrency(),
      min = isCryptoCurrency() ? cryptoDecimalPointRules(parseFloat(minFloat)) : Math.floor(minFloat).toFixed(2),
      max = isCryptoCurrency() ? cryptoDecimalPointRules(parseFloat(maxFloat)) : Math.ceil(maxFloat).toFixed(2),
      currentRangeMin = getSliderMin(slider),
      currentRangeMax = getSliderMax(slider);

    currencyChanged = currencyChanged || false;

    currentValueMin = getSliderValueMin(slider);
    currentValueMax = getSliderValueMax(slider);

    //$('.range .bar-chart').html(tmpl($('#tmpl-bar-chart').html(), { obj: intervals }));

    if (currencyChanged) {
      currentValueMin = min;
      currentValueMax = max;

      setSliderMin(slider, currentValueMin);
      setSliderMax(slider, currentValueMax);
    } else {

      if (currentValueMin < min || currentRangeMin == currentValueMin) {
        currentValueMin = min;
      }

      if (currentValueMax > max || currentRangeMax == currentValueMax) {
        currentValueMax = max;
      }

      if (isCryptoCurrency()) {
        currentValueMin = cryptoDecimalPointRules(parseFloat(currentValueMin));
        currentValueMax = cryptoDecimalPointRules(parseFloat(currentValueMax));
      }
    }

    // Updates HTML of Price Range ([number] - [number])
    // var html = '';

    // $.each(priceRange, function(i) {
    //   var textMin = isCryptoCurrency() ? (min) : commaSeparateNumber(min);
    //   var textMax = isCryptoCurrency() ? (max) : commaSeparateNumber(max);

    //   html += 'Price Range <span class="' + i.toLowerCase() + ((i === cur) ? '' : ' hide') + '">' + textMin + ' - ' + textMax + '</span>';
    // });

    // $('.price-slider-wrap > .header').html(html);

    // Updates HTML of Min: [number] Max: [number]
    if (isCryptoCurrency()) {
      $('.price-min .amount .' + cur.toLowerCase()).text(cur + ' ' + min);
      $('.price-max .amount .' + cur.toLowerCase()).text(cur + ' ' + max);
    } else {
      var amountMin = getCurrencySign(cur) + commaSeparateNumber(min);
      var amountMax = getCurrencySign(cur) + commaSeparateNumber(max);
      if (cur.toLowerCase() == 'sek') {
        amountMin = commaSeparateNumber(min) + ' ' + getCurrencySign(cur);
        amountMax = commaSeparateNumber(max) + ' ' + getCurrencySign(cur);
      }
      $('.price-min .amount .' + cur.toLowerCase()).text(amountMin);
      $('.price-max .amount .' + cur.toLowerCase()).text(amountMax);
    }
  }

  // Returns false when no slider was created, so callers can skip binding
  // events on a slider that does not exist.
  function initializeSlider(slider, min, max) {
    if (!min && !max) return false;
    setSliderMax(slider, max);
    setSliderMin(slider, min);

    //var newComputedMin = Math.pow(min / max, 1.0 / 3.0) * PRECISION;
    noUiSlider.create(slider, {
      connect: true,
      start: [0, PRECISION],
      range: {
        'min': [0],
        'max': [PRECISION]
      }
    });

    return true;
  }

  function sendRequest(slider, data, successCb, failCb, alwaysCb, min, max, getXHR) {

    if (!min) min = getSliderValueMin(slider);
    if (!max) max = getSliderValueMax(slider);

    console.log({
      max
    })

    var options = buildProductFilterOptions(min, max, false, false);
    options.name = data.name;
    options.count = data.count;

    // FROM BACKEND Don't pass max when max is equal to the total slider max
    if (parseInt(max) == getSliderMax(slider)) options.max = '';
    console.log(options)

    var xhr = searchModule.productGroupFilter(options, function(res) {
      typeof successCb === 'function' && successCb(res);
    }, function(res) {
      if (status === 'abort') return;
      console.log(res);
      typeof failCb === 'function' && failCb(res, status);
    }, function(res) {
      typeof alwaysCb === 'function' && alwaysCb(res);
    });

    if (getXHR) {
      return xhr;
    }
  }

  function sendRequestJewellery(slider, data, successCb, failCb, alwaysCb, min, max, getXHR) {

    if (!min) min = getSliderValueMin(slider);
    if (!max) max = getSliderValueMax(slider);

    var options = buildProductFilterOptions(min, max, false, false);
    options.name = data.name;
    options.count = data.count;

    // FROM BACKEND Don't pass max when max is equal to the total slider max
    if (parseInt(max) == getSliderMax(slider)) options.max = '';

    var xhr = searchModule.jewellery(options, function(res) {
      typeof successCb === 'function' && successCb(res);
    }, function(res) {
      if (status === 'abort') return;
      console.log(res);
      typeof failCb === 'function' && failCb(res, status);
    }, function(res) {
      typeof alwaysCb === 'function' && alwaysCb(res);
    });

    if (getXHR) {
      return xhr;
    }
  }

  function updatePriceRangeDisplayText(slider) {
    var min, max;

    min = getSliderValueMin(slider);
    max = getSliderValueMax(slider);

    if (isAuctionsOverview()) {
      $('.price-slider-wrap > .heading').find('span').text(commaSeparateNumber(min) + ' - ' + commaSeparateNumber(max));
    } else {
      if (isCryptoCurrency()) {
        $('.price-slider-wrap > .heading').find('.' + getCurrency().toLowerCase()).text(min + ' - ' + max);
      } else {
        $('.price-slider-wrap > .heading').find('.' + getCurrency().toLowerCase()).text(commaSeparateNumber(min) + ' - ' + commaSeparateNumber(max));
      }
    }

    return {
      min: min,
      max: max
    }
  }

  function setSliderMax(slider, max) {
    slider.setAttribute('max', max);
  }

  function setSliderMin(slider, min) {
    slider.setAttribute('min', min);
  }

  function getSliderMax(slider) {
    return parseFloat(slider.getAttribute('max'));
  }

  function getSliderMin(slider) {
    return parseFloat(slider.getAttribute('min'));
  }

  function getSliderValue(slider) {
    return [getSliderValueMin(slider), getSliderValueMax(slider)];
  }

  function setSliderValue(slider, v) {

    var f = 3.0;

    var max = getSliderMax(slider);
    var min = getSliderMin(slider);
    var range = max - min;

    v[0] = clamp(v[0], min, max);
    v[1] = clamp(v[1], min, max);

    v[0] -= min;
    v[1] -= min;

    v[0] = Math.pow(v[0] / range, 1.0 / f) * PRECISION;
    v[1] = Math.pow(v[1] / range, 1.0 / f) * PRECISION;

    v[0] = clamp(v[0], 0, PRECISION);
    v[1] = clamp(v[1], 0, PRECISION);

    //console.log('after=' + v[0]);
    if (Number.isNaN(v[1]) || Number.isNaN(v[0])) {
      console.error('Slider value is NaN');
    } else {
      slider.noUiSlider.set(v);
    }
  }

  function getSliderValueMin(slider) {
    var v = slider.noUiSlider.get()[0];

    var max = getSliderMax(slider);
    var min = getSliderMin(slider);

    var f = 3.0;

    var i = v / PRECISION;

    v = Math.pow(i, f) * (max - min);

    v += min;

    v = getCurrencyDecmial(v);

    return clamp(v, min, max);
  }

  function getSliderValueMax(slider) {
    var v = slider.noUiSlider.get()[1];

    var max = getSliderMax(slider);
    var min = getSliderMin(slider);

    var f = 3.0;

    var i = v / PRECISION;

    v = Math.pow(i, f) * (max - min);

    v += min;

    v = getCurrencyDecmial(v);

    return clamp(v, min, max);
  }

  function clamp(v, min, max) {
    return Math.min(max, Math.max(min, v));
  }

  function isOffMin(slider) {
    return slider.noUiSlider.get()[0] != 0;
  }

  function isOffMax(slider) {
    return slider.noUiSlider.get()[1] != PRECISION;
  }

  return {
    getSliderValueMin: getSliderValueMin,
    getSliderValueMax: getSliderValueMax,
    getSliderMin: getSliderMin,
    getSliderMax: getSliderMax,
    getSliderValue: getSliderValue,
    setSliderValue: setSliderValue,
    updateSliderMinMax: updateSliderMinMax,
    isOffMin: isOffMin,
    isOffMax: isOffMax,
    sendRequest: sendRequest,
    initializeSlider: initializeSlider,
    updatePriceRangeDisplayText: updatePriceRangeDisplayText,
    sendRequestJewellery: sendRequestJewellery,
  }
}());

/* Add for mocha testing */
// Basically it make the sliderModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = sliderModule;
}
/***********************************************************/
/***********************************************************/
/* Filter Module */
/***********************************************************/
/***********************************************************/

var filterModule = (function() {

  var filterFlag,
    hideResultCount = false,
    isCurrencyChanged = false,
    nextPageProducts = '', // Storage of next page url for buy products
    nextPageSearchProducts = ''; // Storage of next page url for search products

  function setSavedFilterOption() {
    $('input#less-1-oz').prop('checked', false);
    $('input#one-oz').prop('checked', false);
    $('input#more-1-oz').prop('checked', false);
    $('input#bars').prop('checked', false);
    $('input#coins').prop('checked', false);
    $('input#switzerland').prop('checked', false);
    $('input#australia').prop('checked', false);
    $('input#canada').prop('checked', false);
    $('input#in-stock').prop('checked', false);
    $('input#pre-sale').prop('checked', false);
    $('input#checkboxCurrentYear').prop('checked', false);
    $('input#checkboxLastYear').prop('checked', false);
    $('input#previous-years').prop('checked', false);
  }

  function setSavedFilterJewelleryOption() {
    $('input#necklace').prop('checked', false);
    $('input#bracelet').prop('checked', false);
    $('input#ring').prop('checked', false);
    $('input#bangle').prop('checked', false);
    $('input#earrings').prop('checked', false);
    $('input#pendant').prop('checked', false);
    $('input#ornament').prop('checked', false);
    $('input#k24').prop('checked', false);
    $('input#k22').prop('checked', false);
    $('input#g0').prop('checked', false);
    $('input#g10').prop('checked', false);
    $('input#g30').prop('checked', false);
    $('input#g50').prop('checked', false);
  }

  function setSavedFilterAuctionOption() {
    $('input#bid-entered').prop('checked', false);
    $('input#saved').prop('checked', false);
    $('input#active').prop('checked', false);
    $('input#ended').prop('checked', false);
    $('input#won').prop('checked', false);
    $('input#gold').prop('checked', false);
    $('input#silver').prop('checked', false);
    $('input#platinum').prop('checked', false);
    $('input#bars').prop('checked', false);
    $('input#coins').prop('checked', false);
    $('input#jewellery').prop('checked', false);
    $('input.all-options').prop('checked', false);
  }

  function setFilterHeaderCount(count) {
    var $headingResult = $('.filter-heading .result');

    if (hideResultCount) {
      $headingResult.addClass('hide');
      return;
    }

    $headingResult.removeClass('hide');
    $headingResult.find('.number').text(count);
    if (count > 1) {
      $headingResult.find('.match').text('matches');
    } else if (count === 1) {
      $headingResult.find('.match').text('match');
    } else {
      $headingResult.find('.number').text('No');
      $headingResult.find('.match').text('matches');
    }
  }

  function setProductListHeaderCount(count) {

    var $headingResult = $('.result-count');

    $headingResult.removeClass('hide');
    $headingResult.find('.number').text(count);
    if (count > 1) {
      $headingResult.find('.word').text('items');
    } else {
      $headingResult.find('.word').text('item');
    }
  }

  function checkCheckBoxFilterState(state) {
    for (var w in state.weight) {
      if (state.weight[w] === true) {
        return true;
      }
    }
    for (var c in state.country) {
      if (state.country[c] === true) {
        return true;
      }
    }
    for (var a in state.availability) {
      if (state.availability[a] === true) {
        return true;
      }
    }
    for (var y in state.year) {
      if (state.year[y] === true) {
        return true;
      }
    }
    return false;
  }

  // Used when changing location
  function changeProductsBasedOnLocation() {
    if (typeof currencyFlag === 'object') {
      currencyFlag.abort();
    }
    // var min = $('#min-slider-input').val() ? getCurrencyDecmial($('#min-slider-input').val()) : '';
    // var max = $('#max-slider-input').val() ? getCurrencyDecmial($('#max-slider-input').val()) : '';
    var options = buildProductFilterOptions(null, null, true, true);

    options.name = page;
    options.page = 1;
    options.sortType = 'popular';
    options.sortDirection = 'desc';

    currencyFlag = searchModule.productGroupFilter(options, function(res) {
      nextPageProducts = res.pagination.nextPage;
      priceRange[getCurrency()].min = res.result.priceRange.min;
      priceRange[getCurrency()].max = res.result.priceRange.max;

      if (!noSlider) {
        var priceSlider = document.getElementById('price-slider');
        sliderModule.updateSliderMinMax(priceSlider, priceRange[getCurrency()].min, priceRange[getCurrency()].max, priceRange, true, null);
        price = sliderModule.setSliderValue(priceSlider, [priceRange[getCurrency()].min, priceRange[getCurrency()].max]);
        $('#min-slider-input').val(getCurrencyDecmial(priceRange[getCurrency()].min));
        $('#max-slider-input').val(getCurrencyDecmial(priceRange[getCurrency()].max));
        $('#min-slider-input').val('');
        $('#max-slider-input').val('');
        sliderModule.updatePriceRangeDisplayText(priceSlider);
      }

      $('.buy-items').empty();
      if (res.result.groups.length) {
        for (var i = 0, len = res.result.groups.length; i < len; i++) {
          $('.buy-items').append(tmpl($('#tmpl-filter-product-item').html(), {
            obj: res.result.groups[i],
            time: res.time
          }));
        }
      } else {
        $('.buy-items').html('<p>No products were found matching your selected filter(s). Please try again.</p>')
      }
    });
  }

  function changeJewelleryProductsBasedOnLocation() {
    if (typeof currencyFlag === 'object') {
      currencyFlag.abort();
    }
    var min = $('#min-slider-input').val() ? getCurrencyDecmial($('#min-slider-input').val()) : '';
    var max = $('#max-slider-input').val() ? getCurrencyDecmial($('#max-slider-input').val()) : '';
    var options = buildProductFilterOptions(min, max, false, false);
    options.name = page;
    options.page = 1;
    options.sortType = 'popular';
    options.sortDirection = 'desc';

    currencyFlag = searchModule.jewellery(options, function(res) {
      nextPageProducts = res.pagination.nextPage;
      $('.jewellery-list').empty();
      if (res.result.products.length) {
        for (var i = 0, len = res.result.products.length; i < len; i++) {
          $('.jewellery-list').append(tmpl($('#tmpl-filter-product-jewellery-item').html(), {
            obj: res.result.products,
            time: res.time
          }));
        }
      } else {
        $('.jewellery-list').html('<p>No products were found matching your selected filter(s). Please try again.</p>')
      }
    });
  }

  function changeProductsOverviewPrice(oldCur) {
    if (typeof currencyFlag === 'object') {
      currencyFlag.abort();
    }

    currencyFlag = productModule.getProductPrice(getAllProductIdsArr(), getCurrency(), function() {
      if (nextPageProducts && oldCur) {
        nextPageProducts = nextPageProducts.replace(oldCur, getCurrency());
      }
    });
  }

  function changeSearchOverviewPrice(oldCur) {
    productModule.getProductPrice(getAllProductIdsArr(), getCurrency(), function() {
      if (nextPageSearchProducts && oldCur) {
        nextPageSearchProducts = nextPageSearchProducts.replace(oldCur, getCurrency());
      }
    })
  }

  function isSliderDefaultValueSelectedAndNoCheckboxFilterSelected() {
    var priceSliderMin = parseFloat($('#price-slider').attr('min')),
      priceSliderMax = parseFloat($('#price-slider').attr('max')),
      min = getCurrencyDecmial(priceSliderMin),
      max = getCurrencyDecmial(priceSliderMax);

    return $('#min-slider-input').val() == min && $('#max-slider-input').val() == max && $('.product-filter input[type=checkbox]:checked').length === 0;
  }

  function saveOptions(defaultMin, defaultMax) {
    var checkbox = [],
      checkboxStr = '',
      defaultMin = defaultMin || '',
      defaultMax = defaultMax || '',
      min = '',
      max = '',
      sliderMinVal = $('#min-slider-input').val(),
      sliderMaxVal = $('#max-slider-input').val();

    $('.product-filter input[type=checkbox]:checked').each(function(i, input) {
      checkbox.push($(input).attr('id'));
    });

    checkboxStr = checkbox.join(',');

    // Prevent showing filter when changing currency only
    min = sliderMinVal <= defaultMin || sliderMinVal == 0 ? '' : sliderMinVal;
    max = sliderMaxVal == defaultMax ? '' : sliderMaxVal;

    if (checkbox.length || min || max) {
      var obj = {
        url: window.location.pathname,
        ids: checkboxStr,
        min: min,
        max: max,
        currency: getCurrency()
      };
      localStorage.setItem('filterProductOptionIds', JSON.stringify(obj));
      if (readCookie('hasProductFilterOption')) return;
      createCookie('hasProductFilterOption', true); // Use to hide/show default product
    } else {
      localStorage.removeItem('filterProductOptionIds');
      eraseCookie('hasProductFilterOption');
    }
  }

  function saveJewelleryOptions(defaultMin, defaultMax) {
    var checkbox = [],
      checkboxStr = '',
      defaultMin = defaultMin || '',
      defaultMax = defaultMax || '',
      min = '',
      max = '',
      sliderMinVal = $('#min-slider-input').val(),
      sliderMaxVal = $('#max-slider-input').val();

    $('.product-filter input[type=checkbox]:checked').each(function(i, input) {
      checkbox.push($(input).attr('id'));
    });

    checkboxStr = checkbox.join(',');

    // Prevent showing filter when changing currency only
    min = sliderMinVal <= defaultMin || sliderMinVal == 0 ? '' : sliderMinVal;
    max = sliderMaxVal == defaultMax ? '' : sliderMaxVal;

    if (checkbox.length || min || max) {
      var obj = {
        url: window.location.pathname,
        ids: checkboxStr,
        min: min,
        max: max,
        currency: getCurrency()
      };
      localStorage.setItem('filterProductJewelleryOptionIds', JSON.stringify(obj));
      if (readCookie('hasProductFilterJewelleryOption')) return;
      createCookie('hasProductFilterJewelleryOption', true); // Use to hide/show default product
    } else {
      localStorage.removeItem('filterProductJewelleryOptionIds');
      eraseCookie('hasProductFilterJewelleryOption');
    }
  }

  function saveAuctionOptions(defaultMin, defaultMax) {
    var checkbox = [],
      checkboxStr = '',
      defaultMin = defaultMin || '',
      defaultMax = defaultMax || '',
      min = '',
      max = '',
      sliderMinVal = $('#min-slider-input').val(),
      sliderMaxVal = $('#max-slider-input').val(),
      priceSlider = document.getElementById('price-slider');

    $('.auction-form.product-filter input[type=checkbox]:checked').each(function(i, input) {
      checkbox.push($(input).attr('id'));
    });

    checkboxStr = checkbox.join(',');

    // Prevent showing filter when changing currency only
    min = sliderMinVal <= defaultMin || parseInt(sliderMinVal) == sliderModule.getSliderMin(priceSlider) ? '' : sliderMinVal;
    max = sliderMaxVal == defaultMax || parseInt(sliderMaxVal) == sliderModule.getSliderMax(priceSlider) ? '' : sliderMaxVal;

    if (checkbox.length || min || max) {
      var obj = {
        url: window.location.pathname,
        ids: checkboxStr,
        min: min,
        max: max,
        currency: getCurrency()
      };
      localStorage.setItem('filterProductAuctionOptionIds', JSON.stringify(obj));
      if (readCookie('hasProductFilterAuctionOption')) return;
      createCookie('hasProductFilterAuctionOption', true); // Use to hide/show default product
    } else {
      localStorage.removeItem('filterProductAuctionOptionIds');
      eraseCookie('hasProductFilterAuctionOption');
    }
  }

  function loadBuyPage(priceRange, page, productTotal, productPageCount, noSlider) {
    var weightFlag = 0,
      priceFlag = 0,
      $initialProduct = $('.buy-items').children(),
      apg = !isApgDefault() ? '&apg=' + getApgString() : '',
      sortStr = '',
      sortDir = '',
      initialPriceRange = getPriceRangeApg(priceRange, getApgString(), getCurrency()),
      min = parseFloat(initialPriceRange.min),
      max = parseFloat(initialPriceRange.max),
      totalCount = productTotal,
      pageCount = productPageCount,
      ajaxFlag = true,
      currencyFlag,
      autoRefreshPrice,
      noSlider = noSlider || false,
      defaultFilterState = {
        weight: {
          less1: $('input#less-1-oz')[0].checked,
          one: $('input#one-oz')[0].checked,
          more1: $('input#more-1-oz')[0].checked,
        },
        type: {
          bars: $('input#bars')[0].checked,
          coins: $('input#coins')[0].checked,
        },
        country: {
          switzerland: $('input#switzerland')[0].checked,
          australia: $('input#australia')[0].checked,
          canada: $('input#canada')[0].checked,
        },
        availability: {
          inStock: $('input#in-stock')[0].checked,
          preSale: $('input#pre-sale')[0].checked,
        },
        year: {
          checkboxCurrentYear: $('input#checkboxCurrentYear')[0].checked,
          checkboxLastYear: $('input#checkboxLastYear')[0].checked,
          prevYears: $('input#previous-years')[0].checked,
        },
        count: productTotal
      },
      initFilterState = defaultFilterState,
      pageLoader = new Loading();
    var priceSlider = document.getElementById('price-slider');

    if (nextPage.length > 0) {
      nextPageProducts = nextPage + '&currency=' + getCurrency() + '&apg=' + getApgId();
    }

    $('.currency-wrap .radio-one-line input').off('click');

    priceSlider.setAttribute('rangemin', min);
    priceSlider.setAttribute('rangemax', max);
    setSavedFilterOption();

    if (!noSlider) {
      sliderModule.initializeSlider(priceSlider, min, max);
      console.log(priceRange);
      var initialMin = initialPriceRange.min,
        initialMax = initialPriceRange.max;

      sliderModule.updateSliderMinMax(priceSlider, initialMin, initialMax, initialPriceRange, false, null);
    }

    $('.filter-control').on('click', function() {
      var _this = $(this),
        $img = $('#arrow-head'),
        src = $img.attr('src'),
        $target = $('.product-filter');

      if ($target.hasClass('hide')) {
        $img.attr('src', src.replace(/down/, 'up'));
      } else {
        $img.attr('src', src.replace(/up/, 'down'));
      }
      $target.toggleClass('hide');
    });

    function showLoader() {
      $('.product-filter').find('.loading').removeClass('hide');
    }

    function hideLoader() {
      $('.product-filter').find('.loading').addClass('hide');
    }

    function filterSendRequest(price) {
      price = price || {};
      name = $('.buy-items').data('page');
      console.time('Product Filter Request');
      showLoader();
      ajaxFlag = false;

      if (typeof filterFlag === 'object') {
        filterFlag.abort();
      }

      filterFlag = sliderModule.sendRequest(
        priceSlider, // SLIDER 
        {
          count: 20,
          name: name
        }, // DATA
        function(res) { // SUCCESS CALLBACK
          console.time('Product Filter Render');
          $('.buy-items').removeClass('hide').empty();
          if (res.result.groups.length) {
            //var groupProducts = filterGrouping(res);
            for (var i = 0, len = res.result.groups.length; i < len; i++) {
              $('.buy-items').append(tmpl($('#tmpl-filter-product-item').html(), {
                obj: res.result.groups[i],
                time: res.time
              }));
            }
          } else {
            $('.buy-items').html('<p class="no-product">No products were found matching your selected filter(s). Please try again.</p>')
          }
          hideLoader();
          console.timeEnd('Product Filter Render');

          // var groupProducts = filterGrouping(res);
          // renderFilteredGroupProducts(groupProducts, res.time);

          // productModule.startPromoTimers();

          // Add total results count in filter screen
          setFilterHeaderCount(res.pagination.totalCount);
          // $('.product-filter').removeClass('hide');

          if (res.pagination.nextPage.length) {
            nextPageProducts = res.pagination.nextPage + '&currency=' + getCurrency();
          } else {
            nextPageProducts = '';
          }
          ajaxFlag = true;
        },
        function(res, status) { // FAIL CALLBACK
          var popup = new Popup({
            title: 'API Error',
            message: 'Something is wrong. API Status <strong>' + res.status + '</strong>. Please reload the page.'
          });
          popup.render();
        },
        function() { // ALWAYS CALLBACK
          console.timeEnd('Product Filter Request');
          hideLoader();
        },
        $.isEmptyObject(price) ? '' : price.min,
        $.isEmptyObject(price) ? '' : price.max,
        true
      );
    }

    $('.product-filter input[type=checkbox]').on('click', function() {

      defaultFilterState.weight = {
        less1: $('input#less-1-oz')[0].checked,
        one: $('input#one-oz')[0].checked,
        more1: $('input#more-1-oz')[0].checked,
      };

      defaultFilterState.type = {
        bars: $('input#bars')[0].checked,
        coins: $('input#coins')[0].checked,
      };

      defaultFilterState.country = {
        switzerland: $('input#switzerland')[0].checked,
        australia: $('input#australia')[0].checked,
        canada: $('input#canada')[0].checked,
      };

      defaultFilterState.availability = {
        inStock: $('input#in-stock')[0].checked,
        preSale: $('input#pre-sale')[0].checked,
      };

      defaultFilterState.year = {
        checkboxCurrentYear: $('input#checkboxCurrentYear')[0].checked,
        checkboxLastYear: $('input#checkboxLastYear')[0].checked,
        prevYears: $('input#previous-years')[0].checked,
      };

      var currentYearFilter = getFilterYearPlusOne();
      var lastYearFilter = currentYearFilter - 1;
      $('input#checkboxCurrentYear').attr('value', currentYearFilter);
      $('input#checkboxLastYear').attr('value', lastYearFilter);
      $('input#previous-years').attr('value', '!' + currentYearFilter + '|' + lastYearFilter);

      if ($('.product-filter input[type=checkbox]:checked').length) {
        hideResultCount = false;
      } else {
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      }
      saveOptions();
      filterSendRequest();
    });

    $('.buy-items').on('click', '.see-more', function() {
      var _this = $(this);
      var id = _this.parents('table').data('group-id');
      var groupIds = readCookie('opened-product-groups') ? readCookie('opened-product-groups') : [];

      // This check if table group id is in the cookie then automatically displays
      // the hidden products and remove the see more button
      if (groupIds && groupIds.length) {

        var arr = groupIds.split(',');
        if ($.inArray(String(id), arr) != -1) {
          _this.parents('table').find('> tbody > tr.hide').removeClass('hide');
          _this.remove();
          return;
        }

        groupIds += ',' + id;
        createCookie('opened-product-groups', groupIds, 1);
      } else {
        groupIds.push(id);
        var groupIdsString = groupIds.length > 1 ? groupIds.join(',') : groupIds[0];
        createCookie('opened-product-groups', groupIdsString, 1);
      }

      _this.parents('table').find('> tbody > tr.hide').removeClass('hide');
      _this.remove();
    })

    $('#clear-filter').on('click', function() {
      var min = priceRange[getCurrency()].min,
        max = priceRange[getCurrency()].max;

      setSavedFilterOption();
      //$('.buy-items').html($initialProduct);

      price = sliderModule.setSliderValue(priceSlider, [min, max]);
      $('.price-slider-wrap > .heading .span').addClass('hide');
      $('.price-slider-wrap > .heading .' + getCurrency().toLowerCase()).removeClass('hide');

      hideResultCount = true;
      $('#min-slider-input').val(getCurrencyDecmial(min));
      $('#max-slider-input').val(getCurrencyDecmial(max));
      $('#min-slider-input').trigger('change');
      $('#min-slider-input').val('');
      $('#max-slider-input').val('');
      localStorage.removeItem('filterProductOptionIds');
    });

    // Rewrite DOM because redis have apg
    var html = '';

    //priceRange = getPriceRangeByApg(priceRange, getApgString());
    $.each(priceRange, function(i, cur) {
      if (isCryptoCurrency()) {
        var min = cryptoDecimalPointRules(parseFloat(cur.min)),
          max = cryptoDecimalPointRules(parseFloat(cur.max));

        html += '<span class="' + i.toLowerCase() + ((i === getCurrency()) ? '' : ' hide') + '">' + ' ' + min + ' - ' + max + '</span>';
      } else {
        html += '<span class="' + i.toLowerCase() + ((i === getCurrency()) ? '' : ' hide') + '">' + ' ' + commaSeparateNumber(parseFloat(cur.min).toFixed(2)) + ' - ' + commaSeparateNumber(parseFloat(cur.max).toFixed(2)) + '</span>';
      }
    });

    $('.price-slider-wrap > .heading').html('Price Range ' + html);

    if (!noSlider) {
      priceSlider.noUiSlider.on('slide', function(data) {
        var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
        $('#min-slider-input').val(getCurrencyDecmial(price.min));
        $('#max-slider-input').val(getCurrencyDecmial(price.max));
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      });

      priceSlider.noUiSlider.on('change', function(data) {
        var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
        $('#min-slider-input').val(getCurrencyDecmial(price.min));
        $('#max-slider-input').val(getCurrencyDecmial(price.max));
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
        saveOptions();
        filterSendRequest(price);
      });
    }

    function handleFilter() {
      var $min = $('#min-slider-input');
      var $max = $('#max-slider-input');
      var minVal = parseFloat($min.val());
      var maxVal = parseFloat($max.val());

      // MIN
      if (!isNaN(minVal)) {
        var minSliderPrice = sliderModule.getSliderMin(priceSlider);
        minVal = minVal < minSliderPrice ? minSliderPrice : minVal;
      } else {
        $min.val($('#price-slider').attr('min'));
        minVal = parseFloat($('#price-slider').attr('min')).toFixed(2);
      }

      // MAX
      if (!isNaN(maxVal)) {
        var maxSliderPrice = sliderModule.getSliderMax(priceSlider);
        maxVal = maxVal > maxSliderPrice ? maxSliderPrice : maxVal;
      } else {
        $max.val($('#price-slider').attr('max'));
        maxVal = parseFloat($('#price-slider').attr('max')).toFixed(2);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[0] = minVal;
      v[1] = maxVal;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $min.val(getCurrencyDecmial(v[0]));
      $max.val(getCurrencyDecmial(v[1]));

      var price = sliderModule.updatePriceRangeDisplayText(priceSlider);

      hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      saveOptions();
      filterSendRequest(price);
    }

    $('#min-slider-input').on('change', function() {
      var val = parseFloat($(this).val());
      if (!isNaN(val)) {
        var min = sliderModule.getSliderMin(priceSlider);
        val = val < min ? min : val;
      } else {
        $(this).val($('#price-slider').attr('min'));
        val = parseFloat($('#price-slider').attr('min')).toFixed(2);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[0] = val;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $(this).val(getCurrencyDecmial(v[0]));
      var price = sliderModule.updatePriceRangeDisplayText(priceSlider);

      hideResultCount = isCurrencyChanged || isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      isCurrencyChanged = false;
      saveOptions();
      filterSendRequest(price);
    });

    $('#max-slider-input').on('change', function() {
      var val = parseFloat($(this).val());
      if (!isNaN(val)) {
        var max = sliderModule.getSliderMax(priceSlider);
        val = val > max ? max : val;
      } else {
        $(this).val($('#price-slider').attr('max'));
        val = parseFloat($('#price-slider').attr('max')).toFixed(2);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[1] = val;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $(this).val(getCurrencyDecmial(v[1]));
      var price = sliderModule.updatePriceRangeDisplayText(priceSlider);

      hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      saveOptions();
      filterSendRequest(price);
    });

    // Trigger change when there is a value in the input box
    // Usually happened after click back button
    // if($('#min-slider-input').val()) {
    //   $('#min-slider-input').trigger('change');
    // }

    // Trigger change when there is a value in the input box
    // Usually happened after click back button
    // if($('#max-slider-input').val()) {
    //   $('#max-slider-input').trigger('change');
    // }

    $(document).on('scroll', debounce(function() {
      if ($('.buy-items .items').length) {
        if (isElementInViewport($('.buy-items .items:last-child'), 2) && nextPageProducts) {
          if (ajaxFlag) {
            ajaxFlag = false;
            //$('.product-overview-wrap').append(smallLoader);
            var req = new Request(servicesUrl + nextPageProducts, {});

            req.noApiErrorPopup = true;

            req.success(function(res) {
              if (res.pagination.nextPage) {
                nextPageProducts = res.pagination.nextPage + '&currency=' + getCurrency();
              } else {
                nextPageProducts = '';
              }
              if (res.result.groups.length) {
                //var groupProducts = filterGrouping(res);
                for (var i = 0, len = res.result.groups.length; i < len; i++) {
                  $('.buy-items').append(tmpl($('#tmpl-filter-product-item').html(), {
                    obj: res.result.groups[i],
                    time: res.time
                  }));
                }
              }
            });

            req.complete(function() {
              ajaxFlag = true;
            })

            req.send();

            // $.ajax({
            //   url: nextPageProducts
            // }).done(function(res) {
            //   if(res.pagination.nextPage) {
            //     nextPageProducts = res.pagination.nextPage + '&currency=' + getCurrency();
            //   } else {
            //     nextPageProducts = '';
            //   }
            //   if(res.result.groups.length) {
            //     //var groupProducts = filterGrouping(res);
            //     for(var i = 0, len = res.result.groups.length; i < len; i++) {
            //       $('.buy-items').append(tmpl($('#tmpl-filter-product-item').html(), { obj: res.result.groups[i], time: res.time }));
            //     }
            //   }
            // }).always(function() {
            //   //$('.bullionstar-search-loader-small').remove();
            //   ajaxFlag = true;
            // });
          }
        }
      }
    }, 200));

    $('.currency-wrap .radio-one-line input').on('click', function() {
      var prevMin = priceRange[getCurrency()].min;
      var prevMax = priceRange[getCurrency()].max;
      var oldCur = getCurrency();
      changeCurrency($(this).val());

      var min = priceRange[getCurrency()].min,
        max = priceRange[getCurrency()].max;

      // var oldMin = sliderModule.getSliderValueMin(priceSlider);
      // var oldMax = sliderModule.getSliderValueMax(priceSlider);

      // if($('#min-slider-input').val() <= prevMin && $('#max-slider-input').val() == prevMax) {
      //   console.log('DEFAULT');
      //   sliderModule.updateSliderMinMax(priceSlider, min, max);

      //   // Reattach event handlers
      //   priceSlider.noUiSlider.on('slide', function(data) {
      //     var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
      //     $('#min-slider-input').val(getCurrencyDecmial(price.min));
      //     $('#max-slider-input').val(getCurrencyDecmial(price.max));
      //     hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      //   });

      //   priceSlider.noUiSlider.on('change', function(data) {
      //     var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
      //     $('#min-slider-input').val(getCurrencyDecmial(price.min));
      //     $('#max-slider-input').val(getCurrencyDecmial(price.max));
      //     hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      //     saveOptions();
      //     filterSendRequest(price);
      //   });
      // }

      if (!noSlider) {
        isCurrencyChanged = true;
        sliderModule.updateSliderMinMax(priceSlider, min, max, priceRange, true, null);
        price = sliderModule.setSliderValue(priceSlider, [min, max]);
        $('#min-slider-input').val(getCurrencyDecmial(min));
        $('#max-slider-input').val(getCurrencyDecmial(max));
        $('#min-slider-input').trigger('change');
        $('#min-slider-input').val('');
        $('#max-slider-input').val('');
      }

      saveOptions(min, max);
      //changeProductsBasedOnLocation();
      changeProductsOverviewPrice(oldCur);
      headerCurrencyChange();
    });

    if (dontShowFilter()) {
      localStorage.removeItem('filterProductOptionIds');
    }

    if (localStorage.getItem('filterProductOptionIds') !== null) {
      var filterOptions = JSON.parse(localStorage.getItem('filterProductOptionIds'));
      if (filterOptions.currency !== getCurrency()) {
        localStorage.removeItem('filterProductOptionIds')
        return;
      }
      if (filterOptions.url === window.location.pathname) {
        console.log(filterOptions)
        if ('min' in filterOptions && 'max' in filterOptions) {
          if (filterOptions.min != min || filterOptions.max != max) {
            $('.filter-control').trigger('click');
          }
        }

        if (filterOptions.ids && filterOptions.ids.length > 0) {
          var checkedFilters = filterOptions.ids.split(',');
          if (checkedFilters.length) {
            $('.filter-control').trigger('click');
          }

          var hasYearFilter = false;

          $.each(checkedFilters, function(i, val) {
            if (val === 'checkboxCurrentYear' || val === 'checkboxLastYear' || val === 'previous-years') {
              hasYearFilter = true;
            }
          })


          for (var x = 0; x < checkedFilters.length; x++) {
            // Check last id then trigger click to update the value of checkbox
            if (hasYearFilter && x === checkedFilters.length - 1) {
              $('#' + checkedFilters[x]).trigger('click');
              return;
            }
            $('#' + checkedFilters[x]).prop('checked', true);
          }
        }

        if (filterOptions.min || filterOptions.max) {

          // Min only
          if (filterOptions.min && !filterOptions.max) {
            console.log('MIN ONLY')
            $('#min-slider-input').val(filterOptions.min).trigger('change');
          }
          // Max only
          if (filterOptions.max && !filterOptions.min) {
            console.log('MAX ONLY')
            $('#max-slider-input').val(filterOptions.max).trigger('change');
          }

          // Both Min and Max
          if (filterOptions.max && filterOptions.min) {
            console.log('BOTH MIN AND MAX')
            $('#min-slider-input').val(filterOptions.min);
            $('#max-slider-input').val(filterOptions.max);
            handleFilter();
          }
        } else {
          filterSendRequest();
        }
      } else {
        localStorage.removeItem('filterProductOptionIds');
        eraseCookie('hasProductFilterOption');
      }
    } else {
      eraseCookie('hasProductFilterOption');
    }

    if (!readCookie('hasProductFilterOption')) {
      $('.buy-items').removeClass('hide');
    }

    changeProductsOverviewPrice();

    if (readCookie('opened-product-groups')) {
      var groupsToShow = readCookie('opened-product-groups').split(',');

      $(groupsToShow).each(function(i, id) {
        var $target = $('.buy-items .items .product-overview-default-wrap .bottom > table[data-group-id="' + id + '"]')
        $target.find('.see-more').closest('tr').remove();
        $target.find('.pricing-row').removeClass('hide');
      })
    }

    autoRefreshPrice = setInterval(function() {
      // Waiting for the API from Joakim to be used here
      //changeProductsBasedOnLocation();
      if (!document.hidden) {
        changeProductsOverviewPrice();
        var cart = localStorage.getItem('cart' + getLocation());
        if (cart != null && cart != '') {
          shoppingCartModule.refresh();
        }
      }
    }, 60000);
  }

  function loadBuyJewelleryPage(priceRange, page, productTotal, productPageCount, noSlider) {
    var weightFlag = 0,
      priceFlag = 0,
      $initialProduct = $('.buy-items').children(),
      apg = !isApgDefault() ? '&apg=' + getApgString() : '',
      sortStr = '',
      sortDir = '',
      initialPriceRange = getPriceRangeApg(priceRange, getApgString(), getCurrency()),
      min = parseFloat(initialPriceRange.min),
      max = parseFloat(initialPriceRange.max),
      totalCount = productTotal,
      pageCount = productPageCount,
      ajaxFlag = true,
      currencyFlag,
      autoRefreshPrice,
      noSlider = noSlider || false,
      defaultFilterJewelleryState = {
        weight: {
          g0: $('input#g0')[0].checked,
          g10: $('input#g10')[0].checked,
          g30: $('input#g30')[0].checked,
          g50: $('input#g50')[0].checked,
        },
        type: {
          ring: $('input#ring')[0].checked,
          bangle: $('input#bangle')[0].checked,
          earrings: $('input#earrings')[0].checked,
          bracelet: $('input#bracelet')[0].checked,
          pendant: $('input#pendant')[0].checked,
          necklace: $('input#necklace')[0].checked,
          ornament: $('input#ornament')[0].checked,
        },
        karat: {
          k24: $('input#k24')[0].checked,
          k22: $('input#k22')[0].checked,
        },
        count: productTotal
      },
      initFilterState = defaultFilterJewelleryState,
      pageLoader = new Loading();

    var priceSlider = document.getElementById('price-slider');

    if (nextPage.length > 0) {
      nextPageProducts = nextPage + '&currency=' + getCurrency();
    }

    function getJewelleryTablePrice() {
      var $table = $('.banner-price table');
      var req = new Request(servicesUrl + '/product/jewellery/prices', {
        currency: getCurrency()
      });
      req.noApiErrorPopup = true;

      req.success(function(res) {
        // 24 Karat
        $table.find('.k24 .title').text(res.items[0].title)
        $table.find('.k24 .price-gram').text('From ' + getCurrency() + ' ' + res.items[0].discounted)
        //$table.find('.k24 .promo-price-gram').text(res.items[0].discounted)

        // 22 Karat
        $table.find('.k22 .title').text(res.items[1].title)
        $table.find('.k22 .price-gram').text('From ' + getCurrency() + ' ' + res.items[1].discounted)
        //$table.find('.k22 .promo-price-gram').text(res.items[1].discounted)
      })
      req.send();
    }

    getJewelleryTablePrice()

    setInterval(function() {
      getJewelleryTablePrice()
    }, 60000)

    $('.currency-wrap .radio-one-line input').off('click');

    priceSlider.setAttribute('rangemin', min);
    priceSlider.setAttribute('rangemax', max);
    setSavedFilterJewelleryOption();

    if (!noSlider) {
      sliderModule.initializeSlider(priceSlider, min, max);
      console.log(priceRange);
      var initialMin = initialPriceRange.min,
        initialMax = initialPriceRange.max;

      sliderModule.updateSliderMinMax(priceSlider, initialMin, initialMax, initialPriceRange, false, null);
    }

    $('.filter-control').on('click', function() {
      var _this = $(this),
        $img = $('#arrow-head'),
        src = $img.attr('src'),
        $target = $('.product-filter');

      if ($target.hasClass('hide')) {
        $img.attr('src', src.replace(/down/, 'up'));
      } else {
        $img.attr('src', src.replace(/up/, 'down'));
      }
      $target.toggleClass('hide');
    });

    function showLoader() {
      $('.product-filter').find('.loading').removeClass('hide');
    }

    function hideLoader() {
      $('.product-filter').find('.loading').addClass('hide');
    }

    function filterSendRequest(price) {
      price = price || {};
      name = $('.jewellery-list').data('page');
      console.time('Product Filter Request');
      showLoader();
      ajaxFlag = false;

      if (typeof filterFlag === 'object') {
        filterFlag.abort();
      }

      filterFlag = sliderModule.sendRequestJewellery(
        priceSlider, // SLIDER 
        {
          count: 20,
          name: name
        }, // DATA
        function(res) { // SUCCESS CALLBACK
          console.time('Product Filter Render');
          $('.jewellery-list').removeClass('hide').empty();
          if (res.result.products.length) {
            //var groupProducts = filterGrouping(res);
            $('.jewellery-list').append(tmpl($('#tmpl-filter-product-jewellery-item').html(), {
              obj: res.result.products,
              time: res.time
            }));
          } else {
            $('.jewellery-list').html('<p class="no-product">No products were found matching your selected filter(s). Please try again.</p>')
          }
          hideLoader();
          console.timeEnd('Product Filter Render');

          // Add total results count in filter screen
          setFilterHeaderCount(res.pagination.totalCount);
          // $('.product-filter').removeClass('hide');

          if (res.pagination.nextPage.length) {
            nextPageProducts = res.pagination.nextPage + '&currency=' + getCurrency();
          } else {
            nextPageProducts = '';
          }
          ajaxFlag = true;
        },
        function(res, status) { // FAIL CALLBACK
          var popup = new Popup({
            title: 'API Error',
            message: 'Something is wrong. API Status <strong>' + res.status + '</strong>. Please reload the page.'
          });
          popup.render();
        },
        function() { // ALWAYS CALLBACK
          console.timeEnd('Product Filter Request');
          hideLoader();
        },
        $.isEmptyObject(price) ? '' : price.min,
        $.isEmptyObject(price) ? '' : price.max,
        true
      );
    }

    $('.product-filter input[type=checkbox]').on('click', function() {

      defaultFilterJewelleryState.type = {
        ring: $('input#ring')[0].checked,
        bangle: $('input#bangle')[0].checked,
        earrings: $('input#earrings')[0].checked,
        bracelet: $('input#bracelet')[0].checked,
        pendant: $('input#pendant')[0].checked,
        necklace: $('input#necklace')[0].checked,
        ornament: $('input#ornament')[0].checked,
      };

      defaultFilterJewelleryState.karat = {
        k24: $('input#k24')[0].checked,
        k22: $('input#k22')[0].checked,
      };

      defaultFilterJewelleryState.weight = {
        g0: $('input#g0')[0].checked,
        g10: $('input#g10')[0].checked,
        g30: $('input#g30')[0].checked,
        g50: $('input#g50')[0].checked,
      };

      if ($('.product-filter input[type=checkbox]:checked').length) {
        hideResultCount = false;
      } else {
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      }
      saveJewelleryOptions();
      filterSendRequest();
    });

    $('#clear-filter').on('click', function() {
      var min = priceRange[getCurrency()].min,
        max = priceRange[getCurrency()].max;

      setSavedFilterJewelleryOption();
      //$('.buy-items').html($initialProduct);

      price = sliderModule.setSliderValue(priceSlider, [min, max]);
      $('.price-slider-wrap > .heading .span').addClass('hide');
      $('.price-slider-wrap > .heading .' + getCurrency().toLowerCase()).removeClass('hide');

      hideResultCount = true;
      $('#min-slider-input').val(getCurrencyDecmial(min));
      $('#max-slider-input').val(getCurrencyDecmial(max));
      $('#min-slider-input').trigger('change');
      $('#min-slider-input').val('');
      $('#max-slider-input').val('');
      localStorage.removeItem('filterProductJewelleryOptionIds');
    });

    // Rewrite DOM because redis have apg
    var html = '';

    //priceRange = getPriceRangeByApg(priceRange, getApgString());
    $.each(priceRange, function(i, cur) {
      if (isCryptoCurrency()) {
        var min = cryptoDecimalPointRules(parseFloat(cur.min)),
          max = cryptoDecimalPointRules(parseFloat(cur.max));

        html += '<span class="' + i.toLowerCase() + ((i === getCurrency()) ? '' : ' hide') + '">' + ' ' + min + ' - ' + max + '</span>';
      } else {
        html += '<span class="' + i.toLowerCase() + ((i === getCurrency()) ? '' : ' hide') + '">' + ' ' + commaSeparateNumber(parseFloat(cur.min).toFixed(2)) + ' - ' + commaSeparateNumber(parseFloat(cur.max).toFixed(2)) + '</span>';
      }
    });

    $('.price-slider-wrap > .heading').html('Price Range ' + html);

    if (!noSlider) {
      priceSlider.noUiSlider.on('slide', function(data) {
        var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
        $('#min-slider-input').val(getCurrencyDecmial(price.min));
        $('#max-slider-input').val(getCurrencyDecmial(price.max));
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      });

      priceSlider.noUiSlider.on('change', function(data) {
        var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
        $('#min-slider-input').val(getCurrencyDecmial(price.min));
        $('#max-slider-input').val(getCurrencyDecmial(price.max));
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
        saveJewelleryOptions();
        filterSendRequest(price);
      });
    }

    function handleFilter() {
      var $min = $('#min-slider-input');
      var $max = $('#max-slider-input');
      var minVal = parseFloat($min.val());
      var maxVal = parseFloat($max.val());

      // MIN
      if (!isNaN(minVal)) {
        var minSliderPrice = sliderModule.getSliderMin(priceSlider);
        minVal = minVal < minSliderPrice ? minSliderPrice : minVal;
      } else {
        $min.val($('#price-slider').attr('min'));
        minVal = parseFloat($('#price-slider').attr('min')).toFixed(2);
      }

      // MAX
      if (!isNaN(maxVal)) {
        var maxSliderPrice = sliderModule.getSliderMax(priceSlider);
        maxVal = maxVal > maxSliderPrice ? maxSliderPrice : maxVal;
      } else {
        $max.val($('#price-slider').attr('max'));
        maxVal = parseFloat($('#price-slider').attr('max')).toFixed(2);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[0] = minVal;
      v[1] = maxVal;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $min.val(getCurrencyDecmial(v[0]));
      $max.val(getCurrencyDecmial(v[1]));

      var price = sliderModule.updatePriceRangeDisplayText(priceSlider);

      hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      saveJewelleryOptions();
      filterSendRequest(price);
    }

    $('#min-slider-input').on('change', function() {
      var val = parseFloat($(this).val());
      if (!isNaN(val)) {
        var min = sliderModule.getSliderMin(priceSlider);
        val = val < min ? min : val;
      } else {
        $(this).val($('#price-slider').attr('min'));
        val = parseFloat($('#price-slider').attr('min')).toFixed(2);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[0] = val;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $(this).val(getCurrencyDecmial(v[0]));
      var price = sliderModule.updatePriceRangeDisplayText(priceSlider);

      hideResultCount = isCurrencyChanged || isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      isCurrencyChanged = false;
      saveJewelleryOptions();
      filterSendRequest(price);
    });

    $('#max-slider-input').on('change', function() {
      var val = parseFloat($(this).val());
      if (!isNaN(val)) {
        var max = sliderModule.getSliderMax(priceSlider);
        val = val > max ? max : val;
      } else {
        $(this).val($('#price-slider').attr('max'));
        val = parseFloat($('#price-slider').attr('max')).toFixed(2);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[1] = val;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $(this).val(getCurrencyDecmial(v[1]));
      var price = sliderModule.updatePriceRangeDisplayText(priceSlider);

      hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      saveJewelleryOptions();
      filterSendRequest(price);
    });

    // Trigger change when there is a value in the input box
    // Usually happened after click back button
    // if($('#min-slider-input').val()) {
    //   $('#min-slider-input').trigger('change');
    // }

    // Trigger change when there is a value in the input box
    // Usually happened after click back button
    // if($('#max-slider-input').val()) {
    //   $('#max-slider-input').trigger('change');
    // }

    $(document).on('scroll', debounce(function() {
      if ($('.jewellery-list .product-jewellery').length) {
        if (isElementInViewport($('.jewellery-list .product-jewellery:last-child'), 2) && nextPageProducts) {
          if (ajaxFlag) {
            ajaxFlag = false;
            //$('.product-overview-wrap').append(smallLoader);
            var locationFilter = nextPageProducts ? '&locationId=' + getLocation() : 'locationId=' + getLocation();
            var req = new Request(servicesUrl + nextPageProducts + locationFilter, {});

            req.noApiErrorPopup = true;

            req.success(function(res) {
              if (res.pagination.nextPage) {
                nextPageProducts = res.pagination.nextPage + '&currency=' + getCurrency();
              } else {
                nextPageProducts = '';
              }
              if (res.result.products.length) {
                //var groupProducts = filterGrouping(res);
                $('.jewellery-list').append(tmpl($('#tmpl-filter-product-jewellery-item').html(), {
                  obj: res.result.products,
                  time: res.time
                }));
              }
            });

            req.complete(function() {
              ajaxFlag = true;
            })

            req.send();

            // $.ajax({
            //   url: nextPageProducts
            // }).done(function(res) {
            //   if(res.pagination.nextPage) {
            //     nextPageProducts = res.pagination.nextPage + '&currency=' + getCurrency();
            //   } else {
            //     nextPageProducts = '';
            //   }
            //   if(res.result.groups.length) {
            //     //var groupProducts = filterGrouping(res);
            //     for(var i = 0, len = res.result.groups.length; i < len; i++) {
            //       $('.buy-items').append(tmpl($('#tmpl-filter-product-item').html(), { obj: res.result.groups[i], time: res.time }));
            //     }
            //   }
            // }).always(function() {
            //   //$('.bullionstar-search-loader-small').remove();
            //   ajaxFlag = true;
            // });
          }
        }
      }
    }, 200));

    $('.currency-wrap .radio-one-line input').on('click', function() {
      var prevMin = priceRange[getCurrency()].min;
      var prevMax = priceRange[getCurrency()].max;
      var oldCur = getCurrency();
      changeCurrency($(this).val());

      var min = priceRange[getCurrency()].min,
        max = priceRange[getCurrency()].max;

      // var oldMin = sliderModule.getSliderValueMin(priceSlider);
      // var oldMax = sliderModule.getSliderValueMax(priceSlider);

      // if($('#min-slider-input').val() <= prevMin && $('#max-slider-input').val() == prevMax) {
      //   console.log('DEFAULT');
      //   //sliderModule.updateSliderMinMax(min, max);

      //   // Reattach event handlers
      //   priceSlider.noUiSlider.on('slide', function(data) {
      //     var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
      //     $('#min-slider-input').val(getCurrencyDecmial(price.min));
      //     $('#max-slider-input').val(getCurrencyDecmial(price.max));
      //     hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      //   });

      //   priceSlider.noUiSlider.on('change', function(data) {
      //     var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
      //     $('#min-slider-input').val(getCurrencyDecmial(price.min));
      //     $('#max-slider-input').val(getCurrencyDecmial(price.max));
      //     hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      //     saveJewelleryOptions();
      //     filterSendRequest(price);
      //   });
      // }

      if (!noSlider) {
        isCurrencyChanged = true;
        sliderModule.updateSliderMinMax(priceSlider, min, max, priceRange, true, null);
        price = sliderModule.setSliderValue(priceSlider, [min, max]);
        $('#min-slider-input').val(getCurrencyDecmial(min));
        $('#max-slider-input').val(getCurrencyDecmial(max));
        $('#min-slider-input').trigger('change');
        $('#min-slider-input').val('');
        $('#max-slider-input').val('');
      }
      saveJewelleryOptions();
      //changeProductsBasedOnLocation();
      changeProductsOverviewPrice(oldCur);
      headerCurrencyChange();
    });

    if (dontShowFilter()) {
      localStorage.removeItem('filterProductJewelleryOptionIds');
    }

    if (localStorage.getItem('filterProductJewelleryOptionIds') !== null) {
      var filterOptions = JSON.parse(localStorage.getItem('filterProductJewelleryOptionIds'));
      if (filterOptions.currency !== getCurrency()) {
        localStorage.removeItem('filterProductJewelleryOptionIds')
        return;
      }
      if (filterOptions.url === window.location.pathname) {
        if ('min' in filterOptions && 'max' in filterOptions) {
          if (filterOptions.min != min || filterOptions.max != max) {
            $('.filter-control').trigger('click');
          }
        }

        if (filterOptions.ids && filterOptions.ids.length > 0) {
          var checkedFilters = filterOptions.ids.split(',');
          if (checkedFilters.length) {
            $('.filter-control').trigger('click');
          }

          for (var x = 0; x < checkedFilters.length; x++) {
            $('#' + checkedFilters[x]).prop('checked', true);
          }
        }

        if (filterOptions.min || filterOptions.max) {

          // Min only
          if (filterOptions.min && !filterOptions.max) {
            console.log('MIN ONLY')
            $('#min-slider-input').val(filterOptions.min).trigger('change');
          }
          // Max only
          if (filterOptions.max && !filterOptions.min) {
            console.log('MAX ONLY')
            $('#max-slider-input').val(filterOptions.max).trigger('change');
          }

          // Both Min and Max
          if (filterOptions.max && filterOptions.min) {
            console.log('BOTH MIN AND MAX')
            $('#min-slider-input').val(filterOptions.min);
            $('#max-slider-input').val(filterOptions.max);
            handleFilter();
          }
        } else {
          filterSendRequest();
        }
      } else {
        localStorage.removeItem('filterProductJewelleryOptionIds');
        eraseCookie('hasProductFilterJewelleryOption');
      }
    } else {
      eraseCookie('hasProductFilterJewelleryOption');
    }

    if (!readCookie('hasProductFilterJewelleryOption')) {
      $('.buy-items').removeClass('hide');
    }

    changeProductsOverviewPrice();

    if (readCookie('opened-product-groups')) {
      var groupsToShow = readCookie('opened-product-groups').split(',');

      $(groupsToShow).each(function(i, id) {
        var $target = $('.buy-items .items .product-overview-default-wrap .bottom > table[data-group-id="' + id + '"]')
        $target.find('.see-more').closest('tr').remove();
        $target.find('.pricing-row').removeClass('hide');
      })
    }

    autoRefreshPrice = setInterval(function() {
      // Waiting for the API from Joakim to be used here
      //changeProductsBasedOnLocation();
      if (!document.hidden) {
        changeProductsOverviewPrice();
        var cart = localStorage.getItem('cart' + getLocation());
        if (cart != null && cart != '') {
          shoppingCartModule.refresh();
        }
      }
    }, 60000);
  }

  function loadAuctionPage(priceRange, page, productTotal, productPageCount, noSlider, accountAuctions) {
    var price = {},
      auctionCurrency = getAuctionCurrency(),
      initialPriceRange = getPriceRangeApg(priceRange, getApgString(), auctionCurrency),
      min = parseFloat(initialPriceRange.min),
      max = parseFloat(initialPriceRange.max),
      ajaxFlag = true,
      noSlider = noSlider || false,
      isMyAuctionPage = window.location.pathname === '/myaccount/auctions';

    var priceSlider = document.getElementById('price-slider');

    if (isLoggedIn()) {
      $('.product-filter.auction-form .watchlist-option').removeClass('hide');
      $('.product-filter.auction-form .status-option-won').removeClass('hide');
    }

    if (nextPage.length > 0) {
      nextPageProducts = nextPage + '&currency=' + auctionCurrency;
    }

    $('.currency-wrap .radio-one-line input').off('click');

    priceSlider.setAttribute('rangemin', min);
    priceSlider.setAttribute('rangemax', max);

    setSavedFilterAuctionOption();

    if (!noSlider) {
      if (priceSlider && priceSlider.noUiSlider) {
        priceSlider.noUiSlider.destroy();
      }
      sliderModule.initializeSlider(priceSlider, min, max);
      console.log(priceRange);
      var initialMin = initialPriceRange.min,
        initialMax = initialPriceRange.max;

      sliderModule.updateSliderMinMax(priceSlider, initialMin, initialMax, initialPriceRange, false, null);
    }

    $('.filter-control').on('click', function() {
      var _this = $(this),
        $img = $('#arrow-head'),
        src = $img.attr('src'),
        $target = $('.product-filter');

      if ($target.hasClass('hide')) {
        $img.attr('src', src.replace(/down/, 'up'));
      } else {
        $img.attr('src', src.replace(/up/, 'down'));
      }
      $target.toggleClass('hide');
    });

    function showLoader() {
      $('.product-filter').find('.loading').removeClass('hide');
    }

    function hideLoader() {
      $('.product-filter').find('.loading').addClass('hide');
    }

    function filterAuctionSendRequest() {
      price = price || {};
      console.time('Auction Filter Request');
      showLoader();
      ajaxFlag = false;

      if (typeof filterFlag === 'object') {
        filterFlag.abort();
      }

      var auctionParams = addAuctionFilterParams();

      auctionModule.listAuctionsFilter(auctionParams, function(res) { // SUCCESS CALLBACK
          console.time('Auction Filter Render');
          $('.auction-list').removeClass('hide').empty();
          if (res.result && res.result.auctions && res.result.auctions.length) {
            $('.auction-list').html(tmpl($('#tmpl-filtered-auction-items').html(), {
              obj: res.result.auctions,
              currentAccountId: getAccountId(),
              currentPage: res.pagination.currentPage
            }));
          } else {
            $('.auction-list').html('<p class="no-product">No auctions were found matching your selected filter(s). Please try again.</p>')
          }
          refreshAuctions();
          hideLoader();
          console.timeEnd('Auction Filter Render');

          // Add total results count in filter screen
          if (res && res.pagination) {
            setFilterHeaderCount(res.pagination.totalCount);
          }
          $('.product-filter').removeClass('hide');

          if (res.pagination.nextPage.length) {
            nextPageProducts = res.pagination.nextPage + '&currency=' + auctionCurrency;
          } else {
            nextPageProducts = '';
          }
          ajaxFlag = true;
        },
        function(res, status) { // FAIL CALLBACK
          var popup = new Popup({
            title: 'API Error',
            message: 'Something is wrong. API Status <strong>' + res.status + '</strong>. Please reload the page.'
          });
          popup.render();
        },
        function() { // ALWAYS CALLBACK
          console.timeEnd('Auction Filter Request');
          hideLoader();
        }
      );
    }

    function addAuctionFilterParams() {
      var params = [];

      if (isMyAccountAuctionsPage()) {
        params.push('accountAuctionsOnly=true');
        params.push('watchlist=bid_entered');
        params.push('watchlist=saved');
      }

      params.push('locationId=' + getLocation());
      // params.push('status&metal&type');

      if (isLoggedIn() && !isMyAccountAuctionsPage()) {
        var checkedWatchlist = $('.auction-form input[name=watchlist]:checked')
        var watchlist = checkedWatchlist.map(function() {
          return 'watchlist=' + this.value;
        }).get();
        params = params.concat(watchlist.length > 0 ? watchlist : 'watchlist=');
      } else {
        $('.auction-form input#saved:checked').prop('checked', false);
      }

      var checkedStatuses = $('.auction-form input[name=statuses]:checked')
      var statuses = checkedStatuses.map(function() {
        if (!isLoggedIn() && this.value == 'won') return;
        return 'statuses=' + this.value;
      }).get();
      params = params.concat(statuses.length > 0 ? statuses : 'statuses=');

      var metals = $('.auction-form input[name=metals]:checked').map(function() {
        return 'metals=' + this.value;
      }).get();
      params = params.concat(metals.length > 0 ? metals : 'metals=');

      var types = $('.auction-form input[name=types]:checked').map(function() {
        return 'types=' + this.value;
      }).get();
      params = params.concat(types.length > 0 ? types : 'types=');

      var sliderValue = sliderModule.getSliderValue(priceSlider)
      var min = sliderValue[0];
      var max = sliderValue[1];

      // if (min !== max && min < max) {
      //   params.push('min=' + min);
      //   params.push('max=' + max);
      // } else {
      //   params.push('min=');
      //   params.push('max=');
      // }

      // FROM BACKEND Don't pass max when min is equal to the total slider min
      if (parseInt(min) == sliderModule.getSliderMin(priceSlider)) {
        params.push('min=');
      } else {
        params.push('min=' + min);
      }

      // FROM BACKEND Don't pass max when max is equal to the total slider max
      if (parseInt(max) == sliderModule.getSliderMax(priceSlider)) {
        params.push('max=');
      } else {
        params.push('max=' + max);
      }

      hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();

      // if (checkedStatuses.length == 0) {
      //   params.push('statuses=active'); // if no-checked filters default to active
      // }

      return params.join('&');
    }

    $('.auction-form.product-filter input[type=checkbox]:not(".all-options")').on('click', function() {
      if ($('.product-filter input[type=checkbox]:checked').length) {
        hideResultCount = false;
      } else {
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      }

      var checkboxGroupName = $(this).prop('name');
      var checkedItems = $('input[name=' + checkboxGroupName + ']:checked');
      var checkboxOptions = $('input[name=' + checkboxGroupName + ']');
      if (checkboxGroupName == 'statuses' && !isLoggedIn()) {
        checkedItems = $('input[name=' + checkboxGroupName + ']:checked:not([value=won])');
        checkboxOptions = $('input[name=' + checkboxGroupName + ']:not([value=won]');
      }

      if (checkedItems.length == checkboxOptions.length) {
        $('#all-' + checkboxGroupName).prop('checked', true);
      } else {
        $('#all-' + checkboxGroupName).prop('checked', false);
      }

      saveAuctionOptions();
      filterAuctionSendRequest();
    });

    $('.auction-form.product-filter input.all-options').on('click', function() {
      var checkboxGroupName = $(this).val();
      if ($(this).is(':checked')) {
        $('.auction-form.product-filter input[name=' + checkboxGroupName + ']').prop('checked', true);
      } else {
        $('.auction-form.product-filter input[name=' + checkboxGroupName + ']').prop('checked', false);
      }
      saveAuctionOptions();
      filterAuctionSendRequest();
    });

    // $('#clear-filter').on('click', function() {
    //   setSavedFilterAuctionOption();
    //   if (priceRange[auctionCurrency]) {
    //     var min = priceRange[auctionCurrency].min,
    //       max = priceRange[auctionCurrency].max;
    //     price = sliderModule.setSliderValue(priceSlider, [min, max]);
    //     $('#min-slider-input').val(getCurrencyDecmial(min));
    //     $('#max-slider-input').val(getCurrencyDecmial(max));
    //   }
    //   $('#min-slider-input').trigger('change');
    //   $('.price-slider-wrap > .heading .span').addClass('hide');
    //   $('.price-slider-wrap > .heading .sgd').removeClass('hide');

    //   $('#min-slider-input').val('');
    //   $('#max-slider-input').val('');
    //   $('.filter-heading .result').addClass('hide');
    //   hideResultCount = true;
    //   localStorage.removeItem('filterProductAuctionOptionIds');
    // });

    $('#reset-filter').on('click', function() {
      setSavedFilterAuctionOption();
      defaultAccountAuctionsFilter().defaultSelectedFilter.forEach(function(selectedItem) {
        $('#' + selectedItem).prop('checked', true);
      });
      saveAuctionOptions();

      if (priceRange[auctionCurrency]) {
        var min = priceRange[auctionCurrency].min,
          max = priceRange[auctionCurrency].max;
        price = sliderModule.setSliderValue(priceSlider, [min, max]);
        $('#min-slider-input').val(getCurrencyDecmial(min));
        $('#max-slider-input').val(getCurrencyDecmial(max));
      }
      $('#min-slider-input').trigger('change');
      // $('.price-slider-wrap > .heading span').addClass('hide');
      // $('.price-slider-wrap > .heading .sgd').removeClass('hide');

      $('#min-slider-input').val('');
      $('#max-slider-input').val('');
      $('.filter-heading .result').addClass('hide');
      // hideResultCount = true;
      localStorage.removeItem('filterProductAuctionOptionIds');
    });

    // Rewrite DOM because redis have apg
    var html = '';

    //priceRange = getPriceRangeByApg(priceRange, getApgString());
    $.each(priceRange, function(i, cur) {
      if (i === 'SGD') {
        html += '<span>' + ' ' + commaSeparateNumber(parseInt(cur.min).toFixed(0)) + ' - ' + commaSeparateNumber(parseInt(cur.max).toFixed(0)) + '</span>';
      }
    });

    $('.price-slider-wrap > .heading').html('Price Range ' + html);

    if (!noSlider) {
      priceSlider.noUiSlider.on('slide', function(data) {
        var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
        $('#min-slider-input').val(getCurrencyDecmial(price.min));
        $('#max-slider-input').val(getCurrencyDecmial(price.max));
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      });

      priceSlider.noUiSlider.on('change', function(data) {
        var price = sliderModule.updatePriceRangeDisplayText(priceSlider);
        $('#min-slider-input').val(getCurrencyDecmial(price.min));
        $('#max-slider-input').val(getCurrencyDecmial(price.max));
        hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
        saveAuctionOptions();
        filterAuctionSendRequest(price);
      });
    }

    function handleAuctionFilter() {
      var $min = $('#min-slider-input');
      var $max = $('#max-slider-input');
      var minVal = parseInt($min.val());
      var maxVal = parseInt($max.val());

      // MIN
      if (!isNaN(minVal)) {
        var minSliderPrice = sliderModule.getSliderMin(priceSlider);
        minVal = minVal < minSliderPrice ? minSliderPrice : minVal;
      } else {
        $min.val($('#price-slider').attr('min'));
        minVal = parseInt($('#price-slider').attr('min')).toFixed(0);
      }

      // MAX
      if (!isNaN(maxVal)) {
        var maxSliderPrice = sliderModule.getSliderMax(priceSlider);
        maxVal = maxVal > maxSliderPrice ? maxSliderPrice : maxVal;
      } else {
        $max.val($('#price-slider').attr('max'));
        maxVal = parseInt($('#price-slider').attr('max')).toFixed(0);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[0] = minVal;
      v[1] = maxVal;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $min.val(getCurrencyDecmial(v[0]));
      $max.val(getCurrencyDecmial(v[1]));

      sliderModule.updatePriceRangeDisplayText(priceSlider);
      hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      saveAuctionOptions();
      filterAuctionSendRequest();
    }

    $('#min-slider-input').on('change', function() {
      var val = parseInt($(this).val());
      if (!isNaN(val)) {
        var min = sliderModule.getSliderMin(priceSlider);
        val = val < min ? min : val;
      } else {
        $(this).val($('#price-slider').attr('min'));
        val = parseInt($('#price-slider').attr('min')).toFixed(0);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[0] = val;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $(this).val(getCurrencyDecmial(v[0]));
      var price = sliderModule.updatePriceRangeDisplayText(priceSlider);

      hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      saveAuctionOptions();
      filterAuctionSendRequest(price);
    });

    $('#max-slider-input').on('change', function() {
      var val = parseFloat($(this).val());
      if (!isNaN(val)) {
        var max = sliderModule.getSliderMax(priceSlider);
        val = val > max ? max : val;
      } else {
        $(this).val($('#price-slider').attr('max'));
        val = parseFloat($('#price-slider').attr('max')).toFixed(0);
      }

      var v = sliderModule.getSliderValue(priceSlider);
      v[1] = val;
      sliderModule.setSliderValue(priceSlider, v);

      v = sliderModule.getSliderValue(priceSlider);
      $(this).val(getCurrencyDecmial(v[1]));
      price = sliderModule.updatePriceRangeDisplayText(priceSlider);

      hideResultCount = isSliderDefaultValueSelectedAndNoCheckboxFilterSelected();
      saveAuctionOptions();
      filterAuctionSendRequest();
    });

    $(document).on('scroll', debounce(function() {
      if ($('.auction-list .product-auction').length) {
        if (isElementInViewport($('.auction-list .product-auction:last-child'), 2) && nextPageProducts) {
          if (ajaxFlag) {
            ajaxFlag = false;
            //$('.product-overview-wrap').append(smallLoader);
            var req = new Request(servicesUrl + nextPageProducts, {});

            req.noApiErrorPopup = true;

            req.success(function(res) {
              if (res.result.auctions.length) {
                $('.auction-list').append(tmpl($('#tmpl-filtered-auction-items').html(), {
                  obj: res.result.auctions,
                  currentAccountId: getAccountId(),
                  currentPage: res.pagination.currentPage
                }));
                refreshAuctions();
                getActiveAuctionsData();
              }

              if (res.pagination.nextPage) {
                nextPageProducts = res.pagination.nextPage + '&currency=' + auctionCurrency;
              } else {
                nextPageProducts = '';
              }
            });

            req.complete(function() {
              ajaxFlag = true;
            })

            req.send();
          }
        }
      }
    }, 200));

    $('.currency-wrap .radio-one-line input').on('click', function() {
      var prevMin = priceRange[auctionCurrency] ? priceRange[auctionCurrency].min : 1;
      var prevMax = priceRange[auctionCurrency] ? priceRange[auctionCurrency].max : 100000;
      var oldCur = getCurrency();
      changeCurrency($(this).val());

      var min = priceRange[auctionCurrency] ? priceRange[auctionCurrency].min : 1,
        max = priceRange[auctionCurrency] ? priceRange[auctionCurrency].max : 100000;

      if (!noSlider) {
        sliderModule.updateSliderMinMax(priceSlider, min, max, priceRange, true, null);
        price = sliderModule.setSliderValue(priceSlider, [min, max]);
        $('#min-slider-input').val(getCurrencyDecmial(min));
        $('#max-slider-input').val(getCurrencyDecmial(max));
        $('#min-slider-input').trigger('change');
        $('#min-slider-input').val('');
        $('#max-slider-input').val('');
      }
      saveAuctionOptions();
      //changeProductsBasedOnLocation();
      changeProductsOverviewPrice(oldCur);
      headerCurrencyChange();
    });

    if (dontShowFilter()) {
      localStorage.removeItem('filterProductAuctionOptionIds');
    }

    if (localStorage.getItem('filterProductAuctionOptionIds') !== null) {
      var filterOptions = JSON.parse(localStorage.getItem('filterProductAuctionOptionIds'));
      // if(filterOptions.currency !== getCurrency()) {
      //   localStorage.removeItem('filterProductAuctionOptionIds')
      //   return;
      // }
      if (filterOptions.url === window.location.pathname) {
        if ('min' in filterOptions && 'max' in filterOptions) {
          if (filterOptions.min != min || filterOptions.max != max) {
            $('.filter-control').trigger('click');
          }
        }

        if (filterOptions.ids && filterOptions.ids.length > 0) {
          var checkedFilters = filterOptions.ids.split(',');
          if (checkedFilters.length) {
            $('.filter-control').trigger('click');
          }

          for (var x = 0; x < checkedFilters.length; x++) {
            $('#' + checkedFilters[x]).prop('checked', true);
          }
        }

        if (filterOptions.min || filterOptions.max) {
          // Min only
          if (filterOptions.min && !filterOptions.max) {
            console.log('MIN ONLY')
            $('#min-slider-input').val(filterOptions.min).trigger('change');
          }
          // Max only
          if (filterOptions.max && !filterOptions.min) {
            console.log('MAX ONLY')
            $('#max-slider-input').val(filterOptions.max).trigger('change');
          }

          // Both Min and Max
          if (filterOptions.max && filterOptions.min) {
            console.log('BOTH MIN AND MAX')
            $('#min-slider-input').val(filterOptions.min);
            $('#max-slider-input').val(filterOptions.max);
            handleAuctionFilter();
          }
        } else {
          filterAuctionSendRequest();
        }
      } else {
        localStorage.removeItem('filterProductAuctionOptionIds');
        eraseCookie('hasProductFilterAuctionOption');
        accountAuctions.defaultSelectedFilter.forEach(function(selectedItem) {
          $('#' + selectedItem).prop('checked', true);
        });
      }
    } else {
      eraseCookie('hasProductFilterAuctionOption');
      accountAuctions.defaultSelectedFilter.forEach(function(selectedItem) {
        $('#' + selectedItem).prop('checked', true);
      });
    }

    /**
     * find this code unnecessary
     */
    // if(!readCookie('hasProductFilterAuctionOption')) {
    //   $('.buy-items').removeClass('hide');
    // }

    changeProductsOverviewPrice();

    // if(readCookie('opened-product-groups')) {
    //   var groupsToShow = readCookie('opened-product-groups').split(',');

    //   $(groupsToShow).each(function(i, id) {
    //     var $target = $('.buy-items .items .product-overview-default-wrap .bottom > table[data-group-id="' + id + '"]')
    //     $target.find('.see-more').closest('tr').remove();
    //     $target.find('.pricing-row').removeClass('hide');
    //   })
    // }
    setTimeout(function() {
      $('.filter-control img#arrow-head').prop('src', $('.filter-control img#arrow-head').prop('src').replace('down', 'up'));
      if ((isLoggedIn() && isMyAuctionPage) || !isMyAuctionPage) {
        filterAuctionSendRequest();
      } else if (!isLoggedIn() && isMyAuctionPage) {
        $(document).trigger('validateAuctionLogin');
      }
    }, 100);
  }

  function getChartData(data) {
    $('.price-info-wrap > .loader').removeClass('hide');
    $('#main-chart').empty();

    var $xhr = $.ajax({
      type: 'GET',
      cache: true,
      crossDomain: true,
      data: data,
      url: servicesUrl + '/spot-chart/getChart',
      dataType: 'json',
      headers: {
        'requestId': uuidv4()
      }
    }).done(function(res) {
      var options = {
        type: 'line',
        width: 320,
        height: 280,
        preserveAspectRatio: 'xMinYMin meet',
        margin: {
          top: 26,
          bottom: 10,
          left: 0,
          right: 0
        },
        withStatistics: true,
        withTimeZone: false,
        withDateCovered: false,
        withLogo: false,
        withLineCursor: true,
        withLineCursorMouseMove: true,
        withHorizontalLinesEnds: true,
        withHorizontalLines: true,
        withVerticalLines: false,
        withVerticalLinesEnds: false,
        withBorder: false,
        gridColor: '#eee',
        cursorPointSize: 5,
        cursorPointColor: '#fcb134',
        cursorPointStrokeColor: '#ba741e',
        lineCursorColor: '#c9934b',
        lineCursorWeight: 1,
        lineCursorDashArray: '6,6',
        fontSize: 12,
        lineCursorBoxHeight: 20,
        lineCursorTextYOffset: 4,
        hasTime: res.hasTime,
        offsetChart: false,
        enableDrag: true,
        timeBoxMarginTop: 1,
        timeBoxBackgroundColor: '#555557',
        timeBoxRight: 25,
        timeBoxWidth: 150,
        timeBoxWidthOffset: 35,
        timeBoxFontColor: '#fff',
        fontColor: '#888a89',
        logoColor: '#888a89',
        timeBoxBorderColor: 'none',
        chartStatsCallback: function(open, low, high, close) {
          $('.price-info-wrap .stats > ._open').html(open);
          $('.price-info-wrap .stats > ._low').html(low);
          $('.price-info-wrap .stats > ._high').html(high);
          $('.price-info-wrap .stats > ._close').html(close);
        },
        dataSeries: [{
          name: 'series1',
          area: true,
          color: 'transparent',
          lineColor: '#e5a158',
          lineWidth: '3',
          startDate: res.startDate,
          data: res.dataSeries,
          numDecimals: res.numDecimals,
        }]
      }
      $('#main-chart').html('');
      $('#main-chart').bstarchart(options);
      $('#main-chart').append('<p class="chart-footnote">The chart illustrates the historical purchasing price for one item of this product</p>');
    }).fail(function(res) {
      console.log(res);
    }).always(function() {
      $('.price-info-wrap > .loader').addClass('hide');
    });
    return $xhr;
  }

  function loadSearchPage() {
    var urlParams = getUrlVars(); // Storage of URL params
    $('#txt-header-search').val(urlParams?.q ? decodeURIComponent(urlParams.q) : '');
    $('#txt-header-search').data('silent', urlParams?.s ? decodeURIComponent(urlParams.s) : '');

    var productCount = 40,
      searchFlag = true, // Used to make sure that only 1 Ajax call is at a time is being used when scrolling down to next page
      nextPageArticles = '', // Storage of next page url for articles
      nextPageVideos = '', // Storage of next page url for videos 
      hasInitialProduct = false, // Used to check if refine button should be hidden
      initialProduct, // Storage of initial product
      queryStr = $('#txt-header-search').val() || urlParams.q,
      availability = ('available' in urlParams && urlParams.available == 'true') ? '&availability=4' : '';

    function useSilentSearchParam() {
      var str = '';
      var s = $('#txt-header-search').data('silent');
      if (s != null && s.length > 0) {
        str = s;
      }
      return str;
    }

    if (!queryStr || queryStr.length == 0) { // handle silent search urls.
      queryStr = useSilentSearchParam();
    }

    if ('s' in urlParams) {
      queryStr = useSilentSearchParam();
    }

    var showAvailable = $('#show-in-stock')[0].checked = availability;

    var popupLoading = new Loading();

    // DEV NOTE: Not used anymore, moved to common_desktop.js
    function updateProductResult() {
      searchModule.productFilter({
        count: 40,
        query: queryStr
      }, function(res) {
        setFilterHeaderCount(res.pagination.totalCount)
        if (res.result.products.length) {
          $('.search-result-product').html(tmpl($('#tmpl-home-product').html(), {
            obj: res.result.products,
            time: res.time,
            rank: false
          }));
          productModule.startPromoTimers();
        } else {
          $('.search-result-product').html('<p class="no-result">We\'re sorry. We cannot find any matches for your search term.</p>');
        }
      });
    }

    function getSearchProductsOnly(query, showAvailable) {
      query = query || '';
      $('.search-result .search-result-product').remove();

      var loading = new Loading()
      loading.render();

      var data = {
        count: ('s' in urlParams) ? 1000 : productCount,
        query: query,
        sortType: 'search'
      };

      if (showAvailable) {
        data.availability = 4;
      }

      var getProducts = searchModule.productFilter(data, function(res) {
        setFilterHeaderCount(res.pagination.totalCount)
        $('.search-result').append(tmpl($('#tmpl-search-page-product').html(), res));
        $('.search-result .search-result-product').removeClass('hide');
        productModule.startPromoTimers();
        nextPageSearchProducts = res.pagination.nextPage;
        loading.close();
      }, null, null, true);
    }

    function getSearchResult(query, showAvailable) {
      // Defaults
      query = query || '';
      options = '';
      searchFlag = false;

      $('.search-result').empty();
      $('.search-result-nav li').removeClass('active');

      var data = {
        count: ('s' in urlParams) ? 1000 : productCount,
        query: query,
        sortType: 'search'
      };

      if (showAvailable) {
        data.availability = 4;
      }

      var getProducts = searchModule.productFilter(data, function(res) {
        setFilterHeaderCount(res.pagination.totalCount)
        $('.search-result').append(tmpl($('#tmpl-search-page-product').html(), res));
        productModule.startPromoTimers();
      }, null, null, true);

      var getArticles = searchModule.blog({
        count: productCount,
        query: query
      }, function(res) {
        $('.search-result').append(tmpl($('#tmpl-search-page-article').html(), res));
      }, null, null, true);

      var getVideos = searchModule.video({
        count: productCount,
        query: query
      }, function(res) {
        $('.search-result').append(tmpl($('#tmpl-search-page-video').html(), res));
      }, null, null, true);

      searchModule.stats({
        accountId: getAccountId(),
        ref: 'SEARCH_PAGE_LOAD',
        urlBase64: '',
        query: query
      });

      $.when(getProducts, getArticles, getVideos).then(function(products, articles, videos) {
        if (products[0].result.products.length) {
          hasInitialProduct = true;
          $('.search-result-nav .products').addClass('active');
          $('.search-result .search-result-product').removeClass('hide');
        } else if (articles[0].result.length) {
          $('.filtering').addClass('hide');
          $('.search-result-nav .articles').addClass('active');
          $('.search-result .search-result-article').removeClass('hide');
        } else if (videos[0].result.length) {
          $('.filtering').addClass('hide');
          $('.search-result-nav .videos').addClass('active');
          $('.search-result .search-result-video').removeClass('hide');
        } else {
          hasInitialProduct = false;
          $('.search-result-nav .products').trigger('click');
        }

        // Store next page products
        if (products[0].pagination.nextPage.length) {
          nextPageSearchProducts = products[0].pagination.nextPage;
          console.log(nextPageSearchProducts)
        } else {
          nextPageSearchProducts = '';
        }

        // Store next page articles
        if (articles[0].pagination.nextPage.length) {
          nextPageArticles = articles[0].pagination.nextPage;
        } else {
          nextPageArticles = '';
        }

        // Store next page videos
        if (videos[0].pagination.nextPage.length) {
          nextPageVideos = videos[0].pagination.nextPage;
        } else {
          nextPageVideos = '';
        }

        popupLoading.close();
        searchFlag = true;

        if (!query) {
          $('.search-result-nav .products').trigger('click');
        }

        if (readCookie('search-nav')) {
          $('.search-result-nav ul li.' + readCookie('search-nav')).trigger('click');
        }
      });
    }

    if (queryStr.length > 0) {
      popupLoading.render();
      getSearchResult(queryStr, showAvailable);
    }

    $('.currency-wrap .radio-one-line input').off('click');

    $('.currency-wrap .radio-one-line input').on('click', function() {
      var oldCur = getCurrency();
      changeCurrency($(this).val());
      changeSearchOverviewPrice(oldCur);
      headerCurrencyChange();
    });

    //$('#header-location').on('change', updateProductResult);

    $('.wrap-body').on('click', '.search-result-nav ul li', function(e) {

      var _this = $(this),
        target = _this.attr('class');

      $('.search-result').children().addClass('hide');
      $('.search-result-nav ul li').removeClass('active');
      _this.addClass('active');

      if (_this.hasClass('articles')) {
        $('.search-result-article').removeClass('hide');
        $('.search-page-wrap .filtering').addClass('hide');
        createCookie('search-nav', 'articles', 1);
      } else if (_this.hasClass('products')) {
        $('.search-result-product').removeClass('hide');
        $('.search-page-wrap .filtering').removeClass('hide');
        createCookie('search-nav', 'products', 1);
      } else if (_this.hasClass('videos')) {
        $('.search-result-video').removeClass('hide');
        $('.search-page-wrap .filtering').addClass('hide');
        createCookie('search-nav', 'videos', 1);
      }
    });

    $('#show-in-stock').on('click', function() {
      filterInStock($(this)[0].checked);
    });

    function filterInStock(showAvailable) {
      var query = 's' in urlParams ? useSilentSearchParam() : ($('#txt-header-search').val() || urlParams.q);
      var paramToUse = 's' in urlParams ? 's' : 'q'; // s = silent (will not write query to search input), q = normal

      if ('history' in window && showAvailable) {
        window.history.replaceState({}, 'search', '?' + paramToUse + '=' + query + '&available=true');
      } else {
        window.history.replaceState({}, 'search', '?' + paramToUse + '=' + query);
      }
      getSearchProductsOnly(query, showAvailable);

      var searchParams = new URLSearchParams(nextPageSearchProducts);
      if (showAvailable) {
        if (searchParams.has('availability')) return;
        searchParams.append('availability', 4);
      } else {
        searchParams.delete('availability');
      }
      // console.log(decodeURIComponent(searchParams.toString()))
      // if(nextPageSearchProducts) {
      //   nextPageSearchProducts = decodeURIComponent(searchParams.toString())
      // }
    }

    // Update search products after click shopping cart back
    /*$(document).on('click', '.page-wrap .back', function() {
      $.ajax({
        url: '/search/v1/product/?language=EN' + defaultAPIParams + $('#txt-header-search').val()
      }).done(function(res) {
        setFilterHeaderCount(res.pagination.totalCount);
        $('.search-result-product').remove();
        $('.search-result').append(tmpl($('#tmpl-search-page-product').html(), res));
        $('.search-result-product').removeClass('hide');
        productModule.startPromoTimers();
      });
    });*/

    $('.wrap-body').on('click', '.search-result .video', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var id = $(this).data('id'),
        src = 'https://www.youtube.com/embed/' + id + '?rel=0&autoplay=1';

      var popup = new PopupYoutube(src);
      popup.render();

      var options = {
        accountId: getAccountId(),
        ref: 'SEARCH_PAGE_CLICK',
        urlBase64: btoa($(this).data('url')),
        query: $('#txt-header-search').val()
      };

      searchModule.stats(options);
    });

    $('.wrap-body').on('click', '.search-result .article', function(e) {
      e.preventDefault();
      var options = {
        accountId: getAccountId(),
        ref: 'SEARCH_PAGE_CLICK',
        urlBase64: btoa($(this).data('url')),
        query: $('#txt-header-search').val()
      };

      searchModule.stats(options, function(res) {
        if (res.url) {
          window.location.href = res.url;
        }
      });
    });

    $('.wrap-body').on('click', '.search-result .product-search header', function(e) {

      // Save to cookie
      // ---------------
      // Account ID
      // Ref
      // Url
      // Query
      var _this = $(this);

      var stats = getAccountIdParameter() + '&ref=SEARCH_PAGE_CLICK&url=' + encodeURIComponent(_this.data('url')) + '&query=' + encodeURIComponent($('#txt-header-search').val());

      eraseCookie('send-stat-params');
      createCookie('send-stat-params', stats, 1);

      window.location.href = _this.data('url');
    });

    $('.wrap-body').on('click', '.search-result .product-promo-wrap .info', function(e) {

      // Save to cookie
      // ---------------
      // Account ID
      // Ref
      // Url
      // Query
      var _this = $(this);

      var stats = getAccountIdParameter() + '&ref=SEARCH_PAGE_CLICK&url=' + encodeURIComponent(_this.data('url')) + '&query=' + encodeURIComponent($('#txt-header-search').val());

      eraseCookie('send-stat-params');
      createCookie('send-stat-params', stats, 1);

      window.location.href = _this.data('url');
    });

    /*$('.wrap').on('click', '.search-result .promo-heading', function(e) {
     $(this).next().trigger('click');
    });*/

    $(window).on('scroll', debounce(function() {
      if ($('.search-result-nav .products').hasClass('active')) {
        // Products
        if ($('.product').length) {
          if (isElementInViewport($('.product:last-child'), 1) && nextPageSearchProducts) {
            if (searchFlag) {
              searchFlag = false;
              popupLoading.render();

              console.log('servicesSGUrl(4): ' + nextPageSearchProducts);
              var req = new Request(servicesSGUrl + nextPageSearchProducts, {
                currency: getCurrency()
              });

              req.noApiErrorPopup = true;

              req.success(function(res) {
                nextPageSearchProducts = res.pagination.nextPage;
                if (res.result.products.length) {
                  $('.search-result-product').append(tmpl($('#tmpl-search-product').html(), {
                    obj: res.result.products,
                    time: res.time,
                    rank: false
                  }));
                  productModule.startPromoTimers();
                }
              });

              req.complete(function() {
                searchFlag = true;
                popupLoading.close();
              });

              req.send();

              // $.ajax({
              //   url: nextPageSearchProducts + q + '&currency=' + getCurrency()
              // }).done(function(res) {
              //   nextPageSearchProducts = res.pagination.nextPage;
              //   if(res.result.products.length) {
              //     $('.search-result-product').append(tmpl($('#tmpl-home-product').html(), { obj: res.result.products, time: res.time, rank: false }));
              //     productModule.startPromoTimers();
              //   }
              // }).always(function() {
              //   searchFlag = true;
              //   popupLoading.close();
              // });
            }
          }
        }
      } else if ($('.search-result-nav .articles').hasClass('active')) {
        // Articles
        if ($('.search-result-article .entry').length) {
          if (isElementInViewport($('.search-result-article .entry:last-child'), 1) && nextPageArticles) {
            if (searchFlag) {
              searchFlag = false;
              popupLoading.render();

              console.log('servicesSGUrl(3): ' + nextPageArticles);
              var req = new Request(servicesSGUrl + nextPageArticles, {});

              req.noApiErrorPopup = true;

              req.success(function(res) {
                nextPageArticles = res.pagination.nextPage;
                if (res.result.length) {
                  $.each(res.result, function(i, item) {
                    $('.search-result-article').append(tmpl($('#tmpl-search-page-article-entry').html(), {
                      obj: item
                    }));
                  });
                }
              });

              req.complete(function() {
                searchFlag = true;
                popupLoading.close();
              });

              req.send();

              // $.ajax({
              //   url: nextPageArticles + q
              // }).done(function(res) {
              //   nextPageArticles = res.pagination.nextPage;
              //   if(res.result.length) {
              //     $.each(res.result, function(i, item) {
              //       $('.search-result-article').append(tmpl($('#tmpl-search-page-article-entry').html(), { obj: item }));
              //     });
              //   }
              // }).always(function() {
              //   searchFlag = true;
              //   popupLoading.close();
              // });
            }
          }
        }
      } else if ($('.search-result-nav .videos').hasClass('active')) {
        // Videos
        if ($('.search-result-video .entry').length) {
          if (isElementInViewport($('.search-result-video .entry:last-child'), 1) && nextPageVideos) {
            if (searchFlag) {
              searchFlag = false;
              popupLoading.render();

              console.log('servicesSGUrl(2): ' + nextPageVideos);
              var req = new Request(servicesSGUrl + nextPageVideos, {});

              req.noApiErrorPopup = true;

              req.success(function(res) {
                nextPageVideos = res.pagination.nextPage;
                if (res.result.length) {
                  $.each(res.result, function(i, item) {
                    $('.search-result-video').append(tmpl($('#tmpl-search-page-video-entry').html(), {
                      obj: item
                    }));
                  });
                }
              });

              req.complete(function() {
                searchFlag = true;
                popupLoading.close();
              });

              req.send();

              // $.ajax({
              //   url: nextPageVideos + q
              // }).done(function(res) {
              //   nextPageVideos = res.pagination.nextPage;
              //   if(res.result.length) {
              //     $.each(res.result, function(i, item) {
              //       $('.search-result-video').append(tmpl($('#tmpl-search-page-video-entry').html(), { obj: item }));
              //     });
              //   }
              // }).always(function() {
              //   searchFlag = true;
              //   popupLoading.close();
              // });
            }
          }
        }
      }
    }, 200));

    $('#txt-header-search').on('keypress', function(e) {
      if (e.keyCode === 13) {
        if (searchFlag) {
          var query = $('#txt-header-search').val() || urlParams.q;
          var showInStock = $('#show-in-stock')[0].checked;
          if (showInStock) {
            window.history.replaceState({}, 'search', '?q=' + query + '&available=true');
          } else {
            window.history.replaceState({}, 'search', '?q=' + query);
          }
          getSearchResult($('#txt-header-search').val(), showInStock);
        }
      }
    });

    $('#btn-search-page').on('click', function() {
      if (searchFlag) {
        var query = $('#txt-header-search').val() || urlParams.q;
        var showInStock = $('#show-in-stock')[0].checked;
        if (showInStock) {
          window.history.replaceState({}, 'search', '?q=' + query + '&available=true');
        } else {
          window.history.replaceState({}, 'search', '?q=' + query);
        }
        getSearchResult($('#txt-header-search').val(), showInStock);
      }
    });
  }

  // function updatePriceRangeText(priceSlider) {
  //   var min = sliderModule.getSliderValueMin(priceSlider),
  //       max = sliderModule.getSliderValueMax(priceSlider);

  //   if(getCurrency() === 'BTC') {
  //     $('.price-slider-wrap > .heading').find('.' + getCurrency().toLowerCase()).text(min + ' - ' + max);
  //   } else {
  //     $('.price-slider-wrap > .heading').find('.' + getCurrency().toLowerCase()).text(commaSeparateNumber(min) + ' - ' + commaSeparateNumber(max));
  //   }
  // }

  return {
    loadBuyPage: loadBuyPage,
    loadBuyJewelleryPage: loadBuyJewelleryPage,
    loadAuctionPage: loadAuctionPage,
    getChartData: getChartData,
    loadSearchPage: loadSearchPage,
    changeProductsBasedOnLocation: changeProductsBasedOnLocation,
    changeJewelleryProductsBasedOnLocation: changeJewelleryProductsBasedOnLocation,
    setFilterHeaderCount: setFilterHeaderCount,
    changeProductsOverviewPrice: changeProductsOverviewPrice,
  }
}());

/* Add for mocha testing */
// Basically it make the filterModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = filterModule;
}
/***********************************************************/
/***********************************************************/
/* Reviews Module */
/***********************************************************/
/***********************************************************/

var reviewsModule = (function() {

  /*
    DESC: Get reviews. USED IN: /o/c/ page
    POST /product/v1/order-review/get
  */
  function get(orderId, successCb, errorCb) {
    var req = new Request(servicesUrl + '/product/v1/order-review/get', {
      orderId: orderId
    });

    req.success(function(res) {
      if (res.success) {
        typeof successCb === 'function' && successCb(res);
      }
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.call();
  }

  /*
    DESC: Submit reviews. USED IN: /o/c/ page
    POST /product/v1/order-review/submit
    orderId=KKCLNFIRKQ76737
    reviewTypeId=
    username=test
  */
  function submit(data) {
    var req = new Request(servicesUrl + '/product/v1/order-review/submit', data);

    req.success(function(res) {
      if (res.success) {
        if (res.site === 'Youtube') {
          $('.popup-review-us .type[data-type=' + res.reviewTypeId + ']').html('<h4>Thank you for subscribing to BullionStar\'s YouTube channel</h4><p>We will verify your subscription and add the free product to your order shortly.</p>')
          return;
        }
        if (res.otherSite) {
          $('.popup-review-us .type[data-type=' + res.reviewTypeId + ']').html('<h4>Thank you for reviewing BullionStar on ' + res.site + '! </h4><p>We will verify your review and add the free product to your order shortly. Please note that you can get another FREE product if you review us on ' + res.otherSite + ' if you haven’t done so already.</p>')
        } else {
          $('.popup-review-us .type[data-type=' + res.reviewTypeId + ']').html('<h4>Thank you for reviewing BullionStar on ' + res.site + '! </h4><p>We will verify your review and add the free product to your order shortly.</p>')
        }
      }
    });

    req.error(function(res) {
      var popup = new Popup({
        title: res.title,
        message: res.message
      });
      popup.render();
    });

    req.call();
  }

  return {
    get: get,
    submit: submit,
  }
}());

/* Add for mocha testing */
// Basically it make the reviewsModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = reviewsModule;
}
/***********************************************************/
/***********************************************************/
/* Search Module */
/***********************************************************/
/***********************************************************/

var searchModule = (function() {
  var language = 'EN';

  function productGroupFilter(data, successCb, errorCb, completeCb, getXHR) {
    var data = data || {};
    data.currency = getCurrency();
    data.locationId = getLocation();
    data.apg = getApgId();
    data.language = language;

    var min = data.min || 0;
    var max = data.max || 0;

    if (min <= priceRange[getCurrency()].min) {
      delete data.min;
    }
    if (max >= priceRange[getCurrency()].max) {
      delete data.max;
    }

    var req = new Request(servicesUrl + '/product/filter/desktop', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      typeof successCb === 'function' && successCb(res);
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.complete(function(res) {
      typeof completeCb === 'function' && completeCb(res);
    });

    req.send();

    if (getXHR) {
      return req.xhr;
    }
  }

  function productFilter(data, successCb, errorCb, completeCb, getXHR) {
    var data = data || {};
    data.currency = getCurrency();
    data.locationId = getLocation();
    data.apg = getApgId();
    data.language = language;
    data.sessionId = sessionModule.getSessionId();
    data.machineId = getMachineId();

    if (window.location.pathname !== '/search/') {
      var min = data.min || 0;
      var max = data.max || 0;

      if (min <= priceRange[getCurrency()].min) {
        delete data.min;
      }
      if (max >= priceRange[getCurrency()].max) {
        delete data.max;
      }
    }

    var req = new Request(servicesUrl + '/product/v1/product/search', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      typeof successCb === 'function' && successCb(res);
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.complete(function(res) {
      typeof completeCb === 'function' && completeCb(res);
    });

    req.send();

    if (getXHR) {
      return req.xhr;
    }
  }

  function getProduct(data, successCb, errorCb, completeCb, getXHR) {
    var data = data || {};
    data.currency = getCurrency();
    data.locationId = getLocation();
    data.apg = getApgId();
    data.language = language;

    var req = new Request(servicesUrl + '/product/filter/get', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      typeof successCb === 'function' && successCb(res);
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.complete(function(res) {
      typeof completeCb === 'function' && completeCb(res);
    });

    req.send();

    if (getXHR) {
      return req.xhr;
    }
  }

  function blog(data, successCb, errorCb, completeCb, getXHR) {
    var data = data || {};
    data.currency = getCurrency();
    data.locationId = getLocation();
    data.apg = getApgId();
    data.language = language;

    var req = new Request(servicesUrl + '/product/v1/blog/search', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      typeof successCb === 'function' && successCb(res);
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.complete(function(res) {
      typeof completeCb === 'function' && completeCb(res);
    });

    req.send();

    if (getXHR) {
      return req.xhr;
    }
  }

  function video(data, successCb, errorCb, completeCb, getXHR) {
    var data = data || {};
    data.locationId = getLocation();
    data.language = language;

    var req = new Request(servicesUrl + '/product/v1/video/search', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      typeof successCb === 'function' && successCb(res);
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.complete(function(res) {
      typeof completeCb === 'function' && completeCb(res);
    });

    req.send();

    if (getXHR) {
      return req.xhr;
    }
  }

  function stats(data, successCb, errorCb, completeCb) {
    var data = data || {};
    data.language = language;
    data.sessionId = sessionModule.getSessionId();

    var req = new Request(servicesUrl + '/search/v1/stat', data);
    req.noApiErrorPopup = true;

    req.success(function(res) {
      typeof successCb === 'function' && successCb(res);
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.complete(function(res) {
      typeof completeCb === 'function' && completeCb(res);
    });

    req.send();
  }

  function jewellery(data, successCb, errorCb, completeCb, getXHR) {
    var data = data || {};
    data.currency = getCurrency();
    data.locationId = getLocation();
    data.apg = getApgId();
    data.language = language;

    var req = new Request(servicesUrl + '/product/jewellery/search/filter', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      typeof successCb === 'function' && successCb(res);
    });

    req.error(function(res) {
      typeof errorCb === 'function' && errorCb(res);
    });

    req.complete(function(res) {
      typeof completeCb === 'function' && completeCb(res);
    });

    req.send();

    if (getXHR) {
      return req.xhr;
    }
  }

  return {
    productGroupFilter: productGroupFilter,
    productFilter: productFilter,
    getProduct: getProduct,
    blog: blog,
    video: video,
    stats: stats,
    jewellery: jewellery
  }

}());

/* Add for mocha testing */
// Basically it make the searchModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = searchModule;
}
var twitterModule = (function() {
  function init() {
    var currentPage = 1;
    getTweets(currentPage);

    $('.twitter-timeline').on('click', '.tweet', function() {
      window.open($(this).data('tweet-link'), '_blank', 'noopener,noreferrer');
    });

    $('.twitter-timeline').on('click', '.tweet a', function(event) {
      event.stopPropagation();
    });

    $('.twitter-timeline').on('scroll', debounce(function() {
      if (($(this)[0].scrollHeight * 0.7) <= $(this).scrollTop() + $(this).height()) {
        if (!$('.twitter-timeline').find('.view-more').length) {
          getTweets(++currentPage);
        }
      }
    }, 300));

    $('.twitter-timeline').on('click', '.tweet-video', function(event) {
      event.stopPropagation();
      $(this).find('img').addClass('hide');
      $(this).find('video').removeClass('hide');
      $(this).find('video').get(0).play();
    });
  }

  function getTweets(page = 1, size = 20) {
    var req = new JsonRequest(servicesUrl + '/tweets/list?page=' + page + '&pageSize=' + size, {}, false, 'GET');

    req.success(function(res) {
      if (res.success) {
        if (!$('.twitter-timeline').find('.view-more').length) {
          $('.twitter-widget .twitter-timeline').append(tmpl($('#tmpl-tweet').html(), {
            obj: res.items
          }));
        }

        $('.twitter').removeClass('is-loading');
      }
    });

    req.error(function(res) {
      console.log(res)
    });

    req.send();
  }

  function addLinksToText(text, urls, hashtags) {
    if (!urls) return addHashtagsToText(text, hashtags);

    // Sort URLs by start index in descending order to avoid messing up indices while replacing
    urls.sort((a, b) => b.start - a.start);

    urls.forEach(url => {
      const link = `<a href="${url.expandedUrl}" target="_blank" rel="noopener noreferrer">${url.displayUrl}</a>`;
      text = text.slice(0, url.start) + link + text.slice(url.end);
    });

    return addHashtagsToText(text, hashtags);
  }

  function addHashtagsToText(text, hashtags) {
    if (!hashtags) return text;
    hashtags.forEach(hashtag => {
      text = text.replace('#' + hashtag.tag, `<a href="https://twitter.com/hashtag/${hashtag.tag}" target="_blank" rel="noopener noreferrer">#${hashtag.tag}</a>`);
    });
    return text;
  }

  return {
    init: init,
    getTweets: getTweets,
    addLinksToText: addLinksToText,
    addHashtagsToText: addHashtagsToText,
  };
}());
var sessionModule = (function() {
  function getSessionId(registerAsync) {
    if (typeof registerAsync === 'undefined') {
      registerAsync = true;
    }

    var sessionId = readCookie('session-id');
    if (!sessionId) {
      sessionId = createSessionId(registerAsync);
      if (sessionId.length > 0) {
        createCookie('session-id', sessionId);
      }
    }

    return sessionId;
  }

  function registerPageViewLoad(registerAsync) {
    if (typeof registerAsync === 'undefined') {
      registerAsync = true;
    }

    var sessionId = getSessionId(registerAsync);
    registerPageView(sessionId, window.location.href);

  }

  function createSessionId(registerAsync) {
    var tag = getTag();
    // if (tag.length == 0) {
    //   return ''; // No tag, do not register.
    // }

    history.pushState(null, document.title, window.location.pathname + window.location.search); // Remove tag from hash.

    var sessionId = null;
    if (self?.crypto?.randomUUID) {
      sessionId = self.crypto.randomUUID();
      console.log('createSessionId using crypto method result: ' + sessionId);
    } else {
      var sessionId = generateUUIDFallback();
      console.log('createSessionId using fallback method result: ' + sessionId);
    }

    if (registerAsync) {
      registerSessionIdAsync(sessionId, tag);
    } else {
      registerSessionId(sessionId, tag);
    }

    return sessionId;
  }

  function registerSessionIdAsync(sessionId, tag) {
    registerSessionId(sessionId, tag);
  }

  async function registerSessionId(sessionId, tag) {
    try {
      const response = await new Request(servicesUrl + '/account/session/create', {
        sessionId: sessionId,
        tag: tag.name,
        campaign: tag.campaign,
        referrerUrl: document.referrer
      }).send();

      registerPageView(sessionId, window.location.href);
    } catch (error) {
      console.error('registerSessionId error: ' + error);
    }
  }

  function registerPageView(sessionId, url) {
    var productId = '';
    if (/\/buy\/product?/.test(window.location.pathname)) {
      if (!isMobile) {
        productId = $('#btn-add-to-cart').length ? $('#btn-add-to-cart').data('id') : $('.btn-email-notif').data('id');
        // productId = $('.product-detail-wrap.main-page').data('product-id');
      } else {
        productId = $('.product-details .items').data('product-id');
      }

      if (productId === undefined || productId === null) {
        productId = '';
      }
    }

    navigator.sendBeacon(servicesUrl + '/account/session/beacon/page-view', JSON.stringify({
      sessionId: sessionId,
      locationId: getLocation(),
      url: url,
      machineId: getMachineId(),
      productId: productId
    }));
  }

  function registerClick(url, destination, productId, clickPosition, queryId) {
    var dest = '';
    if (destination) {
      dest = destination;
    }

    var pid = '';
    if (productId) {
      pid = productId;
    }

    var cp = -1;
    if (clickPosition) {
      cp = clickPosition;
    }

    var qid = '';
    if (queryId) {
      qid = queryId;
    }

    navigator.sendBeacon(servicesUrl + '/account/session/beacon/click', JSON.stringify({
      sessionId: getSessionId(),
      locationId: getLocation(),
      url: url,
      machineId: getMachineId(),
      dest: dest,
      productId: pid,
      cp: cp,
      qid: qid,
    }));
  }

  function getTag() {
    var tag = {
      name: "",
      campaign: ""
    };

    if (window.location.hash) {
      var h = '' + window.location.hash;
      console.log("h.indexOf('=')=" + h.indexOf('=') + " h=" + h);
      if (!isLowerCase(h) && h.indexOf('=') == -1) { // Lowercase is for internal anchors and lets avoid various hash for location switch.
        console.log('h is OK: ' + h);
        tag.name = h;
        return tag;
      }
    }

    var gcampaignid = getGoogleCampaignIdentifier();
    if (gcampaignid && gcampaignid.length > 0) {
      var gclid = getGoogleClickIdentifier();
      tag.name = "GLAD:" + gclid;
      tag.campaign = gcampaignid;
      return tag;
    }

    var msad = getMicrosoftIdentifier();
    if (msad && msad.length > 0) {
      tag.name = "MSAD:" + msad;
      return tag;
    }

    return tag;
  }

  //gclid
  function getGoogleClickIdentifier() {
    return new URLSearchParams(window.location.search).get('gclid');
  }

  function getGoogleCampaignIdentifier() {
    return new URLSearchParams(window.location.search).get('gad_campaignid');
  }

  //utm_content 
  function getMicrosoftIdentifier() {
    return new URLSearchParams(window.location.search).get('utm_content');
  }

  function isLowerCase(str) {
    return str === str.toLowerCase() && str !== str.toUpperCase();
  }

  function generateUUIDFallback() { // used if crypto is not available.
    // Get current time in milliseconds
    var d = new Date().getTime();

    // Define the UUID template with placeholder characters
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";

    // Replace the placeholders with random hexadecimal digits
    uuid = uuid.replace(/[xy]/g, function(c) {
      // Generate a random number between 0 and 15
      var r = (d + Math.random() * 16) % 16 | 0;

      // Update value of d for the next placeholder
      d = Math.floor(d / 16);

      // Convert the number to a hexadecimal digit and return it
      return (c == "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });

    return uuid;
  }

  return {
    getSessionId: getSessionId,
    registerPageViewLoad: registerPageViewLoad,
    registerClick: registerClick
  }
}());

/* Add for mocha testing */
// Basically it make the sessionModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = sessionModule;
}
(function($) {
  var tncTitle = '',
    tncContent = '',
    tncAffiliateTitle = '',
    tncAffiliateContent = '',
    shoppingCartPlus1Flag;

  window.stringContainerCreds = {
    e: '',
    p: ''
  };

  if ($('.main-header').length > 0) {
    var alwaysCb = null;
    if (window.location.pathname === '/myaccount/dashboard') {
      alwaysCb = dashboardInit;
    } else if (window.location.pathname === '/myaccount/photos') {
      alwaysCb = photosInit;
    } else if (window.location.pathname === '/myaccount/storagecharges') {
      alwaysCb = storageChargesInit;
    } else if (window.location.pathname === '/myaccount/transactions') {
      alwaysCb = transactionsInit;
    } else if (window.location.pathname === '/setalerts') {
      alwaysCb = setAlertsInit;
    }

    accountModule.getInfo(null, alwaysCb);
    // Don't run shoppingCartModule.load() when .cart is not visible
    if (!$('.main-header .cart').hasClass('invisible')) {
      shoppingCartModule.load();
    }
  }

  $('.product > .link').on('click', function(e) {
    var url = $(this).data('url');
    if (e.metaKey) {
      window.open(url, '_blank').focus();
      return;
    }

    window.location.href = url;
  });

  // reactChromeHeader: the hydrated header owns sticky-scroll + mega-menu hover
  // (components/chrome/HeaderBehaviors.jsx), so skip the legacy versions here to
  // avoid double-binding. (Desktop has no announcement markup in the header.)
  if ($('.main-header').length > 0 && !window.reactChromeHeader) {
    getAnnouncement();

    // /*
    // Sticky header on window scroll
    var headerHeight = $('.wrap-header').outerHeight(true);
    // var mainContentHeight = mainContent.offsetHeight;
    var bodyPositionTop = 0;
    var scrollPosition = window.scrollY;
    // var footerPositionTop = 0;

    // window.addEventListener('resize', function() {
    //   $('.wrap-body').css({width: $('.main-header').width() });
    // });

    $('html').css({
      scrollPaddingTop: ($('.main-header').outerHeight(true) + 20) + 'px'
    });

    window.onscroll = function() {
      if (!$('body').hasClass('openedSubMenu')) {
        bodyPositionTop = $('.wrap-body')[0].getBoundingClientRect().top;
        // footerPositionTop = $('.main-footer')[0].getBoundingClientRect().top;
        scrollPosition = window.scrollY;
        if (scrollPosition > 0) {
          $('body').addClass("sticky");
          $('.wrap-body').css({
            paddingTop: $('.main-header').outerHeight(true) + 'px'
          });
          bodyPositionTop = $('.wrap-body')[0].getBoundingClientRect().top;
        } else {
          $('body').removeClass("sticky");
          $('.wrap-body').css({
            top: 0
          });
          $('.wrap-body').css({
            paddingTop: 0
          });
          // $('html').css({scrollPaddingTop: 0});
        }
      } else {
        if ($('body').hasClass('sticky')) {
          $('.wrap-body').css({
            top: bodyPositionTop + 'px'
          });
          // $('.main-footer').css({top: footerPositionTop - 20 + 'px'});
        }
      }
    };

    $('.nav .menu-first').on("mouseenter", function() {
      $('body').addClass('openedSubMenu');
      if ($('body').hasClass('sticky')) {
        window.scroll({
          top: 0,
          left: 0
        });
      }
    });

    $('.nav .menu-first').on("mouseleave", function() {
      $('body').removeClass('openedSubMenu');
      if ($('body').hasClass('sticky')) {
        window.scroll({
          top: scrollPosition,
          left: 0
        });
      } else {
        if (window.scrollY > 0) {
          $(window).scroll();
        }
      }
    });
    // */
  }

  {
    var mobileShowDesktop = readCookie('mobileShowDesktop');
    if (mobileShowDesktop) {
      document.getElementById('back-to-mobile-wrap').innerHTML = '<a href="javascript:void()" id="back-to-mobile">Return to Mobile Site</a>';
    }
  }

  // Run in home
  // Run in AutoInvest page
  // LTO sidebar is available
  if (window.location.pathname === '/' || window.location.pathname === '/autoinvest' || $('.sidebar .product-promo-wrap').length) {
    // Get home products prices (Most Ordered in 7 days, Recommended Products) every 30 sec or LTO
    setInterval(function() {
      if (!document.hidden) {
        productModule.getProductPrice(getAllProductIdsArr(), getCurrency());
      }
    }, 30000);
  }

  // [web-core] Skip when the X timeline is the hydrated React TwitterLive widget.
  if ($('.sidebar > .twitter-widget:not([data-react-twitter])').length) {
    twitterModule.init();
  }

  // Run if promo sidebar is available in the page
  // if($('.sidebar .product-promo-wrap').length) {
  //   setInterval(runPromoCall, 30000)
  // }

  // Run if shopping cart has a value
  if ($('#shopping-cart-count').text() > 0) {
    setInterval(function() {
      if (!document.hidden) {
        shoppingCartModule.refresh();
      }
    }, 30000);
  }
  // ...
  // For Menus
  // ...

  /*function hideMenu() {
    $('.menu-third-wrap').addClass('hide');
    $('.menu-first .toggle').removeClass('active');
  }*/

  /*$('.main-menu').on('click', function(e) {
    e.stopPropagation();
    // var _this = $(this);
    // _this.find('.menu').toggleClass('hide');
  });

  $('.menu-first > li > a').on('click', function(e) {
    e.stopPropagation();
    // var _this = $(this);
    // _this.next().toggleClass('hide');
  });

  $('.menu-first .toggle').on('click', function(e) {
    e.stopPropagation();
  });
  
  $('.menu-first .toggle').on('mouseover', function(e) {
    var _this = $(this),
        target = _this.data('target');

    $('.menu-first .toggle').removeClass('active');
    _this.addClass('active');

    $('.menu-third-wrap').addClass('hide');
    $('.menu-third-wrap[data-index=' + target + ']').removeClass('hide');
  }).on('mouseout', function(e) {
    if($('.menu-third-wrap:hover').length) return;
    $('.menu-third-wrap').addClass('hide');
    $('.menu-first .toggle').removeClass('active');
  });

  $('.menu-third-wrap').on('mouseout', function(e) {
    if($('.menu-third-wrap:hover').length) return;
    $('.menu-third-wrap').addClass('hide');
    $('.menu-first .toggle').removeClass('active');
  });*/

  //$(document).on('click', hideMenu);
  // ...

  // Focus
  $('.form-field input, .form-field textarea').on('focus', function(e) {
    var _this = $(this);
    _this.parents('.form-field').find('label').addClass('active');
    _this.parent().addClass('focus');
  });

  // Blur
  $('.form-field input, .form-field textarea').on('blur', function(e) {
    var _this = $(this);
    if (!_this.val()) {
      _this.prev().removeClass('active');
    }
    _this.parent().removeClass('focus');
  });

  // Click
  $(document).on('click', '.form-field label', function(e) {
    var _this = $(this);
    if ($(this).parent().hasClass('show-label')) return;
    _this.addClass('active');
    _this.next().trigger('focus');
  });

  // Focus
  $(document).on('focus', '.form-field input, .form-field textarea', function(e) {
    var _this = $(this);
    _this.parents('.form-field').find('label').addClass('active');
    _this.parents('.form-field').addClass('focus');
  });

  // Blur
  $(document).on('blur', '.form-field input, .form-field textarea', function(e) {
    var _this = $(this);
    if (!_this.val()) {
      _this.prev().removeClass('active');
    }
    _this.parents('.form-field').removeClass('focus');
  });

  $('body').on('change', '.country-code-selection', function(e) {
    e.stopPropagation();

    var _this = $(this);
    // Set Flag
    _this.prev().find('> .flag').removeClass(function(i, className) {
      $(this).removeClass(className);
    }).addClass('flag flag-' + _this.find('option:selected').data('country'));

    // Set Country code
    _this.prev().find('> .code').text('+' + _this.find('option:selected').data('code'));
  });

  $('body').on('change blur', '.bullion-select.with-flag select', function(e) {
    var _this = $(this);
    var v = _this.val();
    if (v) {
      _this.parent('.with-flag').find('> .flag').removeClass(function(i, className) {
        $(this).removeClass(className);
      }).addClass('flag flag-' + v.toLowerCase());
    }
  });

  $('#btn-login').on('click', function() {
    /*console.log($(this).parent());
    formValidationModule.validateForm($(this).parent(), 'Login', function(data) {
      console.log(data);
      authenticationModule.login(data, null);
    }, null, true);*/
    var login = new PopupLogin();
    login.render();
  });

  $('.logout').on('click', function() {
    authenticationModule.logout();
  });

  // Show radio button description
  $('.wrap-body').on('click', '.lbl-for-rdo-with-desc', function() {
    var parent = $(this).data('parent') || 'payment'; // Default is payment
    $('.' + parent + ' .radio-description').addClass('hide');
    $(this).parent().next('.radio-description').removeClass('hide');
  });

  $(document).on('click', '.btn-close-popup', function() {
    $('.backdrop1').remove();
  });

  $(document).on('keypress', '.form-wrap input', function(e) {

    if (e.keyCode == 13) {
      var action = $(this).data('enter-action');
      if (action != null) {
        $(action).trigger('click');
      }
    }
  });

  // Open Tnc anywhere
  $(document).on('click', '.open-tnc', function(e) {
    e.preventDefault();
    var _this = $(this);
    if (tncTitle.length === 0 && tncContent.length === 0) {
      // var loading = new Loading();
      // loading.render();

      var req = new Request(servicesUrl + '/help/search/tnc', {
        language: language,
        target: 'd'
      });

      req.success(function(res) {
        tncTitle = res.contentTitle;
        tncContent = res.contentHtml;
        var popup = new PopupTNC(tncTitle, tncContent);
        popup.render();

        if (_this.data('nz')) {
          setTimeout(function() {
            var $target = $('.popup-tnc .body');
            $target.animate({
              scrollTop: $target[0].scrollHeight - $target[0].clientHeight
            }, 200);
          }, 100)
        }
      });

      req.call();

      // $.ajax({
      //   url: '/api/v1/data/tnc?language=EN&target=d'
      // }).done(function(res) {
      //   loading.close();
      //   tncTitle = res.contentTitle;
      //   tncContent = res.contentHtml;
      //   var popup = new PopupTNC(tncTitle, tncContent);
      //   popup.render();
      // }).fail(function(res) {
      //   console.log(res);
      // }).always(function(res) {
      //   loading.close();
      // });
    } else {
      var popup = new PopupTNC(tncTitle, tncContent);
      popup.render();

      if (_this.data('nz')) {
        setTimeout(function() {
          var $target = $('.popup-tnc .body');
          $target.animate({
            scrollTop: $target[0].scrollHeight - $target[0].clientHeight
          }, 200);
        }, 100)
      }
    }
  });

  // Open Affiliate Tnc anywhere
  $(document).on('click', '.open-tnc-affiliate', function(e) {
    e.preventDefault();
    var _this = $(this);
    if (tncAffiliateTitle.length === 0 && tncAffiliateContent.length === 0) {
      var req = new Request(servicesUrl + '/help/search/tnc-affiliate', {
        language: language,
        target: 'd'
      });

      req.success(function(res) {
        tncAffiliateTitle = res.contentTitle;
        tncAffiliateContent = res.contentHtml;
        var popup = new PopupTNC(tncAffiliateTitle, tncAffiliateContent);
        popup.render();

        if (_this.data('nz')) {
          setTimeout(function() {
            var $target = $('.popup-tnc .body');
            $target.animate({
              scrollTop: $target[0].scrollHeight - $target[0].clientHeight
            }, 200);
          }, 100)
        }
      });

      req.call();
    } else {
      var popup = new PopupTNC(tncAffiliateTitle, tncAffiliateContent);
      popup.render();

      if (_this.data('nz')) {
        setTimeout(function() {
          var $target = $('.popup-tnc .body');
          $target.animate({
            scrollTop: $target[0].scrollHeight - $target[0].clientHeight
          }, 200);
        }, 100)
      }
    }
  });

  $(document).on('click', '.show-other-fields', function() {
    var _this = $(this);

    _this.next().toggleClass('hide');
    _this.find('.image').toggleClass('active');
  });

  $(document).on('keyup', '.trigger-show-other-field', function() {
    var _this = $(this),
      // .tab-fields for user creation .joint for /myaccount/details
      $parent = _this.parents('.tab-fields').length ? _this.parents('.tab-fields') : _this.parents('.joint');

    if (parseInt(_this.val().trim().length)) {
      $parent.find('.form-field').not('.state-form-select-field').removeClass('hide');
      _this.addClass('txt-required');
      if ($parent.find('.state-form-select-field').next().find('.country-select').val() === 'US') {
        $parent.find('.state-form-select-field').removeClass('hide');
        $parent.find('.state-form-field').addClass('hide');
      }
    } else {
      $parent.find('.form-field').addClass('hide');
      _this.parent('.form-field').removeClass('hide');
      _this.removeClass('txt-required');
    }
  });

  $(document).on('input change', '.txt-number', function(e) {
    var old = e.target.value;
    var clean = e.target.value.replace(/[^0-9]/g, '');
    if (old != clean) {
      $(e.target).val(clean);
    }
  });

  /*$(document).on('keypress', '.txt-number', function(e) {
    var key = e.charCode || e.keyCode;
    return key >= 48 && key <= 57;
  });*/

  $(document).on('keypress keydown', '.txt-number', function(e) {
    var key = e.charCode || e.keyCode || 0;
    // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
    // home, end, period, and numpad decimal
    // add 190 to allow decimal

    // console.log('charCode: ' + e.charCode + ' keyCode: ' + e.keyCode);

    // if(e.shiftKey) {
    //   e.preventDefault();
    //   return;
    // }

    return (
      key == 8 ||
      key == 9 ||
      key == 13 ||
      key == 46 || // Delete key
      // key == 110 || // Decimal
      (key >= 35 && key <= 40) ||
      (key >= 48 && key <= 57) ||
      (key >= 96 && key <= 105));
  });

  $(document).on('keypress keydown', '.txt-creditcard', function(e) {
    var key = e.charCode || e.keyCode || 0;

    if (e.ctrlKey) {
      return true;
    }

    return (
      key == 8 ||
      key == 9 ||
      key == 13 ||
      // key == 46 || // Decimal
      // key == 110 || // Decimal
      (key >= 35 && key <= 40) ||
      (key >= 48 && key <= 57) ||
      (key >= 96 && key <= 105));
  });

  function formatCreditCardNumber(target, position, length) {
    var formatted = target.value.replace(/[^\d]/g, '').replace(/(.{4})/g, '$1 ');
    if (length > 15 && formatted.endsWith(' ')) {
      formatted = formatted.slice(0, -1);
    }
    target.value = formatted;
    target.selectionEnd = position += ((target.value.charAt(position) === ' ' && target.value.charAt(length) === ' ' && length !== target.value.length) ? 1 : 0);
  }

  $(document).on('input paste', '.txt-creditcard', function(e) {

    // var num = $(this).val();
    //     num = num.replace(/\s/g, '');

    // if(num) {
    //   num = num.match(/.{1,4}/g);
    //   num = num.join(' ');
    //   $(this).val(num);

    //   if(num.length <= 0 ) {
    //     $(this).val('')
    //   } else if(num.length > 19) {
    //     $(this).val(num.substring(0, 20));
    //   } else {
    //     $(this).val(num);
    //   }
    // }

    var target = e.target,
      position = target.selectionEnd,
      length = target.value.length,
      key = e.keyCode || e.charCode;

    formatCreditCardNumber(target, position, length);
  });

  $(document).on('keydown', '.txt-creditcard', function(e) {

    var target = e.target,
      position = target.selectionEnd,
      length = target.value.length,
      key = e.keyCode || e.charCode;

    if (key == 8 || key == 46) {

      var pos = target.selectionEnd;
      // Only move the cursor backwards
      if (target.selectionEnd === 5 || target.selectionEnd === 10 || target.selectionEnd === 15) {
        target.selectionEnd = pos - 1;
        return false;
      }

      // Remove including space
      if ((target.selectionEnd === 6 && length === 6) ||
        (target.selectionEnd === 11 && length === 11) ||
        (target.selectionEnd === 16 && length === 16) ||
        target.selectionEnd >= 20) {
        target.value = target.value.slice(0, -2);
        target.selectionEnd = pos - 1;
        return false;
      }
    } else {
      formatCreditCardNumber(target, position, length);
    }
  });

  function formatNzBankAccountNumber(target) {
    var value = target.value.replace(/[^\d]/g, '');
    var formatted = target.value;
    if (value.length >= 19) {
      formatted = value.replace(/(\d{2})(\d{4})(\d{7})(\d{2,3})/g, (a, b, c, d, e) => b + '-' + c + '-' + d + '-' + e);
    } else if (value.length >= 13) {
      formatted = value.replace(/(\d{2})(\d{4})(\d{7})(.*)/g, (a, b, c, d, e) => b + '-' + c + '-' + d + '-' + e);
    } else if (value.length >= 6) {
      formatted = value.replace(/(\d{2})(\d{4})(.*)/g, (a, b, c, d) => b + '-' + c + '-' + d);
    } else if (value.length > 2) {
      formatted = value.replace(/(\d{2})(.*)/g, (a, b, c) => b + '-' + c);
    } else {
      formatted = value.replace(/(\d{2})(.*)/g, (a, b) => b);
    }

    formatted = formatted.substr(0, 19);
    if (formatted.endsWith('-')) {
      formatted = formatted.slice(0, -1);
    }

    target.value = formatted;
  }

  function formatGbSortCode(target) {
    var formatted = target.value.replace(/[^\d]/g, '').replace(/(.{2})/g, '$1-').substr(0, 8);
    if (formatted.endsWith('-')) {
      formatted = formatted.slice(0, -1);
    }

    target.value = formatted;
  }

  function formatAuBSBCode(target) {
    var formatted = target.value.replace(/[^\d]/g, '').replace(/(.{3})/g, '$1-').substr(0, 7);
    if (formatted.endsWith('-')) {
      formatted = formatted.slice(0, -1);
    }

    target.value = formatted;
  }

  $(document).on('input paste', 'input[data-input-type="nzdaccountnumber"]', function(e) {
    formatNzBankAccountNumber(e.target);
  });

  $(document).on('input paste', 'input[data-input-type="gbpsortcode"]', function(e) {
    formatGbSortCode(e.target);
  });

  $(document).on('input paste', 'input[data-input-type="audbsbcode"]', function(e) {
    formatAuBSBCode(e.target);
  });

  /*$(document).on('keypress', '.txt-decimal', function(e) {
    var key = e.charCode || e.keyCode;
    return (key >= 48 && key <= 57) || key == 46;
  });*/

  $(document).on('keypress keydown', '.txt-decimal', function(e) {
    var key = e.charCode || e.keyCode || 0;
    // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
    // home, end, period, and numpad decimal
    // add 190 to allow decimal

    // if(e.shiftKey) {
    //   e.preventDefault();
    // }

    return (
      key == 8 ||
      key == 9 ||
      key == 13 ||
      key == 46 ||
      key == 110 ||
      key == 190 ||
      (key >= 35 && key <= 40) ||
      (key >= 48 && key <= 57) ||
      (key >= 96 && key <= 105));
  });

  // $(document).on('click', '.product .link, .product-jewellery .link', function (e) {
  //   var _this = $(this),
  //     url = _this.data('url');
  //   if (e.ctrlKey || e.metaKey) {
  //     window.open(url, '_blank').focus();
  //     return;
  //   }
  //   window.location.href = url;
  // });

  $(document).on('click', '.product-overview-default-wrap .link', function(e) {
    var _this = $(this);
    url = _this.data('url');
    if (e.ctrlKey || e.metaKey) {
      window.open(url, '_blank').focus();
      return;
    }
    window.location.href = url;
  })

  // ...
  // For Shopping Cart
  // ...

  // var cartItemsCount = 0;
  // if(readCookie('shopping-cart-count') != null) {
  //   cartItemsCount = readCookie('shopping-cart-count');
  // }
  /*var popupCart = new PopupCart(true);
  popupCart.render();*/

  /*$('.cart').on('click', function(e) {
    $(this).find('.dropdown').removeClass('hide');
  })*/

  var insideCartIcon = false;
  var insideCart = false;

  function updateCartVisibility() {
    if (insideCartIcon || insideCart) {
      $('.cart .cart-dropdown').show();
    } else {
      $('.cart .cart-dropdown').hide();
    }
  }

  function isInsideCart(e) {
    var bb = $('.cart-dropdown').get(0).getBoundingClientRect();
    if (e.clientX < bb.left) {
      return false;
    }

    if (e.clientX > bb.right) {
      return false;
    }

    if (e.clientY < bb.top) {
      return false;
    }

    if (e.clientY > bb.bottom) {
      return false;
    }

    return true;
  }

  $('.cart').on('mouseenter', function() {
    insideCartIcon = true;
    updateCartVisibility();
  });

  $('.cart').on('mouseleave', function() {
    insideCartIcon = false;
    console.log('cart.mouseleave');
    updateCartVisibility();
    $('.shopping-cart-item-container .warning').addClass('hide');
  });

  $('.cart-dropdown').on('mouseenter', function() {
    insideCart = true;
    updateCartVisibility();
  });

  $('body').on('mousemove', function(e) {
    if (insideCart && !isInsideCart(e)) {
      insideCart = false;
      updateCartVisibility();
    }
  });

  // Delegate root for the Shopping Cart dropdown controls below.
  //
  // PHP site: .cart-dropdown is server-rendered and the node is never replaced,
  // so keep delegating from the element exactly as before. cartIsReactOwned is
  // false there (nothing sets data-react-cart), making this branch identical to
  // the previous code at runtime.
  //
  // web-core: the hydrated header renders .cart / .cart-dropdown from React and
  // marks .cart with data-react-cart (see CartDropdown.jsx). A remount of that
  // subtree swaps in a fresh node and every handler bound to the old one is
  // silently dropped -- +1 / quantity / remove go dead with the node still in
  // the DOM. <body> is never replaced, so delegating from there survives it.
  //
  // <body> and not document on purpose: the handlers below rely on
  // stopPropagation() to keep cart clicks away from the document-level 'a' click
  // tracker, which only holds while the delegate root sits BELOW document.
  var cartIsReactOwned = !!document.querySelector('[data-react-cart]'),
    $cartRoot = cartIsReactOwned ? $('body') : $('.cart .cart-dropdown'),
    cartSel = cartIsReactOwned ? '.cart .cart-dropdown ' : '';

  // Change Item in Shopping Cart dropdown
  $cartRoot.on('change', cartSel + '.shopping-cart-item-wrap .quantity', function(e) {
    shoppingCartModule.handleChange($(this).closest('.shopping-cart-item-wrap').data('id'));
  });

  // Keyup after typing number Item in Shopping Cart dropdown
  $cartRoot.on('keyup', cartSel + '.shopping-cart-item-wrap .quantity', function(e) {
    if (isKeycodeNumber(e)) {
      shoppingCartModule.handleChange($(this).closest('.shopping-cart-item-wrap').data('id'));
    }
  });

  // +1 Item in Shopping Cart dropdown
  $cartRoot.on('click', cartSel + '.shopping-cart-item-wrap .add', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var _this = $(this),
      $parent = _this.parents('.shopping-cart-item-wrap'),
      id = $parent.data('id'),
      curVal = parseInt(_this.prev().val()) || 0;

    e.preventDefault();

    if (id === '') {
      return;
    }

    if (_this.prev().val() <= 0) {
      _this.prev().val(1);
    } else {
      _this.prev().val(curVal + 1);
    }

    $parent.data('qty', _this.prev().val());

    var queryIdParams = getUrlVars().queryId;

    // Popup Added Item Cart is triggering this event to sync shopping cart dropdown and popup added item cart value
    var $popup = $('.popup-added-item-cart');
    if (typeof shoppingCartPlus1Flag === 'object') {
      shoppingCartPlus1Flag.abort();
    }
    if ($popup.length) {
      shoppingCartPlus1Flag = shoppingCartModule.update(null, true, true, id, queryIdParams);
    } else {
      shoppingCartPlus1Flag = shoppingCartModule.update(null, true, true, id, queryIdParams, true);
    }

  });

  // Remove Item in Shopping Cart dropdown
  $cartRoot.on('click', cartSel + '.shopping-cart-item-wrap .remove', function() {
    var _this = $(this),
      $parent = _this.parents('.shopping-cart-item-wrap'),
      id = $parent.data('id');

    // React owns the cart markup (web-core's hydrated header, [data-react-cart]):
    // remove() re-renders the whole list from the response, so don't slideUp and
    // detach the node out from under React.
    if (document.querySelector('[data-react-cart]')) {
      shoppingCartModule.remove({
        productId: id
      });
      return;
    }

    shoppingCartModule.remove({
      productId: id
    }, function(res) {
      // remove
      $parent.slideUp(500, function() {
        $(this).remove();
        // Display empty cart if necessary
        shoppingCartModule.build(res);
      });
    });
  });


  $cartRoot.on('click', cartSel + '.image a', function(e) {
    window.location = $(this).attr('href');
    e.stopPropagation();
  });

  $cartRoot.on('click', cartSel + '.title a', function(e) {
    window.location = $(this).attr('href');
    e.stopPropagation();
  });

  $cartRoot.on('click', cartSel + '.warning span', function(e) {
    $(this).parent().addClass('hide');
    e.stopPropagation();
  })

  $cartRoot.on('click', cartSel + '#go-to-checkout-page', function(e) {
    e.preventDefault();
    var _this = $(this);

    shoppingCartModule.refresh(function(res) {
      if (res.message) {
        if (res.cartEntries.length) {
          var options = {
            title: res.title,
            message: res.message,
            customButtons: true,
            buttons: [{
              name: 'Ok',
              link: false,
              action: 'callback',
              callback: function() {
                window.location.href = '/buy/checkout';
              }
            }]
          };
          var popup = new Popup(options);
          popup.render();
        } else {
          var popup = new Popup({
            title: res.title,
            message: res.message
          });
          popup.render();
        }
      } else {
        window.location.href = _this.attr('href');
      }
    });
  })

  // Add Item to cart
  $(document).on('click', '.btn-add-to-cart', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var _this = $(this),
      data = {
        productId: _this.data('id'),
        quantity: parseInt(_this.prev('.quantity').val())
      };

    var override = _this.attr('data-always-show-popup') ? true : false;

    if (!_this.data('id')) {
      return;
    }

    if (!data.quantity) {
      return;
    }

    var queryId = _this.data('query-id');
    if (!queryId) {
      queryId = getUrlVars().queryId;
    }

    if (queryId) {
      data.queryId = queryId;
    }

    shoppingCartModule.add(data, function() {
      _this.prev('.quantity').val(1);
      var idQuantity = JSON.parse(localStorage.getItem('id-quantity')) || [];

      if (searchObjectInArray(_this.data('id'), idQuantity)) {
        localStorage.removeItem('id-quantity');
      }

      // Always remove override attribute
      _this.removeAttr('data-always-show-popup');
    }, false, override);
  });

  function registerProductClick(element) {
    var productId = element.data('product-id');
    if (!productId) {
      productId = element.closest('*[data-product-id]').data('product-id')
    }

    if (!productId) {
      console.warn('No product ID found');
      return;
    }

    var queryId = element.data('query-id');
    if (!queryId) {
      queryId = getUrlVars().queryId;
    }

    var clickPosition = element.data('rank');
    if (!clickPosition) {
      clickPosition = -1;
    }

    sessionModule.registerClick(window.location.href, element.href, productId, clickPosition, queryId);
  }

  // Register clicks
  $(document).on('click', 'a', function() {
    var _this = $(this);

    try {
      if (_this.attr('href').indexOf('/buy/product') > -1) {
        registerProductClick(_this);
      }
    } catch (err) {
      console.warn('Failed to product click : ' + err);
    }
  });

  // ...
  // For /help/ and /contact page
  // ...

  var searchHelpMissTimer = null;

  function searchHelpPage() {

    if (searchHelpMissTimer != null) {
      clearTimeout(searchHelpMissTimer);
      searchHelpMissTimer = null;
    }

    new Request(servicesUrl + '/help/search/', {
        query: $('.search-help-page-box input').val()
      })
      .success(function(res) {
        console.log(res);
        $('.search-help-page-box .result').removeClass('hide');
        $('.search-help-page-box .result').html(tmpl($('#tmpl-search-result').html(), {
          obj: res
        }));

        if (res.result.length == 0) { // Send miss stat to api.
          searchHelpMissTimer = setTimeout(searchHelpMiss, 2000, res.query);

        }
      }).send();
  }

  $('.search-help-page-box').on('click', function(e) {
    e.stopPropagation();
  })

  $('.search-help-page-box input').on('input focus', debounce(function() {
    if ($(this).val()) {
      $('#help-search-clear').removeClass('hide');
    } else {
      $('#help-search-clear').addClass('hide');
    }
    if ($(this).val().length >= 3) {
      searchHelpPage();
    } else {
      $('.search-help-page-box .result').addClass('hide');
    }
  }, 300));

  $('#help-search-clear').on('click', function() {
    $('.search-help-page-box input').val('');
    $('.search-help-page-box input').trigger('focus');
  });

  $('#btn-search-help').on('click', searchHelpPage);

  $('.main-menu').on('click', function() {
    if (!isTouchDevice()) {
      window.location = '/buy/';
    }
  });

  $(document).on('click', function(e) {
    $('.search-help-page-box .result').addClass('hide');
    // $('#search-suggestion-nav').addClass('hide');

    // this is added to avoid overlapping sub menu when search result is shown
    $('.nav > ul > li > div').removeClass('invisible');
    // console.log($(e.target).closest('.cart').length)
    // if(!$(e.target).closest('.cart').length && !$(e.target).closest('.backdrop2').length) {
    //   $('.cart > .dropdown').addClass('hide');
    // }
  });
  // ...

  // ...
  // For Right Sidebar
  // ...

  $(document).on('mousedown', '.product-promo-wrap .promo-heading, .product-promo-wrap .info', function(e) {
    e.preventDefault();
    var _this = $(this);
    window.location.href = _this.data('url');
  });

  $(document).on('mousedown', '.product-promo-wrap .info .controls', function(e) {
    e.stopPropagation();
  });

  function updateSidebarSpotPrices(spotPrices) {
    for (var key in spotPrices) {
      $('.spot-price > ul li[data-metal=' + key + ']').find('.value').text(spotPrices[key].value);
      $('.spot-price > ul li[data-metal=' + key + ']').find('.percent-change').text(spotPrices[key].percent);
      if (spotPrices[key].signum === 1) {
        $('.spot-price > ul li[data-metal=' + key + ']')
          .find('.percent-change')
          .removeClass('font-red')
          .addClass('font-green');
      } else if (spotPrices[key].signum === -1) {
        $('.spot-price > ul li[data-metal=' + key + ']')
          .find('.percent-change')
          .addClass('font-red')
          .removeClass('font-green');
      } else {
        $('.spot-price > ul li[data-metal=' + key + ']')
          .find('.percent-change')
          .removeClass('font-green')
          .removeClass('font-red');
      }
    }
  }

  var $xhr;

  function getChart(cb) {
    var req = new Request(servicesUrl + '/spot-chart/graph/get', chartData);
    req.cache(true);
    req.type('get');
    req.getXHR = true;

    req.success(function(res) {
      var options = {
        type: 'line',
        width: 500,
        height: 400,
        preserveAspectRatio: 'none',
        margin: {
          top: 35,
          bottom: 10,
          left: 6,
          right: 0
        },
        withStatistics: false,
        withTimeZone: false,
        withDateCovered: false,
        withLogo: false,
        withLineCursor: true,
        withLineCursorMouseMove: true,
        withHorizontalLinesEnds: true,
        withHorizontalLines: true,
        withVerticalLines: false,
        withVerticalLinesEnds: false,
        gridColor: '#eee',
        gridHorizontalOffset: 5,
        withBorder: false,
        lineCursorColor: '#c9934b',
        lineCursorWeight: 0,
        lineCursorDashArray: '6,6',
        cursorPointSize: 5,
        cursorPointColor: '#fcb134',
        cursorPointStrokeColor: '#ba741e',
        fontSize: isFirefox() ? 16 : 17,
        lineCursorBoxHeight: 23,
        lineCursorTextYOffset: 1,
        hasTime: res.hasTime,
        offsetChart: false,
        enableDrag: true,
        timeBoxBackgroundColor: '#555557',
        //timeBoxWidthOffset: 10,
        timeBoxMarginTop: 3,
        //timeBoxWidth: 195,
        //valueBoxWidth: 120,
        timeBoxHeight: 28,
        //valueBoxYOffset: 3,
        dataSeries: [{
          name: 'series1',
          area: true,
          color: 'transparent',
          lineColor: '#e5a158',
          lineWidth: '3',
          startDate: res.startDate,
          data: res.dataSeries,
          numDecimals: res.numDecimals
        }]
      }

      $('.sidebar .chart').bstarchart(options);
      updateSidebarSpotPrices(res.spotPrices);
      typeof cb === 'function' && cb(res);
    });

    req.send();

    $xhr = req.xhr;

    return $xhr;
  }

  // [web-core] The sidebar spot-price chart is the hydrated React SpotPriceChart
  // when this marker is present — it owns its own state, fetch, and chart draw,
  // so skip all the legacy init/handlers/kickoff below.
  var reactOwnsSpot = $('.spot-price[data-react-spot]').length > 0;

  if (!reactOwnsSpot && $('#chart-from-index').length > 0) {
    var sel = localStorage.getItem('spot-price-metal');
    if (!sel) {
      sel = 'XAU';
    }

    $('#chart-from-index').val(sel);
  }

  if (!reactOwnsSpot && $('#chart-weight-unit').length > 0) {
    var sel = localStorage.getItem('spot-price-weight');
    if (!sel) {
      sel = 'tr_oz';
    }

    $('#chart-weight-unit').val(sel);
  }

  if (!reactOwnsSpot && $('.chart-options').length > 0) {
    var sel = localStorage.getItem('spot-price-option');
    if (!sel) {
      sel = 'TYPE_1M';
    }

    $('.chart-options').children().each(function() {
      if ($(this).data('period') == sel) {
        $(this).addClass('active');
      }
    });
  }

  var chartData = {
    pm: $('#chart-from-index').val(),
    currency: getCurrency(),
    period: $('.chart-options > .chart-option.active').data('period'),
    width: 250,
    height: 215,
    timeZoneId: moment.tz.guess(),
    weightUnit: $('#chart-weight-unit').val(),
    locationId: getLocation()
  };

  $('.chart-options > .chart-option').on('click', function() {
    if (reactOwnsSpot) return; // [web-core] React-owned spot-price handles its own clicks
    var _this = $(this);

    $('.chart').empty();

    $('.chart-options > .chart-option').removeClass('active');
    _this.addClass('active');

    chartData.pm = $('#chart-from-index').val();
    chartData.currency = getCurrency();
    chartData.period = _this.data('period');
    chartData.weightUnit = $('#chart-weight-unit').val();

    localStorage.setItem('spot-price-option', _this.data('period'));
    if (typeof $xhr === 'object') $xhr.abort();
    $xhr = getChart();
  });

  $('#chart-from-index').on('change', function() {
    if (reactOwnsSpot) return; // [web-core] React-owned spot-price handles its own change
    var _this = $(this);

    $('.chart').empty();

    chartData.pm = _this.val();

    localStorage.setItem('spot-price-metal', _this.val());
    if (typeof $xhr === 'object') $xhr.abort();
    $xhr = getChart();
  });

  $('#chart-weight-unit').on('change', function() {
    if (reactOwnsSpot) return; // [web-core] React-owned spot-price handles its own change
    var _this = $(this);

    $('.chart').empty();

    chartData.weightUnit = _this.val();

    localStorage.setItem('spot-price-weight', _this.val());
    if (typeof $xhr === 'object') $xhr.abort();
    $xhr = getChart();
  });

  // Call auto update of sidebar chart and spot price
  var getSpotPriceInterval;

  function getSpotPrice() {
    //if (!document.hidden) {
    getChart(function(res) {
      clearInterval(getSpotPriceInterval);
      if (res.timeToNextUpdate <= 30000) res.timeToNextUpdate = 30000;
      getSpotPriceInterval = setInterval(getSpotPrice, res.timeToNextUpdate);

      $('.spot-price').removeClass('is-loading');
    });

    productModule.updateChart();
    // } else {
    //   clearInterval(getSpotPriceInterval);
    //   getSpotPriceInterval = setInterval(getSpotPrice, 60000);
    // }
  }

  if (!reactOwnsSpot && $('.sidebar > .spot-price').length) {
    setTimeout(getSpotPrice, 200);
  }

  // Subscribe email
  $('.subscribe #btn-subscribe').on('click', function(e) {
    var subscribe = new Request(servicesUrl + '/account/massmail/subscribe-news', {
      sessionId: sessionModule.getSessionId(),
      locationId: getLocation(),
      email: $('.subscribe input').val()
    })
    subscribe.afterErrorDialogFunction(function() {
      $('.subscribe input').focus();
    });
    subscribe.afterSuccessDialogFunction(function() {
      $('.subscribe input').val('');
      $('.subscribe label').removeClass('active');
      $('.subscribe').remove();
    });
    subscribe.call();
  });

  $('.subscribe-blog #btn-subscribe-blogs').on('click', function(e) {
    var subscribe = new Request(servicesUrl + '/account/massmail/subscribe-blogs', {
      sessionId: sessionModule.getSessionId(),
      locationId: getLocation(),
      email: $('.subscribe-blog input').val()
    })
    subscribe.afterErrorDialogFunction(function() {
      $('.subscribe-blog input').focus();
    });
    subscribe.afterSuccessDialogFunction(function() {
      $('.subscribe-blog input').val('');
    });
    subscribe.call();
  });

  $('.latest-blog-posts #btn-subscribe-blogs').on('click', function(e) {
    var subscribe = new Request(servicesUrl + '/account/massmail/subscribe-blogs', {
      sessionId: sessionModule.getSessionId(),
      locationId: getLocation(),
      email: $('.latest-blog-posts input').val()
    })
    subscribe.afterErrorDialogFunction(function() {
      $('.latest-blog-posts input').focus();
    });
    subscribe.afterSuccessDialogFunction(function() {
      $('.latest-blog-posts input').val('');
    });
    subscribe.call();
  });
  // ...

  //productModule.startPromoTimers();

  $('.virtual-tour').on('click', function(e) {
    e.preventDefault();
    var popup = new PopupVirtualTour();
    popup.render();
  })

  $('.banner-nav > li').on('click', function() {
    var _this = $(this),
      target = _this.data('target');

    $('.banner-nav > li').removeClass('active');
    _this.addClass('active');

    $('.banner-target > div').addClass('hide');
    $('.banner-target > div').eq(target - 1).removeClass('hide');

    // hide expanded welcome banner if any
    $('.welcome-expanded').addClass('invisible');
  });

  var $homeBanner = $('.carousel'),
    $homeBannerNav = $('.carousel .nav li'),
    carouselCtr = 1;

  // Hack to accomodate changes on adding country logic on the banner
  // Some JS part is in /d_index.php
  $homeBannerNav.each(function(i, el) {
    $(el).attr('data-target', i + 1)
  })

  function moveCarousel() {
    $homeBanner.find('> div').addClass('hide');
    $homeBanner.find('> div:nth-child(' + carouselCtr + ')').removeClass('hide');
    $homeBannerNav.removeClass('active');
    $homeBanner.find('.nav li:nth-child(' + carouselCtr + ')').addClass('active');
    resetCarouselTimer();
  }

  function runCarousel() {
    carouselCtr = carouselCtr >= $homeBannerNav.length ? 1 : carouselCtr + 1;
    moveCarousel();
  }

  function resetCarouselTimer() {
    clearInterval(carouselInt);
    carouselInt = setInterval(runCarousel, 9000);
  }

  $homeBannerNav.on('click', function() {
    carouselCtr = $(this).data('target');
    moveCarousel();
  });

  // Run only on homepage and if banner is more than 1
  if (window.location.pathname === '/' && $('.carousel .nav li').length > 1) {
    var carouselInt = setInterval(runCarousel, 9000);
  }

  if (window.location.pathname !== '/search/') {
    eraseCookie('search-nav');
  }

  $('#btn-submit-job').on('click', function() {

    formValidationModule.validateForm($('.form'), 'Careers', function(data) {
      /*      if(!$('input[type=file]').eq(0).val()) {
              var popup = new Popup({ title: 'Careers', message: 'No file has been attached. Please attach a file and try again.' });
              popup.render();
              return;
            }
      */
      var formData = new FormData($('#upload-document-wrap')[0]);
      formData.append('code', 342516);

      // var loading = new Loading();
      // loading.render();

      var req = new Request(servicesUrl + '/account/v1/careers', formData);

      req.setContentType(false);
      req.setProcessData(false);

      req.success(function(res) {
        if (res.success) {
          //$('#upload-document-wrap')[0].reset();
          formValidationModule.resetForm('.form')
          // window.location.href = '/cvsent';
        }
      });

      req.call();

      // $.ajax({
      //   url: '/api/v1/careers',
      //   data: formData,
      //   method: 'POST',
      //   cache: false,
      //   contentType: false,
      //   processData: false
      // }).done(function(res) {
      //   console.log(res);
      //   if(res.success) {
      //     return;
      //     window.location.href = '/cvsent';
      //   }
      // }).fail(function(res) {
      //   console.log(res);
      // }).always(function() {
      //   loading.close();
      // })
    }, null, true);

  });

  $('#career-cv').on('change', function(e) {
    var ext = $(this).val().match(/\.([^\.]+)$/)[1];
    var extClean = ext.toLowerCase();
    switch (extClean) {
      case 'gif':
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'pdf':
        break;
      default:
        var popup = new Popup({
          title: 'Document Uploader',
          message: 'The file type you selected is not supported. Please try again.'
        });
        popup.render();
        $(this).val('');
    }
  });

  // Fix field labels of inputs on load 
  $.each($('input'), function(i, input) {
    var $input = $(input),
      $parent;
    if ($input.parent('.form-field').length ||
      $input.parent('.subscription-input-wrap').length) {

      if ($input.parent('.form-field').length) {
        $parent = $input.parent('.form-field');
      } else if ($input.parent('.subscription-input-wrap').length) {
        $parent = $input.parent('.subscription-input-wrap');
      }

      if ($input.val().length) {
        $parent.find('label').addClass('active');
      } else {
        $parent.find('label').removeClass('active');
      }
    }
  });

  $.each($('textarea'), function(i, input) {
    var $input = $(input),
      $parent;
    if ($input.parent('.form-field').length) {

      if ($input.parent('.form-field').length) {
        $parent = $input.parent('.form-field');
      }

      if ($input.val().length) {
        $parent.find('label').addClass('active');
      } else {
        $parent.find('label').removeClass('active');
      }
    }
  });

  // #btn-email-us-2 is used on product details because there is 2 identical Contact Us section to accomodate Torgny's request about showing contact us after price information when window gets narrower.
  $('#btn-email-us, #btn-email-us-2').on('click', function() {
    var id = $(this).data('product-id'),
      productInquiry = $(this).data('product-inquiry') || false;

    var popupEmailUs = new PopupEmailUs(id, productInquiry);
    popupEmailUs.render();
  });

  // Spot price links to chart
  $('.spot-price > ul > li').on('click', function() {
    //var url = '/charts/?fromIndex=' + $(this).data('metal') + '&toIndex=' + getCurrency() + '&period=YEAR_1&weightUnit=tr_oz';
    //window.location.href = url;

    // [web-core] React-owned spot-price handles its own metal clicks; a jQuery
    // .val() + .trigger('change') never reaches the React onChange.
    if ($(this).closest('.spot-price[data-react-spot]').length) return;

    var _this = $(this),
      metal = _this.data('metal');

    $('#chart-from-index').val(metal);
    $('#chart-from-index').trigger('change');
  });

  $(document).on('click', '.btn-email-notif', function(e) {
    var _this = $(this),
      id = _this.data('id');
    if (hasLoggedInId()) {
      productModule.setProductNotify({
        productId: id,
        locationId: getLocation()
      });
    } else {
      var popupNotifyMe = new PopupNotifyMe(id);
      popupNotifyMe.render();
    }
  });

  $(document).on('click', '#close-announcement', function() {
    var newIds = $(this).data('aid');

    var ids = localStorage.getItem('announcement-dismissed');
    if (ids) {
      ids += ',' + newIds;
    } else {
      ids = newIds;
    }

    localStorage.setItem('announcement-dismissed', ids);
    $('.header-announcement').remove();
  });

  // Add stop scrolling .cart-dropdown when it reaches the bottom
  var $cartPopover = $('.cart-dropdown');
  $cartPopover.on('mousewheel', function(e, d) {
    if ($('.shopping-cart-item-container').length === 0) return;
    var scrollHeight = $('.shopping-cart-item-container')[0].scrollHeight,
      height = $('.shopping-cart-item-container').height();
    scrollTop = $('.shopping-cart-item-container').scrollTop();

    if ((scrollTop === (scrollHeight - height) && d < 0) || (scrollTop === 0 && d > 0)) {
      e.preventDefault();
    }
  });

  // var urlParams = getUrlVars();
  // if(urlParams.showLogin !== undefined && 
  //    urlParams.showLogin == 'true' && 
  //    !readCookie('logged-in-id')) {
  //   $('#btn-login').trigger('click');
  // }

  $('a').not('[data-react-hydrated] a').each(function(i, a) {
    var href = $(a).attr('href');
    // Check for the following start: /, #
    // Check for string .bullionstar.com

    if (!/^(\/|\#)|mailto|javascript|safemetals|admin\.safemetals|bullionstar/.test(href)) {
      $(a).attr('target', '_blank');
    }
  });

  // $(document).on('mousewheel', 'input.quantity, input[type=number]', function (e) {
  //   e.preventDefault();
  // });

  // Avoid select dropdown stacking with DOM dropdown
  // (reactChromeHeader: HeaderBehaviors.jsx owns this for the hydrated header.)
  if (!window.reactChromeHeader) {
    $('.main-header .top .we-speak, .main-header .top .currency-wrap, .main-header .middle .hello, .main-header .middle .cart').on('mouseover', function() {
      $('select').trigger('blur');
    });
  }

  // $('.sidebar .product-promo-wrap').removeClass('hide');

  $('body').removeClass('no-scroll');

  $('#back-to-mobile').on('click', function() {
    eraseCookie('mobileShowDesktop');
    window.location.reload();
  });

  $('.link-to').on('click', function() {
    window.location.href = $(this).data('url');
  });

  if (window.location.pathname !== '/charts/gold-price-today' && window.location.pathname !== '/charts/silver-price-today') {
    eraseCookie('gold-price-currency');
    eraseCookie('silver-price-currency');
  }

  $('#search-suggestion-nav').on('click', function(e) {
    e.stopPropagation();
  })

  $('#search-suggestion-nav').on('click', '.send-stat', function(e) {
    // Save to cookie
    // ---------------
    // Account ID
    // Ref
    // Url
    // Rank
    // Query
    var statParams = {
      ref: $(this).data('stat-ref'),
      url: $(this).attr('href'),
      rank: $(this).data('rank'),
      query: $('#txt-header-search').val()
    };

    localStorage.setItem('send-stat-params', JSON.stringify(statParams));
  });

  // Send Stats for search
  if (localStorage.getItem('send-stat-params') != null) {
    var statParams = JSON.parse(localStorage.getItem('send-stat-params'));
    var data = {
      ref: statParams.ref,
      urlBase64: btoa(statParams.url),
      rank: statParams.rank,
      query: statParams.query
    };
    searchModule.stats(data, null, null, function() {
      localStorage.removeItem('send-stat-params');
    });
  }

  $('.sidebar .no-spread').on('click', function() {
    window.location.href = '/buy/product/gold-bullionstar-100g';
  });

  if (/\/buy\/?/.test(window.location.pathname)) {
    console.log('in /buy/');
  } else {
    console.log('Not in /buy/');
    eraseCookie('opened-product-groups');
  }

  // if(/\/buy\/product\/?/.test(window.location.pathname)) {
  //   console.log('in /buy/product/');
  // } else {
  //   console.log('Not in /buy/product/');
  //   eraseCookie('product-details-period');
  // }

  if (window.location.pathname === '/') {
    $('.banner-nav li:visible').eq(0).trigger('click');

    // AKAMAI
    getNoSpreadBannerPrice();
    setInterval(function() {
      if (!document.hidden) {
        getNoSpreadBannerPrice();
      }
    }, 60000);
  }

  if (window.location.pathname === '/why-invest-in-silver' && getLocation() != '2') {
    getNoSpreadSilverBarPriceSG();

    setInterval(function() {
      if (!document.hidden) {
        getNoSpreadSilverBarPriceSG();
      }
    }, 60000);
  }

  // if(siteStatus === 'down') {
  //   var waitingTime = (parseInt(siteDowntimeStart) + parseInt(siteDowntimeLength)) * 1000;
  //   var siteStatusCountTimer = null;
  //   var now = new Date().getTime();
  //   var minRemaining = getRemainingMinutes(waitingTime, now);
  //   var siteStatusPopup = new Popup({ title: 'Website Maintenance', message: 'The website is temporarily unavailable due to scheduled maintenance for another <span class="site-status-min-remaining">' + minRemaining + '</span> minute(s).' });
  //   siteStatusPopup.render();

  //   siteStatusCountTimer = setInterval(function() {
  //     var now = new Date().getTime();
  //     var minRemaining = getRemainingMinutes(waitingTime, now);

  //     $('.site-status-min-remaining').text(minRemaining);
  //     if(now >= waitingTime) {
  //       siteStatusPopup.close();
  //       clearInterval(siteStatusCountTimer);
  //     }
  //   }, 1000)
  // }

  if (/\/blogs?/.test(window.location.pathname)) {
    // AKAMAI
    getNoSpreadBlogsWidgetPrice();
    setInterval(function() {
      if (!document.hidden) {
        getNoSpreadBlogsWidgetPrice();
      }
    }, 60000);

    // Load blog post number
    var req = new Request(servicesUrl + '/product/v1/blog/count', {});

    req.success(function(res) {
      console.log(res)
      if (res.items.length) {
        $('.blog-post-filter .filter-item').find('.total .count').text(res.total);
        for (var x = 0; x < res.items.length; x++) {
          $('.blog-post-filter .filter-item').find('.' + res.items[x].name + ' .count').text(res.items[x].count);
        }
      }
    });

    req.send();
  }

  if (/\/buy\/product?/.test(window.location.pathname)) {
    // Trigger add cart popup in URL
    console.log('in /buy/product/');
    console.log(getUrlVars());
    var buyProductParams = getUrlVars();
    if ('add' in buyProductParams) {
      if (buyProductParams.add == 1) {
        setTimeout(function() {
          $('#btn-add-to-cart').attr('data-always-show-popup', 'true').trigger('click');
        }, 500);
      }
    }

    // AKAMAI
    // Update product details price on load
    var prodId = $('#btn-add-to-cart').data('id') || $('.product-default-wrap .btn-email-notif').data('id');
    productModule.getProductPrice([prodId], getCurrency(), function(res) {
      if (res.products.length) {
        if (res.products[0].promoPrice) {
          var prod = res.products[0];
          var left = parseInt((prod.promoExpireDate - res.time) / 1000);
          $('.product-default-wrap .promo-heading .promoTime').attr('data-time-left', left);
          $('.product-default-wrap .promo-heading .promoTime').html('Ends in ' + promoTimeLeft(left));
          productModule.startPromoTimers();
        }
      }
    });
  }

  if (/\/auction\/product?/.test(window.location.pathname)) {
    // Update product details price on load
    var prodId = $('#btn-add-to-cart').data('id') || $('.product-default-wrap .btn-email-notif').data('id');
    productModule.getProductPrice([prodId], getCurrency(), function(res) {
      if (res.products.length) {
        if (res.products[0].promoPrice) {
          var prod = res.products[0];
          var left = parseInt((prod.promoExpireDate - res.time) / 1000);
          $('.product-default-wrap .promo-heading .promoTime').attr('data-time-left', left);
          $('.product-default-wrap .promo-heading .promoTime').html('Ends in ' + promoTimeLeft(left));
          productModule.startPromoTimers();
        }
      }
    });
  }

  // AKAMAI
  // Get Promo products from API on load
  runPromoCall();
  //rotateLtoProducts();

  // AKAMAI
  // Get Sidebar News
  /* function getNewsSidebar() {
     var req = new Request(servicesUrl + '/product/v1/news/latest', {});
     req.type('get');
     req.cache(true);
     req.noApiErrorPopup = true;
 
     req.success(function(res) {
       var html = '';
       if(res.items && res.items.length) {
         for(var x = 0; x < res.items.length; x++) {
           html += '<li><a href="' + res.items[x].url + '" target="_blank"><span class="title">' + res.items[x].title + '</span><span class="time">' + res.items[x].age + '</span></a></li>';
         }
       }
       $('.sidebar .news .news-list').html(html);
     });
 
     req.error(function() {
       setTimeout(getNewsSidebar, 5000);
     })
 
     req.send();
   }
 
   getNewsSidebar();
 
   // AKAMAI
   // Get Sidebar News
   function getBlogPostSidebar() {
     var req = new Request(servicesUrl + '/product/v1/blog/latest', {});
     req.type('get');
     req.noApiErrorPopup = true;
 
     req.success(function(res) {
       var html = '';
       if(res.items.length) {
         for(var x = 0; x < res.items.length; x++) {
           html += '<li><a href="' + res.items[x].url + '"><figure><img src="' + res.items[x].imageUrl + '" alt="' + res.items[x].title + '"></figure><span><span class="title">' + res.items[x].title + '</span><span class="time">' + res.items[x].age + '</span></span></a></li>';
         }
       }
       $('.sidebar .latest-blog-posts .blog-post-list').html(html);
     });
 
     req.error(function() {
       setTimeout(getBlogPostSidebar, 5000);
     })
 
     req.send();
   }
 
   getBlogPostSidebar();*/

  if (window.location.pathname === '/contact') {
    console.log('CONTACT');
    var urlParam = getUrlVars();
    if ('suggestion' in urlParam && urlParam.suggestion === 'true') {
      var popup = new PopupEmailUs('', false, 'Suggestions for Improvement')
      popup.render();
    }
  }

  // This is for temporary disabling NZ location due to lockdown
  // for(var prop in CLEAN_LOC) {
  //   var loc = CLEAN_LOC[prop];
  //   if(loc.buyOrdersBlocked) {
  //     // DISABLE NZ LOCATION
  //     if(getLocation() == loc.id) {
  //       var popup = new Popup({
  //         title: loc.buyOrdersBlockedTitle,
  //         message: loc.buyOrdersBlockedMessage,
  //         okCallback: function() {
  //           $('#header-location').val(1).trigger('change');
  //         }
  //       });
  //       popup.render();
  //       return;
  //     }
  //   }
  // }

  // DEV NOTE: We have to sets of .retail-carousel one is used on tablet view and desktop
  //           Both should have the same image, image length and image file in order
  var $retailBanner = $('.retail-carousel')
  $retailBannerNav = $('.retail-carousel .nav li'),
    $retailBannerNavLength = $retailBanner.eq(0).find('.nav li').length, // Either use eq(0) or eq(1)
    retailCarouselCtr = 1;

  function moveRetailCarousel() {
    $retailBanner.find('> figure').addClass('hide');
    $retailBanner.find('> figure:nth-child(' + retailCarouselCtr + ')').removeClass('hide');
    $retailBannerNav.removeClass('active');
    $retailBanner.find('.nav li:nth-child(' + retailCarouselCtr + ')').addClass('active');
    resetRetailCarouselTimer();
  }

  function runRetailCarousel() {
    retailCarouselCtr = retailCarouselCtr >= $retailBannerNavLength ? 1 : retailCarouselCtr + 1;
    moveRetailCarousel();
  }

  function resetRetailCarouselTimer() {
    clearInterval(retailCarouselInt);
    retailCarouselInt = setInterval(runRetailCarousel, 9000);
  }

  $retailBannerNav.on('click', function() {
    retailCarouselCtr = $(this).data('target');
    moveRetailCarousel();
  });

  // Run only on homepage and if banner is more than 1
  if (window.location.pathname === '/' && $retailBannerNavLength > 1) {
    var retailCarouselInt = setInterval(runRetailCarousel, 9000);
  }

  $('.support-tab-wrap:not([data-react-tabs]) > .tabs > li').on('click', function() {
    var _this = $(this);

    $('.support-tab-wrap:not([data-react-tabs]) > .tabs > li').removeClass('active');
    _this.addClass('active');
    $('.support-tab-wrap:not([data-react-tabs]) .opening').addClass('hide')
    if (_this.hasClass('retail')) {
      $('.support-tab-wrap:not([data-react-tabs]) .opening.retail').removeClass('hide')
    } else {
      $('.support-tab-wrap:not([data-react-tabs]) .opening.support').removeClass('hide')
    }
  });


  $('.support-tab-wrap:not([data-react-tabs]) .opening.support').addClass('hide')
  $('.support-tab-wrap:not([data-react-tabs]) > .tabs > li.retail').addClass('active')
  $('.support-tab-wrap:not([data-react-tabs]) .opening.retail').removeClass('hide');

  $(document).on('click', '.bell.watchlist', function() {
    if (!validateAuctionLogin()) {
      return;
    }
    console.log($(this))
    var id = $(this).closest('.product-auction').data('id');
    auctionModule.saveToWatchlist(id);
  });

  $(document).on('click', '.bell.watchlisted', function() {
    if (!validateAuctionLogin()) {
      return;
    }
    console.log($(this))
    var id = $(this).closest('.product-auction').data('id');
    auctionModule.removeToWatchlist(id);
  });

  $(document).on('click', '.product-auction:not(.ended) .btn-place-bid', function() {
    if (!validateAuctionLogin()) {
      return;
    }

    var $auctionEl = $(this).closest('.product-auction');
    var auction = {
      id: $auctionEl.data('id'),
      title: $auctionEl.data('title'),
      imageUrl: $auctionEl.data('image-url'),
      latestBid: $auctionEl.data('latest-bid'),
      endDate: $auctionEl.data('end-date'),
      systemTime: $auctionEl.data('system-time'),
      bids: $auctionEl.data('bids'),
      bid: $auctionEl.find('input.bid').val(),
      latestBidderAccountId: $auctionEl.data('latest-bidder-account-id'),
      minimumBid: $auctionEl.data('minimum-bid'),
      minimumBidPrice: $auctionEl.data('minimum-bid-price'),
      autobid: $auctionEl.data('autobid'),
      maximumAutobid: $auctionEl.data('maximum-autobid'),
      maximumAutobidPrice: $auctionEl.data('maximum-autobid-price'),
      increment: $auctionEl.data('increment'),
      // currency: $auctionEl.data('latest-bid').split(' ')?.[0] || 'SGD'
    }
    console.log('auction obj', auction);
    if (getAccountId() == auction.latestBidderAccountId) {
      if ($auctionEl.find('input.bid').val() === '') {
        auction.bid = $auctionEl.data('minimum-bid');
      }
      if (auction.autobid) {
        var popup = new PopupEditAutoBid(auction);
      } else {
        var popup = new PopupEditBid(auction);
      }
      popup.render();
    } else {
      var popup = new PopupConfirmBid(auction);
      popup.render();
    }
  });

  $(document).on('click', '.bid-count:not(.no-bid), .btn-view-bids:not(.no-bid)', function(e) {
    e.stopPropagation();

    var $auctionEl = $(this).closest('.product-auction');
    var auctionId = $auctionEl.data('id');
    auctionModule.getAuctionBids(auctionId, function(res) {
      var auction = {
        id: auctionId,
        title: $auctionEl.data('title'),
        imageUrl: $auctionEl.data('image-url'),
        latestBid: $auctionEl.data('latest-bid'),
        endDate: $auctionEl.data('end-date'),
        systemTime: $auctionEl.data('system-time'),
        totalBidders: res.totalBidders,
        totalCount: res.totalCount,
        items: res.items
      }
      var popup = new PopupBidHistory(auction);
      popup.render();
    });
  });

  $(document).on('click', '.product-auction:not(.ended) .btn-buy-now', function() {
    if (!validateAuctionLogin()) {
      return;
    }

    var auctionId = $(this).data('id');
    auctionModule.buyNow(auctionId);
  });

  $(document).on('click', '.auction-list .product-auction.ended', function() {
    localStorage.setItem('checkout-auction-id', $(this).data('id'));
    window.location.href = '/auctions/' + $(this).data('id');
  });

  $(document).on('validateAuctionLogin', validateAuctionLogin);

  function validateAuctionLogin() {
    if (!isLoggedIn()) {
      var popupLogin = new PopupLogin({
        form: {
          heading: 'Login Required',
          message: 'You must have a BullionStar account to place auction bids. Please login to your account or sign up for a new account.'
        }
      });
      popupLogin.render();
      return false;
    }
    return true;
  }

  $(document).on('click', '.welcome-to-bullionstar span img', function() {
    $('.welcome-expanded').removeClass('invisible');
  });

  $(document).on('click', '.welcome-to-bullionstar .close-expanded-banner', function() {
    $('.welcome-expanded').addClass('invisible');
  });

  // display only US contact on US site, and only NZ contact for NZ site if visitor geolocation is local
  (function() {
    let geoCountry = getGeoCountry();
    let stockLocation = getLocation();

    if (stockLocation == 2 && geoCountry == 'US') {
      $('.number .phone-numbers-us').removeClass('hide');
    } else if (stockLocation == 3 && geoCountry == 'NZ') {
      $('.number .phone-numbers-nz').removeClass('hide');
    } else {
      $('.number .phone-numbers').removeClass('hide');
    }
  })();

})(jQuery);

$('.shipping-vault-tab-wrap > .tabs > li').on('click', function() {
  var _this = $(this);

  $('.shipping-vault-tab-wrap > .tabs > li').removeClass('active');
  _this.addClass('active');
  $('.shipping-vault-tab-wrap .opening').addClass('hide')
  if (_this.hasClass('shipping')) {
    $('.shipping-vault-tab-wrap .opening.shipping').removeClass('hide')
    $('.shipping-vault-body > .right.desktop.shipping').removeClass('hide')
    $('.shipping-vault-body > .right.desktop.vault').addClass('hide')
    $('.shipping-vault-body > .right.tablet.shipping').removeClass('hide')
    $('.shipping-vault-body > .right.tablet.vault').addClass('hide')
  } else {
    $('.shipping-vault-tab-wrap .opening.vault').removeClass('hide')
    $('.shipping-vault-body > .right.desktop.vault').removeClass('hide')
    $('.shipping-vault-body > .right.desktop.shipping').addClass('hide')
    $('.shipping-vault-body > .right.tablet.vault').removeClass('hide')
    $('.shipping-vault-body > .right.tablet.shipping').addClass('hide')
  }
});
$('.shipping-vault-tab-wrap > .tabs > li.shipping').addClass('active')

let oneTimeChangeLocationPopupVal = localStorage.getItem('one-time-change-location-popup');
console.log(oneTimeChangeLocationPopupVal)

if (!oneTimeChangeLocationPopupVal) {
  let geoCountry = getGeoCountry();
  let stockLocation = getLocation();
  console.log(geoCountry + " " + stockLocation)

  let showPopup = false;
  let existingStockLocation;
  let newStockLocation;
  let changeLocationId;
  let newStockLocationText;
  if (geoCountry == 'US' && stockLocation != 2) {
    if (stockLocation == 1) {
      existingStockLocation = 'Singapore';
    }
    if (stockLocation == 3) {
      existingStockLocation = 'New Zealand';
    }
    newStockLocation = 'the United States';
    newStockLocationText = 'US';
    changeLocationId = 2;
    showPopup = true;
  }

  if (geoCountry == 'SG' && stockLocation != 1) {
    if (stockLocation == 2) {
      existingStockLocation = 'the United States';
    }
    if (stockLocation == 3) {
      existingStockLocation = 'New Zealand';
    }
    newStockLocation = 'Singapore';
    newStockLocationText = 'SG';
    changeLocationId = 1;
    showPopup = true;
  }

  if (geoCountry == 'NZ' && stockLocation != 3) {
    if (stockLocation == 1) {
      existingStockLocation = 'Singapore';
    }
    if (stockLocation == 2) {
      existingStockLocation = 'the United States';
    }
    newStockLocation = 'New Zealand';
    newStockLocationText = 'NZ';
    changeLocationId = 3;
    showPopup = true;
  }

  if (showPopup) {
    let messageText = "We're showing you products that are stocked in " + existingStockLocation + ". Would you like to change stock location to see products in " + newStockLocation + '?';
    let oneTimechangeLocation = new PopupOneTimeChangeLocation(messageText, 'Change to ' + newStockLocationText, changeLocationId);
    oneTimechangeLocation.render();
    localStorage.setItem('one-time-change-location-popup', true);
  }
}